import { $ as SlimDocument, A as ListItem, At as isValidURL, C as Subscript, Ct as CodeBlockDeleteIndicatorPluginKey, D as MathFigure, Dt as parseMarkdownLanguage, Et as getLanguageMode, F as Hyperlink, Ft as Audio, G as currentActiveFootnoteId, H as Footnote, I as getValidURL, It as insertMedia, J as EmptyMediaNode, K as listFootnotes, L as openLink, Lt as uploadMediaToServer, M as ImageMenuComponent, Mt as CODEBLOCK_MARKDOWN_INPUT_REGEX, N as Image, Nt as MARKDOWN_CODEBLOCK_REGEX, O as InlineMathBase, Ot as getText, P as HyperlinkMenuComponent, Pt as buildRegex, Q as SingleBlockDocument, R as Highlight, Rt as ALLOWED_MIME_TYPES, S as enableCadmusSpellCheck, St as CodeBlockDeleteIndicatorPlugin, T as OrderedList, Tt as getLanguageDisplay, U as FootnoteListPluginKey, V as htmlToDOMOutputSpec, W as FootnoteActiveStatusPluginKey, X as NodePasteRule, Y as Emoji, Z as Document, _ as Superscript, _t as Paste, a as useThreadList, at as FloatingMenuComponent, b as canSpellCheckWithCadmus, bt as CodeBlockPastePlugin, c as ThreadActiveStatusPluginKey, ct as fontFamilySans, d as TextColor, dt as List, et as sendableWordCountChange, f as editorWordCount, ft as Blockquote, g as TableMenuComponent, gt as listExistingBlanks, h as Table, ht as Blank, i as TrailingNode, it as FloatingMenuExtension, j as Indentation, jt as BASE_URL_REGEX, k as BlockMathBase, kt as textWordCount, l as currentActiveThreadId, lt as Code, m as TaskItem, mt as BlockBackground, n as CadmusEditorWrapper, nt as HistoryPluginKey, o as Thread, ot as findTableGroup, p as Telemetry, pt as BlockTextVisibility, q as TaskList, r as Video, rt as Collab, s as ThreadListPluginKey, st as editorTypography, t as makeCodeBlockDomSpec, tt as History, u as listThreads, ut as BulletList, v as SuggestionMenuComponent, vt as PastePluginKey, w as PasteChip, wt as findCodeBlockSelection, x as disableSpellCheck, xt as CodeBlockPastePluginKey, y as Suggestion, yt as copyEventHandler, z as useFootnoteList, zt as MediaUploader } from "./makeCodeBlockDomSpec-CtiYDMcB.mjs";
import { Editor as CoreEditor, Extension, InputRule, Mark, Node as Node$1, callOrReturn, findParentNode, generateHTML, getExtensionField, getMarkAttributes, isNodeSelection, mergeAttributes, posToDOMRect, textblockTypeInputRule } from "@tiptap/core";
import { Bold } from "@tiptap/extension-bold";
import { HardBreak } from "@tiptap/extension-hard-break";
import { Heading } from "@tiptap/extension-heading";
import { Italic } from "@tiptap/extension-italic";
import { Paragraph } from "@tiptap/extension-paragraph";
import { Strike } from "@tiptap/extension-strike";
import { Text } from "@tiptap/extension-text";
import { TextAlign } from "@tiptap/extension-text-align";
import { TextStyle } from "@tiptap/extension-text-style";
import { Underline } from "@tiptap/extension-underline";
import { EditorState, NodeSelection, Plugin, PluginKey, Selection, TextSelection } from "@tiptap/pm/state";
import { Decoration, DecorationSet, __parseFromClipboard } from "@tiptap/pm/view";
import { Button, ColorPickerMenu, ControlButton, Controlbar as Controlbar$1, DEFAULT_HIGHLIGHT_COLOR, DEFAULT_TEXT_COLOR, DropdownMenu, HIDDEN_CHAR_STYLES, Input, LinkButton, Switch, Tabs, Text as Text$1, Toolbar, Tooltip, colors, levels } from "@vericus/cadmus-ui";
import crel from "crelt";
import { DOMSerializer, Node } from "@tiptap/pm/model";
import { Step, Step as Step$1 } from "@tiptap/pm/transform";
import { styled } from "styled-components";
import { exitCode } from "@tiptap/pm/commands";
import { redo, redoDepth, undo, undoDepth } from "@tiptap/pm/history";
import CodeMirror from "codemirror";
import "codemirror/addon/edit/closebrackets.js";
import "codemirror/addon/selection/active-line.js";
import "codemirror/addon/selection/mark-selection.js";
import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useLayoutEffect, useMemo, useRef, useState } from "react";
import { Editor, Editor as Editor$2, EditorContent, NodeViewWrapper, ReactNodeViewRenderer, useEditor, useEditor as useEditor$1, useEditorState, useEditorState as useEditorState$1 } from "@tiptap/react";
import { FloatingNode, FloatingPortal, FloatingTree, autoUpdate, offset, safePolygon, useDismiss, useFloating, useFloatingNodeId, useFocus, useHover, useId, useInteractions, useRole } from "@floating-ui/react";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import { collab, getVersion, receiveTransaction, sendableSteps } from "@tiptap/pm/collab";
import tinycolor from "tinycolor2";
import { MathfieldElement, convertLatexToMarkup } from "mathlive";
import isEqual from "lodash-es/isEqual.js";
import { renderToString } from "react-dom/server";
import { keyName } from "w3c-keyname";
//#region src/extensions/atom-selection/atom-selection.ts
const atomSelectionPluginKey = new PluginKey("atomSelection");
const AtomSelection = Extension.create({
	name: "AtomSelection",
	addProseMirrorPlugins() {
		return [new Plugin({
			key: atomSelectionPluginKey,
			props: {
				decorations(state) {
					const { doc, selection } = state;
					const decorations = [];
					if (selection.empty) return DecorationSet.empty;
					const { from, to } = selection;
					doc.nodesBetween(from, to, (node, pos) => {
						if (node.isAtom || [
							"image",
							"audio",
							"video"
						].includes(node.type.name)) decorations.push(Decoration.node(pos, pos + node.nodeSize, { class: "ProseMirror-selectednode" }));
						return true;
					});
					return DecorationSet.create(doc, decorations);
				},
				handleClick: (view) => {
					if (!view.hasFocus()) this.editor.commands.setMeta("focus", true);
					return false;
				}
			}
		})];
	}
});
//#endregion
//#region src/extensions/code-block/code-block-node-view.ts
var CodeBlockView = class {
	node;
	editor;
	view;
	schema;
	cm;
	dom;
	getPos;
	updating;
	incomingChanges;
	languageDisplay;
	onCopy;
	constructor(node, editor, getPos) {
		this.node = node;
		this.editor = editor;
		this.view = editor.view;
		this.schema = node.type.schema;
		this.getPos = getPos;
		this.updating = false;
		this.incomingChanges = false;
		this.cm = CodeMirror(null, {
			value: node.textContent,
			lineNumbers: node.attrs.lineNumbersVisible,
			extraKeys: this.codeMirrorKeymap(),
			mode: getLanguageMode(node.attrs.language),
			theme: node.attrs.theme,
			tabSize: 4,
			indentUnit: 4,
			showCursorWhenSelecting: true,
			styleSelectedText: true,
			autoCloseBrackets: true,
			styleActiveLine: false,
			lineWrapping: true,
			viewportMargin: Infinity
		});
		const textAreaElement = this.cm.getInputField();
		textAreaElement.ariaLabel = "Input your code here";
		textAreaElement.tabIndex = -1;
		this.dom = this.cm.getWrapperElement();
		this.languageDisplay = crel("div", {
			class: "language-display",
			style: `visibility: ${node.attrs.languageVisible ? "visible" : "hidden"}`
		});
		crel(this.dom, [this.languageDisplay]);
		this.languageDisplay.innerHTML = getLanguageDisplay(node.attrs.language);
		if (node.attrs.languageVisible) this.dom.classList.remove("language-display-off");
		else this.dom.classList.add("language-display-off");
		if (this.editor.isEditable) this.dom.classList.remove("CodeMirror-Readonly");
		else this.dom.classList.add("CodeMirror-Readonly");
		setTimeout(() => this.cm.refresh(), 20);
		this.cm.setOption("readOnly", !this.editor.isEditable);
		this.cm.on("beforeChange", () => this.incomingChanges = true);
		this.cm.on("cursorActivity", () => {
			if (!this.updating && !this.incomingChanges) this.forwardSelection();
		});
		this.cm.on("changes", () => {
			if (!this.updating) {
				this.valueChanged();
				this.forwardSelection();
			}
			this.incomingChanges = false;
		});
		this.cm.on("focus", () => setTimeout(() => this.forwardSelection(true), 0));
		this.cm.on("blur", () => this.cm.setOption("styleActiveLine", false));
		this.onCopy = copyEventHandler(this.editor.storage.paste.editorId);
		/**
		* Buble up copy, cut, paste, dragStart & drop event to prosemirror editor
		*/
		this.cm.on("copy", (_cm, event) => {
			this.onCopy(this.editor.view, event);
		});
		this.cm.on("cut", (_cm, event) => {
			this.onCopy(this.editor.view, event);
		});
		this.cm.on("dragstart", (_cm, event) => {
			this.onCopy(this.editor.view, event);
		});
		this.cm.on("paste", (_cm, event) => {
			this.onPaste(event, false);
			event.preventDefault();
		});
		this.cm.on("drop", (_cm, event) => {
			this.onPaste(event, false);
			event.preventDefault();
		});
	}
	forwardSelection(bypass = false) {
		if (!this.cm.hasFocus() && !bypass) return;
		this.cm.setOption("styleActiveLine", true);
		const state = this.view.state;
		const selection = this.asProseMirrorSelection(state.doc);
		this.editor.chain().dismissMenu().command(({ tr, dispatch }) => {
			dispatch?.(tr.setSelection(selection).setMeta("focus", true));
			return true;
		}).run();
	}
	asProseMirrorSelection(doc) {
		const offset = this.getPos() + 1;
		const anchor = this.cm.indexFromPos(this.cm.getCursor("anchor")) + offset;
		const head = this.cm.indexFromPos(this.cm.getCursor("head")) + offset;
		return TextSelection.create(doc, anchor, head);
	}
	valueChanged() {
		const change = computeTextChange(this.node.textContent, this.cm.getValue());
		if (!change) return;
		const start = this.getPos() + 1;
		const tr = this.view.state.tr.replaceWith(start + change.from, start + change.to, change.text ? this.schema.text(change.text) : []);
		this.view.dispatch(tr);
	}
	codeMirrorKeymap() {
		const view = this.view;
		const mod = /Mac/.test(navigator.platform) ? "Cmd" : "Ctrl";
		return CodeMirror.normalizeKeyMap({
			Up: () => this.maybeEscape("line", -1),
			Left: () => this.maybeEscape("char", -1),
			Down: () => this.maybeEscape("line", 1),
			Right: () => this.maybeEscape("char", 1),
			"Ctrl-Enter": () => {
				if (exitCode(view.state, view.dispatch)) view.focus();
			},
			"Alt-M": () => {
				document.getElementById("code-block-language-selection")?.focus();
			},
			Esc: () => this.cm.display.input.blur(),
			[`${mod}-Z`]: () => undo(view.state, view.dispatch),
			[`Shift-${mod}-Z`]: () => redo(view.state, view.dispatch),
			[`${mod}-Y`]: () => redo(view.state, view.dispatch)
		});
	}
	maybeEscape(unit, dir) {
		const pos = this.cm.getCursor();
		if (this.cm.somethingSelected() || pos.line != (dir < 0 ? this.cm.firstLine() : this.cm.lastLine()) || unit == "char" && pos.ch != (dir < 0 ? 0 : this.cm.getLine(pos.line).length)) return CodeMirror.Pass;
		this.editor.chain().command(({ tr, dispatch }) => {
			const nextSelection = Selection.findFrom(tr.doc.resolve(this.getPos() + (dir < 0 ? 0 : this.node.nodeSize)), dir, false);
			if (nextSelection) dispatch?.(tr.setSelection(nextSelection));
			return true;
		}).focus().run();
		return null;
	}
	update(node) {
		if (node.type !== this.node.type) return false;
		this.node = node;
		this.cm.setOption("readOnly", !this.editor.isEditable);
		this.cm.setOption("mode", getLanguageMode(node.attrs.language));
		this.cm.setOption("theme", node.attrs.theme);
		this.cm.setOption("lineNumbers", node.attrs.lineNumbersVisible);
		const change = computeTextChange(this.cm.getValue(), node.textContent);
		if (change) {
			this.updating = true;
			this.cm.replaceRange(change.text, this.cm.posFromIndex(change.from), this.cm.posFromIndex(change.to));
			this.updating = false;
		}
		this.languageDisplay.innerHTML = getLanguageDisplay(node.attrs.language);
		this.languageDisplay.style.visibility = node.attrs.languageVisible ? "visible" : "hidden";
		if (node.attrs.languageVisible) this.dom.classList.remove("language-display-off");
		else this.dom.classList.add("language-display-off");
		if (this.editor.isEditable) this.dom.classList.remove("CodeMirror-Readonly");
		else this.dom.classList.add("CodeMirror-Readonly");
		return true;
	}
	/**
	* PM Callback function to handle selection from the editor. Passes the
	* ProseMirror selection to a CodeMirror selection
	*/
	setSelection(anchor, head) {
		this.cm.focus();
		this.updating = true;
		this.cm.setSelection(this.cm.posFromIndex(anchor), this.cm.posFromIndex(head));
		this.updating = false;
	}
	selectNode() {
		this.dom.classList.add("ProseMirror-selectednode");
		this.cm.focus();
	}
	stopEvent(event) {
		if (event.dataTransfer || event.clipboardData) return false;
		return true;
	}
	onPaste(event, moved) {
		let text;
		let html;
		const dataTransfer = event.dataTransfer;
		const clipboardData = event.clipboardData;
		if (dataTransfer) {
			html = dataTransfer.getData("text/html");
			text = dataTransfer.getData("text/plain");
		} else if (clipboardData) {
			html = clipboardData.getData("text/html");
			text = clipboardData.getData("text/plain");
		}
		const slice = __parseFromClipboard(this.editor.view, text ?? "", html ?? "", this.editor.view.shiftKey, this.editor.view.state.selection.$from);
		this.editor.commands.handlePaste(event, moved, slice, html, text);
		return true;
	}
};
/**
* `computeTextChange` compare two strings and find the minimal change between
* them.
*
* It iterates from the start and end of the strings, until it hits a
* difference, and returns an object giving the change's start, end, and
* replacement text, or `null` if there was no change.
*/
function computeTextChange(previousText, currentText) {
	if (previousText === currentText) return null;
	let from = 0;
	let to = previousText.length;
	let currentTo = currentText.length;
	while (from < to && previousText.charCodeAt(from) === currentText.charCodeAt(from)) ++from;
	while (to > from && currentTo > from && previousText.charCodeAt(to - 1) === currentText.charCodeAt(currentTo - 1)) {
		to--;
		currentTo--;
	}
	return {
		from,
		to,
		text: currentText.slice(from, currentTo)
	};
}
//#endregion
//#region src/extensions/code-block/code-block.ts
const CodeBlock = Node$1.create({
	name: "codeBlock",
	content: "text*",
	draggable: true,
	marks: "",
	code: true,
	defining: true,
	isolating: true,
	addOptions() {
		return {
			/** Default HTMLAttributes to be rendered */
			HTMLAttributes: {},
			/** Default `CodeBlockTheme` */
			theme: "cadmus-light"
		};
	},
	addAttributes() {
		return {
			language: {
				default: "plain",
				parseHTML: (element) => {
					return element.children[0] ? element.children[0].getAttribute("data-code-block-lang") : null;
				},
				renderHTML: (attributes) => ({ "data-code-block-lang": attributes.language })
			},
			lineNumbersVisible: { default: true },
			languageVisible: { default: true },
			theme: {
				default: typeof window?.matchMedia === "function" && window.matchMedia("(prefers-color-scheme: dark)").matches ? "cadmus-dark" : "cadmus-light",
				parseHTML: (element) => {
					return element.children[0] ? element.children[0].getAttribute("data-code-block-theme") : null;
				},
				renderHTML: (attributes) => ({ "data-code-block-theme": attributes.theme })
			}
		};
	},
	parseHTML() {
		return [{
			tag: "pre",
			preserveWhitespace: "full"
		}];
	},
	addKeyboardShortcuts() {
		return {
			ArrowLeft: () => this.editor.commands.handleCodeBlockArrow("left"),
			ArrowRight: () => this.editor.commands.handleCodeBlockArrow("right"),
			ArrowUp: () => this.editor.commands.handleCodeBlockArrow("up"),
			ArrowDown: () => this.editor.commands.handleCodeBlockArrow("down")
		};
	},
	renderHTML({ HTMLAttributes }) {
		return ["pre", [
			"code",
			mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
			0
		]];
	},
	addNodeView() {
		return ({ node, editor, getPos }) => {
			return new CodeBlockView(node, editor, getPos);
		};
	},
	addProseMirrorPlugins() {
		return [CodeBlockDeleteIndicatorPlugin(), CodeBlockPastePlugin()];
	},
	addCommands() {
		return {
			insertCodeBlock: (options) => ({ tr, dispatch, state, commands }) => {
				if (findTableGroup(state.selection)) return false;
				const { selection } = tr;
				const { $from } = selection;
				if (findCodeBlockSelection(state.selection)) {
					if (dispatch) {
						commands.setTextSelection($from.pos);
						return true;
					}
				}
				const node = this.type.create(options);
				if (options && options.position !== void 0) {
					if (dispatch) {
						tr.insert(options.position, node);
						commands.setTextSelection(options.position);
					}
				} else {
					const { selection } = tr;
					if (dispatch) {
						const content = state.doc.textBetween(selection.from, selection.to);
						tr.replaceRangeWith(selection.from, selection.to, node);
						tr.insertText(content, selection.from);
						commands.setTextSelection(selection.from + 2);
					}
				}
				return true;
			},
			setCodeBlockTheme: (theme) => ({ state, chain }) => {
				const { selection } = state;
				const sel = findCodeBlockSelection(selection);
				if (!sel) return false;
				const { pos } = sel;
				return chain().setNodeSelection(pos).updateAttributes(this.name, { theme }).setTextSelection(selection).run();
			},
			setCodeBlockLanguage: (lang) => ({ state, chain }) => {
				const { selection } = state;
				const sel = findCodeBlockSelection(selection);
				if (!sel) return false;
				const { pos } = sel;
				return chain().setNodeSelection(pos).updateAttributes(this.name, { language: lang }).setTextSelection(selection).run();
			},
			setActiveLanguageVisibility: (visibility) => ({ state, chain }) => {
				const { selection } = state;
				const sel = findCodeBlockSelection(selection);
				if (!sel) return false;
				const { pos } = sel;
				return chain().setNodeSelection(pos).updateAttributes(this.name, { languageVisible: visibility }).setTextSelection(selection).run();
			},
			setLineNumbersVisibility: (visibility) => ({ state, chain }) => {
				const { selection } = state;
				const sel = findCodeBlockSelection(selection);
				if (!sel) return false;
				const { pos } = sel;
				return chain().setNodeSelection(pos).updateAttributes(this.name, { lineNumbersVisible: visibility }).setTextSelection(selection).run();
			},
			deleteCodeBlock: () => ({ chain, state }) => {
				const { selection } = state;
				const sel = findCodeBlockSelection(selection);
				if (sel) chain().preDeleteHighlightCodeBlock(false).deleteRange({
					from: sel.pos,
					to: sel.pos + sel.node.nodeSize
				}).focus().run();
				return true;
			},
			preDeleteHighlightCodeBlock: (state) => ({ tr, dispatch }) => {
				dispatch?.(tr.setMeta(CodeBlockDeleteIndicatorPluginKey, { highlight: state }));
				return true;
			},
			handleCodeBlockArrow: (dir) => ({ state, dispatch, view }) => {
				if (state.selection.empty && view.endOfTextblock(dir)) {
					const { $head } = state.selection;
					const searchBias = dir == "left" || dir == "up" ? -1 : 1;
					if ($head.node().type.name === "doc") return false;
					const position = searchBias > 0 ? $head.after() : $head.before();
					const nextPos = Selection.findFrom(state.doc.resolve(position), searchBias, true);
					if (nextPos?.$head && nextPos.$head.parent.type.name == "codeBlock") {
						dispatch?.(state.tr.setSelection(nextPos));
						return true;
					}
				}
				return false;
			},
			handleVSCodePasteMetadata: (event, moved, _slice, _html, _text) => ({ commands }) => {
				if (moved) return false;
				let vscode;
				if (event.clipboardData) vscode = event.clipboardData?.getData("vscode-editor-data");
				else vscode = event.dataTransfer?.getData("vscode-editor-data");
				const language = (vscode ? JSON.parse(vscode) : void 0)?.mode;
				if (!language) return false;
				return commands.setCodeBlockPasteMeta({
					language: parseMarkdownLanguage(language),
					source: "vscode"
				});
			},
			handleCodeBlockPasteMetadata: (_event, moved, slice, _html, _text) => ({ commands, state }) => {
				if (moved) return false;
				if (!findCodeBlockSelection(state.selection)?.node) return false;
				if (slice.content.firstChild?.type === this.type) return false;
				return commands.setCodeBlockPasteMeta({ insideCodeBlock: true });
			},
			setCodeBlockPasteMeta: (meta) => ({ tr, dispatch }) => {
				dispatch?.(tr.setMeta(CodeBlockPastePluginKey, meta));
				return true;
			},
			handleVSCodePaste: (text) => ({ tr, dispatch, state }) => {
				if (!text) return false;
				const codeBlockPasteMeta = tr.getMeta(CodeBlockPastePluginKey);
				if (codeBlockPasteMeta?.source === "vscode") {
					const codeBlockNode = this.type.createChecked({ language: codeBlockPasteMeta.language }, state.schema.text(text));
					tr.replaceSelectionWith(codeBlockNode).scrollIntoView();
					dispatch?.(tr);
					return true;
				}
				return false;
			},
			handleMarkdownPasteMetadata: (_event, _moved, _slice, _html, text) => ({ commands }) => {
				if (!text) return false;
				if (MARKDOWN_CODEBLOCK_REGEX.test(text)) {
					const matches = text.match(MARKDOWN_CODEBLOCK_REGEX);
					if (!matches || matches.length < 3) return false;
					const language = parseMarkdownLanguage(matches[1]);
					return commands.setCodeBlockPasteMeta({
						language,
						source: "markdown"
					});
				}
				return false;
			},
			handleMarkdownPaste: (text) => ({ tr, dispatch, state }) => {
				if (!text) return false;
				const codeBlockPasteMeta = tr.getMeta(CodeBlockPastePluginKey);
				if (codeBlockPasteMeta?.source === "markdown" && MARKDOWN_CODEBLOCK_REGEX.test(text)) {
					const matches = text.match(MARKDOWN_CODEBLOCK_REGEX);
					if (!matches || matches.length < 3) return false;
					const content = matches[2];
					const codeBlockNode = this.type.createChecked({ language: codeBlockPasteMeta.language }, state.schema.text(content));
					tr.replaceSelectionWith(codeBlockNode).scrollIntoView();
					dispatch?.(tr);
					return true;
				}
				return false;
			},
			addCodeBlockPasteChip: () => ({ commands }) => commands.addPasteChipAfterPredicate(findCodeBlockSelection)
		};
	},
	addInputRules() {
		return [textblockTypeInputRule({
			find: CODEBLOCK_MARKDOWN_INPUT_REGEX,
			type: this.type,
			getAttributes: (match) => ({ language: parseMarkdownLanguage(match[1]) })
		})];
	}
});
//#endregion
//#region src/extensions/code-block/code-block-menu-component.tsx
/**
* Bubble Menu Component for CodeBlock controls.
*/
function CodeBlockMenuComponent(props) {
	const { editor, portalId } = props;
	const shouldShow = useCallback(({ state }) => {
		const { selection } = state;
		return findCodeBlockSelection(selection) !== void 0;
	}, []);
	const getBoundingClientRect = useCallback(() => {
		const { view, state } = editor;
		const { selection } = state;
		const codeBlockNode = findCodeBlockSelection(selection);
		const { ranges } = selection;
		const from = Math.min(...ranges.map((range) => range.$from.pos));
		const to = Math.max(...ranges.map((range) => range.$to.pos));
		if (codeBlockNode) return posToDOMRect(view, codeBlockNode.pos, codeBlockNode.pos + codeBlockNode.node.nodeSize);
		return posToDOMRect(view, from, to);
	}, [editor]);
	const [optionsDropdownOpen, setOptionsDropdownOpen] = useState(false);
	const { isDarkTheme, activeLanguage, isLanguageVisible, isLineNumbersVisible } = useEditorState$1({
		editor,
		selector: (ctx) => {
			const sel = findCodeBlockSelection(ctx.editor.state.selection);
			return {
				isDarkTheme: sel?.node.attrs.theme === "cadmus-dark",
				activeLanguage: sel?.node.attrs?.language || "plain",
				isLanguageVisible: sel?.node.attrs?.languageVisible,
				isLineNumbersVisible: sel?.node.attrs.lineNumbersVisible
			};
		}
	});
	const switchTheme = () => editor.commands.setCodeBlockTheme(isDarkTheme ? "cadmus-light" : "cadmus-dark");
	const languageSelectionDropdownContent = /* @__PURE__ */ jsxs(DropdownMenu.Content, { children: [
		/* @__PURE__ */ jsx(DropdownMenu.Item, {
			selected: activeLanguage === "plain",
			onSelect: () => {
				editor.commands.setCodeBlockLanguage("plain");
			},
			content: "Plain Text"
		}),
		/* @__PURE__ */ jsx(DropdownMenu.Separator, {}),
		LANGUAGES.map((lang) => /* @__PURE__ */ jsx(DropdownMenu.Item, {
			selected: activeLanguage === lang,
			onSelect: () => {
				editor.commands.setCodeBlockLanguage(lang);
			},
			content: getLanguageDisplay(lang)
		}, lang))
	] });
	const optionsDropdownContent = /* @__PURE__ */ jsxs(DropdownMenu.Content, { children: [/* @__PURE__ */ jsx(DropdownMenu.CheckboxItem, {
		toggleable: true,
		checked: isLineNumbersVisible,
		onCheckedChange: () => editor.commands.setLineNumbersVisibility(!isLineNumbersVisible),
		iconName: "CodeBlockLineNumbers",
		content: "Line numbers"
	}), /* @__PURE__ */ jsx(DropdownMenu.CheckboxItem, {
		toggleable: true,
		checked: isLanguageVisible,
		onCheckedChange: () => editor.commands.setActiveLanguageVisibility(!isLanguageVisible),
		iconName: "CodeBlockLanguageCaption",
		content: "Language caption"
	})] });
	return /* @__PURE__ */ jsx(FloatingMenuComponent, {
		portalId,
		editor,
		pluginKey: "codeblockFloatingMenu",
		shouldShow,
		getBoundingClientRect,
		isAsync: true,
		children: /* @__PURE__ */ jsxs(CodeBlockToolbar, {
			"aria-label": "Code block options",
			onKeyDown: (e) => {
				if (e.key === "Escape") editor.commands.focus();
			},
			"aria-keyshortcuts": "Alt+M",
			children: [
				/* @__PURE__ */ jsxs(DropdownMenu.Root, { children: [/* @__PURE__ */ jsx(Toolbar.Button, {
					asChild: true,
					children: /* @__PURE__ */ jsx(DropdownMenu.Trigger, {
						asChild: true,
						children: /* @__PURE__ */ jsx(ControlButton, {
							id: "code-block-language-selection",
							onClick: () => {
								setOptionsDropdownOpen(false);
							},
							"aria-label": getLanguageDisplay(activeLanguage),
							withDownCaret: true,
							children: getLanguageDisplay(activeLanguage)
						})
					})
				}), languageSelectionDropdownContent] }),
				/* @__PURE__ */ jsx(ToolbarDivider, {}),
				/* @__PURE__ */ jsx(Toolbar.Button, {
					asChild: true,
					children: /* @__PURE__ */ jsx(ControlButton, {
						"aria-label": !isDarkTheme ? "Light Theme" : "Dark Theme",
						onClick: switchTheme,
						iconName: !isDarkTheme ? "SunLightDark" : "SunDarkLight"
					})
				}),
				/* @__PURE__ */ jsx(ToolbarDivider, {}),
				/* @__PURE__ */ jsx(Toolbar.Button, {
					asChild: true,
					children: /* @__PURE__ */ jsx(ControlButton, {
						"aria-label": "Delete Codeblock",
						onMouseEnter: () => editor.commands.preDeleteHighlightCodeBlock(true),
						onMouseLeave: () => editor.commands.preDeleteHighlightCodeBlock(false),
						onClick: () => editor.commands.deleteCodeBlock(),
						iconName: "Trash"
					})
				}),
				/* @__PURE__ */ jsx(ToolbarDivider, {}),
				/* @__PURE__ */ jsxs(DropdownMenu.Root, { children: [/* @__PURE__ */ jsx(Toolbar.Button, {
					asChild: true,
					children: /* @__PURE__ */ jsx(DropdownMenu.Trigger, {
						asChild: true,
						children: /* @__PURE__ */ jsx(ControlButton, {
							"aria-label": "More",
							onClick: () => {
								setOptionsDropdownOpen(!optionsDropdownOpen);
							},
							iconName: "More"
						})
					})
				}), optionsDropdownContent] })
			]
		})
	});
}
const LANGUAGES = [
	"c",
	"c++",
	"c#",
	"css",
	"elixir",
	"go",
	"haskell",
	"html",
	"json",
	"java",
	"javascript",
	"kotlin",
	"markdown",
	"matlab",
	"objective-c",
	"python",
	"r",
	"scala",
	"shell",
	"sql",
	"typescript",
	"yaml"
];
const CodeBlockToolbar = styled(Toolbar.Root)`
  background: white;
  box-shadow: ${levels.two};
  display: flex;
  height: 36px;
`;
const ToolbarDivider = styled(Toolbar.Separator)`
  display: inline-flex;
  width: 1px;
  height: 20px;
  background: rgba(89, 115, 166, 0.15);
  margin: 7px 2px;
`;
//#endregion
//#region src/extensions/editor-placeholder/editor-placeholder.ts
const EditorPlaceholderPluginKey = new PluginKey("editorPlaceholder");
/**
* Extension to create simple and rich placeholders inside empty nodes.
*
* The placeholders can be a simple textual Title and Content placeholder text
* combination or the custom Cadmus Referencing placeholder which displays a
* button to open Cadmus Manual.
*/
const EditorPlaceholder = Extension.create({
	name: "editorPlaceholder",
	addProseMirrorPlugins() {
		const openManualPreset = (preset) => {
			this.editor.commands.setMeta("openManualPreset", preset);
		};
		return [new Plugin({
			key: EditorPlaceholderPluginKey,
			state: {
				init: (_, editorState) => {
					return createPlaceholders(editorState, this.options, openManualPreset);
				},
				apply: (_tr, _pluginState, _oldState, newState) => {
					return createPlaceholders(newState, this.options, openManualPreset);
				}
			},
			props: { decorations: (state) => this.editor.isEditable ? EditorPlaceholderPluginKey.getState(state) : void 0 }
		})];
	}
});
/**
* check if placeholder needs to be displayed in the first two blocks
* of the document
*/
function createPlaceholders(editorState, options, openManualPreset) {
	let state = DecorationSet.empty;
	const { doc } = editorState;
	const { childCount } = doc;
	if (options.singleLinePlaceholder && childCount > 1) return state;
	if (childCount > 2) return state;
	let shouldDisplaySecondPlaceholder = true;
	const firstNode = doc.child(0);
	const secondNode = doc.maybeChild(1);
	if (firstNode.isBlock && firstNode.textContent === "" && firstNode.childCount === 0) {
		if (options.titlePlaceholder && firstNode.type.name === "heading") state = state.add(doc, [TextPlaceholderWidget(1, options.titlePlaceholder)]);
		else if (options.contentPlaceholder && firstNode.type.name === "paragraph" && !(secondNode?.isBlock && secondNode.textContent !== "")) {
			shouldDisplaySecondPlaceholder = false;
			state = state.add(doc, [TextPlaceholderWidget(1, options.contentPlaceholder)]);
		} else if (options.referencesPlaceholder && firstNode.type.name === "paragraph" && !(secondNode?.isBlock && secondNode.textContent !== "")) {
			shouldDisplaySecondPlaceholder = false;
			state = state.add(doc, [ReferencesPlaceholderWidget(1, openManualPreset)]);
		}
	}
	if (firstNode.isBlock && firstNode.type.name !== "heading") shouldDisplaySecondPlaceholder = false;
	if (secondNode?.isBlock && secondNode.textContent === "" && secondNode.childCount === 0 && shouldDisplaySecondPlaceholder && secondNode.type.name === "paragraph") {
		if (options.referencesPlaceholder) state = state.add(doc, [ReferencesPlaceholderWidget(firstNode.nodeSize + 1, openManualPreset)]);
		else if (options.contentPlaceholder) state = state.add(doc, [TextPlaceholderWidget(firstNode.nodeSize + 1, options.contentPlaceholder)]);
	}
	return state;
}
const TextPlaceholderWidget = (pos, text) => {
	const wrapper = crel("span", { class: "outer-placeholder" }, crel("span", { class: "inner-placeholder" }, text));
	return Decoration.widget(pos, () => wrapper);
};
const ReferencesPlaceholderWidget = (pos, openManualPreset) => {
	const onClick = () => {
		openManualPreset?.("referencing_style");
	};
	const button = crel("button", {
		class: "cui-LinkButton",
		onclick: onClick
	}, crel("span", "View the guide"));
	const wrapper = crel("span", { class: "outer-placeholder" }, crel("span", { class: "inner-placeholder" }, "Add a Reference. ", button, " for tips."));
	return Decoration.widget(pos, () => wrapper, { stopEvent: (e) => {
		if (e.target && button.contains(e.target) && e.type === "mousedown") e.preventDefault();
		return true;
	} });
};
//#endregion
//#region src/extensions/hidden-characters/hidden-characters.ts
const HiddenCharactersPluginKey = new PluginKey("hiddenCharacters");
const GLYPH_BY_CHAR = new Map([
	{
		chars: [" "],
		name: "space",
		inline: true
	},
	{
		chars: ["\xA0"],
		name: "nbsp",
		inline: true
	},
	{
		chars: ["	"],
		name: "tab",
		inline: true
	},
	{
		chars: ["­"],
		name: "soft-hyphen"
	},
	{
		chars: [
			"​",
			"‌",
			"‍",
			"⁠"
		],
		name: "zero-width"
	}
].flatMap((g) => g.chars.map((char) => [char, g])));
function inlineDecoration(from, name) {
	return Decoration.inline(from, from + 1, {
		class: `cdm-hidden-char-inline cdm-hidden-char-${name}`,
		style: `--hc-glyph: '${HIDDEN_CHAR_STYLES[name].glyph}'`
	});
}
function widgetDecoration(pos, name) {
	return Decoration.widget(pos, () => {
		const el = document.createElement("span");
		el.className = `cdm-hidden-char-widget cdm-hidden-char-${name}`;
		el.setAttribute("contenteditable", "false");
		el.setAttribute("aria-hidden", "true");
		el.textContent = HIDDEN_CHAR_STYLES[name].glyph;
		return el;
	}, {
		ignoreSelection: true,
		marks: [],
		side: 1
	});
}
function buildDecorations(doc, from, to) {
	const decorations = [];
	doc.nodesBetween(from, to, (node, pos) => {
		if (node.isText) {
			const text = node.text ?? "";
			for (let i = 0; i < text.length; i++) {
				const glyph = GLYPH_BY_CHAR.get(text[i]);
				if (!glyph) continue;
				const charPos = pos + i;
				decorations.push(glyph.inline === true ? inlineDecoration(charPos, glyph.name) : widgetDecoration(charPos, glyph.name));
			}
			return;
		}
		if (node.isTextblock) {
			const end = pos + node.nodeSize - 1;
			decorations.push(widgetDecoration(end, "pilcrow"));
		} else if (node.type.name === "hardBreak") decorations.push(widgetDecoration(pos, "break"));
	});
	return decorations;
}
/**
* Incrementally update the decorations for a document change:
* rebuild only the changed blocks.
*/
function updateDecorations(set, tr) {
	const changed = [];
	for (const stepMap of tr.mapping.maps) {
		for (const range of changed) {
			range.from = stepMap.map(range.from, -1);
			range.to = stepMap.map(range.to, 1);
		}
		stepMap.forEach((_oldFrom, _oldTo, from, to) => {
			changed.push({
				from,
				to
			});
		});
	}
	const size = tr.doc.content.size;
	const blocks = changed.map(({ from, to }) => {
		const $from = tr.doc.resolve(Math.max(0, Math.min(from, size)));
		const $to = tr.doc.resolve(Math.max(0, Math.min(to, size)));
		return {
			from: $from.depth > 0 ? $from.before(1) : $from.pos,
			to: $to.depth > 0 ? $to.after(1) : $to.pos
		};
	});
	blocks.sort((a, b) => a.from - b.from);
	const merged = [];
	for (const block of blocks) {
		const last = merged.at(-1);
		if (last !== void 0 && block.from <= last.to) last.to = Math.max(last.to, block.to);
		else merged.push(block);
	}
	let updated = set.map(tr.mapping, tr.doc);
	for (const { from, to } of merged) {
		updated = updated.remove(updated.find(from, to));
		updated = updated.add(tr.doc, buildDecorations(tr.doc, from, to));
	}
	return updated;
}
const HiddenCharacters = Extension.create({
	name: "hiddenCharacters",
	addCommands() {
		return { toggleHiddenCharacters: () => ({ tr, dispatch }) => {
			if (dispatch) {
				tr.setMeta(HiddenCharactersPluginKey, { toggle: true });
				tr.setMeta("addToHistory", false);
				dispatch(tr);
			}
			return true;
		} };
	},
	addProseMirrorPlugins() {
		return [new Plugin({
			key: HiddenCharactersPluginKey,
			state: {
				init: () => ({
					enabled: false,
					decorations: DecorationSet.empty
				}),
				apply(tr, value) {
					if (tr.getMeta(HiddenCharactersPluginKey)) {
						const enabled = !value.enabled;
						return {
							enabled,
							decorations: enabled ? DecorationSet.create(tr.doc, buildDecorations(tr.doc, 0, tr.doc.content.size)) : DecorationSet.empty
						};
					}
					if (!value.enabled || !tr.docChanged) return value;
					return {
						enabled: true,
						decorations: updateDecorations(value.decorations, tr)
					};
				}
			},
			props: { decorations(state) {
				return HiddenCharactersPluginKey.getState(state)?.decorations;
			} }
		})];
	}
});
//#endregion
//#region src/extensions/indentation/helpers/getEnabledIndentStyles.ts
function getEnabledIndentStyles(editor) {
	return editor.storage.specialIndentation?.enabledStyles;
}
//#endregion
//#region src/extensions/math/math-delete-indicator-plugin.ts
const MathDeleteIndicatorPluginKey = new PluginKey("MathDeleteIndicator");
/**
* Plugin that shows visual indicator of math blocks that will get deleted
* when user click on delete button
*/
const MathDeleteIndicatorPlugin = () => new Plugin({
	key: MathDeleteIndicatorPluginKey,
	state: {
		init() {
			return { highlight: -1 };
		},
		apply(tr, currentState) {
			const payload = tr.getMeta(MathDeleteIndicatorPluginKey);
			if (payload) return payload;
			return currentState;
		}
	},
	props: { decorations(editorState) {
		const deleteIndicatorState = this.getState(editorState);
		if (deleteIndicatorState?.highlight && deleteIndicatorState.highlight > -1) {
			const decorations = [];
			decorations.push(Decoration.node(deleteIndicatorState.highlight, deleteIndicatorState.highlight + 1, { class: "math-predelete" }));
			return DecorationSet.create(editorState.doc, decorations);
		}
		return DecorationSet.empty;
	} }
});
//#endregion
//#region src/extensions/math/utils.ts
function getMathNodeTypes(schema) {
	if (schema.cached.mathNodeTypes) return schema.cached.mathNodeTypes;
	const roles = {};
	Object.keys(schema.nodes).forEach((type) => {
		const nodeType = schema.nodes[type];
		if (nodeType.spec.mathRole) roles[nodeType.spec.mathRole] = nodeType;
	});
	schema.cached.mathNodeTypes = roles;
	return roles;
}
//#endregion
//#region src/extensions/math/math-menu-plugin.ts
/** Plugin key for `MathMenuPlugin` */
const MathMenuPluginKey = new PluginKey("mathMenu");
/**
* Plugin to render a floating menu for math creation and edit on math blocks.
*
* This plugin store the state of the clicked math node which MathMenu used
* to control whether it needs to be opened or closed through the Transaction metadata
* actions under the `MathMenuPluginKey`:
*
*   - `TriggerMenuAction` will open the menu with the given `node.attrs.equation` as the input contents.
*
*   - `DismissMenuAction` will unset the plugin state removing any menu.
*/
const MathMenuPlugin = ({ editor }) => new Plugin({
	key: MathMenuPluginKey,
	state: {
		init() {
			return null;
		},
		apply(tr, state) {
			const payload = tr.getMeta(MathMenuPluginKey);
			switch (payload?.type) {
				case "triggerMenu": return payload.target;
				case "dismissMenu": return null;
				default: return state;
			}
		}
	},
	props: { handleClick(view, pos) {
		const { state } = view;
		const pluginState = this.getState(state);
		const node = state.doc.nodeAt(pos);
		const mathTypes = getMathNodeTypes(editor.schema);
		if (node && [mathTypes.inline.name, mathTypes.block.name].includes(node.type.name)) {
			editor.chain().dismissMenu().focus().setNodeSelection(pos).setEquationMenuTarget({
				node,
				pos
			}).run();
			return true;
		} else if (pluginState) editor.commands.setEquationMenuTarget();
		return false;
	} }
});
//#endregion
//#region src/extensions/math/components/MathView/utils.ts
const OPTIONS = [
	"createHTML",
	"customVirtualKeyboardLayers",
	"customVirtualKeyboards",
	"defaultMode",
	"fontsDirectory",
	"horizontalSpacingScale",
	"inlineShortcutTimeout",
	"inlineShortcuts",
	"keybindings",
	"keypressSound",
	"keypressVibration",
	"letterShapeStyle",
	"locale",
	"macros",
	"plonkSound",
	"readAloudHook",
	"readOnly",
	"removeExtraneousParentheses",
	"scriptDepth",
	"smartFence",
	"smartMode",
	"smartSuperscript",
	"speakHook",
	"speechEngine",
	"speechEngineRate",
	"speechEngineVoice",
	"strings",
	"textToSpeechMarkup",
	"textToSpeechRules",
	"textToSpeechRulesOptions",
	"virtualKeyboardLayout",
	"virtualKeyboardMode",
	"virtualKeyboardTheme",
	"virtualKeyboardToggleGlyph",
	"virtualKeyboards"
];
/**
* mount/unmount are unhandled
*/
const FUNCTION_MAPPING = {
	/**retargeting onChange to fire input events to match react expected behavior */
	onChange: "input",
	onInput: "input",
	onFocus: "focus",
	onBlur: "blur",
	onCommit: "change",
	onKeystroke: "keystroke",
	onModeChange: "mode-change",
	onMoveOutOf: "focus-out",
	onReadAloudStatus: "read-aloud-status",
	onSelectionWillChange: "selection-will-change",
	onUndoStateDidChange: "undo-state-did-change",
	onUndoStateWillChange: "undo-state-will-change",
	onVirtualKeyboardToggle: "virtual-keyboard-toggle"
};
const FUNCTION_PROPS = Object.keys(FUNCTION_MAPPING);
const MAPPING = {
	className: "class",
	htmlFor: "for"
};
function filterConfig(props) {
	const config = {};
	const passProps = {};
	for (const _key in props) {
		const key = MAPPING[_key] || _key;
		let value = props[_key];
		if (FUNCTION_PROPS.indexOf(key) > -1) {} else if (OPTIONS.indexOf(key) > -1) {
			if (React.isValidElement(value) || value instanceof Array && value.every(React.isValidElement)) value = renderToString(value);
			config[key] = value;
		} else passProps[key] = value;
	}
	return [config, passProps];
}
/**
* Performance Optimization
* ------------------------
* This hook memoizes config in order to prevent unnecessary rendering/changes
* The hook deemed the new config dep !== previous config dep, hence invoking `setOptions`.
* This solution will update options only if they have changed is comparison to the previous values (not object containing them),
*  avoiding uncessary rendering.
*
* @param ref
* @param config
*/
function useUpdateOptions(ref, config) {
	const configRef = useRef(config);
	useLayoutEffect(() => {
		if (!isEqual(configRef.current, config)) {
			ref.current?.setOptions(config);
			configRef.current = config;
		}
	}, [
		ref,
		config,
		configRef
	]);
	useEffect(() => {
		ref.current?.setOptions(config);
	}, []);
}
function useEventRegistration(ref, props) {
	useEffect(() => {
		const node = ref.current;
		if (!node) return;
		const fns = Object.keys(props).filter((key) => typeof props[key] === "function" && FUNCTION_PROPS.indexOf(MAPPING[key] || key) > -1).map((key) => {
			return {
				key: FUNCTION_MAPPING[MAPPING[key] || key],
				fn: (...args) => {
					props[key](...args);
				}
			};
		});
		fns.forEach(({ key, fn }) => {
			node.addEventListener(key, fn);
		});
		return () => {
			fns.forEach(({ key, fn }) => node.removeEventListener(key, fn));
		};
	}, [ref, props]);
}
//#endregion
//#region src/extensions/math/components/MathView/MathView.tsx
/**
* React component wrapper for the `math-field` web component. This component
* provides a API layer on top of the internal web-component to use it like a
* controlled input.
*/
const MathView = forwardRef((props, ref) => {
	const [value, setValue] = useState(props.defaultValue || props.value);
	const _ref = useRef(null);
	useImperativeHandle(ref, () => _ref.current, [_ref]);
	const [config, passProps] = useMemo(() => filterConfig(props), [props]);
	useEventRegistration(_ref, props);
	useUpdateOptions(_ref, config);
	useEffect(() => {
		_ref.current?.setValue(props.value);
	}, [props.value]);
	return /* @__PURE__ */ jsx("math-field", {
		...passProps,
		onChange: props.defaultValue ? () => setValue(_ref.current?.value) : void 0,
		ref: _ref,
		style: {
			fontSize: 18,
			whiteSpace: "normal"
		},
		onKeyDown: (e) => {
			if (e.key === "Escape") _ref.current?.blur();
		},
		children: value
	});
});
//#endregion
//#region src/extensions/math/components/useMathMenuOpenCallback.ts
/**
* Create a callback to trigger the Math editor menu on the current node if its
* a Math node.
*/
function useMathMenuOpenCallback(props) {
	const { editor, getPos } = props;
	return useCallback(() => {
		if (typeof getPos === "function") {
			const nodeSelection = new NodeSelection(editor.state.doc.resolve(getPos()));
			editor.chain().focus(void 0, { scrollIntoView: false }).dismissMenu().run();
			setTimeout(() => {
				editor.chain().command(({ tr, dispatch }) => {
					dispatch?.(tr.setSelection(nodeSelection));
					return true;
				}).setMeta("focus", true).focus().setEquationMenuTarget({
					pos: getPos(),
					node: nodeSelection.node
				}).run();
			}, 0);
		}
	}, [editor, getPos]);
}
//#endregion
//#region src/extensions/math/components/MathBlockNodeView/CaptionInput.tsx
const CaptionInput = (props) => {
	const { caption, onInputOpenChange, onConfirm, editor, getPos } = props;
	const [value, setValue] = useState(caption);
	const onKeyDown = useCallback((e) => {
		if (e.key === "Enter") onConfirm(e.currentTarget.value);
	}, [onConfirm]);
	const { x, y, refs, strategy, context } = useFloating({
		placement: "right",
		middleware: [offset(-80)],
		open: true,
		onOpenChange: (newOpen) => {
			if (value !== caption) onConfirm(value);
			onInputOpenChange(newOpen);
		},
		whileElementsMounted: autoUpdate
	});
	const { getFloatingProps } = useInteractions([
		useRole(context, { role: "dialog" }),
		useFocus(context),
		useDismiss(context)
	]);
	useLayoutEffect(() => {
		refs.setReference({ getBoundingClientRect: () => {
			const pos = getPos();
			return editor.view.nodeDOM(pos).getBoundingClientRect();
		} });
	}, [
		refs,
		editor,
		getPos
	]);
	return /* @__PURE__ */ jsx("div", {
		...getFloatingProps({
			ref: refs.setFloating,
			style: {
				position: strategy,
				top: y ?? 0,
				left: x ?? 0,
				zIndex: 500
			}
		}),
		children: /* @__PURE__ */ jsx(StyledInput, {
			type: "text",
			value,
			onChange: (e) => setValue(e.target.value),
			autoFocus: true,
			onKeyDown,
			maxLength: 10,
			placeholder: "(ref)"
		})
	});
};
const StyledInput = styled(Input)`
  display: inline-block;
  background: white;
  input {
    text-align: right;
    width: 80px;
    min-width: unset;
    background: ${colors.grey50};
    font-size: 14px;
    line-height: 21px;
  }
`;
//#endregion
//#region src/extensions/math/components/MathBlockNodeView/OptionsMenu.tsx
/**
* Component for a dropdown menu with extra math block edit options.
*/
const OptionsMenu = forwardRef((props, ref) => {
	const { editor, getPos, setCaptionInputOpen, onOpenChange, node } = props;
	return /* @__PURE__ */ jsxs(DropdownMenu.Root, {
		onOpenChange,
		children: [/* @__PURE__ */ jsx(DropdownMenu.Trigger, {
			asChild: true,
			children: /* @__PURE__ */ jsx(ControlButton, {
				iconName: "More",
				ref
			})
		}), /* @__PURE__ */ jsxs(DropdownMenu.Content, {
			style: {
				zIndex: 300,
				position: "relative"
			},
			children: [
				/* @__PURE__ */ jsx(DropdownMenu.Item, {
					iconName: "Edit",
					content: "Edit equation",
					onSelect: () => {
						editor.chain().command(({ tr, dispatch }) => {
							dispatch?.(tr.setSelection(NodeSelection.create(tr.doc, getPos())));
							return true;
						}).maybeOpenEquationMenu().run();
					}
				}),
				/* @__PURE__ */ jsx(DropdownMenu.Item, {
					iconName: "QuoteOpen",
					content: `${node.attrs.caption === "" ? "Add" : "Edit"} reference`,
					onSelect: () => {
						setCaptionInputOpen(true);
						editor.commands.setNodeSelection(getPos());
					}
				}),
				/* @__PURE__ */ jsx(DropdownMenu.Item, {
					iconName: "Trash",
					content: "Delete",
					onMouseEnter: () => editor.commands.predeleteHighlightEquation(getPos(), true),
					onMouseLeave: () => editor.commands.predeleteHighlightEquation(getPos(), false),
					onSelect: () => editor.chain().deleteEquation(getPos()).focus().run()
				})
			]
		})]
	});
});
//#endregion
//#region src/extensions/math/components/MathBlockNodeView/MathBlockNodeView.tsx
const MathBlockNodeView = (props) => {
	const caption = props.node.attrs.caption ?? "";
	const equation = props.node.attrs.equation;
	const mathViewRef = useRef(null);
	useEffect(() => {
		mathViewRef.current?.setValue(equation, { suppressChangeNotifications: true });
	}, [equation]);
	if (!props.editor.isEditable) return /* @__PURE__ */ jsxs(NodeViewWrapper, { children: [/* @__PURE__ */ jsx(BlockRoot, {
		readOnly: true,
		children: /* @__PURE__ */ jsx(MathView, {
			defaultMode: "math",
			ref: mathViewRef,
			readOnly: true,
			defaultValue: equation,
			plonkSound: void 0,
			keypressSound: void 0
		})
	}), caption !== "" ? /* @__PURE__ */ jsx(Caption, { children: caption }) : null] });
	return /* @__PURE__ */ jsxs(NodeViewWrapper, { children: [/* @__PURE__ */ jsx(BlockMathHoverFloatingMenu, { ...props }), caption !== "" ? /* @__PURE__ */ jsx(Caption, { children: caption }) : null] });
};
const Caption = styled.div`
  position: absolute;
  right: 8px;
  top: 0;
  display: inline-flex;
  height: 100%;
  align-items: center;
  z-index: 400;
  font-size: 14px;
  line-height: 21px;
  pointer-events: none;
`;
const BlockMathHoverFloatingMenu = (props) => {
	const { editor, node, getPos } = props;
	const caption = node.attrs.caption ?? "";
	const equation = node.attrs.equation;
	const openMenu = useMathMenuOpenCallback({
		editor,
		getPos
	});
	const mathViewRef = useRef(null);
	const [hovered, setHovered] = useState(false);
	const [innerOpen, setInnerOpen] = useState(false);
	const [captionEdit, setCaptionEdit] = useState(false);
	const onCaptionConfirm = useCallback((newCaption) => {
		setCaptionEdit(false);
		editor.commands.updateEquationCaption(newCaption);
	}, [editor, setCaptionEdit]);
	const nodeId = useFloatingNodeId();
	const { x, y, refs, strategy, context } = useFloating({
		placement: "right-start",
		middleware: [offset({
			mainAxis: 0,
			alignmentAxis: -4
		})],
		onOpenChange: setHovered,
		whileElementsMounted: autoUpdate
	});
	const { getReferenceProps, getFloatingProps } = useInteractions([useHover(context, {
		delay: {
			open: 0,
			close: 1e3
		},
		handleClose: safePolygon()
	}), useDismiss(context, {
		ancestorScroll: true,
		referencePress: true
	})]);
	useEffect(() => {
		mathViewRef.current?.setValue(equation, { suppressChangeNotifications: true });
	}, [mathViewRef, equation]);
	return /* @__PURE__ */ jsxs(Fragment$1, { children: [
		/* @__PURE__ */ jsx(BlockRoot, {
			...getReferenceProps({ ref: refs.setReference }),
			hovered: hovered || captionEdit,
			children: /* @__PURE__ */ jsx(MathView, {
				defaultMode: "math",
				ref: mathViewRef,
				readOnly: true,
				defaultValue: equation,
				onFocus: openMenu,
				plonkSound: void 0,
				keypressSound: void 0,
				"aria-label": "Press enter to edit"
			})
		}),
		/* @__PURE__ */ jsx(FloatingTree, { children: /* @__PURE__ */ jsx(FloatingNode, {
			id: nodeId,
			children: /* @__PURE__ */ jsx(FloatingPortal, { children: (hovered || innerOpen) && !captionEdit && /* @__PURE__ */ jsx("div", {
				...getFloatingProps({
					ref: refs.setFloating,
					style: {
						position: strategy,
						top: y ?? 0,
						left: x ?? 0,
						zIndex: 200
					}
				}),
				children: /* @__PURE__ */ jsx(OptionsMenu, {
					...props,
					setCaptionInputOpen: setCaptionEdit,
					onOpenChange: setInnerOpen
				})
			}) })
		}) }),
		captionEdit && /* @__PURE__ */ jsx(CaptionInput, {
			caption,
			onInputOpenChange: setCaptionEdit,
			onConfirm: onCaptionConfirm,
			editor: props.editor,
			getPos: props.getPos
		})
	] });
};
const BlockRoot = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px 0px;

  background: ${(p) => p.hovered ? "rgba(244, 245, 248, 0.5)" : "inherit"};

  --selection-background-color: transparent;
  cursor: pointer;

  &:hover,
  &.ProseMirror-selectednode {
    background: rgba(244, 245, 248, 0.5);
  }

  /* mathlive is not responsiveness, so we need to restrict the width */
  width: 100%;
  overflow: hidden;
`;
//#endregion
//#region src/extensions/math/nodes/block-math.ts
/**
* Block level atomic math nodes to display equation
*/
const BlockMath = BlockMathBase.extend({
	onCreate() {
		const { type, editor } = this;
		const { storage } = editor;
		storage.placeholder?.placeholders?.set(this.name, {
			check: (_selection, node, _pos) => {
				if (node.type.name !== type.name) return false;
				if (node.attrs.equation === "") return true;
				return false;
			},
			decoration: (node, pos) => {
				return Decoration.node(pos, pos + node.nodeSize, { class: "empty-math-node" });
			}
		});
	},
	renderHTML({ HTMLAttributes, node }) {
		return [
			"div",
			mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, { class: "math-block-wrapper math-node" }),
			...htmlToDOMOutputSpec(this.options.convertLatexToMarkup(node.attrs.equation)),
			["div", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, { class: "math-block-caption" })]
		];
	},
	addNodeView() {
		return ReactNodeViewRenderer(MathBlockNodeView);
	},
	addCommands() {
		return {
			insertBlockMath: () => ({ state, chain, dispatch }) => {
				if (findTableGroup(state.selection) || findCodeBlockSelection(state.selection)) return false;
				if (dispatch) return chain().insertContent(`<figure data-math-group="true"><math-field/></figure>`).focus().maybeOpenEquationMenu().run();
				return true;
			},
			updateEquationCaption: (newCaption) => ({ commands, state, editor }) => {
				if (!isNodeSelection(state.selection)) return false;
				const mathTypes = getMathNodeTypes(editor.schema);
				const node = state.selection.node;
				if (mathTypes.block.name !== node.type.name) return false;
				commands.updateAttributes(this.type, { caption: newCaption });
				return true;
			}
		};
	}
});
//#endregion
//#region src/extensions/math/components/MathInlineNodeView/styles.tsx
const InlineMathView = styled(MathView)`
  display: inline-flex;
  align-items: center;
  padding-left: 5px;
  padding-right: 5px;

  --selection-background-color: transparent;
  cursor: pointer;
  &:hover,
  &.ProseMirror-selectednode {
    background: rgba(244, 245, 248, 0.5);
  }

  /* mathlive is not responsiveness, so we need to restrict the width */
  max-width: 710px;
  overflow: hidden;
`;
//#endregion
//#region src/extensions/math/components/MathInlineNodeView/MathInlineNodeView.tsx
const MathInlineNodeView = (props) => {
	const equation = props.node.attrs.equation;
	const readOnlyRef = useRef(null);
	useEffect(() => {
		readOnlyRef.current?.setValue(equation, { suppressChangeNotifications: true });
	}, [equation]);
	if (!props.editor.isEditable) return /* @__PURE__ */ jsx(NodeViewWrapper, {
		as: "span",
		children: /* @__PURE__ */ jsx(InlineMathView, {
			ref: readOnlyRef,
			defaultMode: "inline-math",
			readOnly: true,
			defaultValue: equation,
			plonkSound: void 0,
			keypressSound: void 0
		})
	});
	return /* @__PURE__ */ jsx(MathInlineNodeViewEditable, { ...props });
};
const MathInlineNodeViewEditable = (props) => {
	const { editor, getPos, node } = props;
	const equation = node.attrs.equation;
	const openMenu = useMathMenuOpenCallback({
		editor,
		getPos
	});
	const ref = useRef(null);
	useEffect(() => {
		ref.current?.setValue(equation, { suppressChangeNotifications: true });
	}, [equation]);
	return /* @__PURE__ */ jsx(NodeViewWrapper, {
		as: "span",
		children: /* @__PURE__ */ jsx(InlineMathView, {
			ref,
			defaultMode: "inline-math",
			readOnly: true,
			defaultValue: equation,
			onFocus: openMenu,
			plonkSound: void 0,
			keypressSound: void 0,
			"aria-label": "Press enter to edit"
		})
	});
};
//#endregion
//#region src/extensions/math/nodes/inline-math.ts
/**
* Inline level atomic math nodes to display equation
*/
const InlineMath = InlineMathBase.extend({
	onCreate() {
		const { type, editor } = this;
		const { storage } = editor;
		storage.placeholder?.placeholders?.set(this.name, {
			check: (_selection, node, _pos) => {
				if (node.type.name !== type.name) return false;
				if (node.attrs.equation === "") return true;
				return false;
			},
			decoration: (node, pos) => {
				return Decoration.node(pos, pos + node.nodeSize, { class: "empty-math-node" });
			}
		});
	},
	renderHTML({ HTMLAttributes, node }) {
		return [
			"span",
			mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, { class: "inline-math-node" }),
			...htmlToDOMOutputSpec(this.options.convertLatexToMarkup(node.attrs.equation))
		];
	},
	addNodeView() {
		return ReactNodeViewRenderer(MathInlineNodeView);
	},
	addCommands() {
		return { insertInlineMath: () => ({ state, chain, dispatch }) => {
			if (findCodeBlockSelection(state.selection)) return false;
			if (dispatch) return chain().insertContent(`<math-field/>`).focus().command(({ tr, dispatch }) => {
				const { selection, doc } = tr;
				dispatch?.(tr.setSelection(NodeSelection.create(doc, selection.from - 1)));
				return true;
			}).maybeOpenEquationMenu().run();
			return true;
		} };
	}
});
//#endregion
//#region src/extensions/math/math-extension.ts
const MathExtension = Extension.create({
	name: "math",
	addExtensions: () => [
		MathFigure,
		BlockMath.configure({ convertLatexToMarkup: (latex) => {
			return convertLatexToMarkup(latex, { mathstyle: "displaystyle" });
		} }),
		InlineMath.configure({ convertLatexToMarkup: (latex) => {
			return convertLatexToMarkup(latex, { mathstyle: "textstyle" });
		} })
	],
	addProseMirrorPlugins() {
		return [MathMenuPlugin({ editor: this.editor }), MathDeleteIndicatorPlugin()];
	},
	onBeforeCreate() {
		new MathfieldElement();
	},
	addKeyboardShortcuts() {
		return {
			Enter: () => this.editor.commands.maybeOpenEquationMenu(),
			Delete: () => this.editor.commands.deleteEquation()
		};
	},
	extendNodeSchema(extension) {
		return { mathRole: callOrReturn(getExtensionField(extension, "mathRole", {
			name: extension.name,
			options: extension.options,
			storage: extension.storage
		})) };
	},
	addCommands() {
		return {
			updateEquation: (newEquation) => ({ editor, state, chain }) => {
				if (!isNodeSelection(state.selection)) return false;
				const mathTypes = getMathNodeTypes(editor.schema);
				const node = state.selection.node;
				if (![mathTypes.inline.name, mathTypes.block.name].includes(node.type.name)) return false;
				return chain().updateAttributes(node.type, { equation: newEquation }).dismissMenu().focus().command(({ tr, dispatch }) => {
					const { selection } = tr;
					const { from } = selection;
					const nextSelection = Selection.findFrom(tr.doc.resolve(from + 1), 1, true);
					if (nextSelection) dispatch?.(tr.setSelection(nextSelection));
					return true;
				}).run();
			},
			setEquationMenuTarget: (target) => ({ tr, dispatch }) => {
				const payload = target ? {
					type: "triggerMenu",
					target
				} : { type: "dismissMenu" };
				dispatch?.(tr.setMeta(MathMenuPluginKey, payload));
				return true;
			},
			maybeOpenEquationMenu: () => ({ editor, state, commands }) => {
				const { selection } = state;
				const mathTypes = getMathNodeTypes(editor.schema);
				if (isNodeSelection(selection)) {
					const { node } = selection;
					if ([mathTypes.inline.name, mathTypes.block.name].includes(node.type.name)) {
						commands.setEquationMenuTarget({
							node,
							pos: selection.from
						});
						return true;
					}
				}
				return false;
			},
			predeleteHighlightEquation: (pos, show) => ({ tr, dispatch }) => {
				dispatch?.(tr.setMeta(MathDeleteIndicatorPluginKey, { highlight: show ? pos : -1 }));
				return true;
			},
			deleteEquation: (pos) => ({ editor, chain }) => {
				let chainedCommands = chain();
				const mathTypes = getMathNodeTypes(editor.schema);
				let nodePos;
				if (pos) {
					nodePos = pos;
					chainedCommands = chainedCommands.command(({ tr, dispatch }) => {
						const node = tr.doc.nodeAt(pos);
						if (!node) return false;
						if (node.type.name === mathTypes.block.name) {
							const nodeSelection = new NodeSelection(tr.doc.resolve(pos));
							dispatch?.(tr.setSelection(nodeSelection));
						}
						return true;
					});
				}
				return chainedCommands.command(({ tr, dispatch }) => {
					const { selection } = tr;
					if (!isNodeSelection(selection)) if (pos === void 0) return false;
					else {
						const node = tr.doc.nodeAt(pos);
						if (!node) return false;
						if ([mathTypes.figure.name, mathTypes.inline.name].includes(node.type.name)) {
							dispatch?.(tr.delete(pos, pos + node.nodeSize));
							return true;
						}
						return false;
					}
					if (selection.node.type.name === mathTypes.inline.name || selection.node.type.name === mathTypes.figure.name) dispatch?.(tr.delete(selection.from, selection.to));
					else {
						const mathRoot = findParentNode((node) => node.type.name === mathTypes.figure.name)(selection);
						nodePos = selection.from;
						if (mathRoot) dispatch?.(tr.delete(mathRoot.pos, mathRoot.pos + mathRoot.node.nodeSize));
					}
					return true;
				}).predeleteHighlightEquation(nodePos ?? 0, false).run();
			}
		};
	}
});
//#endregion
//#region src/extensions/math/components/MathEditor/icons/BracketedFractionIcon.tsx
const BracketedFractionIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "26",
		height: "29",
		viewBox: "0 0 26 29",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M5.99791 23.338C5.99791 23.446 5.88991 23.5 5.67391 23.5H5.43991C5.35591 23.428 5.18791 23.284 4.93591 23.068C2.77591 21.1 1.69591 18.244 1.69591 14.5C1.69591 13.036 1.86991 11.698 2.21791 10.486C2.76991 8.602 3.67591 7.084 4.93591 5.932C5.01991 5.86 5.11591 5.782 5.22391 5.698C5.33191 5.602 5.40391 5.536 5.43991 5.5H5.67391C5.81791 5.5 5.90791 5.518 5.94391 5.554C5.97991 5.59 5.99791 5.626 5.99791 5.662C5.99791 5.71 5.93191 5.8 5.79991 5.932C3.93991 7.9 3.00991 10.756 3.00991 14.5C3.00991 18.244 3.93991 21.1 5.79991 23.068C5.93191 23.2 5.99791 23.29 5.99791 23.338Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M9 3.33333C9 3.14924 9.14924 3 9.33333 3H16.6667C16.8508 3 17 3.14924 17 3.33333V10.6667C17 10.8508 16.8508 11 16.6667 11H9.33333C9.14924 11 9 10.8508 9 10.6667V3.33333Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M10 4V10H16V4H10ZM9.33333 3C9.14924 3 9 3.14924 9 3.33333V10.6667C9 10.8508 9.14924 11 9.33333 11H16.6667C16.8508 11 17 10.8508 17 10.6667V3.33333C17 3.14924 16.8508 3 16.6667 3H9.33333Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M8 13H18",
				stroke: "#3A517F",
				strokeWidth: "0.5"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M9 15.3333C9 15.1492 9.14924 15 9.33333 15H16.6667C16.8508 15 17 15.1492 17 15.3333V22.6667C17 22.8508 16.8508 23 16.6667 23H9.33333C9.14924 23 9 22.8508 9 22.6667V15.3333Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M10 16V22H16V16H10ZM9.33333 15C9.14924 15 9 15.1492 9 15.3333V22.6667C9 22.8508 9.14924 23 9.33333 23H16.6667C16.8508 23 17 22.8508 17 22.6667V15.3333C17 15.1492 16.8508 15 16.6667 15H9.33333Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M20.08 5.518L20.152 5.5C20.212 5.5 20.272 5.5 20.332 5.5H20.548C20.632 5.572 20.8 5.716 21.052 5.932C23.212 7.9 24.292 10.756 24.292 14.5C24.292 15.976 24.118 17.308 23.77 18.496C23.218 20.392 22.312 21.916 21.052 23.068C20.968 23.14 20.872 23.218 20.764 23.302C20.656 23.398 20.584 23.464 20.548 23.5H20.332C20.188 23.5 20.092 23.488 20.044 23.464C20.008 23.44 19.99 23.38 19.99 23.284C20.002 23.272 20.068 23.194 20.188 23.05C22.048 21.118 22.978 18.268 22.978 14.5C22.978 10.732 22.048 7.882 20.188 5.95C20.068 5.806 20.002 5.728 19.99 5.716C19.99 5.62 20.02 5.554 20.08 5.518Z",
				fill: "#3A517F"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/CeilingIcon.tsx
const CeilingIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "26",
		height: "29",
		viewBox: "0 0 26 29",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M3.13395 5.788C3.18195 5.644 3.27795 5.548 3.42195 5.5H5.36595C6.66195 5.5 7.33395 5.512 7.38195 5.536C7.51395 5.608 7.57995 5.716 7.57995 5.86C7.57995 6.004 7.51395 6.112 7.38195 6.184C7.33395 6.208 6.73395 6.22 5.58195 6.22H3.85395V23.23C3.76995 23.398 3.66195 23.488 3.52995 23.5C3.38595 23.5 3.25395 23.404 3.13395 23.212V5.788Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M9 10.8333C9 10.6492 9.14924 10.5 9.33333 10.5H16.6667C16.8508 10.5 17 10.6492 17 10.8333V18.1667C17 18.3508 16.8508 18.5 16.6667 18.5H9.33333C9.14924 18.5 9 18.3508 9 18.1667V10.8333Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M10 11.5V17.5H16V11.5H10ZM9.33333 10.5C9.14924 10.5 9 10.6492 9 10.8333V18.1667C9 18.3508 9.14924 18.5 9.33333 18.5H16.6667C16.8508 18.5 17 18.3508 17 18.1667V10.8333C17 10.6492 16.8508 10.5 16.6667 10.5H9.33333Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M22.842 23.23C22.758 23.398 22.65 23.488 22.518 23.5C22.374 23.5 22.242 23.404 22.122 23.212V6.22H20.394C19.242 6.22 18.648 6.208 18.612 6.184C18.468 6.112 18.396 5.998 18.396 5.842C18.396 5.71 18.468 5.608 18.612 5.536C18.648 5.512 19.326 5.5 20.646 5.5H22.608C22.728 5.596 22.806 5.686 22.842 5.77V23.23Z",
				fill: "#3A517F"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/CoproductIcon.tsx
const CoproductIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "30",
		height: "31",
		viewBox: "0 0 30 31",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M22 11.3333C22 11.1492 22.1492 11 22.3333 11H29.6667C29.8508 11 30 11.1492 30 11.3333V18.6667C30 18.8508 29.8508 19 29.6667 19H22.3333C22.1492 19 22 18.8508 22 18.6667V11.3333Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M23 12V18H29V12H23ZM22.3333 11C22.1492 11 22 11.1492 22 11.3333V18.6667C22 18.8508 22.1492 19 22.3333 19H29.6667C29.8508 19 30 18.8508 30 18.6667V11.3333C30 11.1492 29.8508 11 29.6667 11H22.3333Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M15.4666 21.98C15.5946 22.524 16.064 22.8173 16.8746 22.86H17.0986V23.5H3.77063V22.86H3.99463C4.74129 22.8173 5.19996 22.5667 5.37063 22.108L5.41863 21.98V9.004L5.37063 8.892C5.19996 8.43333 4.74129 8.18267 3.99463 8.14H3.77063V7.5H8.85863V8.14H8.63463C8.20796 8.16133 7.88263 8.24133 7.65863 8.38C7.44529 8.508 7.30129 8.716 7.22663 9.004L7.21063 15.932V22.86H13.6586V9.004L13.6106 8.892C13.44 8.43333 12.9813 8.18267 12.2346 8.14H12.0106V7.5H17.0986V8.14H16.8746C16.448 8.16133 16.1226 8.24133 15.8986 8.38C15.6853 8.508 15.5413 8.716 15.4666 9.004V21.98Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M20 6.5H22V8.5H20V6.5Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M19 5.5H23V9.5H19V5.5ZM20 6.5V8.5H22V6.5H20Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M20 21.5H22V23.5H20V21.5Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M19 20.5H23V24.5H19V20.5ZM20 21.5V23.5H22V21.5H20Z",
				fill: "#7070A9"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/CurlyBracketIcon.tsx
const CurlyBracketIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "28",
		height: "29",
		viewBox: "0 0 28 29",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M7.812 23.158C7.812 23.314 7.776 23.428 7.704 23.5H7.38C6.468 23.5 5.682 23.344 5.022 23.032C4.374 22.732 3.972 22.258 3.816 21.61C3.792 21.526 3.774 20.656 3.762 19C3.762 18.748 3.762 18.43 3.762 18.046C3.75 16.978 3.72 16.378 3.672 16.246C3.66 16.234 3.654 16.222 3.654 16.21C3.51 15.838 3.234 15.52 2.826 15.256C2.418 14.98 1.968 14.842 1.476 14.842C1.344 14.842 1.26 14.824 1.224 14.788C1.188 14.752 1.17 14.656 1.17 14.5C1.17 14.344 1.188 14.248 1.224 14.212C1.26 14.176 1.344 14.158 1.476 14.158C1.968 14.158 2.418 14.026 2.826 13.762C3.234 13.486 3.51 13.162 3.654 12.79C3.702 12.646 3.726 12.496 3.726 12.34C3.738 12.184 3.75 11.398 3.762 9.982C3.774 8.338 3.792 7.474 3.816 7.39C3.912 7.006 4.104 6.688 4.392 6.436C4.92 5.908 5.718 5.602 6.786 5.518C6.81 5.518 6.888 5.518 7.02 5.518C7.164 5.506 7.272 5.5 7.344 5.5H7.704C7.776 5.572 7.812 5.68 7.812 5.824C7.812 5.98 7.794 6.076 7.758 6.112C7.734 6.148 7.638 6.166 7.47 6.166C6.798 6.202 6.24 6.394 5.796 6.742C5.556 6.922 5.4 7.126 5.328 7.354C5.268 7.51 5.238 8.398 5.238 10.018C5.238 11.578 5.232 12.394 5.22 12.466C5.1 13.402 4.38 14.08 3.06 14.5C4.392 14.956 5.112 15.634 5.22 16.534C5.232 16.606 5.238 17.422 5.238 18.982C5.238 20.602 5.268 21.49 5.328 21.646C5.448 21.982 5.712 22.258 6.12 22.474C6.528 22.69 6.978 22.81 7.47 22.834C7.638 22.834 7.734 22.852 7.758 22.888C7.794 22.924 7.812 23.014 7.812 23.158Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M10 10.8333C10 10.6492 10.1492 10.5 10.3333 10.5H17.6667C17.8508 10.5 18 10.6492 18 10.8333V18.1667C18 18.3508 17.8508 18.5 17.6667 18.5H10.3333C10.1492 18.5 10 18.3508 10 18.1667V10.8333Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M11 11.5V17.5H17V11.5H11ZM10.3333 10.5C10.1492 10.5 10 10.6492 10 10.8333V18.1667C10 18.3508 10.1492 18.5 10.3333 18.5H17.6667C17.8508 18.5 18 18.3508 18 18.1667V10.8333C18 10.6492 17.8508 10.5 17.6667 10.5H10.3333Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M20.17 5.842C20.17 5.686 20.182 5.59 20.206 5.554C20.23 5.518 20.302 5.5 20.422 5.5H20.584C21.544 5.5 22.342 5.662 22.978 5.986C23.614 6.31 24.016 6.778 24.184 7.39C24.22 7.498 24.238 8.368 24.238 10C24.25 11.62 24.262 12.478 24.274 12.574C24.394 13.006 24.664 13.378 25.084 13.69C25.504 14.002 25.978 14.158 26.506 14.158C26.638 14.158 26.722 14.176 26.758 14.212C26.794 14.248 26.812 14.344 26.812 14.5C26.812 14.656 26.794 14.752 26.758 14.788C26.722 14.824 26.638 14.842 26.506 14.842C26.038 14.842 25.594 14.974 25.174 15.238C24.766 15.502 24.496 15.814 24.364 16.174C24.304 16.33 24.268 16.492 24.256 16.66C24.256 16.816 24.25 17.596 24.238 19C24.226 20.656 24.208 21.526 24.184 21.61C24.088 21.994 23.896 22.312 23.608 22.564C22.96 23.188 21.958 23.5 20.602 23.5H20.404C20.308 23.5 20.242 23.476 20.206 23.428C20.182 23.392 20.17 23.296 20.17 23.14C20.17 23.008 20.182 22.924 20.206 22.888C20.23 22.852 20.29 22.834 20.386 22.834C20.974 22.834 21.478 22.708 21.898 22.456C22.33 22.204 22.606 21.886 22.726 21.502C22.738 21.442 22.75 20.59 22.762 18.946L22.78 16.498C22.996 15.502 23.716 14.836 24.94 14.5C24.544 14.368 24.244 14.248 24.04 14.14C23.38 13.744 22.972 13.252 22.816 12.664L22.78 12.484L22.762 10.036C22.75 8.404 22.738 7.552 22.726 7.48C22.606 7.096 22.33 6.784 21.898 6.544C21.478 6.292 20.974 6.166 20.386 6.166C20.29 6.166 20.23 6.148 20.206 6.112C20.182 6.076 20.17 5.986 20.17 5.842Z",
				fill: "#3A517F"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/DDotIcon.tsx
const DDotIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "30",
		height: "28",
		viewBox: "0 0 30 28",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M16.6212 7.58342C16.3092 7.58342 16.0452 7.47542 15.8292 7.25942C15.6252 7.04342 15.5232 6.79142 15.5232 6.50342C15.5232 6.23942 15.6012 6.01142 15.7572 5.81942C15.9252 5.62742 16.1292 5.50142 16.3692 5.44142C16.5252 5.39342 16.6872 5.39342 16.8552 5.44142C17.0952 5.48942 17.2932 5.61542 17.4492 5.81942C17.6172 6.02342 17.7012 6.24542 17.7012 6.48542C17.7012 6.79742 17.5932 7.06142 17.3772 7.27742C17.1612 7.48142 16.9092 7.58342 16.6212 7.58342Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M13.3731 7.58342C13.0611 7.58342 12.7971 7.47542 12.5811 7.25942C12.3771 7.04342 12.2751 6.79142 12.2751 6.50342C12.2751 6.23942 12.3531 6.01142 12.5091 5.81942C12.6771 5.62742 12.8811 5.50142 13.1211 5.44142C13.2771 5.39342 13.4391 5.39342 13.6071 5.44142C13.8471 5.48942 14.0451 5.61542 14.2011 5.81942C14.3691 6.02342 14.4531 6.24542 14.4531 6.48542C14.4531 6.79742 14.3451 7.06142 14.1291 7.27742C13.9131 7.48142 13.6611 7.58342 13.3731 7.58342Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M9 10.4971C9 10.2209 9.22386 9.99707 9.5 9.99707H20.5C20.7761 9.99707 21 10.2209 21 10.4971V21.4971C21 21.7732 20.7761 21.9971 20.5 21.9971H9.5C9.22386 21.9971 9 21.7732 9 21.4971V10.4971Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M10 10.9971V20.9971H20V10.9971H10ZM9.5 9.99707C9.22386 9.99707 9 10.2209 9 10.4971V21.4971C9 21.7732 9.22386 21.9971 9.5 21.9971H20.5C20.7761 21.9971 21 21.7732 21 21.4971V10.4971C21 10.2209 20.7761 9.99707 20.5 9.99707H9.5Z",
				fill: "#7070A9"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/DerivativeIcon.tsx
const DerivativeIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "17",
		height: "29",
		viewBox: "0 0 17 29",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M3.86221 4.804C3.89421 4.804 4.20621 4.784 4.79821 4.744C5.39021 4.696 5.69421 4.672 5.71021 4.672H5.74621V8.32C5.74621 10.768 5.75021 12.004 5.75821 12.028C5.78221 12.188 5.83821 12.296 5.92621 12.352C6.02221 12.4 6.20221 12.432 6.46621 12.448H6.68221V13C6.66621 13 6.35821 13.02 5.75821 13.06C5.16621 13.1 4.85421 13.124 4.82221 13.132H4.73821V12.472L4.64221 12.556C4.18621 12.94 3.66621 13.132 3.08221 13.132C2.52221 13.132 2.02621 12.944 1.59421 12.568C1.09821 12.128 0.794207 11.552 0.682207 10.84C0.674207 10.776 0.670207 10.636 0.670207 10.42C0.670207 9.644 0.918207 8.996 1.41421 8.476C1.91021 7.956 2.50221 7.696 3.19021 7.696C3.78221 7.696 4.31021 7.892 4.77421 8.284V7.06C4.77421 6.228 4.77021 5.796 4.76221 5.764C4.73821 5.612 4.67821 5.512 4.58221 5.464C4.49421 5.408 4.31821 5.372 4.05421 5.356H3.83821V5.08C3.83821 4.896 3.84621 4.804 3.86221 4.804ZM4.73821 8.896C4.37821 8.392 3.92621 8.14 3.38221 8.14C2.99021 8.14 2.64221 8.284 2.33821 8.572C2.13821 8.78 2.00221 9.024 1.93021 9.304C1.86621 9.584 1.83421 9.972 1.83421 10.468C1.83421 11.356 2.00221 11.964 2.33821 12.292C2.58621 12.556 2.89821 12.688 3.27421 12.688C3.55421 12.688 3.82221 12.612 4.07821 12.46C4.33421 12.308 4.53821 12.1 4.69021 11.836L4.73821 11.764V8.896Z",
				fill: "#0F172E"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M8.09619 5.33333C8.09619 5.14924 8.24543 5 8.42952 5H15.7629C15.947 5 16.0962 5.14924 16.0962 5.33333V12.6667C16.0962 12.8508 15.947 13 15.7629 13H8.42952C8.24543 13 8.09619 12.8508 8.09619 12.6667V5.33333Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M9.09619 6V12H15.0962V6H9.09619ZM8.42952 5C8.24543 5 8.09619 5.14924 8.09619 5.33333V12.6667C8.09619 12.8508 8.24543 13 8.42952 13H15.7629C15.947 13 16.0962 12.8508 16.0962 12.6667V5.33333C16.0962 5.14924 15.947 5 15.7629 5H8.42952Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M0.0961914 16H16.0962",
				stroke: "#3A517F",
				strokeWidth: "0.5"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M8.76241 22.664C8.71441 22.616 8.69041 22.572 8.69041 22.532C8.72241 22.316 8.84641 22.04 9.06241 21.704C9.43841 21.136 9.91041 20.808 10.4784 20.72C10.5904 20.704 10.6744 20.696 10.7304 20.696C11.0104 20.696 11.2664 20.768 11.4984 20.912C11.7384 21.056 11.9104 21.236 12.0144 21.452C12.1184 21.316 12.1824 21.232 12.2064 21.2C12.5024 20.864 12.8424 20.696 13.2264 20.696C13.5544 20.696 13.8184 20.792 14.0184 20.984C14.2264 21.168 14.3304 21.396 14.3304 21.668C14.3304 21.916 14.2584 22.124 14.1144 22.292C13.9784 22.46 13.7944 22.544 13.5624 22.544C13.4104 22.544 13.2864 22.5 13.1904 22.412C13.0944 22.324 13.0464 22.208 13.0464 22.064C13.0464 21.696 13.2464 21.444 13.6464 21.308C13.6464 21.3 13.6024 21.272 13.5144 21.224C13.4344 21.176 13.3184 21.152 13.1664 21.152C13.0624 21.152 12.9864 21.16 12.9384 21.176C12.6344 21.304 12.4104 21.568 12.2664 21.968C12.2424 22.032 12.1264 22.48 11.9184 23.312C11.7104 24.136 11.5984 24.6 11.5824 24.704C11.5584 24.824 11.5464 24.944 11.5464 25.064C11.5464 25.256 11.6024 25.408 11.7144 25.52C11.8264 25.632 11.9744 25.688 12.1584 25.688C12.4944 25.688 12.7984 25.548 13.0704 25.268C13.3424 24.98 13.5264 24.664 13.6224 24.32C13.6464 24.24 13.6704 24.196 13.6944 24.188C13.7184 24.172 13.7824 24.164 13.8864 24.164C14.0384 24.164 14.1144 24.196 14.1144 24.26C14.1144 24.268 14.1064 24.312 14.0904 24.392C13.9544 24.888 13.6744 25.32 13.2504 25.688C12.8744 25.984 12.4784 26.132 12.0624 26.132C11.5024 26.132 11.0784 25.88 10.7904 25.376C10.5584 25.736 10.2624 25.976 9.90241 26.096C9.83041 26.112 9.72641 26.12 9.59041 26.12C9.12641 26.12 8.79841 25.956 8.60641 25.628C8.52641 25.492 8.48641 25.332 8.48641 25.148C8.48641 24.908 8.55841 24.704 8.70241 24.536C8.84641 24.368 9.03041 24.284 9.25441 24.284C9.59841 24.284 9.77041 24.452 9.77041 24.788C9.77041 25.084 9.63041 25.3 9.35041 25.436C9.33441 25.444 9.31441 25.456 9.29041 25.472C9.26641 25.48 9.24641 25.488 9.23041 25.496C9.21441 25.504 9.20241 25.508 9.19441 25.508L9.15841 25.52C9.15841 25.544 9.21841 25.58 9.33841 25.628C9.43441 25.668 9.53841 25.688 9.65041 25.688C9.93841 25.688 10.1864 25.508 10.3944 25.148C10.4824 25.004 10.6384 24.484 10.8624 23.588C10.9104 23.404 10.9624 23.2 11.0184 22.976C11.0744 22.752 11.1144 22.58 11.1384 22.46C11.1704 22.34 11.1904 22.268 11.1984 22.244C11.2384 22.028 11.2584 21.872 11.2584 21.776C11.2584 21.584 11.2064 21.432 11.1024 21.32C10.9984 21.208 10.8544 21.152 10.6704 21.152C10.3104 21.152 9.99841 21.292 9.73441 21.572C9.47041 21.844 9.28641 22.16 9.18241 22.52C9.16641 22.592 9.14641 22.636 9.12241 22.652C9.10641 22.66 9.04241 22.664 8.93041 22.664H8.76241Z",
				fill: "#0F172E"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M4.76602 17.804C4.79802 17.804 5.11002 17.784 5.70202 17.744C6.29402 17.696 6.59802 17.672 6.61402 17.672H6.65002V21.32C6.65002 23.768 6.65402 25.004 6.66202 25.028C6.68602 25.188 6.74202 25.296 6.83002 25.352C6.92602 25.4 7.10602 25.432 7.37002 25.448H7.58602V26C7.57002 26 7.26202 26.02 6.66202 26.06C6.07002 26.1 5.75802 26.124 5.72602 26.132H5.64202V25.472L5.54602 25.556C5.09002 25.94 4.57002 26.132 3.98602 26.132C3.42602 26.132 2.93002 25.944 2.49802 25.568C2.00202 25.128 1.69802 24.552 1.58602 23.84C1.57802 23.776 1.57402 23.636 1.57402 23.42C1.57402 22.644 1.82202 21.996 2.31802 21.476C2.81402 20.956 3.40602 20.696 4.09402 20.696C4.68602 20.696 5.21402 20.892 5.67802 21.284V20.06C5.67802 19.228 5.67402 18.796 5.66602 18.764C5.64202 18.612 5.58202 18.512 5.48602 18.464C5.39802 18.408 5.22202 18.372 4.95802 18.356H4.74202V18.08C4.74202 17.896 4.75002 17.804 4.76602 17.804ZM5.64202 21.896C5.28202 21.392 4.83002 21.14 4.28602 21.14C3.89402 21.14 3.54602 21.284 3.24202 21.572C3.04202 21.78 2.90602 22.024 2.83402 22.304C2.77002 22.584 2.73802 22.972 2.73802 23.468C2.73802 24.356 2.90602 24.964 3.24202 25.292C3.49002 25.556 3.80202 25.688 4.17802 25.688C4.45802 25.688 4.72602 25.612 4.98202 25.46C5.23802 25.308 5.44202 25.1 5.59402 24.836L5.64202 24.764V21.896Z",
				fill: "#0F172E"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/DotIcon.tsx
const DotIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "28",
		height: "28",
		viewBox: "0 0 28 28",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M14.7408 7.58342C14.4288 7.58342 14.1648 7.47542 13.9488 7.25942C13.7448 7.04342 13.6428 6.79142 13.6428 6.50342C13.6428 6.23942 13.7208 6.01142 13.8768 5.81942C14.0448 5.62742 14.2488 5.50142 14.4888 5.44142C14.6448 5.39342 14.8068 5.39342 14.9748 5.44142C15.2148 5.48942 15.4128 5.61542 15.5688 5.81942C15.7368 6.02342 15.8208 6.24542 15.8208 6.48542C15.8208 6.79742 15.7128 7.06142 15.4968 7.27742C15.2808 7.48142 15.0288 7.58342 14.7408 7.58342Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M8 10.4971C8 10.2209 8.22386 9.99707 8.5 9.99707H19.5C19.7761 9.99707 20 10.2209 20 10.4971V21.4971C20 21.7732 19.7761 21.9971 19.5 21.9971H8.5C8.22386 21.9971 8 21.7732 8 21.4971V10.4971Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M9 10.9971V20.9971H19V10.9971H9ZM8.5 9.99707C8.22386 9.99707 8 10.2209 8 10.4971V21.4971C8 21.7732 8.22386 21.9971 8.5 21.9971H19.5C19.7761 21.9971 20 21.7732 20 21.4971V10.4971C20 10.2209 19.7761 9.99707 19.5 9.99707H8.5Z",
				fill: "#7070A9"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/DoubleIntegralIcon.tsx
const DoubleIntegralIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "30",
		height: "31",
		viewBox: "0 0 30 31",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M22 11.3333C22 11.1492 22.1492 11 22.3333 11H29.6667C29.8508 11 30 11.1492 30 11.3333V18.6667C30 18.8508 29.8508 19 29.6667 19H22.3333C22.1492 19 22 18.8508 22 18.6667V11.3333Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M23 12V18H29V12H23ZM22.3333 11C22.1492 11 22 11.1492 22 11.3333V18.6667C22 18.8508 22.1492 19 22.3333 19H29.6667C29.8508 19 30 18.8508 30 18.6667V11.3333C30 11.1492 29.8508 11 29.6667 11H22.3333Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M5.99463 22.06C6.14396 21.9107 6.33063 21.836 6.55463 21.836C6.77863 21.836 6.96529 21.9107 7.11463 22.06C7.26396 22.22 7.33863 22.4067 7.33863 22.62C7.33863 22.94 7.21063 23.164 6.95463 23.292C6.94396 23.3027 6.91729 23.3133 6.87463 23.324C6.83196 23.3453 6.78929 23.3613 6.74663 23.372L6.69863 23.404C6.69863 23.4147 6.72529 23.4467 6.77863 23.5C6.84263 23.5533 6.89596 23.5907 6.93863 23.612C7.10929 23.74 7.31729 23.804 7.56263 23.804C7.76529 23.804 7.93596 23.756 8.07463 23.66C8.33063 23.5107 8.52263 23.2333 8.65063 22.828C8.83196 22.316 9.00263 20.956 9.16263 18.748C9.31196 16.7213 9.47196 15.0147 9.64263 13.628C9.91996 11.4627 10.08 10.268 10.1226 10.044C10.3893 8.508 10.9066 7.48933 11.6746 6.988C11.9413 6.81733 12.2346 6.7 12.5546 6.636C12.576 6.636 12.624 6.636 12.6986 6.636C12.784 6.62533 12.8533 6.62 12.9066 6.62C13.408 6.652 13.824 6.828 14.1546 7.148C14.4853 7.468 14.6506 7.87867 14.6506 8.38C14.6506 8.61467 14.576 8.80667 14.4266 8.956C14.2773 9.10533 14.0906 9.18 13.8666 9.18C13.6426 9.18 13.456 9.10533 13.3066 8.956C13.1573 8.796 13.0826 8.60933 13.0826 8.396C13.0826 8.076 13.2106 7.852 13.4666 7.724C13.4773 7.71333 13.504 7.70267 13.5466 7.692C13.5893 7.67067 13.6266 7.64933 13.6586 7.628L13.7226 7.612C13.7226 7.55867 13.6426 7.48933 13.4826 7.404C13.3013 7.276 13.0933 7.212 12.8586 7.212C12.3893 7.212 12.048 7.48933 11.8346 8.044C11.7066 8.35333 11.6053 8.78 11.5306 9.324C11.4666 9.85733 11.3813 10.8387 11.2746 12.268C11.1253 14.2733 10.9653 15.9747 10.7946 17.372C10.5813 19.2067 10.4213 20.4013 10.3146 20.956C10.0053 22.6627 9.39729 23.74 8.49063 24.188C8.21329 24.3267 7.91463 24.396 7.59463 24.396C6.82663 24.396 6.28263 24.0653 5.96263 23.404C5.83463 23.18 5.77063 22.924 5.77063 22.636C5.77063 22.4013 5.84529 22.2093 5.99463 22.06ZM11.5466 22.06C11.696 21.9107 11.8826 21.836 12.1066 21.836C12.3306 21.836 12.5173 21.9107 12.6666 22.06C12.816 22.22 12.8906 22.4067 12.8906 22.62C12.8906 22.94 12.7626 23.164 12.5066 23.292C12.496 23.3027 12.4693 23.3133 12.4266 23.324C12.384 23.3453 12.3466 23.3613 12.3146 23.372L12.2506 23.404C12.2506 23.4147 12.2773 23.4467 12.3306 23.5C12.3946 23.5533 12.448 23.5907 12.4906 23.612C12.6613 23.74 12.8693 23.804 13.1146 23.804C13.3066 23.804 13.4773 23.756 13.6266 23.66C13.8826 23.5107 14.0746 23.2333 14.2026 22.828C14.384 22.316 14.5546 20.956 14.7146 18.748C14.864 16.7213 15.024 15.0147 15.1946 13.628C15.472 11.4627 15.632 10.268 15.6746 10.044C15.9413 8.508 16.4586 7.48933 17.2266 6.988C17.4933 6.81733 17.7866 6.7 18.1066 6.636C18.128 6.636 18.176 6.636 18.2506 6.636C18.336 6.62533 18.4053 6.62 18.4586 6.62C18.96 6.652 19.376 6.828 19.7066 7.148C20.0373 7.468 20.2026 7.87867 20.2026 8.38C20.2026 8.61467 20.128 8.80667 19.9786 8.956C19.8293 9.10533 19.6426 9.18 19.4186 9.18C19.1946 9.18 19.008 9.10533 18.8586 8.956C18.7093 8.796 18.6346 8.60933 18.6346 8.396C18.6346 8.076 18.7626 7.852 19.0186 7.724C19.0293 7.71333 19.056 7.70267 19.0986 7.692C19.1413 7.67067 19.184 7.64933 19.2266 7.628L19.2746 7.612C19.2746 7.55867 19.1946 7.48933 19.0346 7.404C18.864 7.276 18.656 7.212 18.4106 7.212C17.9413 7.212 17.6 7.48933 17.3866 8.044C17.2586 8.35333 17.1573 8.78 17.0826 9.324C17.0186 9.85733 16.9333 10.8387 16.8266 12.268C16.6773 14.2733 16.5173 15.9747 16.3466 17.372C16.1333 19.2067 15.9733 20.4013 15.8666 20.956C15.5573 22.6627 14.9493 23.74 14.0426 24.188C13.7653 24.3267 13.4666 24.396 13.1466 24.396C12.3786 24.396 11.8346 24.0653 11.5146 23.404C11.3866 23.18 11.3226 22.924 11.3226 22.636C11.3226 22.4013 11.3973 22.2093 11.5466 22.06Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M20 6.5H22V8.5H20V6.5Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M19 5.5H23V9.5H19V5.5ZM20 6.5V8.5H22V6.5H20Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M20 21.5H22V23.5H20V21.5Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M19 20.5H23V24.5H19V20.5ZM20 21.5V23.5H22V21.5H20Z",
				fill: "#7070A9"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/ExponentialIcon.tsx
const ExponentialIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "26",
		height: "24",
		viewBox: "0 0 26 24",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M8.44153 10.722C8.98753 10.3233 9.65053 10.124 10.4305 10.124C10.7945 10.124 11.0112 10.1283 11.0805 10.137C11.7999 10.241 12.3502 10.5227 12.7315 10.982C13.1215 11.4413 13.3165 12.061 13.3165 12.841C13.3165 12.9883 13.2732 13.088 13.1865 13.14C13.1519 13.1573 12.4715 13.166 11.1455 13.166H9.16953V13.283C9.16953 13.959 9.30386 14.4617 9.57253 14.791C9.8412 15.1117 10.2745 15.298 10.8725 15.35C10.9245 15.3587 10.9982 15.363 11.0935 15.363C11.4142 15.363 11.7002 15.2807 11.9515 15.116C12.2115 14.9513 12.3935 14.7303 12.4975 14.453C12.5409 14.3577 12.5842 14.3013 12.6275 14.284C12.6709 14.258 12.7662 14.245 12.9135 14.245C13.1822 14.245 13.3165 14.3143 13.3165 14.453C13.3165 14.4963 13.3122 14.5267 13.3035 14.544C13.1649 15.0033 12.8702 15.3673 12.4195 15.636C11.8995 15.9307 11.3232 16.078 10.6905 16.078C9.75453 16.078 8.99186 15.8527 8.40253 15.402C7.82186 14.9427 7.46653 14.3187 7.33653 13.53C7.3192 13.3913 7.31053 13.2397 7.31053 13.075C7.31053 12.061 7.68753 11.2767 8.44153 10.722ZM11.8735 12.412C11.7782 11.32 11.3319 10.774 10.5345 10.774C10.3005 10.774 10.0795 10.8303 9.87153 10.943C9.6722 11.047 9.52486 11.1857 9.42953 11.359C9.29086 11.5843 9.20853 11.9223 9.18253 12.373V12.542H11.8735V12.412Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M15.25 6.05C15.25 6.02239 15.2724 6 15.3 6H19.2C19.2276 6 19.25 6.02239 19.25 6.05V9.95C19.25 9.97761 19.2276 10 19.2 10H15.3C15.2724 10 15.25 9.97761 15.25 9.95V6.05Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M15.3 5H19.2C19.7799 5 20.25 5.4701 20.25 6.05V9.95C20.25 10.5299 19.7799 11 19.2 11H15.3C14.7201 11 14.25 10.5299 14.25 9.95V6.05C14.25 5.4701 14.7201 5 15.3 5ZM15.3 6C15.2724 6 15.25 6.02239 15.25 6.05V9.95C15.25 9.97761 15.2724 10 15.3 10H19.2C19.2276 10 19.25 9.97761 19.25 9.95V6.05C19.25 6.02239 19.2276 6 19.2 6H15.3Z",
				fill: "#7070A9"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/FloorIcon.tsx
const FloorIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "26",
		height: "29",
		viewBox: "0 0 26 29",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M3.42195 23.5C3.27795 23.452 3.18195 23.356 3.13395 23.212V5.788C3.25395 5.596 3.38595 5.5 3.52995 5.5C3.66195 5.512 3.76995 5.602 3.85395 5.77V22.78H5.58195C6.73395 22.78 7.33395 22.792 7.38195 22.816C7.51395 22.888 7.57995 22.996 7.57995 23.14C7.57995 23.284 7.51395 23.392 7.38195 23.464C7.33395 23.488 6.66195 23.5 5.36595 23.5H3.42195Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M9 10.8333C9 10.6492 9.14924 10.5 9.33333 10.5H16.6667C16.8508 10.5 17 10.6492 17 10.8333V18.1667C17 18.3508 16.8508 18.5 16.6667 18.5H9.33333C9.14924 18.5 9 18.3508 9 18.1667V10.8333Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M10 11.5V17.5H16V11.5H10ZM9.33333 10.5C9.14924 10.5 9 10.6492 9 10.8333V18.1667C9 18.3508 9.14924 18.5 9.33333 18.5H16.6667C16.8508 18.5 17 18.3508 17 18.1667V10.8333C17 10.6492 16.8508 10.5 16.6667 10.5H9.33333Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M22.518 5.5C22.65 5.512 22.758 5.602 22.842 5.77V23.23C22.818 23.29 22.74 23.374 22.608 23.482L20.646 23.5C19.59 23.5 18.978 23.494 18.81 23.482C18.654 23.482 18.546 23.452 18.486 23.392C18.426 23.332 18.396 23.254 18.396 23.158C18.396 23.002 18.468 22.888 18.612 22.816C18.648 22.792 19.242 22.78 20.394 22.78H22.122V5.788C22.242 5.596 22.374 5.5 22.518 5.5Z",
				fill: "#3A517F"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/FractionIcon.tsx
const FractionIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "26",
		height: "29",
		viewBox: "0 0 26 29",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M9 3.33333C9 3.14924 9.14924 3 9.33333 3H16.6667C16.8508 3 17 3.14924 17 3.33333V10.6667C17 10.8508 16.8508 11 16.6667 11H9.33333C9.14924 11 9 10.8508 9 10.6667V3.33333Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M10 4V10H16V4H10ZM9.33333 3C9.14924 3 9 3.14924 9 3.33333V10.6667C9 10.8508 9.14924 11 9.33333 11H16.6667C16.8508 11 17 10.8508 17 10.6667V3.33333C17 3.14924 16.8508 3 16.6667 3H9.33333Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M8 13H18",
				stroke: "#3A517F",
				strokeWidth: "0.5"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M9 15.3333C9 15.1492 9.14924 15 9.33333 15H16.6667C16.8508 15 17 15.1492 17 15.3333V22.6667C17 22.8508 16.8508 23 16.6667 23H9.33333C9.14924 23 9 22.8508 9 22.6667V15.3333Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M10 16V22H16V16H10ZM9.33333 15C9.14924 15 9 15.1492 9 15.3333V22.6667C9 22.8508 9.14924 23 9.33333 23H16.6667C16.8508 23 17 22.8508 17 22.6667V15.3333C17 15.1492 16.8508 15 16.6667 15H9.33333Z",
				fill: "#7070A9"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/HatIcon.tsx
const HatIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "18",
		height: "22",
		viewBox: "0 0 18 22",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M6.36319 5.09148L6.36319 5.09147L6.3627 5.09211C6.3498 5.10889 6.34479 5.12724 6.34244 5.13947C6.33988 5.15279 6.33906 5.1667 6.33906 5.17999C6.33906 5.25466 6.37672 5.3137 6.43799 5.35357C6.50198 5.3952 6.57947 5.41315 6.66528 5.41315C6.74493 5.41315 6.8173 5.39727 6.87636 5.35884C6.8902 5.34984 6.90547 5.33452 6.91791 5.32157C6.93253 5.30635 6.95092 5.28608 6.97285 5.26111L6.97288 5.26114L6.9745 5.25917C7.01852 5.20546 7.09474 5.10804 7.20261 4.96769C7.31592 4.82376 7.44268 4.66233 7.58289 4.48339C7.72905 4.30377 7.93714 4.04355 8.20705 3.70287C8.45925 3.38456 8.72323 3.05245 8.99899 2.70654C9.68039 3.56609 10.1971 4.21597 10.5492 4.65611C10.7302 4.88242 10.8678 5.05342 10.9619 5.169C11.0089 5.22676 11.0452 5.27092 11.0708 5.30131C11.0835 5.31645 11.0938 5.32856 11.1017 5.33735C11.1055 5.3417 11.1092 5.34574 11.1125 5.34911L11.1127 5.34935C11.1143 5.35102 11.1213 5.35844 11.1301 5.36411L11.1299 5.36441L11.1363 5.36778C11.1997 5.40074 11.2655 5.41843 11.333 5.41843C11.4665 5.41843 11.584 5.38061 11.6355 5.27082C11.6611 5.22027 11.6771 5.15472 11.6388 5.09655L11.639 5.09641L11.6352 5.0916C10.8599 4.10038 10.2723 3.35285 9.87233 2.84913C9.67238 2.59731 9.51916 2.40619 9.41281 2.27596C9.35967 2.21089 9.31794 2.16066 9.2878 2.12553C9.27278 2.10803 9.26021 2.09377 9.25034 2.08313C9.24543 2.07784 9.24071 2.07293 9.2364 2.06875C9.23322 2.06567 9.22648 2.05921 9.21835 2.05392C9.16638 2.02011 9.09892 2.00232 9.02284 1.99471L9.02288 1.99434H9.01537C8.92535 1.99434 8.84471 2.01181 8.77998 2.05392L8.77998 2.05392C8.77347 2.05815 8.7688 2.06272 8.76808 2.06344L8.768 2.06351L8.76406 2.06753L8.75805 2.07423L8.74222 2.09294C8.72925 2.10852 8.71069 2.1312 8.68667 2.16081C8.63856 2.2201 8.56786 2.30802 8.47464 2.42448C8.28817 2.65744 8.01123 3.00506 7.64385 3.46728L7.64368 3.46749C6.91437 4.39186 6.48751 4.93323 6.36319 5.09148Z",
				fill: "#3A517F",
				stroke: "#3A517F",
				strokeWidth: "0.15"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M3 7.49707C3 7.22093 3.22386 6.99707 3.5 6.99707H14.5C14.7761 6.99707 15 7.22093 15 7.49707V18.4971C15 18.7732 14.7761 18.9971 14.5 18.9971H3.5C3.22386 18.9971 3 18.7732 3 18.4971V7.49707Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M4 7.99707V17.9971H14V7.99707H4ZM3.5 6.99707C3.22386 6.99707 3 7.22093 3 7.49707V18.4971C3 18.7732 3.22386 18.9971 3.5 18.9971H14.5C14.7761 18.9971 15 18.7732 15 18.4971V7.49707C15 7.22093 14.7761 6.99707 14.5 6.99707H3.5Z",
				fill: "#7070A9"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/IntegralIcon.tsx
const IntegralIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "24",
		height: "22",
		viewBox: "0 0 24 22",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M15 7.33333C15 7.14924 15.1492 7 15.3333 7H22.6667C22.8508 7 23 7.14924 23 7.33333V14.6667C23 14.8508 22.8508 15 22.6667 15H15.3333C15.1492 15 15 14.8508 15 14.6667V7.33333Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M16 8V14H22V8H16ZM15.3333 7C15.1492 7 15 7.14924 15 7.33333V14.6667C15 14.8508 15.1492 15 15.3333 15H22.6667C22.8508 15 23 14.8508 23 14.6667V7.33333C23 7.14924 22.8508 7 22.6667 7H15.3333Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M1.85713 18.06C2.00646 17.9107 2.19313 17.836 2.41713 17.836C2.64113 17.836 2.82779 17.9107 2.97713 18.06C3.12646 18.22 3.20113 18.4067 3.20113 18.62C3.20113 18.94 3.07313 19.164 2.81713 19.292C2.80646 19.3027 2.77979 19.3133 2.73713 19.324C2.69446 19.3453 2.65179 19.3613 2.60913 19.372L2.56113 19.404C2.56113 19.4147 2.58779 19.4467 2.64113 19.5C2.70513 19.5533 2.75846 19.5907 2.80113 19.612C2.97179 19.74 3.17979 19.804 3.42513 19.804C3.62779 19.804 3.79846 19.756 3.93713 19.66C4.19313 19.5107 4.38513 19.2333 4.51313 18.828C4.69446 18.316 4.86513 16.956 5.02513 14.748C5.17446 12.7213 5.33446 11.0147 5.50513 9.628C5.78246 7.46267 5.94246 6.268 5.98513 6.044C6.25179 4.508 6.76913 3.48933 7.53713 2.988C7.80379 2.81733 8.09713 2.7 8.41713 2.636C8.43846 2.636 8.48646 2.636 8.56113 2.636C8.64646 2.62533 8.71579 2.62 8.76913 2.62C9.27046 2.652 9.68646 2.828 10.0171 3.148C10.3478 3.468 10.5131 3.87867 10.5131 4.38C10.5131 4.61467 10.4385 4.80667 10.2891 4.956C10.1398 5.10533 9.95313 5.18 9.72913 5.18C9.50513 5.18 9.31846 5.10533 9.16913 4.956C9.01979 4.796 8.94513 4.60933 8.94513 4.396C8.94513 4.076 9.07313 3.852 9.32913 3.724C9.33979 3.71333 9.36646 3.70267 9.40913 3.692C9.45179 3.67067 9.48913 3.64933 9.52113 3.628L9.58513 3.612C9.58513 3.55867 9.50513 3.48933 9.34513 3.404C9.16379 3.276 8.95579 3.212 8.72113 3.212C8.25179 3.212 7.91046 3.48933 7.69713 4.044C7.56913 4.35333 7.46779 4.78 7.39313 5.324C7.32913 5.85733 7.24379 6.83867 7.13713 8.268C6.98779 10.2733 6.82779 11.9747 6.65713 13.372C6.44379 15.2067 6.28379 16.4013 6.17713 16.956C5.86779 18.6627 5.25979 19.74 4.35313 20.188C4.07579 20.3267 3.77713 20.396 3.45713 20.396C2.68913 20.396 2.14513 20.0653 1.82513 19.404C1.69713 19.18 1.63313 18.924 1.63313 18.636C1.63313 18.4013 1.70779 18.2093 1.85713 18.06Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M13 2.5H15V4.5H13V2.5Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12 1.5H16V5.5H12V1.5ZM13 2.5V4.5H15V2.5H13Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M13 17.5H15V19.5H13V17.5Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12 16.5H16V20.5H12V16.5ZM13 17.5V19.5H15V17.5H13Z",
				fill: "#7070A9"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/IntersectionIcon.tsx
const IntersectionIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "30",
		height: "31",
		viewBox: "0 0 30 31",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M22 11.3333C22 11.1492 22.1492 11 22.3333 11H29.6667C29.8508 11 30 11.1492 30 11.3333V18.6667C30 18.8508 29.8508 19 29.6667 19H22.3333C22.1492 19 22 18.8508 22 18.6667V11.3333Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M23 12V18H29V12H23ZM22.3333 11C22.1492 11 22 11.1492 22 11.3333V18.6667C22 18.8508 22.1492 19 22.3333 19H29.6667C29.8508 19 30 18.8508 30 18.6667V11.3333C30 11.1492 29.8508 11 29.6667 11H22.3333Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M6.89588 22.972C6.74654 23.2387 6.60254 23.3987 6.46388 23.452C6.38921 23.484 6.30921 23.5 6.22388 23.5C5.91454 23.5 5.70121 23.34 5.58388 23.02C5.56254 22.956 5.55188 21.2387 5.55188 17.868C5.55188 14.4547 5.55721 12.7053 5.56788 12.62C5.69588 11.2227 6.24521 10.06 7.21588 9.132C8.19721 8.204 9.36521 7.67067 10.7199 7.532C10.7732 7.52133 10.8479 7.516 10.9439 7.516C10.9865 7.49467 11.1465 7.49467 11.4239 7.516C11.9039 7.516 12.3839 7.57467 12.8639 7.692C13.9092 7.96933 14.8052 8.492 15.5519 9.26C16.4692 10.2093 16.9812 11.3293 17.0879 12.62C17.0985 12.7053 17.1039 14.4547 17.1039 17.868C17.1039 21.2387 17.0932 22.956 17.0719 23.02C16.9759 23.3293 16.7625 23.484 16.4319 23.484C16.1119 23.484 15.8932 23.3133 15.7759 22.972C15.7759 21.8307 15.7705 20.1133 15.7599 17.82C15.7492 15.5267 15.7439 13.804 15.7439 12.652L15.7119 12.444C15.5625 11.5693 15.1892 10.8227 14.5919 10.204C13.6852 9.29733 12.5972 8.844 11.3279 8.844C10.6132 8.844 9.92521 9.00933 9.26388 9.34C8.65588 9.63867 8.14388 10.06 7.72788 10.604C7.32254 11.1373 7.06121 11.7507 6.94388 12.444L6.91188 12.652L6.89588 17.82V22.972Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M20 6.5H22V8.5H20V6.5Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M19 5.5H23V9.5H19V5.5ZM20 6.5V8.5H22V6.5H20Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M20 21.5H22V23.5H20V21.5Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M19 20.5H23V24.5H19V20.5ZM20 21.5V23.5H22V21.5H20Z",
				fill: "#7070A9"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/InverseCosecIcon.tsx
const InverseCosecIcon = (props) => {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "18",
		viewBox: "0 0 24 18",
		...props,
		children: /* @__PURE__ */ jsx("path", { d: "M4.13531 8.224C3.60731 8.224 3.24731 8.392 3.05531 8.728C2.87131 9.056 2.77931 9.556 2.77931 10.228C2.77931 10.836 2.85531 11.308 3.00731 11.644C3.15931 11.972 3.43531 12.196 3.83531 12.316C3.98731 12.372 4.17531 12.4 4.39931 12.4H4.50731C4.97931 12.4 5.33131 12.14 5.56331 11.62C5.60331 11.524 5.63931 11.468 5.67131 11.452C5.70331 11.436 5.79931 11.428 5.95931 11.428C6.12731 11.428 6.22331 11.436 6.24731 11.452C6.30331 11.476 6.33131 11.524 6.33131 11.596C6.33131 11.612 6.31531 11.66 6.28331 11.74C6.13131 12.156 5.85931 12.484 5.46731 12.724C5.08331 12.956 4.60331 13.072 4.02731 13.072C3.30731 13.072 2.70331 12.908 2.21531 12.58C1.44731 12.1 1.06331 11.352 1.06331 10.336C1.06331 9.512 1.31131 8.864 1.80731 8.392C2.34331 7.84 3.08331 7.564 4.02731 7.564C5.45131 7.564 6.16331 7.964 6.16331 8.764C6.16331 9.028 6.08731 9.232 5.93531 9.376C5.79131 9.52 5.59131 9.592 5.33531 9.592C5.07931 9.592 4.87531 9.52 4.72331 9.376C4.57131 9.224 4.49531 9.02 4.49531 8.764C4.49531 8.564 4.54731 8.392 4.65131 8.248H4.59131C4.46331 8.232 4.31131 8.224 4.13531 8.224ZM9.18422 12.448C9.98422 12.448 10.3842 12.2 10.3842 11.704C10.3842 11.4 10.2002 11.184 9.83222 11.056C9.72822 11.008 9.46022 10.948 9.02822 10.876C8.49222 10.78 8.11222 10.68 7.88822 10.576C7.32022 10.296 6.98822 9.908 6.89222 9.412C6.88422 9.372 6.88022 9.308 6.88022 9.22C6.88022 8.884 6.96822 8.58 7.14422 8.308C7.46422 7.812 8.11622 7.564 9.10022 7.564C9.50822 7.564 9.89622 7.632 10.2642 7.768L10.4802 7.66L10.7082 7.564H10.8162C10.8962 7.564 10.9482 7.572 10.9722 7.588C11.0122 7.612 11.0362 7.656 11.0442 7.72C11.0522 7.784 11.0562 7.996 11.0562 8.356C11.0562 8.716 11.0522 8.928 11.0442 8.992C11.0362 9.056 11.0122 9.1 10.9722 9.124C10.9482 9.14 10.8522 9.148 10.6842 9.148C10.5242 9.148 10.4282 9.14 10.3962 9.124C10.3402 9.092 10.3122 9.02 10.3122 8.908C10.2882 8.66 10.1722 8.468 9.96422 8.332C9.75622 8.196 9.47222 8.128 9.11222 8.128C8.30422 8.128 7.90022 8.34 7.90022 8.764C7.90022 8.972 8.10422 9.156 8.51222 9.316C8.55222 9.324 8.77222 9.364 9.17222 9.436C9.58022 9.508 9.80422 9.552 9.84422 9.568C10.6522 9.76 11.1602 10.216 11.3682 10.936C11.3842 11.016 11.3922 11.136 11.3922 11.296C11.3922 12.48 10.6562 13.072 9.18422 13.072C8.57622 13.072 8.12422 12.96 7.82822 12.736C7.61222 12.856 7.41622 12.968 7.24022 13.072H7.12022C7.04022 13.072 6.98822 13.064 6.96422 13.048C6.92422 13.024 6.90022 12.976 6.89222 12.904C6.88422 12.832 6.88022 12.572 6.88022 12.124C6.88022 11.676 6.88022 11.416 6.88022 11.344C6.88822 11.272 6.91222 11.224 6.95222 11.2C6.98422 11.176 7.08022 11.164 7.24022 11.164C7.40822 11.164 7.50822 11.172 7.54022 11.188C7.57222 11.212 7.61222 11.288 7.66022 11.416C7.77222 11.776 7.94822 12.04 8.18822 12.208C8.42822 12.368 8.76022 12.448 9.18422 12.448ZM15.1134 8.224C14.5854 8.224 14.2254 8.392 14.0334 8.728C13.8494 9.056 13.7574 9.556 13.7574 10.228C13.7574 10.836 13.8334 11.308 13.9854 11.644C14.1374 11.972 14.4134 12.196 14.8134 12.316C14.9654 12.372 15.1534 12.4 15.3774 12.4H15.4854C15.9574 12.4 16.3094 12.14 16.5414 11.62C16.5814 11.524 16.6174 11.468 16.6494 11.452C16.6814 11.436 16.7774 11.428 16.9374 11.428C17.1054 11.428 17.2014 11.436 17.2254 11.452C17.2814 11.476 17.3094 11.524 17.3094 11.596C17.3094 11.612 17.2934 11.66 17.2614 11.74C17.1094 12.156 16.8374 12.484 16.4454 12.724C16.0614 12.956 15.5814 13.072 15.0054 13.072C14.2854 13.072 13.6814 12.908 13.1934 12.58C12.4254 12.1 12.0414 11.352 12.0414 10.336C12.0414 9.512 12.2894 8.864 12.7854 8.392C13.3214 7.84 14.0614 7.564 15.0054 7.564C16.4294 7.564 17.1414 7.964 17.1414 8.764C17.1414 9.028 17.0654 9.232 16.9134 9.376C16.7694 9.52 16.5694 9.592 16.3134 9.592C16.0574 9.592 15.8534 9.52 15.7014 9.376C15.5494 9.224 15.4734 9.02 15.4734 8.764C15.4734 8.564 15.5254 8.392 15.6294 8.248H15.5694C15.4414 8.232 15.2894 8.224 15.1134 8.224ZM17.4959 7.8048V6.9984H19.6919V7.8048H17.4959ZM23.3218 9C23.2162 8.9856 22.7674 8.9784 21.9754 8.9784C21.1834 8.9784 20.7394 8.9856 20.6434 9H20.5498V8.5536H21.493V6.8112C21.493 5.6496 21.4882 5.0688 21.4786 5.0688C21.2098 5.1504 20.9026 5.1912 20.557 5.1912H20.4346V4.7448H20.557C21.205 4.7448 21.7114 4.6104 22.0762 4.3416L22.1554 4.284H22.2562C22.3618 4.284 22.4242 4.3104 22.4434 4.3632C22.453 4.3824 22.4578 5.0856 22.4578 6.4728V8.5536H23.4154V9H23.3218Z" })
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/InverseCosineIcon.tsx
const InverseCosineIcon = (props) => {
	return /* @__PURE__ */ jsx("svg", {
		width: "26",
		height: "18",
		viewBox: "0 0 26 18",
		...props,
		children: /* @__PURE__ */ jsx("path", { d: "M4.86187 8.224C4.33387 8.224 3.97387 8.392 3.78187 8.728C3.59787 9.056 3.50587 9.556 3.50587 10.228C3.50587 10.836 3.58187 11.308 3.73387 11.644C3.88587 11.972 4.16187 12.196 4.56187 12.316C4.71387 12.372 4.90187 12.4 5.12587 12.4H5.23387C5.70587 12.4 6.05787 12.14 6.28988 11.62C6.32987 11.524 6.36587 11.468 6.39787 11.452C6.42987 11.436 6.52587 11.428 6.68587 11.428C6.85387 11.428 6.94987 11.436 6.97387 11.452C7.02987 11.476 7.05787 11.524 7.05787 11.596C7.05787 11.612 7.04187 11.66 7.00988 11.74C6.85787 12.156 6.58587 12.484 6.19387 12.724C5.80987 12.956 5.32987 13.072 4.75387 13.072C4.03387 13.072 3.42987 12.908 2.94187 12.58C2.17387 12.1 1.78987 11.352 1.78987 10.336C1.78987 9.512 2.03787 8.864 2.53387 8.392C3.06987 7.84 3.80987 7.564 4.75387 7.564C6.17787 7.564 6.88987 7.964 6.88987 8.764C6.88987 9.028 6.81387 9.232 6.66187 9.376C6.51787 9.52 6.31787 9.592 6.06187 9.592C5.80587 9.592 5.60187 9.52 5.44987 9.376C5.29787 9.224 5.22187 9.02 5.22187 8.764C5.22187 8.564 5.27387 8.392 5.37787 8.248H5.31787C5.18987 8.232 5.03787 8.224 4.86187 8.224ZM10.3308 7.576H10.4988C10.8188 7.576 11.0068 7.58 11.0628 7.588C12.3268 7.732 13.1388 8.336 13.4988 9.4C13.6028 9.736 13.6548 10.052 13.6548 10.348C13.6548 11.028 13.4708 11.592 13.1028 12.04C12.7348 12.48 12.2428 12.784 11.6268 12.952C11.3388 13.024 10.9948 13.06 10.5948 13.06C9.81078 13.06 9.19078 12.908 8.73478 12.604C7.93478 12.132 7.53478 11.388 7.53478 10.372C7.53478 9.66 7.74278 9.052 8.15878 8.548C8.62278 7.996 9.28678 7.676 10.1508 7.588C10.1988 7.58 10.2588 7.576 10.3308 7.576ZM11.6508 8.596C11.4348 8.324 11.0628 8.188 10.5348 8.188C10.2068 8.188 9.92678 8.272 9.69478 8.44C9.51878 8.576 9.39878 8.764 9.33478 9.004C9.27878 9.236 9.25078 9.648 9.25078 10.24C9.25078 10.776 9.27078 11.168 9.31078 11.416C9.35878 11.664 9.43878 11.856 9.55078 11.992C9.77478 12.264 10.1228 12.4 10.5948 12.4C11.0668 12.4 11.4148 12.264 11.6388 11.992C11.7508 11.856 11.8268 11.664 11.8668 11.416C11.9148 11.168 11.9388 10.776 11.9388 10.24C11.9388 9.728 11.9188 9.36 11.8788 9.136C11.8388 8.904 11.7628 8.724 11.6508 8.596ZM16.5131 12.448C17.3131 12.448 17.7131 12.2 17.7131 11.704C17.7131 11.4 17.5291 11.184 17.1611 11.056C17.0571 11.008 16.7891 10.948 16.3571 10.876C15.8211 10.78 15.4411 10.68 15.2171 10.576C14.6491 10.296 14.3171 9.908 14.2211 9.412C14.2131 9.372 14.2091 9.308 14.2091 9.22C14.2091 8.884 14.2971 8.58 14.4731 8.308C14.7931 7.812 15.4451 7.564 16.4291 7.564C16.8371 7.564 17.2251 7.632 17.5931 7.768L17.8091 7.66L18.0371 7.564H18.1451C18.2251 7.564 18.2771 7.572 18.3011 7.588C18.3411 7.612 18.3651 7.656 18.3731 7.72C18.3811 7.784 18.3851 7.996 18.3851 8.356C18.3851 8.716 18.3811 8.928 18.3731 8.992C18.3651 9.056 18.3411 9.1 18.3011 9.124C18.2771 9.14 18.1811 9.148 18.0131 9.148C17.8531 9.148 17.7571 9.14 17.7251 9.124C17.6691 9.092 17.6411 9.02 17.6411 8.908C17.6171 8.66 17.5011 8.468 17.2931 8.332C17.0851 8.196 16.8011 8.128 16.4411 8.128C15.6331 8.128 15.2291 8.34 15.2291 8.764C15.2291 8.972 15.4331 9.156 15.8411 9.316C15.8811 9.324 16.1011 9.364 16.5011 9.436C16.9091 9.508 17.1331 9.552 17.1731 9.568C17.9811 9.76 18.4891 10.216 18.6971 10.936C18.7131 11.016 18.7211 11.136 18.7211 11.296C18.7211 12.48 17.9851 13.072 16.5131 13.072C15.9051 13.072 15.4531 12.96 15.1571 12.736C14.9411 12.856 14.7451 12.968 14.5691 13.072H14.4491C14.3691 13.072 14.3171 13.064 14.2931 13.048C14.2531 13.024 14.2291 12.976 14.2211 12.904C14.2131 12.832 14.2091 12.572 14.2091 12.124C14.2091 11.676 14.2091 11.416 14.2091 11.344C14.2171 11.272 14.2411 11.224 14.2811 11.2C14.3131 11.176 14.4091 11.164 14.5691 11.164C14.7371 11.164 14.8371 11.172 14.8691 11.188C14.9011 11.212 14.9411 11.288 14.9891 11.416C15.1011 11.776 15.2771 12.04 15.5171 12.208C15.7571 12.368 16.0891 12.448 16.5131 12.448ZM18.9959 7.8048V6.9984H21.1919V7.8048H18.9959ZM24.8218 9C24.7162 8.9856 24.2674 8.9784 23.4754 8.9784C22.6834 8.9784 22.2394 8.9856 22.1434 9H22.0498V8.5536H22.993V6.8112C22.993 5.6496 22.9882 5.0688 22.9786 5.0688C22.7098 5.1504 22.4026 5.1912 22.057 5.1912H21.9346V4.7448H22.057C22.705 4.7448 23.2114 4.6104 23.5762 4.3416L23.6554 4.284H23.7562C23.8618 4.284 23.9242 4.3104 23.9434 4.3632C23.953 4.3824 23.9578 5.0856 23.9578 6.4728V8.5536H24.9154V9H24.8218Z" })
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/InverseCotTanIcon.tsx
const InverseCotTanIcon = (props) => {
	return /* @__PURE__ */ jsx("svg", {
		width: "26",
		height: "18",
		viewBox: "0 0 26 18",
		...props,
		children: /* @__PURE__ */ jsx("path", { d: "M4.94391 8.224C4.41591 8.224 4.05591 8.392 3.86391 8.728C3.67991 9.056 3.58791 9.556 3.58791 10.228C3.58791 10.836 3.66391 11.308 3.81591 11.644C3.96791 11.972 4.24391 12.196 4.64391 12.316C4.79591 12.372 4.98391 12.4 5.20791 12.4H5.31591C5.78791 12.4 6.13991 12.14 6.37191 11.62C6.41191 11.524 6.44791 11.468 6.47991 11.452C6.51191 11.436 6.60791 11.428 6.76791 11.428C6.93591 11.428 7.03191 11.436 7.05591 11.452C7.11191 11.476 7.13991 11.524 7.13991 11.596C7.13991 11.612 7.12391 11.66 7.09191 11.74C6.93991 12.156 6.66791 12.484 6.27591 12.724C5.89191 12.956 5.41191 13.072 4.83591 13.072C4.11591 13.072 3.51191 12.908 3.02391 12.58C2.25591 12.1 1.87191 11.352 1.87191 10.336C1.87191 9.512 2.11991 8.864 2.61591 8.392C3.15191 7.84 3.89191 7.564 4.83591 7.564C6.25991 7.564 6.97191 7.964 6.97191 8.764C6.97191 9.028 6.89591 9.232 6.74391 9.376C6.59991 9.52 6.39991 9.592 6.14391 9.592C5.88791 9.592 5.68391 9.52 5.53191 9.376C5.37991 9.224 5.30391 9.02 5.30391 8.764C5.30391 8.564 5.35591 8.392 5.45991 8.248H5.39991C5.27191 8.232 5.11991 8.224 4.94391 8.224ZM10.4128 7.576H10.5808C10.9008 7.576 11.0888 7.58 11.1448 7.588C12.4088 7.732 13.2208 8.336 13.5808 9.4C13.6848 9.736 13.7368 10.052 13.7368 10.348C13.7368 11.028 13.5528 11.592 13.1848 12.04C12.8168 12.48 12.3248 12.784 11.7088 12.952C11.4208 13.024 11.0768 13.06 10.6768 13.06C9.89281 13.06 9.27281 12.908 8.81681 12.604C8.01681 12.132 7.61681 11.388 7.61681 10.372C7.61681 9.66 7.82481 9.052 8.24081 8.548C8.70481 7.996 9.36881 7.676 10.2328 7.588C10.2808 7.58 10.3408 7.576 10.4128 7.576ZM11.7328 8.596C11.5168 8.324 11.1448 8.188 10.6168 8.188C10.2888 8.188 10.0088 8.272 9.77681 8.44C9.60081 8.576 9.48081 8.764 9.41681 9.004C9.36081 9.236 9.33281 9.648 9.33281 10.24C9.33281 10.776 9.35281 11.168 9.39281 11.416C9.44081 11.664 9.52081 11.856 9.63281 11.992C9.85681 12.264 10.2048 12.4 10.6768 12.4C11.1488 12.4 11.4968 12.264 11.7208 11.992C11.8328 11.856 11.9088 11.664 11.9488 11.416C11.9968 11.168 12.0208 10.776 12.0208 10.24C12.0208 9.728 12.0008 9.36 11.9608 9.136C11.9208 8.904 11.8448 8.724 11.7328 8.596ZM15.7792 5.548V5.38H16.5232V7.672H18.1912V8.416H16.5232V10.132C16.5312 11.324 16.5472 11.956 16.5712 12.028C16.5712 12.036 16.5792 12.056 16.5952 12.088C16.7072 12.304 16.8752 12.412 17.0992 12.412C17.4112 12.412 17.5992 12.192 17.6632 11.752C17.6712 11.712 17.6752 11.548 17.6752 11.26V10.876H18.4192V11.284C18.4192 11.58 18.4112 11.756 18.3952 11.812C18.3472 12.108 18.2192 12.364 18.0112 12.58C17.8112 12.788 17.5592 12.936 17.2552 13.024L17.0992 13.06H16.7992C15.8152 13.06 15.2272 12.72 15.0352 12.04C14.9952 11.896 14.9752 11.236 14.9752 10.06V8.416H14.0872V7.804H14.1352C14.3992 7.804 14.6592 7.712 14.9152 7.528C15.1632 7.344 15.3632 7.076 15.5152 6.724C15.6672 6.372 15.7552 5.98 15.7792 5.548ZM18.9959 7.8048V6.9984H21.1919V7.8048H18.9959ZM24.8218 9C24.7162 8.9856 24.2674 8.9784 23.4754 8.9784C22.6834 8.9784 22.2394 8.9856 22.1434 9H22.0498V8.5536H22.993V6.8112C22.993 5.6496 22.9882 5.0688 22.9786 5.0688C22.7098 5.1504 22.4026 5.1912 22.057 5.1912H21.9346V4.7448H22.057C22.705 4.7448 23.2114 4.6104 23.5762 4.3416L23.6554 4.284H23.7562C23.8618 4.284 23.9242 4.3104 23.9434 4.3632C23.953 4.3824 23.9578 5.0856 23.9578 6.4728V8.5536H24.9154V9H24.8218Z" })
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/InverseSecIcon.tsx
const InverseSecIcon = (props) => {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "18",
		viewBox: "0 0 24 18",
		...props,
		children: /* @__PURE__ */ jsx("path", { d: "M3.15609 12.448C3.95609 12.448 4.35609 12.2 4.35609 11.704C4.35609 11.4 4.17209 11.184 3.80409 11.056C3.70009 11.008 3.43209 10.948 3.00009 10.876C2.46409 10.78 2.08409 10.68 1.86009 10.576C1.29209 10.296 0.960093 9.908 0.864093 9.412C0.856093 9.372 0.852093 9.308 0.852093 9.22C0.852093 8.884 0.940093 8.58 1.11609 8.308C1.43609 7.812 2.08809 7.564 3.07209 7.564C3.48009 7.564 3.86809 7.632 4.23609 7.768L4.45209 7.66L4.68009 7.564H4.78809C4.86809 7.564 4.92009 7.572 4.94409 7.588C4.98409 7.612 5.00809 7.656 5.01609 7.72C5.02409 7.784 5.02809 7.996 5.02809 8.356C5.02809 8.716 5.02409 8.928 5.01609 8.992C5.00809 9.056 4.98409 9.1 4.94409 9.124C4.92009 9.14 4.82409 9.148 4.65609 9.148C4.49609 9.148 4.40009 9.14 4.36809 9.124C4.31209 9.092 4.28409 9.02 4.28409 8.908C4.26009 8.66 4.14409 8.468 3.93609 8.332C3.72809 8.196 3.44409 8.128 3.08409 8.128C2.27609 8.128 1.87209 8.34 1.87209 8.764C1.87209 8.972 2.07609 9.156 2.48409 9.316C2.52409 9.324 2.74409 9.364 3.14409 9.436C3.55209 9.508 3.77609 9.552 3.81609 9.568C4.62409 9.76 5.13209 10.216 5.34009 10.936C5.35609 11.016 5.36409 11.136 5.36409 11.296C5.36409 12.48 4.62809 13.072 3.15609 13.072C2.54809 13.072 2.09609 12.96 1.80009 12.736C1.58409 12.856 1.38809 12.968 1.21209 13.072H1.09209C1.01209 13.072 0.960093 13.064 0.936093 13.048C0.896093 13.024 0.872093 12.976 0.864093 12.904C0.856093 12.832 0.852093 12.572 0.852093 12.124C0.852093 11.676 0.852093 11.416 0.852093 11.344C0.860093 11.272 0.884093 11.224 0.924093 11.2C0.956093 11.176 1.05209 11.164 1.21209 11.164C1.38009 11.164 1.48009 11.172 1.51209 11.188C1.54409 11.212 1.58409 11.288 1.63209 11.416C1.74409 11.776 1.92009 12.04 2.16009 12.208C2.40009 12.368 2.73209 12.448 3.15609 12.448ZM6.97331 8.128C7.47731 7.76 8.08931 7.576 8.80931 7.576C9.14531 7.576 9.34531 7.58 9.40931 7.588C10.0733 7.684 10.5813 7.944 10.9333 8.368C11.2933 8.792 11.4733 9.364 11.4733 10.084C11.4733 10.22 11.4333 10.312 11.3533 10.36C11.3213 10.376 10.6933 10.384 9.46931 10.384H7.64531V10.492C7.64531 11.116 7.76931 11.58 8.01731 11.884C8.26531 12.18 8.66531 12.352 9.21731 12.4C9.26531 12.408 9.33331 12.412 9.42131 12.412C9.71731 12.412 9.98131 12.336 10.2133 12.184C10.4533 12.032 10.6213 11.828 10.7173 11.572C10.7573 11.484 10.7973 11.432 10.8373 11.416C10.8773 11.392 10.9653 11.38 11.1013 11.38C11.3493 11.38 11.4733 11.444 11.4733 11.572C11.4733 11.612 11.4693 11.64 11.4613 11.656C11.3333 12.08 11.0613 12.416 10.6453 12.664C10.1653 12.936 9.63331 13.072 9.04931 13.072C8.18531 13.072 7.48131 12.864 6.93731 12.448C6.40131 12.024 6.07331 11.448 5.95331 10.72C5.93731 10.592 5.92931 10.452 5.92931 10.3C5.92931 9.364 6.27731 8.64 6.97331 8.128ZM10.1413 9.688C10.0533 8.68 9.64131 8.176 8.90531 8.176C8.68931 8.176 8.48531 8.228 8.29331 8.332C8.10931 8.428 7.97331 8.556 7.88531 8.716C7.75731 8.924 7.68131 9.236 7.65731 9.652V9.808H10.1413V9.688ZM15.1134 8.224C14.5854 8.224 14.2254 8.392 14.0334 8.728C13.8494 9.056 13.7574 9.556 13.7574 10.228C13.7574 10.836 13.8334 11.308 13.9854 11.644C14.1374 11.972 14.4134 12.196 14.8134 12.316C14.9654 12.372 15.1534 12.4 15.3774 12.4H15.4854C15.9574 12.4 16.3094 12.14 16.5414 11.62C16.5814 11.524 16.6174 11.468 16.6494 11.452C16.6814 11.436 16.7774 11.428 16.9374 11.428C17.1054 11.428 17.2014 11.436 17.2254 11.452C17.2814 11.476 17.3094 11.524 17.3094 11.596C17.3094 11.612 17.2934 11.66 17.2614 11.74C17.1094 12.156 16.8374 12.484 16.4454 12.724C16.0614 12.956 15.5814 13.072 15.0054 13.072C14.2854 13.072 13.6814 12.908 13.1934 12.58C12.4254 12.1 12.0414 11.352 12.0414 10.336C12.0414 9.512 12.2894 8.864 12.7854 8.392C13.3214 7.84 14.0614 7.564 15.0054 7.564C16.4294 7.564 17.1414 7.964 17.1414 8.764C17.1414 9.028 17.0654 9.232 16.9134 9.376C16.7694 9.52 16.5694 9.592 16.3134 9.592C16.0574 9.592 15.8534 9.52 15.7014 9.376C15.5494 9.224 15.4734 9.02 15.4734 8.764C15.4734 8.564 15.5254 8.392 15.6294 8.248H15.5694C15.4414 8.232 15.2894 8.224 15.1134 8.224ZM17.4959 7.8048V6.9984H19.6919V7.8048H17.4959ZM23.3218 9C23.2162 8.9856 22.7674 8.9784 21.9754 8.9784C21.1834 8.9784 20.7394 8.9856 20.6434 9H20.5498V8.5536H21.493V6.8112C21.493 5.6496 21.4882 5.0688 21.4786 5.0688C21.2098 5.1504 20.9026 5.1912 20.557 5.1912H20.4346V4.7448H20.557C21.205 4.7448 21.7114 4.6104 22.0762 4.3416L22.1554 4.284H22.2562C22.3618 4.284 22.4242 4.3104 22.4434 4.3632C22.453 4.3824 22.4578 5.0856 22.4578 6.4728V8.5536H23.4154V9H23.3218Z" })
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/InverseSineIcon.tsx
const InverseSineIcon = (props) => {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "18",
		viewBox: "0 0 24 18",
		...props,
		children: /* @__PURE__ */ jsx("path", { d: "M3.61703 12.448C4.41703 12.448 4.81703 12.2 4.81703 11.704C4.81703 11.4 4.63303 11.184 4.26503 11.056C4.16103 11.008 3.89303 10.948 3.46103 10.876C2.92503 10.78 2.54503 10.68 2.32103 10.576C1.75303 10.296 1.42103 9.908 1.32503 9.412C1.31703 9.372 1.31303 9.308 1.31303 9.22C1.31303 8.884 1.40103 8.58 1.57703 8.308C1.89703 7.812 2.54903 7.564 3.53303 7.564C3.94103 7.564 4.32903 7.632 4.69703 7.768L4.91303 7.66L5.14103 7.564H5.24903C5.32903 7.564 5.38103 7.572 5.40503 7.588C5.44503 7.612 5.46903 7.656 5.47703 7.72C5.48503 7.784 5.48903 7.996 5.48903 8.356C5.48903 8.716 5.48503 8.928 5.47703 8.992C5.46903 9.056 5.44503 9.1 5.40503 9.124C5.38103 9.14 5.28503 9.148 5.11703 9.148C4.95703 9.148 4.86103 9.14 4.82903 9.124C4.77303 9.092 4.74503 9.02 4.74503 8.908C4.72103 8.66 4.60503 8.468 4.39703 8.332C4.18903 8.196 3.90503 8.128 3.54503 8.128C2.73703 8.128 2.33303 8.34 2.33303 8.764C2.33303 8.972 2.53703 9.156 2.94503 9.316C2.98503 9.324 3.20503 9.364 3.60503 9.436C4.01303 9.508 4.23703 9.552 4.27703 9.568C5.08503 9.76 5.59303 10.216 5.80103 10.936C5.81703 11.016 5.82503 11.136 5.82503 11.296C5.82503 12.48 5.08903 13.072 3.61703 13.072C3.00903 13.072 2.55703 12.96 2.26103 12.736C2.04503 12.856 1.84903 12.968 1.67303 13.072H1.55303C1.47303 13.072 1.42103 13.064 1.39703 13.048C1.35703 13.024 1.33303 12.976 1.32503 12.904C1.31703 12.832 1.31303 12.572 1.31303 12.124C1.31303 11.676 1.31303 11.416 1.31303 11.344C1.32103 11.272 1.34503 11.224 1.38503 11.2C1.41703 11.176 1.51303 11.164 1.67303 11.164C1.84103 11.164 1.94103 11.172 1.97303 11.188C2.00503 11.212 2.04503 11.288 2.09303 11.416C2.20503 11.776 2.38103 12.04 2.62103 12.208C2.86103 12.368 3.19303 12.448 3.61703 12.448ZM6.87025 5.68C6.87025 5.384 6.96625 5.14 7.15825 4.948C7.35825 4.756 7.61025 4.66 7.91425 4.66C8.19425 4.676 8.42625 4.78 8.61025 4.972C8.80225 5.156 8.89825 5.392 8.89825 5.68C8.89825 5.976 8.80225 6.22 8.61025 6.412C8.42625 6.604 8.18625 6.7 7.89025 6.7C7.59425 6.7 7.35025 6.608 7.15825 6.424C6.96625 6.232 6.87025 5.984 6.87025 5.68ZM6.55825 7.696L7.63825 7.648L8.71825 7.6H8.79025V12.256H9.53425V13H9.43825C9.34225 12.976 8.88225 12.964 8.05825 12.964C7.18625 12.964 6.69825 12.976 6.59425 13H6.48625V12.256H7.31425V10.492C7.31425 9.3 7.31025 8.688 7.30225 8.656C7.27825 8.56 7.21425 8.5 7.11025 8.476C7.01425 8.452 6.86625 8.44 6.66625 8.44H6.52225V7.696H6.55825ZM10.0183 7.696C11.4343 7.632 12.1463 7.6 12.1543 7.6H12.2263V8.116L12.2383 8.62C12.5423 8.116 13.0903 7.784 13.8823 7.624C13.9783 7.608 14.1223 7.6 14.3143 7.6C14.8743 7.6 15.2983 7.696 15.5863 7.888C15.8743 8.08 16.0623 8.4 16.1503 8.848C16.1663 8.936 16.1783 9.528 16.1863 10.624V12.256H17.0143V13H16.9063C16.8023 12.976 16.3023 12.964 15.4063 12.964C14.5263 12.964 14.0303 12.976 13.9183 13H13.8103V12.256H14.6383V10.672C14.6383 9.584 14.6343 9.012 14.6263 8.956C14.6023 8.7 14.5423 8.512 14.4463 8.392C14.3583 8.272 14.2063 8.212 13.9903 8.212C13.5823 8.212 13.2343 8.336 12.9463 8.584C12.6583 8.832 12.4743 9.144 12.3943 9.52C12.3783 9.592 12.3663 10.068 12.3583 10.948V12.256H13.1863V13H13.0783C12.9663 12.976 12.4703 12.964 11.5903 12.964C10.7023 12.964 10.2023 12.976 10.0903 13H9.98228V12.256H10.8103V10.48C10.8103 9.296 10.8023 8.684 10.7863 8.644C10.7463 8.508 10.5303 8.44 10.1383 8.44H9.98228V7.696H10.0183ZM16.9959 7.8048V6.9984H19.1919V7.8048H16.9959ZM22.8218 9C22.7162 8.9856 22.2674 8.9784 21.4754 8.9784C20.6834 8.9784 20.2394 8.9856 20.1434 9H20.0498V8.5536H20.993V6.8112C20.993 5.6496 20.9882 5.0688 20.9786 5.0688C20.7098 5.1504 20.4026 5.1912 20.057 5.1912H19.9346V4.7448H20.057C20.705 4.7448 21.2114 4.6104 21.5762 4.3416L21.6554 4.284H21.7562C21.8618 4.284 21.9242 4.3104 21.9434 4.3632C21.953 4.3824 21.9578 5.0856 21.9578 6.4728V8.5536H22.9154V9H22.8218Z" })
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/InverseTanIcon.tsx
const InverseTanIcon = (props) => {
	return /* @__PURE__ */ jsx("svg", {
		width: "26",
		height: "18",
		viewBox: "0 0 26 18",
		...props,
		children: /* @__PURE__ */ jsx("path", { d: "M2.51197 5.548V5.38H3.25597V7.672H4.92397V8.416H3.25597V10.132C3.26397 11.324 3.27997 11.956 3.30397 12.028C3.30397 12.036 3.31197 12.056 3.32797 12.088C3.43997 12.304 3.60797 12.412 3.83197 12.412C4.14397 12.412 4.33197 12.192 4.39597 11.752C4.40397 11.712 4.40797 11.548 4.40797 11.26V10.876H5.15197V11.284C5.15197 11.58 5.14397 11.756 5.12797 11.812C5.07997 12.108 4.95197 12.364 4.74397 12.58C4.54397 12.788 4.29197 12.936 3.98797 13.024L3.83197 13.06H3.53197C2.54797 13.06 1.95997 12.72 1.76797 12.04C1.72797 11.896 1.70797 11.236 1.70797 10.06V8.416H0.819968V7.804H0.867968C1.13197 7.804 1.39197 7.712 1.64797 7.528C1.89597 7.344 2.09597 7.076 2.24797 6.724C2.39997 6.372 2.48797 5.98 2.51197 5.548ZM11.5992 13C11.3432 13 11.1432 12.996 10.9992 12.988C10.8632 12.972 10.7152 12.944 10.5552 12.904C10.3952 12.864 10.2752 12.796 10.1952 12.7C10.1152 12.604 10.0632 12.48 10.0392 12.328L9.90716 12.448C9.47516 12.864 8.89116 13.072 8.15516 13.072C7.56316 13.072 7.05916 12.936 6.64316 12.664C6.22716 12.384 6.01916 12.012 6.01916 11.548C6.01916 11.268 6.11516 11.012 6.30716 10.78C6.50716 10.54 6.77916 10.348 7.12316 10.204C7.75516 9.94 8.58716 9.784 9.61916 9.736H9.83516V9.496C9.83516 9.04 9.73916 8.708 9.54716 8.5C9.35516 8.284 9.04316 8.176 8.61116 8.176C8.33916 8.176 8.12316 8.188 7.96316 8.212H7.90316C8.02316 8.396 8.08316 8.576 8.08316 8.752C8.08316 9 8.00716 9.204 7.85516 9.364C7.71116 9.516 7.50716 9.592 7.24316 9.592C6.99516 9.592 6.79516 9.52 6.64316 9.376C6.49916 9.232 6.41916 9.044 6.40316 8.812C6.40316 8.356 6.59916 8.036 6.99116 7.852C7.39116 7.66 7.95916 7.564 8.69516 7.564C9.72716 7.564 10.4832 7.812 10.9632 8.308C11.1312 8.492 11.2472 8.692 11.3112 8.908C11.3512 9.02 11.3712 9.148 11.3712 9.292C11.3792 9.428 11.3832 9.88 11.3832 10.648V12.076C11.4952 12.188 11.6952 12.248 11.9832 12.256C12.1432 12.256 12.2392 12.276 12.2712 12.316C12.3112 12.348 12.3312 12.452 12.3312 12.628C12.3312 12.82 12.2872 12.936 12.1992 12.976C12.1752 12.992 11.9752 13 11.5992 13ZM7.60316 11.548C7.60316 11.796 7.68716 12.012 7.85516 12.196C8.03116 12.372 8.24316 12.46 8.49116 12.46C8.73916 12.46 8.97516 12.408 9.19916 12.304C9.43116 12.192 9.60316 12.052 9.71516 11.884C9.73116 11.852 9.75516 11.8 9.78716 11.728C9.81916 11.648 9.83516 11.604 9.83516 11.596V10.288H9.79916C9.04716 10.344 8.47516 10.496 8.08316 10.744C7.76316 10.984 7.60316 11.252 7.60316 11.548ZM12.5183 7.696C13.9343 7.632 14.6463 7.6 14.6543 7.6H14.7263V8.116L14.7383 8.62C15.0423 8.116 15.5903 7.784 16.3823 7.624C16.4783 7.608 16.6223 7.6 16.8143 7.6C17.3743 7.6 17.7983 7.696 18.0863 7.888C18.3743 8.08 18.5623 8.4 18.6503 8.848C18.6663 8.936 18.6783 9.528 18.6863 10.624V12.256H19.5143V13H19.4063C19.3023 12.976 18.8023 12.964 17.9063 12.964C17.0263 12.964 16.5303 12.976 16.4183 13H16.3103V12.256H17.1383V10.672C17.1383 9.584 17.1343 9.012 17.1263 8.956C17.1023 8.7 17.0423 8.512 16.9463 8.392C16.8583 8.272 16.7063 8.212 16.4903 8.212C16.0823 8.212 15.7343 8.336 15.4463 8.584C15.1583 8.832 14.9743 9.144 14.8943 9.52C14.8783 9.592 14.8663 10.068 14.8583 10.948V12.256H15.6863V13H15.5783C15.4663 12.976 14.9703 12.964 14.0903 12.964C13.2023 12.964 12.7023 12.976 12.5903 13H12.4823V12.256H13.3103V10.48C13.3103 9.296 13.3023 8.684 13.2863 8.644C13.2463 8.508 13.0303 8.44 12.6383 8.44H12.4823V7.696H12.5183ZM19.4959 7.8048V6.9984H21.6919V7.8048H19.4959ZM25.3218 9C25.2162 8.9856 24.7674 8.9784 23.9754 8.9784C23.1834 8.9784 22.7394 8.9856 22.6434 9H22.5498V8.5536H23.493V6.8112C23.493 5.6496 23.4882 5.0688 23.4786 5.0688C23.2098 5.1504 22.9026 5.1912 22.557 5.1912H22.4346V4.7448H22.557C23.205 4.7448 23.7114 4.6104 24.0762 4.3416L24.1554 4.284H24.2562C24.3618 4.284 24.4242 4.3104 24.4434 4.3632C24.453 4.3824 24.4578 5.0856 24.4578 6.4728V8.5536H25.4154V9H25.3218Z" })
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/LeftArrowBetweenIcon.tsx
const LeftArrowBetweenIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "21",
		height: "30",
		viewBox: "0 0 21 30",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M11.2671 15.26C11.3871 15.324 11.4471 15.404 11.4471 15.5C11.4471 15.596 11.3871 15.676 11.2671 15.74H2.09914L2.13514 15.776C2.95914 16.408 3.49914 17.216 3.75514 18.2C3.80314 18.376 3.82714 18.476 3.82714 18.5C3.82714 18.588 3.74314 18.632 3.57514 18.632C3.47914 18.632 3.41514 18.62 3.38314 18.596C3.35914 18.58 3.33914 18.532 3.32314 18.452C3.30714 18.396 3.29114 18.328 3.27514 18.248C3.13114 17.664 2.85514 17.144 2.44714 16.688C2.04714 16.232 1.56314 15.892 0.995141 15.668C0.875141 15.62 0.803141 15.576 0.779141 15.536C0.779141 15.432 0.851141 15.364 0.995141 15.332C1.56314 15.108 2.04714 14.768 2.44714 14.312C2.85514 13.856 3.13114 13.336 3.27514 12.752C3.28314 12.728 3.29114 12.692 3.29914 12.644C3.30714 12.596 3.31114 12.564 3.31114 12.548C3.31914 12.532 3.32714 12.508 3.33514 12.476C3.35114 12.444 3.36714 12.424 3.38314 12.416C3.39914 12.4 3.42314 12.388 3.45514 12.38C3.48714 12.372 3.52714 12.368 3.57514 12.368C3.74314 12.368 3.82714 12.412 3.82714 12.5C3.82714 12.524 3.80314 12.624 3.75514 12.8C3.51514 13.752 2.97514 14.56 2.13514 15.224L2.09914 15.26H11.2671Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M19.8814 15.7527C20.014 15.7527 20.1214 15.6452 20.1214 15.5127C20.1214 15.3801 20.014 15.2727 19.8814 15.2727V15.7527ZM10.2822 15.7527H19.8814V15.2727H10.2822V15.7527Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M13.7188 18.8333C13.7188 18.6492 13.5695 18.5 13.3854 18.5H6.05208C5.86799 18.5 5.71875 18.6492 5.71875 18.8333V26.1667C5.71875 26.3508 5.86799 26.5 6.05208 26.5H13.3854C13.5695 26.5 13.7188 26.3508 13.7188 26.1667V18.8333Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12.7188 19.5V25.5H6.71875V19.5H12.7188ZM13.3854 18.5C13.5695 18.5 13.7188 18.6492 13.7188 18.8333V26.1667C13.7188 26.3508 13.5695 26.5 13.3854 26.5H6.05208C5.86799 26.5 5.71875 26.3508 5.71875 26.1667V18.8333C5.71875 18.6492 5.86799 18.5 6.05208 18.5H13.3854Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M13.7188 3.83333C13.7188 3.64924 13.5695 3.5 13.3854 3.5H6.05208C5.86799 3.5 5.71875 3.64924 5.71875 3.83333V11.1667C5.71875 11.3508 5.86799 11.5 6.05208 11.5H13.3854C13.5695 11.5 13.7188 11.3508 13.7188 11.1667V3.83333Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12.7188 4.5V10.5H6.71875V4.5H12.7188ZM13.3854 3.5C13.5695 3.5 13.7188 3.64924 13.7188 3.83333V11.1667C13.7188 11.3508 13.5695 11.5 13.3854 11.5H6.05208C5.86799 11.5 5.71875 11.3508 5.71875 11.1667V3.83333C5.71875 3.64924 5.86799 3.5 6.05208 3.5H13.3854Z",
				fill: "#7070A9"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/LimitIcon.tsx
const LimitIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "28",
		height: "28",
		viewBox: "0 0 28 28",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M5.23592 4.768C5.24392 4.768 5.61192 4.752 6.33992 4.72L7.43192 4.672H7.50392V12.256H8.33192V13H8.22392C8.11992 12.976 7.63192 12.964 6.75992 12.964C5.89592 12.964 5.41192 12.976 5.30792 13H5.19992V12.256H6.02792V9.016C6.02792 6.856 6.01992 5.756 6.00392 5.716C5.96392 5.58 5.74792 5.512 5.35592 5.512H5.19992V4.768H5.23592ZM9.11595 5.68C9.11595 5.384 9.21195 5.14 9.40395 4.948C9.60395 4.756 9.85595 4.66 10.16 4.66C10.44 4.676 10.672 4.78 10.856 4.972C11.048 5.156 11.144 5.392 11.144 5.68C11.144 5.976 11.048 6.22 10.856 6.412C10.672 6.604 10.432 6.7 10.136 6.7C9.83995 6.7 9.59595 6.608 9.40395 6.424C9.21195 6.232 9.11595 5.984 9.11595 5.68ZM8.80395 7.696L9.88395 7.648L10.964 7.6H11.036V12.256H11.78V13H11.684C11.588 12.976 11.128 12.964 10.304 12.964C9.43195 12.964 8.94395 12.976 8.83995 13H8.73195V12.256H9.55995V10.492C9.55995 9.3 9.55595 8.688 9.54795 8.656C9.52395 8.56 9.45995 8.5 9.35595 8.476C9.25995 8.452 9.11195 8.44 8.91195 8.44H8.76795V7.696H8.80395ZM12.264 7.696C13.68 7.632 14.392 7.6 14.4 7.6H14.472V8.62L14.496 8.596C15 7.932 15.696 7.6 16.584 7.6C17.408 7.6 17.944 7.828 18.192 8.284C18.28 8.42 18.324 8.512 18.324 8.56C18.324 8.576 18.364 8.54 18.444 8.452C18.884 7.884 19.528 7.6 20.376 7.6C20.936 7.6 21.364 7.696 21.66 7.888C21.956 8.08 22.144 8.4 22.224 8.848C22.24 8.936 22.252 9.528 22.26 10.624V12.256H23.088V13H22.98C22.868 12.976 22.372 12.964 21.492 12.964C20.604 12.964 20.104 12.976 19.992 13H19.884V12.256H20.712V10.672C20.712 9.584 20.708 9.012 20.7 8.956C20.676 8.7 20.616 8.512 20.52 8.392C20.432 8.272 20.28 8.212 20.064 8.212C19.656 8.212 19.308 8.336 19.02 8.584C18.732 8.832 18.548 9.144 18.468 9.52C18.452 9.592 18.44 10.068 18.432 10.948V12.256H19.26V13H19.152C19.048 12.976 18.548 12.964 17.652 12.964C16.772 12.964 16.276 12.976 16.164 13H16.056V12.256H16.884V10.672C16.884 9.584 16.88 9.012 16.872 8.956C16.848 8.7 16.788 8.512 16.692 8.392C16.604 8.272 16.452 8.212 16.236 8.212C15.828 8.212 15.48 8.336 15.192 8.584C14.904 8.832 14.72 9.144 14.64 9.52C14.624 9.592 14.612 10.068 14.604 10.948V12.256H15.432V13H15.324C15.212 12.976 14.716 12.964 13.836 12.964C12.948 12.964 12.448 12.976 12.336 13H12.228V12.256H13.056V10.48C13.056 9.296 13.048 8.684 13.032 8.644C12.992 8.508 12.776 8.44 12.384 8.44H12.228V7.696H12.264Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M4.3125 18.05C4.3125 18.0224 4.33489 18 4.3625 18H8.2625C8.29011 18 8.3125 18.0224 8.3125 18.05V21.95C8.3125 21.9776 8.29011 22 8.2625 22H4.3625C4.33489 22 4.3125 21.9776 4.3125 21.95V18.05Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M4.3625 17H8.2625C8.8424 17 9.3125 17.4701 9.3125 18.05V21.95C9.3125 22.5299 8.8424 23 8.2625 23H4.3625C3.7826 23 3.3125 22.5299 3.3125 21.95V18.05C3.3125 17.4701 3.7826 17 4.3625 17ZM4.3625 18C4.33489 18 4.3125 18.0224 4.3125 18.05V21.95C4.3125 21.9776 4.33489 22 4.3625 22H8.2625C8.29011 22 8.3125 21.9776 8.3125 21.95V18.05C8.3125 18.0224 8.29011 18 8.2625 18H4.3625Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M20.3125 18.05C20.3125 18.0224 20.3349 18 20.3625 18H24.2625C24.2901 18 24.3125 18.0224 24.3125 18.05V21.95C24.3125 21.9776 24.2901 22 24.2625 22H20.3625C20.3349 22 20.3125 21.9776 20.3125 21.95V18.05Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M20.3625 17H24.2625C24.8424 17 25.3125 17.4701 25.3125 18.05V21.95C25.3125 22.5299 24.8424 23 24.2625 23H20.3625C19.7826 23 19.3125 22.5299 19.3125 21.95V18.05C19.3125 17.4701 19.7826 17 20.3625 17ZM20.3625 18C20.3349 18 20.3125 18.0224 20.3125 18.05V21.95C20.3125 21.9776 20.3349 22 20.3625 22H24.2625C24.2901 22 24.3125 21.9776 24.3125 21.95V18.05C24.3125 18.0224 24.2901 18 24.2625 18H20.3625Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M9.91849 19.992C9.91849 19.896 9.97715 19.816 10.0945 19.752H13.3985L16.7105 19.744C16.6092 19.6747 16.4705 19.544 16.2945 19.352C16.0012 19 15.7958 18.5973 15.6785 18.144C15.6572 18.048 15.6465 17.9973 15.6465 17.992C15.6465 17.9333 15.6758 17.8907 15.7345 17.864C15.7452 17.8587 15.7985 17.856 15.8945 17.856C15.9905 17.856 16.0465 17.8613 16.0625 17.872C16.0945 17.888 16.1238 17.944 16.1505 18.04C16.2518 18.4773 16.4572 18.8587 16.7665 19.184C17.0812 19.5093 17.4652 19.728 17.9185 19.84C18.0145 19.872 18.0652 19.9093 18.0705 19.952C18.0758 19.9627 18.0785 19.976 18.0785 19.992C18.0785 20.008 18.0758 20.024 18.0705 20.04C18.0705 20.0507 18.0678 20.0613 18.0625 20.072C18.0572 20.0773 18.0518 20.0827 18.0465 20.088C18.0412 20.0933 18.0305 20.1013 18.0145 20.112C18.0038 20.1173 17.9932 20.1227 17.9825 20.128C17.9772 20.128 17.9665 20.1307 17.9505 20.136C17.9398 20.1413 17.9292 20.1467 17.9185 20.152C17.4652 20.264 17.0812 20.4827 16.7665 20.808C16.4572 21.1333 16.2518 21.5147 16.1505 21.952C16.1238 22.048 16.0998 22.1013 16.0785 22.112C16.0625 22.128 15.9985 22.136 15.8865 22.136C15.7692 22.1307 15.6972 22.1093 15.6705 22.072C15.6438 22.0347 15.6465 21.9653 15.6785 21.864C15.7798 21.4213 15.9852 21.0133 16.2945 20.64C16.4385 20.4853 16.5772 20.352 16.7105 20.24H13.3985L10.0945 20.232C9.97715 20.1893 9.91849 20.1093 9.91849 19.992Z",
				fill: "#3A517F"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/Log10Icon.tsx
const Log10Icon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "34",
		height: "26",
		viewBox: "0 0 34 26",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M1.07039 9.768C1.07839 9.768 1.44639 9.752 2.17439 9.72L3.26639 9.672H3.33839V17.256H4.1664V18H4.0584C3.95439 17.976 3.46639 17.964 2.59439 17.964C1.73039 17.964 1.24639 17.976 1.14239 18H1.03439V17.256H1.86239V14.016C1.86239 11.856 1.85439 10.756 1.83839 10.716C1.79839 10.58 1.58239 10.512 1.19039 10.512H1.03439V9.768H1.07039ZM7.26643 12.576H7.43443C7.75443 12.576 7.94243 12.58 7.99843 12.588C9.26243 12.732 10.0744 13.336 10.4344 14.4C10.5384 14.736 10.5904 15.052 10.5904 15.348C10.5904 16.028 10.4064 16.592 10.0384 17.04C9.67043 17.48 9.17843 17.784 8.56243 17.952C8.27443 18.024 7.93043 18.06 7.53043 18.06C6.74643 18.06 6.12643 17.908 5.67043 17.604C4.87043 17.132 4.47043 16.388 4.47043 15.372C4.47043 14.66 4.67843 14.052 5.09443 13.548C5.55843 12.996 6.22243 12.676 7.08643 12.588C7.13443 12.58 7.19443 12.576 7.26643 12.576ZM8.58643 13.596C8.37043 13.324 7.99843 13.188 7.47043 13.188C7.14243 13.188 6.86243 13.272 6.63043 13.44C6.45443 13.576 6.33443 13.764 6.27043 14.004C6.21443 14.236 6.18643 14.648 6.18643 15.24C6.18643 15.776 6.20643 16.168 6.24643 16.416C6.29443 16.664 6.37443 16.856 6.48643 16.992C6.71043 17.264 7.05843 17.4 7.53043 17.4C8.00243 17.4 8.35043 17.264 8.57443 16.992C8.68643 16.856 8.76243 16.664 8.80243 16.416C8.85043 16.168 8.87443 15.776 8.87443 15.24C8.87443 14.728 8.85443 14.36 8.81443 14.136C8.77443 13.904 8.69843 13.724 8.58643 13.596ZM11.9008 17.82C11.6208 17.468 11.4808 17.104 11.4808 16.728C11.4808 16.36 11.5768 16.036 11.7688 15.756L11.8528 15.636L11.7568 15.552C11.4448 15.24 11.2888 14.856 11.2888 14.4C11.2888 13.936 11.4568 13.548 11.7928 13.236C12.2328 12.812 12.8848 12.6 13.7488 12.6C14.3328 12.6 14.8168 12.696 15.2008 12.888L15.3448 12.96C15.7128 12.68 16.1168 12.54 16.5568 12.54C16.7088 12.54 16.8408 12.564 16.9528 12.612C17.2408 12.764 17.3848 13.004 17.3848 13.332C17.3848 13.5 17.3288 13.644 17.2168 13.764C17.1048 13.876 16.9608 13.932 16.7848 13.932C16.6328 13.932 16.5048 13.892 16.4008 13.812C16.2968 13.732 16.2288 13.624 16.1968 13.488C16.1568 13.344 16.1688 13.248 16.2328 13.2C16.2488 13.192 16.2448 13.192 16.2208 13.2C16.2048 13.2 16.1768 13.204 16.1368 13.212C15.9368 13.268 15.8288 13.304 15.8128 13.32C15.8288 13.344 15.8528 13.384 15.8848 13.44C15.9248 13.496 15.9528 13.536 15.9688 13.56C15.9848 13.576 16.0048 13.612 16.0288 13.668C16.0608 13.716 16.0808 13.756 16.0888 13.788C16.1048 13.812 16.1208 13.852 16.1368 13.908C16.1608 13.956 16.1768 14.004 16.1848 14.052C16.1928 14.1 16.2008 14.156 16.2088 14.22C16.2168 14.276 16.2208 14.336 16.2208 14.4C16.2208 14.888 16.0528 15.28 15.7168 15.576C15.2688 16 14.5848 16.212 13.6648 16.212C13.1368 16.212 12.6888 16.12 12.3208 15.936C12.2648 16.032 12.2368 16.128 12.2368 16.224C12.2368 16.384 12.2808 16.524 12.3688 16.644C12.4568 16.764 12.5768 16.844 12.7288 16.884C12.7768 16.9 13.1488 16.908 13.8448 16.908C14.6208 16.916 15.0408 16.924 15.1048 16.932C15.7768 17.012 16.2968 17.196 16.6648 17.484C17.0328 17.764 17.2168 18.212 17.2168 18.828C17.2168 19.18 17.0648 19.484 16.7608 19.74C16.2168 20.188 15.3408 20.412 14.1328 20.412C12.9248 20.412 12.0488 20.188 11.5048 19.74C11.2008 19.492 11.0488 19.192 11.0488 18.84C11.0488 18.728 11.0528 18.652 11.0608 18.612C11.1168 18.444 11.2168 18.288 11.3608 18.144C11.5048 18 11.6688 17.9 11.8528 17.844L11.9008 17.82ZM16.5808 13.164C16.5808 13.164 16.5688 13.16 16.5448 13.152C16.5208 13.152 16.5088 13.156 16.5088 13.164H16.5808ZM14.6968 13.86C14.6168 13.428 14.3008 13.212 13.7488 13.212C13.1968 13.212 12.8848 13.428 12.8128 13.86C12.8048 13.916 12.8008 14.096 12.8008 14.4V14.532C12.8008 14.964 12.8728 15.244 13.0168 15.372C13.1848 15.524 13.4288 15.6 13.7488 15.6C14.3008 15.6 14.6168 15.384 14.6968 14.952C14.7128 14.84 14.7208 14.656 14.7208 14.4C14.7208 14.152 14.7128 13.972 14.6968 13.86ZM14.7568 18.252L14.3848 18.24C14.1288 18.24 13.9088 18.24 13.7248 18.24H13.1608C12.9048 18.24 12.7048 18.264 12.5608 18.312C12.3528 18.408 12.2488 18.58 12.2488 18.828C12.2488 19.076 12.3808 19.292 12.6448 19.476C13.0368 19.692 13.5328 19.8 14.1328 19.8C14.8928 19.8 15.4408 19.648 15.7768 19.344C15.9288 19.184 16.0048 19.02 16.0048 18.852C16.0048 18.668 15.9128 18.532 15.7288 18.444C15.5288 18.34 15.2048 18.276 14.7568 18.252Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M20.1576 22C20.0696 21.988 19.6956 21.982 19.0356 21.982C18.3756 21.982 18.0056 21.988 17.9256 22H17.8476V21.628H18.6336V20.176C18.6336 19.208 18.6296 18.724 18.6216 18.724C18.3976 18.792 18.1416 18.826 17.8536 18.826H17.7516V18.454H17.8536C18.3936 18.454 18.8156 18.342 19.1196 18.118L19.1856 18.07H19.2696C19.3576 18.07 19.4096 18.092 19.4256 18.136C19.4336 18.152 19.4376 18.738 19.4376 19.894V21.628H20.2356V22H20.1576ZM22.0188 18.076H22.1028C22.2548 18.076 22.3468 18.078 22.3788 18.082C23.0868 18.19 23.4828 18.66 23.5668 19.492C23.5868 19.664 23.5968 19.86 23.5968 20.08C23.5968 20.648 23.5268 21.072 23.3868 21.352C23.1588 21.824 22.7448 22.06 22.1448 22.06C21.4328 22.06 20.9848 21.732 20.8008 21.076C20.7288 20.844 20.6928 20.52 20.6928 20.104C20.6928 19.812 20.7108 19.554 20.7468 19.33C20.7868 19.106 20.8528 18.902 20.9448 18.718C21.0368 18.534 21.1648 18.388 21.3288 18.28C21.4968 18.172 21.7008 18.106 21.9408 18.082C21.9608 18.078 21.9868 18.076 22.0188 18.076ZM22.6668 18.712C22.5668 18.488 22.3908 18.376 22.1388 18.376C21.9828 18.376 21.8468 18.434 21.7308 18.55C21.6508 18.634 21.6008 18.744 21.5808 18.88C21.5648 19.016 21.5548 19.334 21.5508 19.834V20.134C21.5508 20.742 21.5668 21.132 21.5988 21.304C21.6228 21.432 21.6828 21.54 21.7788 21.628C21.8788 21.712 22.0008 21.754 22.1448 21.754C22.3608 21.754 22.5208 21.662 22.6248 21.478C22.6888 21.374 22.7248 21.104 22.7328 20.668C22.7328 20.636 22.7328 20.546 22.7328 20.398C22.7368 20.25 22.7388 20.126 22.7388 20.026C22.7388 19.582 22.7348 19.292 22.7268 19.156C22.7148 18.932 22.6948 18.784 22.6668 18.712Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M25.604 12.05C25.604 12.0224 25.6264 12 25.654 12H29.554C29.5816 12 29.604 12.0224 29.604 12.05V15.95C29.604 15.9776 29.5816 16 29.554 16H25.654C25.6264 16 25.604 15.9776 25.604 15.95V12.05Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M25.654 11H29.554C30.1339 11 30.604 11.4701 30.604 12.05V15.95C30.604 16.5299 30.1339 17 29.554 17H25.654C25.0741 17 24.604 16.5299 24.604 15.95V12.05C24.604 11.4701 25.0741 11 25.654 11ZM25.654 12C25.6264 12 25.604 12.0224 25.604 12.05V15.95C25.604 15.9776 25.6264 16 25.654 16H29.554C29.5816 16 29.604 15.9776 29.604 15.95V12.05C29.604 12.0224 29.5816 12 29.554 12H25.654Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M29.876 8.012H29.9C29.916 8.012 29.932 8.012 29.948 8.012C29.964 8.004 29.984 8 30.008 8C30.032 8 30.056 8 30.08 8H30.26C31.012 8.496 31.632 9.176 32.12 10.04C32.608 10.904 32.92 11.86 33.056 12.908C33.096 13.22 33.116 13.58 33.116 13.988C33.116 14.404 33.096 14.768 33.056 15.08C32.848 16.72 32.244 18.076 31.244 19.148C30.9 19.5 30.572 19.78 30.26 19.988H30.08C29.872 19.988 29.768 19.932 29.768 19.82C29.768 19.78 29.824 19.7 29.936 19.58C30.176 19.324 30.372 19.084 30.524 18.86C31.356 17.668 31.772 16.044 31.772 13.988C31.772 11.804 31.3 10.104 30.356 8.888C30.164 8.664 30.024 8.504 29.936 8.408C29.84 8.304 29.784 8.236 29.768 8.204C29.752 8.116 29.788 8.052 29.876 8.012Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M22.296 12.908C22.432 11.86 22.744 10.908 23.232 10.052C23.72 9.188 24.34 8.504 25.092 8H25.272C25.4 8 25.476 8.008 25.5 8.024C25.596 8.072 25.62 8.14 25.572 8.228C25.556 8.26 25.5 8.324 25.404 8.42C25.028 8.836 24.728 9.248 24.504 9.656C23.88 10.808 23.568 12.256 23.568 14C23.568 16.496 24.236 18.412 25.572 19.748C25.62 19.844 25.596 19.916 25.5 19.964C25.476 19.98 25.4 19.988 25.272 19.988H25.092C24.34 19.492 23.72 18.812 23.232 17.948C22.744 17.084 22.432 16.128 22.296 15.08C22.256 14.768 22.236 14.404 22.236 13.988C22.236 13.58 22.256 13.22 22.296 12.908Z",
				fill: "#3A517F"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/LogarithmIcon.tsx
const LogarithmIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "32",
		height: "26",
		viewBox: "0 0 32 26",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M1.2662 9.768C1.2742 9.768 1.6422 9.752 2.3702 9.72L3.4622 9.672H3.5342V17.256H4.3622V18H4.2542C4.1502 17.976 3.6622 17.964 2.7902 17.964C1.9262 17.964 1.4422 17.976 1.3382 18H1.2302V17.256H2.0582V14.016C2.0582 11.856 2.0502 10.756 2.0342 10.716C1.9942 10.58 1.7782 10.512 1.3862 10.512H1.2302V9.768H1.2662ZM7.46223 12.576H7.63023C7.95023 12.576 8.13823 12.58 8.19423 12.588C9.45823 12.732 10.2702 13.336 10.6302 14.4C10.7342 14.736 10.7862 15.052 10.7862 15.348C10.7862 16.028 10.6022 16.592 10.2342 17.04C9.86623 17.48 9.37423 17.784 8.75823 17.952C8.47023 18.024 8.12623 18.06 7.72623 18.06C6.94223 18.06 6.32223 17.908 5.86623 17.604C5.06623 17.132 4.66623 16.388 4.66623 15.372C4.66623 14.66 4.87423 14.052 5.29023 13.548C5.75423 12.996 6.41823 12.676 7.28223 12.588C7.33023 12.58 7.39023 12.576 7.46223 12.576ZM8.78223 13.596C8.56623 13.324 8.19423 13.188 7.66623 13.188C7.33823 13.188 7.05823 13.272 6.82623 13.44C6.65023 13.576 6.53023 13.764 6.46623 14.004C6.41023 14.236 6.38223 14.648 6.38223 15.24C6.38223 15.776 6.40223 16.168 6.44223 16.416C6.49023 16.664 6.57023 16.856 6.68223 16.992C6.90623 17.264 7.25423 17.4 7.72623 17.4C8.19823 17.4 8.54623 17.264 8.77023 16.992C8.88223 16.856 8.95823 16.664 8.99823 16.416C9.04623 16.168 9.07023 15.776 9.07023 15.24C9.07023 14.728 9.05023 14.36 9.01023 14.136C8.97023 13.904 8.89423 13.724 8.78223 13.596ZM12.0966 17.82C11.8166 17.468 11.6766 17.104 11.6766 16.728C11.6766 16.36 11.7726 16.036 11.9646 15.756L12.0486 15.636L11.9526 15.552C11.6406 15.24 11.4846 14.856 11.4846 14.4C11.4846 13.936 11.6526 13.548 11.9886 13.236C12.4286 12.812 13.0806 12.6 13.9446 12.6C14.5286 12.6 15.0126 12.696 15.3966 12.888L15.5406 12.96C15.9086 12.68 16.3126 12.54 16.7526 12.54C16.9046 12.54 17.0366 12.564 17.1486 12.612C17.4366 12.764 17.5806 13.004 17.5806 13.332C17.5806 13.5 17.5246 13.644 17.4126 13.764C17.3006 13.876 17.1566 13.932 16.9806 13.932C16.8286 13.932 16.7006 13.892 16.5966 13.812C16.4926 13.732 16.4246 13.624 16.3926 13.488C16.3526 13.344 16.3646 13.248 16.4286 13.2C16.4446 13.192 16.4406 13.192 16.4166 13.2C16.4006 13.2 16.3726 13.204 16.3326 13.212C16.1326 13.268 16.0246 13.304 16.0086 13.32C16.0246 13.344 16.0486 13.384 16.0806 13.44C16.1206 13.496 16.1486 13.536 16.1646 13.56C16.1806 13.576 16.2006 13.612 16.2246 13.668C16.2566 13.716 16.2766 13.756 16.2846 13.788C16.3006 13.812 16.3166 13.852 16.3326 13.908C16.3566 13.956 16.3726 14.004 16.3806 14.052C16.3886 14.1 16.3966 14.156 16.4046 14.22C16.4126 14.276 16.4166 14.336 16.4166 14.4C16.4166 14.888 16.2486 15.28 15.9126 15.576C15.4646 16 14.7806 16.212 13.8606 16.212C13.3326 16.212 12.8846 16.12 12.5166 15.936C12.4606 16.032 12.4326 16.128 12.4326 16.224C12.4326 16.384 12.4766 16.524 12.5646 16.644C12.6526 16.764 12.7726 16.844 12.9246 16.884C12.9726 16.9 13.3446 16.908 14.0406 16.908C14.8166 16.916 15.2366 16.924 15.3006 16.932C15.9726 17.012 16.4926 17.196 16.8606 17.484C17.2286 17.764 17.4126 18.212 17.4126 18.828C17.4126 19.18 17.2606 19.484 16.9566 19.74C16.4126 20.188 15.5366 20.412 14.3286 20.412C13.1206 20.412 12.2446 20.188 11.7006 19.74C11.3966 19.492 11.2446 19.192 11.2446 18.84C11.2446 18.728 11.2486 18.652 11.2566 18.612C11.3126 18.444 11.4126 18.288 11.5566 18.144C11.7006 18 11.8646 17.9 12.0486 17.844L12.0966 17.82ZM16.7766 13.164C16.7766 13.164 16.7646 13.16 16.7406 13.152C16.7166 13.152 16.7046 13.156 16.7046 13.164H16.7766ZM14.8926 13.86C14.8126 13.428 14.4966 13.212 13.9446 13.212C13.3926 13.212 13.0806 13.428 13.0086 13.86C13.0006 13.916 12.9966 14.096 12.9966 14.4V14.532C12.9966 14.964 13.0686 15.244 13.2126 15.372C13.3806 15.524 13.6246 15.6 13.9446 15.6C14.4966 15.6 14.8126 15.384 14.8926 14.952C14.9086 14.84 14.9166 14.656 14.9166 14.4C14.9166 14.152 14.9086 13.972 14.8926 13.86ZM14.9526 18.252L14.5806 18.24C14.3246 18.24 14.1046 18.24 13.9206 18.24H13.3566C13.1006 18.24 12.9006 18.264 12.7566 18.312C12.5486 18.408 12.4446 18.58 12.4446 18.828C12.4446 19.076 12.5766 19.292 12.8406 19.476C13.2326 19.692 13.7286 19.8 14.3286 19.8C15.0886 19.8 15.6366 19.648 15.9726 19.344C16.1246 19.184 16.2006 19.02 16.2006 18.852C16.2006 18.668 16.1086 18.532 15.9246 18.444C15.7246 18.34 15.4006 18.276 14.9526 18.252Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M22.7998 12.05C22.7998 12.0224 22.8222 12 22.8498 12H26.7498C26.7774 12 26.7998 12.0224 26.7998 12.05V15.95C26.7998 15.9776 26.7774 16 26.7498 16H22.8498C22.8222 16 22.7998 15.9776 22.7998 15.95V12.05Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M22.8498 11H26.7498C27.3297 11 27.7998 11.4701 27.7998 12.05V15.95C27.7998 16.5299 27.3297 17 26.7498 17H22.8498C22.2699 17 21.7998 16.5299 21.7998 15.95V12.05C21.7998 11.4701 22.2699 11 22.8498 11ZM22.8498 12C22.8222 12 22.7998 12.0224 22.7998 12.05V15.95C22.7998 15.9776 22.8222 16 22.8498 16H26.7498C26.7774 16 26.7998 15.9776 26.7998 15.95V12.05C26.7998 12.0224 26.7774 12 26.7498 12H22.8498Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M28.0718 8.012H28.0958C28.1118 8.012 28.1278 8.012 28.1438 8.012C28.1598 8.004 28.1798 8 28.2038 8C28.2278 8 28.2518 8 28.2758 8H28.4558C29.2078 8.496 29.8278 9.176 30.3158 10.04C30.8038 10.904 31.1158 11.86 31.2518 12.908C31.2918 13.22 31.3118 13.58 31.3118 13.988C31.3118 14.404 31.2918 14.768 31.2518 15.08C31.0438 16.72 30.4398 18.076 29.4398 19.148C29.0958 19.5 28.7678 19.78 28.4558 19.988H28.2758C28.0678 19.988 27.9638 19.932 27.9638 19.82C27.9638 19.78 28.0198 19.7 28.1318 19.58C28.3718 19.324 28.5678 19.084 28.7198 18.86C29.5518 17.668 29.9678 16.044 29.9678 13.988C29.9678 11.804 29.4958 10.104 28.5518 8.888C28.3598 8.664 28.2198 8.504 28.1318 8.408C28.0358 8.304 27.9798 8.236 27.9638 8.204C27.9478 8.116 27.9838 8.052 28.0718 8.012Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M18.4918 12.908C18.6278 11.86 18.9398 10.908 19.4278 10.052C19.9158 9.188 20.5358 8.504 21.2878 8H21.4678C21.5958 8 21.6718 8.008 21.6958 8.024C21.7918 8.072 21.8158 8.14 21.7678 8.228C21.7518 8.26 21.6958 8.324 21.5998 8.42C21.2238 8.836 20.9238 9.248 20.6998 9.656C20.0758 10.808 19.7638 12.256 19.7638 14C19.7638 16.496 20.4318 18.412 21.7678 19.748C21.8158 19.844 21.7918 19.916 21.6958 19.964C21.6718 19.98 21.5958 19.988 21.4678 19.988H21.2878C20.5358 19.492 19.9158 18.812 19.4278 17.948C18.9398 17.084 18.6278 16.128 18.4918 15.08C18.4518 14.768 18.4318 14.404 18.4318 13.988C18.4318 13.58 18.4518 13.22 18.4918 12.908Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M16.5557 20H18.5557V22H16.5557V20Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M15.5557 19H19.5557V23H15.5557V19ZM16.5557 20V22H18.5557V20H16.5557Z",
				fill: "#7070A9"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/NaturalLogIcon.tsx
const NaturalLogIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "28",
		height: "20",
		viewBox: "0 0 28 20",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M1.09666 6.768C1.10466 6.768 1.47266 6.752 2.20066 6.72L3.29266 6.672H3.36466V14.256H4.19266V15H4.08466C3.98066 14.976 3.49266 14.964 2.62066 14.964C1.75666 14.964 1.27266 14.976 1.16866 15H1.06066V14.256H1.88866V11.016C1.88866 8.856 1.88066 7.756 1.86466 7.716C1.82466 7.58 1.60866 7.512 1.21666 7.512H1.06066V6.768H1.09666ZM4.5927 9.696C6.0087 9.632 6.7207 9.6 6.7287 9.6H6.8007V10.116L6.8127 10.62C7.1167 10.116 7.6647 9.784 8.4567 9.624C8.5527 9.608 8.6967 9.6 8.8887 9.6C9.4487 9.6 9.8727 9.696 10.1607 9.888C10.4487 10.08 10.6367 10.4 10.7247 10.848C10.7407 10.936 10.7527 11.528 10.7607 12.624V14.256H11.5887V15H11.4807C11.3767 14.976 10.8767 14.964 9.9807 14.964C9.1007 14.964 8.6047 14.976 8.4927 15H8.3847V14.256H9.2127V12.672C9.2127 11.584 9.2087 11.012 9.2007 10.956C9.1767 10.7 9.1167 10.512 9.0207 10.392C8.9327 10.272 8.7807 10.212 8.5647 10.212C8.1567 10.212 7.8087 10.336 7.5207 10.584C7.2327 10.832 7.0487 11.144 6.9687 11.52C6.9527 11.592 6.9407 12.068 6.9327 12.948V14.256H7.7607V15H7.6527C7.5407 14.976 7.0447 14.964 6.1647 14.964C5.2767 14.964 4.7767 14.976 4.6647 15H4.5567V14.256H5.3847V12.48C5.3847 11.296 5.3767 10.684 5.3607 10.644C5.3207 10.508 5.1047 10.44 4.7127 10.44H4.5567V9.696H4.5927Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M17.8213 9.05C17.8213 9.02239 17.8437 9 17.8713 9H21.7713C21.7989 9 21.8213 9.02239 21.8213 9.05V12.95C21.8213 12.9776 21.7989 13 21.7713 13H17.8713C17.8437 13 17.8213 12.9776 17.8213 12.95V9.05Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M17.8713 8H21.7713C22.3512 8 22.8213 8.4701 22.8213 9.05V12.95C22.8213 13.5299 22.3512 14 21.7713 14H17.8713C17.2914 14 16.8213 13.5299 16.8213 12.95V9.05C16.8213 8.4701 17.2914 8 17.8713 8ZM17.8713 9C17.8437 9 17.8213 9.02239 17.8213 9.05V12.95C17.8213 12.9776 17.8437 13 17.8713 13H21.7713C21.7989 13 21.8213 12.9776 21.8213 12.95V9.05C21.8213 9.02239 21.7989 9 21.7713 9H17.8713Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M22.6973 5.012H22.7213C22.7373 5.012 22.7533 5.012 22.7693 5.012C22.7853 5.004 22.8053 5 22.8293 5C22.8533 5 22.8773 5 22.9013 5H23.0813C23.8333 5.496 24.4533 6.176 24.9413 7.04C25.4293 7.904 25.7413 8.86 25.8773 9.908C25.9173 10.22 25.9373 10.58 25.9373 10.988C25.9373 11.404 25.9173 11.768 25.8773 12.08C25.6693 13.72 25.0653 15.076 24.0653 16.148C23.7213 16.5 23.3933 16.78 23.0813 16.988H22.9013C22.6933 16.988 22.5893 16.932 22.5893 16.82C22.5893 16.78 22.6453 16.7 22.7573 16.58C22.9973 16.324 23.1933 16.084 23.3453 15.86C24.1773 14.668 24.5933 13.044 24.5933 10.988C24.5933 8.804 24.1213 7.104 23.1773 5.888C22.9853 5.664 22.8453 5.504 22.7573 5.408C22.6613 5.304 22.6053 5.236 22.5893 5.204C22.5733 5.116 22.6093 5.052 22.6973 5.012Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M13.4479 9.908C13.5839 8.86 13.8959 7.908 14.3839 7.052C14.8719 6.188 15.4919 5.504 16.2439 5H16.4239C16.5519 5 16.6279 5.008 16.6519 5.024C16.7479 5.072 16.7719 5.14 16.7239 5.228C16.7079 5.26 16.6519 5.324 16.5559 5.42C16.1799 5.836 15.8799 6.248 15.6559 6.656C15.0319 7.808 14.7199 9.256 14.7199 11C14.7199 13.496 15.3879 15.412 16.7239 16.748C16.7719 16.844 16.7479 16.916 16.6519 16.964C16.6279 16.98 16.5519 16.988 16.4239 16.988H16.2439C15.4919 16.492 14.8719 15.812 14.3839 14.948C13.8959 14.084 13.5839 13.128 13.4479 12.08C13.4079 11.768 13.3879 11.404 13.3879 10.988C13.3879 10.58 13.4079 10.22 13.4479 9.908Z",
				fill: "#3A517F"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/NiceFractionIcon.tsx
const NiceFractionIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "22",
		height: "26",
		viewBox: "0 0 22 26",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M0.662109 5.33333C0.662109 5.14924 0.811348 5 0.995443 5H8.32878C8.51287 5 8.66211 5.14924 8.66211 5.33333V12.6667C8.66211 12.8508 8.51287 13 8.32878 13H0.995443C0.811348 13 0.662109 12.8508 0.662109 12.6667V5.33333Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M1.66211 6V12H7.66211V6H1.66211ZM0.995443 5C0.811348 5 0.662109 5.14924 0.662109 5.33333V12.6667C0.662109 12.8508 0.811348 13 0.995443 13H8.32878C8.51287 13 8.66211 12.8508 8.66211 12.6667V5.33333C8.66211 5.14924 8.51287 5 8.32878 5H0.995443Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M13.3379 13.3333C13.3379 13.1492 13.4871 13 13.6712 13H21.0046C21.1887 13 21.3379 13.1492 21.3379 13.3333V20.6667C21.3379 20.8508 21.1887 21 21.0046 21H13.6712C13.4871 21 13.3379 20.8508 13.3379 20.6667V13.3333Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M14.3379 14V20H20.3379V14H14.3379ZM13.6712 13C13.4871 13 13.3379 13.1492 13.3379 13.3333V20.6667C13.3379 20.8508 13.4871 21 13.6712 21H21.0046C21.1887 21 21.3379 20.8508 21.3379 20.6667V13.3333C21.3379 13.1492 21.1887 13 21.0046 13H13.6712Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M6.01789 18L15.5579 5.148H16.9799L7.43989 18H6.01789Z",
				fill: "#3B404F"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/NotElementOfIcon.tsx
const NotElementOfIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "28",
		height: "26",
		viewBox: "0 0 28 26",
		...props,
		children: [/* @__PURE__ */ jsx("path", { d: "M16.6627 5.68C16.7227 5.56 16.8307 5.5 16.9867 5.5C17.0827 5.512 17.1667 5.554 17.2387 5.626C17.3107 5.698 17.3407 5.776 17.3287 5.86C17.3287 5.92 16.2847 8.818 14.1967 14.554C12.1207 20.278 11.0527 23.2 10.9927 23.32C10.9207 23.44 10.8247 23.5 10.7047 23.5C10.6087 23.5 10.5247 23.464 10.4527 23.392C10.3807 23.332 10.3447 23.254 10.3447 23.158C10.3447 23.038 11.3887 20.11 13.4767 14.374C15.5647 8.626 16.6267 5.728 16.6627 5.68Z" }), /* @__PURE__ */ jsx("path", { d: "M9.3457 14.5C9.3457 13.072 9.8257 11.884 10.7857 10.936C11.7577 9.98803 12.9337 9.44203 14.3137 9.29803C14.3257 9.29803 14.4277 9.29803 14.6197 9.29803C14.8117 9.28603 15.0637 9.28003 15.3757 9.28003C15.6877 9.28003 15.9877 9.28003 16.2757 9.28003H18.0577C18.2377 9.36403 18.3277 9.48403 18.3277 9.64003C18.3277 9.76003 18.2497 9.87403 18.0937 9.98203L16.2217 10C14.8897 10.012 14.0677 10.048 13.7557 10.108C12.8557 10.336 12.0877 10.744 11.4517 11.332C10.8157 11.908 10.3897 12.61 10.1737 13.438C10.1017 13.726 10.0657 13.948 10.0657 14.104V14.14H18.0577C18.2377 14.236 18.3277 14.356 18.3277 14.5C18.3277 14.644 18.2377 14.764 18.0577 14.86H10.0657V14.896C10.0657 15.052 10.1017 15.274 10.1737 15.562C10.3897 16.378 10.8157 17.086 11.4517 17.686C12.0997 18.286 12.8617 18.682 13.7377 18.874C14.0617 18.946 14.8897 18.988 16.2217 19H18.0937C18.2497 19.108 18.3277 19.228 18.3277 19.36C18.3277 19.516 18.2377 19.636 18.0577 19.72H16.3117C15.0037 19.72 14.2057 19.696 13.9177 19.648C12.8137 19.468 11.8417 19 11.0017 18.244C10.1737 17.488 9.6517 16.588 9.4357 15.544C9.3757 15.268 9.3457 14.92 9.3457 14.5Z" })]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/NotEqualIcon.tsx
const NotEqualIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "28",
		height: "26",
		viewBox: "0 0 28 26",
		...props,
		children: [/* @__PURE__ */ jsx("path", { d: "M8.00317 12.754C8.00317 12.598 8.08717 12.478 8.25517 12.394H19.7212C19.9012 12.478 19.9912 12.598 19.9912 12.754C19.9912 12.886 19.9072 13 19.7392 13.096L14.0152 13.114H8.29117C8.09917 13.054 8.00317 12.934 8.00317 12.754ZM8.00317 16.246C8.00317 16.066 8.09917 15.946 8.29117 15.886H19.7392C19.7512 15.898 19.7752 15.922 19.8112 15.958C19.8592 15.982 19.8892 16.006 19.9012 16.03C19.9252 16.042 19.9432 16.072 19.9552 16.12C19.9792 16.156 19.9912 16.198 19.9912 16.246C19.9912 16.402 19.9012 16.522 19.7212 16.606H8.25517C8.08717 16.522 8.00317 16.402 8.00317 16.246Z" }), /* @__PURE__ */ jsx("path", { d: "M16.826 5.68C16.886 5.56 16.9941 5.5 17.15 5.5C17.2461 5.512 17.33 5.554 17.402 5.626C17.474 5.698 17.5041 5.776 17.4921 5.86C17.4921 5.92 16.4481 8.818 14.36 14.554C12.284 20.278 11.216 23.2 11.156 23.32C11.084 23.44 10.988 23.5 10.868 23.5C10.772 23.5 10.688 23.464 10.616 23.392C10.544 23.332 10.508 23.254 10.508 23.158C10.508 23.038 11.552 20.11 13.64 14.374C15.728 8.626 16.79 5.728 16.826 5.68Z" })]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/NotExistsIcon.tsx
const NotExistsIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "27",
		height: "28",
		viewBox: "0 0 27 28",
		...props,
		children: [/* @__PURE__ */ jsx("path", { d: "M9.75858 9.228C9.59058 9.144 9.50658 9.024 9.50658 8.868C9.50658 8.712 9.59058 8.592 9.75858 8.508H17.2646C17.3846 8.604 17.4626 8.694 17.4986 8.778V20.73C17.4746 20.79 17.3966 20.874 17.2646 20.982L13.5206 21H9.75858C9.59058 20.916 9.50658 20.796 9.50658 20.64C9.50658 20.484 9.59058 20.364 9.75858 20.28H16.7786V15.114H10.0106C9.84258 15.03 9.75858 14.91 9.75858 14.754C9.75858 14.598 9.84258 14.478 10.0106 14.394H16.7786V9.228H9.75858Z" }), /* @__PURE__ */ jsx("path", { d: "M16.3256 5.96491C16.3856 5.84491 16.4936 5.78491 16.6496 5.78491C16.7456 5.79691 16.8296 5.83891 16.9016 5.91091C16.9736 5.98291 17.0036 6.06091 16.9916 6.14491C16.9916 6.20491 15.9476 9.10291 13.8596 14.8389C11.7836 20.5629 10.7156 23.4849 10.6556 23.6049C10.5836 23.7249 10.4876 23.7849 10.3676 23.7849C10.2716 23.7849 10.1876 23.7489 10.1156 23.6769C10.0436 23.6169 10.0076 23.5389 10.0076 23.4429C10.0076 23.3229 11.0516 20.3949 13.1396 14.6589C15.2276 8.91091 16.2896 6.01291 16.3256 5.96491Z" })]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/OpenBracketFractionIcon.tsx
const OpenBracketFractionIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "24",
		height: "29",
		viewBox: "0 0 24 29",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M10.812 23.158C10.812 23.314 10.776 23.428 10.704 23.5H10.38C9.468 23.5 8.682 23.344 8.022 23.032C7.374 22.732 6.972 22.258 6.816 21.61C6.792 21.526 6.774 20.656 6.762 19C6.762 18.748 6.762 18.43 6.762 18.046C6.75 16.978 6.72 16.378 6.672 16.246C6.66 16.234 6.654 16.222 6.654 16.21C6.51 15.838 6.234 15.52 5.826 15.256C5.418 14.98 4.968 14.842 4.476 14.842C4.344 14.842 4.26 14.824 4.224 14.788C4.188 14.752 4.17 14.656 4.17 14.5C4.17 14.344 4.188 14.248 4.224 14.212C4.26 14.176 4.344 14.158 4.476 14.158C4.968 14.158 5.418 14.026 5.826 13.762C6.234 13.486 6.51 13.162 6.654 12.79C6.702 12.646 6.726 12.496 6.726 12.34C6.738 12.184 6.75 11.398 6.762 9.982C6.774 8.338 6.792 7.474 6.816 7.39C6.912 7.006 7.104 6.688 7.392 6.436C7.92 5.908 8.718 5.602 9.786 5.518C9.81 5.518 9.888 5.518 10.02 5.518C10.164 5.506 10.272 5.5 10.344 5.5H10.704C10.776 5.572 10.812 5.68 10.812 5.824C10.812 5.98 10.794 6.076 10.758 6.112C10.734 6.148 10.638 6.166 10.47 6.166C9.798 6.202 9.24 6.394 8.796 6.742C8.556 6.922 8.4 7.126 8.328 7.354C8.268 7.51 8.238 8.398 8.238 10.018C8.238 11.578 8.232 12.394 8.22 12.466C8.1 13.402 7.38 14.08 6.06 14.5C7.392 14.956 8.112 15.634 8.22 16.534C8.232 16.606 8.238 17.422 8.238 18.982C8.238 20.602 8.268 21.49 8.328 21.646C8.448 21.982 8.712 22.258 9.12 22.474C9.528 22.69 9.978 22.81 10.47 22.834C10.638 22.834 10.734 22.852 10.758 22.888C10.794 22.924 10.812 23.014 10.812 23.158Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M13 6.33333C13 6.14924 13.1492 6 13.3333 6H20.6667C20.8508 6 21 6.14924 21 6.33333V13.6667C21 13.8508 20.8508 14 20.6667 14H13.3333C13.1492 14 13 13.8508 13 13.6667V6.33333Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M14 7V13H20V7H14ZM13.3333 6C13.1492 6 13 6.14924 13 6.33333V13.6667C13 13.8508 13.1492 14 13.3333 14H20.6667C20.8508 14 21 13.8508 21 13.6667V6.33333C21 6.14924 20.8508 6 20.6667 6H13.3333Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M13 15.3333C13 15.1492 13.1492 15 13.3333 15H20.6667C20.8508 15 21 15.1492 21 15.3333V22.6667C21 22.8508 20.8508 23 20.6667 23H13.3333C13.1492 23 13 22.8508 13 22.6667V15.3333Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M14 16V22H20V16H14ZM13.3333 15C13.1492 15 13 15.1492 13 15.3333V22.6667C13 22.8508 13.1492 23 13.3333 23H20.6667C20.8508 23 21 22.8508 21 22.6667V15.3333C21 15.1492 20.8508 15 20.6667 15H13.3333Z",
				fill: "#7070A9"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/OverbarIcon.tsx
const OverbarIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "20",
		height: "26",
		viewBox: "0 0 20 26",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M2 4H18",
				stroke: "#3A517F",
				strokeWidth: "0.64",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M4 7.5C4 7.22386 4.22386 7 4.5 7H15.5C15.7761 7 16 7.22386 16 7.5V18.5C16 18.7761 15.7761 19 15.5 19H4.5C4.22386 19 4 18.7761 4 18.5V7.5Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M5 8V18H15V8H5ZM4.5 7C4.22386 7 4 7.22386 4 7.5V18.5C4 18.7761 4.22386 19 4.5 19H15.5C15.7761 19 16 18.7761 16 18.5V7.5C16 7.22386 15.7761 7 15.5 7H4.5Z",
				fill: "#7070A9"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/OverLeftArrowIcon.tsx
const OverLeftArrowIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "16",
		height: "30",
		viewBox: "0 0 16 30",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M14.864 8.68C15.024 8.76533 15.104 8.872 15.104 9C15.104 9.128 15.024 9.23467 14.864 9.32H2.64L2.688 9.368C3.78667 10.2107 4.50667 11.288 4.848 12.6C4.912 12.8347 4.944 12.968 4.944 13C4.944 13.1173 4.832 13.176 4.608 13.176C4.48 13.176 4.39467 13.16 4.352 13.128C4.32 13.1067 4.29333 13.0427 4.272 12.936C4.25067 12.8613 4.22933 12.7707 4.208 12.664C4.016 11.8853 3.648 11.192 3.104 10.584C2.57067 9.976 1.92533 9.52267 1.168 9.224C1.008 9.16 0.912 9.10133 0.88 9.048C0.88 8.90933 0.976 8.81867 1.168 8.776C1.92533 8.47733 2.57067 8.024 3.104 7.416C3.648 6.808 4.016 6.11467 4.208 5.336C4.21867 5.304 4.22933 5.256 4.24 5.192C4.25067 5.128 4.256 5.08533 4.256 5.064C4.26667 5.04267 4.27733 5.01067 4.288 4.968C4.30933 4.92533 4.33067 4.89867 4.352 4.888C4.37333 4.86667 4.40533 4.85067 4.448 4.84C4.49067 4.82933 4.544 4.824 4.608 4.824C4.832 4.824 4.944 4.88267 4.944 5C4.944 5.032 4.912 5.16533 4.848 5.4C4.528 6.66933 3.808 7.74667 2.688 8.632L2.64 8.68H14.864Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M2 14.7949C2 14.5187 2.22386 14.2949 2.5 14.2949H13.5C13.7761 14.2949 14 14.5187 14 14.7949V25.7949C14 26.071 13.7761 26.2949 13.5 26.2949H2.5C2.22386 26.2949 2 26.071 2 25.7949V14.7949Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M3 15.2949V25.2949H13V15.2949H3ZM2.5 14.2949C2.22386 14.2949 2 14.5187 2 14.7949V25.7949C2 26.071 2.22386 26.2949 2.5 26.2949H13.5C13.7761 26.2949 14 26.071 14 25.7949V14.7949C14 14.5187 13.7761 14.2949 13.5 14.2949H2.5Z",
				fill: "#7070A9"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/OverLeftRightArrowIcon.tsx
const OverLeftRightArrowIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "28",
		height: "30",
		viewBox: "0 0 28 30",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M3.29438 9.22H24.7004C24.0377 8.72533 23.5244 8.128 23.1604 7.428C22.927 6.98 22.773 6.53667 22.6984 6.098C22.6984 6.07933 22.6937 6.06067 22.6844 6.042C22.6844 6.02333 22.6844 6.00933 22.6844 6C22.6844 5.89733 22.7777 5.846 22.9644 5.846C23.0764 5.846 23.1464 5.86 23.1744 5.888C23.2117 5.90667 23.2397 5.958 23.2584 6.042C23.2864 6.22867 23.3377 6.42 23.4124 6.616C23.6177 7.24133 23.9584 7.80133 24.4344 8.296C24.9104 8.78133 25.4657 9.13133 26.1004 9.346C26.1844 9.374 26.2264 9.42533 26.2264 9.5C26.2264 9.57467 26.1844 9.626 26.1004 9.654C25.4657 9.86867 24.9104 10.2233 24.4344 10.718C23.9584 11.2033 23.6177 11.7587 23.4124 12.384C23.347 12.58 23.2957 12.7667 23.2584 12.944C23.2397 13.0373 23.2117 13.0933 23.1744 13.112C23.1464 13.14 23.0764 13.154 22.9644 13.154C22.7684 13.154 22.6704 13.1027 22.6704 13C22.6704 12.972 22.6984 12.8553 22.7544 12.65C23.0437 11.4833 23.6924 10.5267 24.7004 9.78H3.29438L3.33638 9.822C4.29771 10.5593 4.92771 11.502 5.22638 12.65C5.28238 12.8553 5.31038 12.972 5.31038 13C5.31038 13.1027 5.21238 13.154 5.01638 13.154C4.90438 13.154 4.82971 13.14 4.79238 13.112C4.76438 13.0933 4.74104 13.0373 4.72238 12.944C4.70371 12.8787 4.68504 12.7993 4.66638 12.706C4.49838 12.0247 4.17638 11.418 3.70038 10.886C3.23371 10.354 2.66904 9.95733 2.00638 9.696C1.86638 9.64 1.78238 9.58867 1.75438 9.542C1.75438 9.42067 1.83838 9.34133 2.00638 9.304C2.66904 9.04267 3.23371 8.646 3.70038 8.114C4.17638 7.582 4.49838 6.97533 4.66638 6.294C4.67571 6.266 4.68504 6.224 4.69438 6.168C4.70371 6.112 4.70838 6.07467 4.70838 6.056C4.71771 6.03733 4.72704 6.00933 4.73638 5.972C4.75504 5.93467 4.77371 5.91133 4.79238 5.902C4.81104 5.88333 4.83904 5.86933 4.87638 5.86C4.91371 5.85067 4.96038 5.846 5.01638 5.846C5.21238 5.846 5.31038 5.89733 5.31038 6C5.31038 6.028 5.28238 6.14467 5.22638 6.35C4.94638 7.46067 4.31638 8.40333 3.33638 9.178L3.29438 9.22Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M8 14.7949C8 14.5188 8.22386 14.2949 8.5 14.2949H19.5C19.7761 14.2949 20 14.5188 20 14.7949V25.7949C20 26.0711 19.7761 26.2949 19.5 26.2949H8.5C8.22386 26.2949 8 26.0711 8 25.7949V14.7949Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M9 15.2949V25.2949H19V15.2949H9ZM8.5 14.2949C8.22386 14.2949 8 14.5188 8 14.7949V25.7949C8 26.0711 8.22386 26.2949 8.5 26.2949H19.5C19.7761 26.2949 20 26.0711 20 25.7949V14.7949C20 14.5188 19.7761 14.2949 19.5 14.2949H8.5Z",
				fill: "#7070A9"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/OverlineSegmentIcon.tsx
const OverlineSegmentIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "22",
		height: "22",
		viewBox: "0 0 22 22",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M5 5.5C5 5.22386 5.22386 5 5.5 5H16.5C16.7761 5 17 5.22386 17 5.5V16.5C17 16.7761 16.7761 17 16.5 17H5.5C5.22386 17 5 16.7761 5 16.5V5.5Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M6 6V16H16V6H6ZM5.5 5C5.22386 5 5 5.22386 5 5.5V16.5C5 16.7761 5.22386 17 5.5 17H16.5C16.7761 17 17 16.7761 17 16.5V5.5C17 5.22386 16.7761 5 16.5 5H5.5Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M3 1V3",
				stroke: "#3A517F",
				strokeWidth: "0.64",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M19 1V3",
				stroke: "#3A517F",
				strokeWidth: "0.64",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M3 2H19",
				stroke: "#3A517F",
				strokeWidth: "0.64",
				strokeLinecap: "round"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/OverRightArrowIcon.tsx
const OverRightArrowIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "16",
		height: "30",
		viewBox: "0 0 16 30",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M1.12 9.32C0.970667 9.24533 0.896 9.13867 0.896 9C0.896 8.86133 0.970667 8.75467 1.12 8.68H13.36C12.6027 8.11467 12.016 7.432 11.6 6.632C11.3333 6.12 11.1573 5.61333 11.072 5.112C11.072 5.09067 11.0667 5.06933 11.056 5.048C11.056 5.02667 11.056 5.01067 11.056 5C11.056 4.88267 11.1627 4.824 11.376 4.824C11.504 4.824 11.584 4.84 11.616 4.872C11.6587 4.89333 11.6907 4.952 11.712 5.048C11.744 5.26133 11.8027 5.48 11.888 5.704C12.1227 6.41867 12.512 7.05867 13.056 7.624C13.6 8.17867 14.2347 8.57867 14.96 8.824C15.056 8.856 15.104 8.91467 15.104 9C15.104 9.08533 15.056 9.144 14.96 9.176C14.2347 9.42133 13.6 9.82667 13.056 10.392C12.512 10.9467 12.1227 11.5813 11.888 12.296C11.8133 12.52 11.7547 12.7333 11.712 12.936C11.6907 13.0427 11.6587 13.1067 11.616 13.128C11.584 13.16 11.504 13.176 11.376 13.176C11.152 13.176 11.04 13.1173 11.04 13C11.04 12.968 11.072 12.8347 11.136 12.6C11.4667 11.2667 12.208 10.1733 13.36 9.32H1.12Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M2 14.7949C2 14.5187 2.22386 14.2949 2.5 14.2949H13.5C13.7761 14.2949 14 14.5187 14 14.7949V25.7949C14 26.071 13.7761 26.2949 13.5 26.2949H2.5C2.22386 26.2949 2 26.071 2 25.7949V14.7949Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M3 15.2949V25.2949H13V15.2949H3ZM2.5 14.2949C2.22386 14.2949 2 14.5187 2 14.7949V25.7949C2 26.071 2.22386 26.2949 2.5 26.2949H13.5C13.7761 26.2949 14 26.071 14 25.7949V14.7949C14 14.5187 13.7761 14.2949 13.5 14.2949H2.5Z",
				fill: "#7070A9"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/PartialDerivativeIcon.tsx
const PartialDerivativeIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "16",
		height: "30",
		viewBox: "0 0 16 30",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M2.7365 6.904C2.5845 6.904 2.4565 6.864 2.3525 6.784C2.2565 6.696 2.2085 6.58 2.2085 6.436C2.2085 6.356 2.2245 6.264 2.2565 6.16C2.3765 5.728 2.5805 5.368 2.8685 5.08C3.1645 4.784 3.5165 4.584 3.9245 4.48C4.1245 4.44 4.2525 4.42 4.3085 4.42H4.4525C4.7165 4.42 4.8725 4.424 4.9205 4.432C5.5845 4.552 6.1125 4.892 6.5045 5.452C6.9045 6.004 7.1045 6.692 7.1045 7.516C7.1045 7.988 7.0165 8.552 6.8405 9.208C6.4245 10.656 5.8565 11.708 5.1365 12.364C4.4885 12.964 3.7725 13.264 2.9885 13.264C2.5645 13.264 2.2125 13.188 1.9325 13.036C1.6525 12.892 1.4045 12.656 1.1885 12.328C1.0125 12.072 0.8965 11.804 0.8405 11.524C0.8245 11.452 0.8165 11.308 0.8165 11.092C0.8165 10.836 0.8405 10.612 0.8885 10.42C1.0725 9.596 1.4645 8.912 2.0645 8.368C2.6085 7.872 3.1445 7.572 3.6725 7.468C3.8245 7.436 3.9925 7.42 4.1765 7.42C4.4165 7.42 4.6165 7.448 4.7765 7.504C5.3045 7.688 5.6365 8.052 5.7725 8.596L5.8085 8.464C5.9685 7.8 6.0485 7.252 6.0485 6.82C6.0485 5.9 5.7325 5.3 5.1005 5.02C4.8845 4.932 4.6645 4.888 4.4405 4.888C4.1365 4.888 3.8565 4.96 3.6005 5.104C3.3445 5.248 3.1405 5.432 2.9885 5.656C3.3165 5.712 3.4805 5.872 3.4805 6.136C3.4805 6.352 3.4045 6.536 3.2525 6.688C3.1085 6.832 2.9365 6.904 2.7365 6.904ZM5.4725 9.328C5.4725 8.488 5.1485 8.004 4.5005 7.876C4.4605 7.868 4.3965 7.864 4.3085 7.864C3.9245 7.864 3.5845 7.96 3.2885 8.152C3.0005 8.344 2.7765 8.592 2.6165 8.896C2.4565 9.168 2.2885 9.652 2.1125 10.348C1.9685 10.924 1.8965 11.344 1.8965 11.608C1.8965 12.368 2.2965 12.748 3.0965 12.748C3.1925 12.748 3.2645 12.744 3.3125 12.736C3.9285 12.632 4.4245 12.272 4.8005 11.656C4.9525 11.392 5.1045 11.016 5.2565 10.528C5.4005 10.072 5.4725 9.672 5.4725 9.328Z",
				fill: "#3B404F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M8 5.33333C8 5.14924 8.14924 5 8.33333 5H15.6667C15.8508 5 16 5.14924 16 5.33333V12.6667C16 12.8508 15.8508 13 15.6667 13H8.33333C8.14924 13 8 12.8508 8 12.6667V5.33333Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M9 6V12H15V6H9ZM8.33333 5C8.14924 5 8 5.14924 8 5.33333V12.6667C8 12.8508 8.14924 13 8.33333 13H15.6667C15.8508 13 16 12.8508 16 12.6667V5.33333C16 5.14924 15.8508 5 15.6667 5H8.33333Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M0 16H16",
				stroke: "#3A517F",
				strokeWidth: "0.5"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M8.66621 22.664C8.61821 22.616 8.59421 22.572 8.59421 22.532C8.62621 22.316 8.75021 22.04 8.96621 21.704C9.34221 21.136 9.81421 20.808 10.3822 20.72C10.4942 20.704 10.5782 20.696 10.6342 20.696C10.9142 20.696 11.1702 20.768 11.4022 20.912C11.6422 21.056 11.8142 21.236 11.9182 21.452C12.0222 21.316 12.0862 21.232 12.1102 21.2C12.4062 20.864 12.7462 20.696 13.1302 20.696C13.4582 20.696 13.7222 20.792 13.9222 20.984C14.1302 21.168 14.2342 21.396 14.2342 21.668C14.2342 21.916 14.1622 22.124 14.0182 22.292C13.8822 22.46 13.6982 22.544 13.4662 22.544C13.3142 22.544 13.1902 22.5 13.0942 22.412C12.9982 22.324 12.9502 22.208 12.9502 22.064C12.9502 21.696 13.1502 21.444 13.5502 21.308C13.5502 21.3 13.5062 21.272 13.4182 21.224C13.3382 21.176 13.2222 21.152 13.0702 21.152C12.9662 21.152 12.8902 21.16 12.8422 21.176C12.5382 21.304 12.3142 21.568 12.1702 21.968C12.1462 22.032 12.0302 22.48 11.8222 23.312C11.6142 24.136 11.5022 24.6 11.4862 24.704C11.4622 24.824 11.4502 24.944 11.4502 25.064C11.4502 25.256 11.5062 25.408 11.6182 25.52C11.7302 25.632 11.8782 25.688 12.0622 25.688C12.3982 25.688 12.7022 25.548 12.9742 25.268C13.2462 24.98 13.4302 24.664 13.5262 24.32C13.5502 24.24 13.5742 24.196 13.5982 24.188C13.6222 24.172 13.6862 24.164 13.7902 24.164C13.9422 24.164 14.0182 24.196 14.0182 24.26C14.0182 24.268 14.0102 24.312 13.9942 24.392C13.8582 24.888 13.5782 25.32 13.1542 25.688C12.7782 25.984 12.3822 26.132 11.9662 26.132C11.4062 26.132 10.9822 25.88 10.6942 25.376C10.4622 25.736 10.1662 25.976 9.80621 26.096C9.73421 26.112 9.63021 26.12 9.49421 26.12C9.03021 26.12 8.70221 25.956 8.51021 25.628C8.43021 25.492 8.39021 25.332 8.39021 25.148C8.39021 24.908 8.46221 24.704 8.60621 24.536C8.75021 24.368 8.93421 24.284 9.15821 24.284C9.50221 24.284 9.67421 24.452 9.67421 24.788C9.67421 25.084 9.53421 25.3 9.25421 25.436C9.23821 25.444 9.21821 25.456 9.19421 25.472C9.17021 25.48 9.15021 25.488 9.13421 25.496C9.11821 25.504 9.10621 25.508 9.09821 25.508L9.06221 25.52C9.06221 25.544 9.12221 25.58 9.24221 25.628C9.33821 25.668 9.44221 25.688 9.55421 25.688C9.84221 25.688 10.0902 25.508 10.2982 25.148C10.3862 25.004 10.5422 24.484 10.7662 23.588C10.8142 23.404 10.8662 23.2 10.9222 22.976C10.9782 22.752 11.0182 22.58 11.0422 22.46C11.0742 22.34 11.0942 22.268 11.1022 22.244C11.1422 22.028 11.1622 21.872 11.1622 21.776C11.1622 21.584 11.1102 21.432 11.0062 21.32C10.9022 21.208 10.7582 21.152 10.5742 21.152C10.2142 21.152 9.90221 21.292 9.63822 21.572C9.37421 21.844 9.19021 22.16 9.08621 22.52C9.07021 22.592 9.05021 22.636 9.02621 22.652C9.01021 22.66 8.94621 22.664 8.83421 22.664H8.66621Z",
				fill: "#0F172E"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M3.64031 19.904C3.48831 19.904 3.36031 19.864 3.25631 19.784C3.16031 19.696 3.11231 19.58 3.11231 19.436C3.11231 19.356 3.12831 19.264 3.16031 19.16C3.28031 18.728 3.48431 18.368 3.77231 18.08C4.06831 17.784 4.42031 17.584 4.82831 17.48C5.02831 17.44 5.15631 17.42 5.21231 17.42H5.35631C5.62031 17.42 5.77631 17.424 5.82431 17.432C6.48831 17.552 7.01631 17.892 7.40831 18.452C7.80831 19.004 8.00831 19.692 8.00831 20.516C8.00831 20.988 7.92031 21.552 7.74431 22.208C7.32831 23.656 6.76031 24.708 6.04031 25.364C5.39231 25.964 4.67631 26.264 3.89231 26.264C3.46831 26.264 3.11631 26.188 2.83631 26.036C2.55631 25.892 2.30831 25.656 2.09231 25.328C1.91631 25.072 1.80031 24.804 1.74431 24.524C1.72831 24.452 1.72031 24.308 1.72031 24.092C1.72031 23.836 1.74431 23.612 1.79231 23.42C1.97631 22.596 2.36831 21.912 2.96831 21.368C3.51231 20.872 4.04831 20.572 4.57631 20.468C4.72831 20.436 4.89631 20.42 5.08031 20.42C5.32031 20.42 5.52031 20.448 5.68031 20.504C6.20831 20.688 6.54031 21.052 6.67631 21.596L6.71231 21.464C6.87231 20.8 6.95231 20.252 6.95231 19.82C6.95231 18.9 6.63631 18.3 6.00431 18.02C5.78831 17.932 5.56831 17.888 5.34431 17.888C5.04031 17.888 4.76031 17.96 4.50431 18.104C4.24831 18.248 4.04431 18.432 3.89231 18.656C4.22031 18.712 4.38431 18.872 4.38431 19.136C4.38431 19.352 4.30831 19.536 4.15631 19.688C4.01231 19.832 3.84031 19.904 3.64031 19.904ZM6.37631 22.328C6.37631 21.488 6.05231 21.004 5.40431 20.876C5.36431 20.868 5.30031 20.864 5.21231 20.864C4.82831 20.864 4.48831 20.96 4.19231 21.152C3.90431 21.344 3.68031 21.592 3.52031 21.896C3.36031 22.168 3.19231 22.652 3.01631 23.348C2.87231 23.924 2.80031 24.344 2.80031 24.608C2.80031 25.368 3.20031 25.748 4.00031 25.748C4.09631 25.748 4.16831 25.744 4.21631 25.736C4.83231 25.632 5.32831 25.272 5.70431 24.656C5.85631 24.392 6.00831 24.016 6.16031 23.528C6.30431 23.072 6.37631 22.672 6.37631 22.328Z",
				fill: "#3B404F"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/PowerIcon.tsx
const PowerIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "28",
		height: "24",
		viewBox: "0 0 28 24",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M5 8.5C5 8.22386 5.22386 8 5.5 8H16.5C16.7761 8 17 8.22386 17 8.5V19.5C17 19.7761 16.7761 20 16.5 20H5.5C5.22386 20 5 19.7761 5 19.5V8.5Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M6 9V19H16V9H6ZM5.5 8C5.22386 8 5 8.22386 5 8.5V19.5C5 19.7761 5.22386 20 5.5 20H16.5C16.7761 20 17 19.7761 17 19.5V8.5C17 8.22386 16.7761 8 16.5 8H5.5Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M19 4.05C19 4.02239 19.0224 4 19.05 4H22.95C22.9776 4 23 4.02239 23 4.05V7.95C23 7.97761 22.9776 8 22.95 8H19.05C19.0224 8 19 7.97761 19 7.95V4.05Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M19.05 3H22.95C23.5299 3 24 3.4701 24 4.05V7.95C24 8.5299 23.5299 9 22.95 9H19.05C18.4701 9 18 8.5299 18 7.95V4.05C18 3.4701 18.4701 3 19.05 3ZM19.05 4C19.0224 4 19 4.02239 19 4.05V7.95C19 7.97761 19.0224 8 19.05 8H22.95C22.9776 8 23 7.97761 23 7.95V4.05C23 4.02239 22.9776 4 22.95 4H19.05Z",
				fill: "#7070A9"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/ProductIcon.tsx
const ProductIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "30",
		height: "31",
		viewBox: "0 0 30 31",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M22 11.3333C22 11.1492 22.1492 11 22.3333 11H29.6667C29.8508 11 30 11.1492 30 11.3333V18.6667C30 18.8508 29.8508 19 29.6667 19H22.3333C22.1492 19 22 18.8508 22 18.6667V11.3333Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M23 12V18H29V12H23ZM22.3333 11C22.1492 11 22 11.1492 22 11.3333V18.6667C22 18.8508 22.1492 19 22.3333 19H29.6667C29.8508 19 30 18.8508 30 18.6667V11.3333C30 11.1492 29.8508 11 29.6667 11H22.3333Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M15.4666 21.98C15.5946 22.524 16.064 22.8173 16.8746 22.86H17.0986V23.5H12.0106V22.86H12.2346C12.9813 22.8173 13.44 22.5667 13.6106 22.108L13.6586 21.98V8.14H7.21063V15.068L7.22663 21.98C7.35463 22.524 7.82396 22.8173 8.63463 22.86H8.85863V23.5H3.77063V22.86H3.99463C4.74129 22.8173 5.19996 22.5667 5.37063 22.108L5.41863 21.98V9.004L5.37063 8.892C5.19996 8.43333 4.74129 8.18267 3.99463 8.14H3.77063V7.5H17.0986V8.14H16.8746C16.448 8.16133 16.1226 8.24133 15.8986 8.38C15.6853 8.508 15.5413 8.716 15.4666 9.004V21.98Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M20 6.5H22V8.5H20V6.5Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M19 5.5H23V9.5H19V5.5ZM20 6.5V8.5H22V6.5H20Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M20 21.5H22V23.5H20V21.5Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M19 20.5H23V24.5H19V20.5ZM20 21.5V23.5H22V21.5H20Z",
				fill: "#7070A9"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/RightArrowBetweenIcon.tsx
const RightArrowBetweenIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "21",
		height: "30",
		viewBox: "0 0 21 30",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M9.73286 15.26C9.61286 15.324 9.55286 15.404 9.55286 15.5C9.55286 15.596 9.61286 15.676 9.73286 15.74H18.9009L18.8649 15.776C18.0409 16.408 17.5009 17.216 17.2449 18.2C17.1969 18.376 17.1729 18.476 17.1729 18.5C17.1729 18.588 17.2569 18.632 17.4249 18.632C17.5209 18.632 17.5849 18.62 17.6169 18.596C17.6409 18.58 17.6609 18.532 17.6769 18.452C17.6929 18.396 17.7089 18.328 17.7249 18.248C17.8689 17.664 18.1449 17.144 18.5529 16.688C18.9529 16.232 19.4369 15.892 20.0049 15.668C20.1249 15.62 20.1969 15.576 20.2209 15.536C20.2209 15.432 20.1489 15.364 20.0049 15.332C19.4369 15.108 18.9529 14.768 18.5529 14.312C18.1449 13.856 17.8689 13.336 17.7249 12.752C17.7169 12.728 17.7089 12.692 17.7009 12.644C17.6929 12.596 17.6889 12.564 17.6889 12.548C17.6809 12.532 17.6729 12.508 17.6649 12.476C17.6489 12.444 17.6329 12.424 17.6169 12.416C17.6009 12.4 17.5769 12.388 17.5449 12.38C17.5129 12.372 17.4729 12.368 17.4249 12.368C17.2569 12.368 17.1729 12.412 17.1729 12.5C17.1729 12.524 17.1969 12.624 17.2449 12.8C17.4849 13.752 18.0249 14.56 18.8649 15.224L18.9009 15.26H9.73286Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M1.11857 15.7527C0.986024 15.7527 0.878572 15.6452 0.878572 15.5127C0.878572 15.3801 0.986024 15.2727 1.11857 15.2727V15.7527ZM10.7178 15.7527H1.11857V15.2727H10.7178V15.7527Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M14.7188 18.8333C14.7188 18.6492 14.5695 18.5 14.3854 18.5H7.05208C6.86799 18.5 6.71875 18.6492 6.71875 18.8333V26.1667C6.71875 26.3508 6.86799 26.5 7.05208 26.5H14.3854C14.5695 26.5 14.7188 26.3508 14.7188 26.1667V18.8333Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M13.7188 19.5V25.5H7.71875V19.5H13.7188ZM14.3854 18.5C14.5695 18.5 14.7188 18.6492 14.7188 18.8333V26.1667C14.7188 26.3508 14.5695 26.5 14.3854 26.5H7.05208C6.86799 26.5 6.71875 26.3508 6.71875 26.1667V18.8333C6.71875 18.6492 6.86799 18.5 7.05208 18.5H14.3854Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M14.7188 3.83333C14.7188 3.64924 14.5695 3.5 14.3854 3.5H7.05208C6.86799 3.5 6.71875 3.64924 6.71875 3.83333V11.1667C6.71875 11.3508 6.86799 11.5 7.05208 11.5H14.3854C14.5695 11.5 14.7188 11.3508 14.7188 11.1667V3.83333Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M13.7188 4.5V10.5H7.71875V4.5H13.7188ZM14.3854 3.5C14.5695 3.5 14.7188 3.64924 14.7188 3.83333V11.1667C14.7188 11.3508 14.5695 11.5 14.3854 11.5H7.05208C6.86799 11.5 6.71875 11.3508 6.71875 11.1667V3.83333C6.71875 3.64924 6.86799 3.5 7.05208 3.5H14.3854Z",
				fill: "#7070A9"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/RootIcon.tsx
const RootIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "28",
		height: "28",
		viewBox: "0 0 28 28",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M15 13.4167C15 13.1865 15.1865 13 15.4167 13H24.5833C24.8135 13 25 13.1865 25 13.4167V22.5833C25 22.8135 24.8135 23 24.5833 23H15.4167C15.1865 23 15 22.8135 15 22.5833V13.4167Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M16 14V22H24V14H16ZM15.4167 13C15.1865 13 15 13.1865 15 13.4167V22.5833C15 22.8135 15.1865 23 15.4167 23H24.5833C24.8135 23 25 22.8135 25 22.5833V13.4167C25 13.1865 24.8135 13 24.5833 13H15.4167Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M6.28174 6.99775C6.28174 6.97014 6.30412 6.94775 6.33174 6.94775H10.2317C10.2594 6.94775 10.2817 6.97014 10.2817 6.99775V10.8978C10.2817 10.9254 10.2594 10.9478 10.2317 10.9478H6.33174C6.30412 10.9478 6.28174 10.9254 6.28174 10.8978V6.99775Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M6.33174 5.94775H10.2317C10.8116 5.94775 11.2817 6.41786 11.2817 6.99775V10.8978C11.2817 11.4777 10.8116 11.9478 10.2317 11.9478H6.33174C5.75184 11.9478 5.28174 11.4777 5.28174 10.8978V6.99775C5.28174 6.41785 5.75184 5.94775 6.33174 5.94775ZM6.33174 6.94775C6.30412 6.94775 6.28174 6.97014 6.28174 6.99775V10.8978C6.28174 10.9254 6.30412 10.9478 6.33174 10.9478H10.2317C10.2594 10.9478 10.2817 10.9254 10.2817 10.8978V6.99775C10.2817 6.97014 10.2594 6.94775 10.2317 6.94775H6.33174Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M16.2937 4.6C16.3897 4.6 16.4677 4.636 16.5277 4.708C16.5877 4.768 16.6237 4.84 16.6357 4.924V5.032L12.4417 13.726L8.21174 22.474C8.16374 22.558 8.04974 22.6 7.86974 22.6C7.76174 22.6 7.68974 22.582 7.65374 22.546L4.16174 14.95L2.99174 15.796C2.93174 15.796 2.84774 15.748 2.73974 15.652C2.63174 15.544 2.57774 15.454 2.57774 15.382C2.57774 15.334 2.76974 15.154 3.15374 14.842C3.54974 14.53 3.95174 14.224 4.35974 13.924C4.77974 13.612 4.99574 13.45 5.00774 13.438C5.03174 13.414 5.06174 13.402 5.09774 13.402C5.18174 13.402 5.25374 13.462 5.31374 13.582L8.42774 20.386C8.43974 20.386 9.06374 19.108 10.2997 16.552C11.5357 13.996 12.7717 11.422 14.0077 8.83C15.2557 6.238 15.8977 4.912 15.9337 4.852C16.0177 4.684 16.1377 4.6 16.2937 4.6Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M16.2939 4.94775H24.7061",
				stroke: "#3A517F",
				strokeWidth: "0.7",
				strokeLinecap: "round"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/RoundBracketIcon.tsx
const RoundBracketIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "24",
		height: "29",
		viewBox: "0 0 24 29",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M5.99791 23.338C5.99791 23.446 5.88991 23.5 5.67391 23.5H5.43991C5.35591 23.428 5.18791 23.284 4.93591 23.068C2.77591 21.1 1.69591 18.244 1.69591 14.5C1.69591 13.036 1.86991 11.698 2.21791 10.486C2.76991 8.602 3.67591 7.084 4.93591 5.932C5.01991 5.86 5.11591 5.782 5.22391 5.698C5.33191 5.602 5.40391 5.536 5.43991 5.5H5.67391C5.81791 5.5 5.90791 5.518 5.94391 5.554C5.97991 5.59 5.99791 5.626 5.99791 5.662C5.99791 5.71 5.93191 5.8 5.79991 5.932C3.93991 7.9 3.00991 10.756 3.00991 14.5C3.00991 18.244 3.93991 21.1 5.79991 23.068C5.93191 23.2 5.99791 23.29 5.99791 23.338Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M8 10.8333C8 10.6492 8.14924 10.5 8.33333 10.5H15.6667C15.8508 10.5 16 10.6492 16 10.8333V18.1667C16 18.3508 15.8508 18.5 15.6667 18.5H8.33333C8.14924 18.5 8 18.3508 8 18.1667V10.8333Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M9 11.5V17.5H15V11.5H9ZM8.33333 10.5C8.14924 10.5 8 10.6492 8 10.8333V18.1667C8 18.3508 8.14924 18.5 8.33333 18.5H15.6667C15.8508 18.5 16 18.3508 16 18.1667V10.8333C16 10.6492 15.8508 10.5 15.6667 10.5H8.33333Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M18.08 5.518L18.152 5.5C18.212 5.5 18.272 5.5 18.332 5.5H18.548C18.632 5.572 18.8 5.716 19.052 5.932C21.212 7.9 22.292 10.756 22.292 14.5C22.292 15.976 22.118 17.308 21.77 18.496C21.218 20.392 20.312 21.916 19.052 23.068C18.968 23.14 18.872 23.218 18.764 23.302C18.656 23.398 18.584 23.464 18.548 23.5H18.332C18.188 23.5 18.092 23.488 18.044 23.464C18.008 23.44 17.99 23.38 17.99 23.284C18.002 23.272 18.068 23.194 18.188 23.05C20.048 21.118 20.978 18.268 20.978 14.5C20.978 10.732 20.048 7.882 18.188 5.95C18.068 5.806 18.002 5.728 17.99 5.716C17.99 5.62 18.02 5.554 18.08 5.518Z",
				fill: "#3A517F"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/SquareBracketIcon.tsx
const SquareBracketIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "24",
		height: "29",
		viewBox: "0 0 24 29",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M4.11423 23.5V5.5H6.58023V6.22H4.83423V22.78H6.58023V23.5H4.11423Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M8 10.8333C8 10.6492 8.14924 10.5 8.33333 10.5H15.6667C15.8508 10.5 16 10.6492 16 10.8333V18.1667C16 18.3508 15.8508 18.5 15.6667 18.5H8.33333C8.14924 18.5 8 18.3508 8 18.1667V10.8333Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M9 11.5V17.5H15V11.5H9ZM8.33333 10.5C8.14924 10.5 8 10.6492 8 10.8333V18.1667C8 18.3508 8.14924 18.5 8.33333 18.5H15.6667C15.8508 18.5 16 18.3508 16 18.1667V10.8333C16 10.6492 15.8508 10.5 15.6667 10.5H8.33333Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M17.396 6.22V5.5H19.862V23.5H17.396V22.78H19.142V6.22H17.396Z",
				fill: "#3A517F"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/SquareIcon.tsx
const SquareIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "22",
		height: "23",
		viewBox: "0 0 22 23",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M2.93359 6.802C2.93359 6.52586 3.15745 6.302 3.43359 6.302H14.4336C14.7097 6.302 14.9336 6.52586 14.9336 6.802V17.802C14.9336 18.0781 14.7097 18.302 14.4336 18.302H3.43359C3.15745 18.302 2.93359 18.0781 2.93359 17.802V6.802Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M3.93359 7.302V17.302H13.9336V7.302H3.93359ZM3.43359 6.302C3.15745 6.302 2.93359 6.52586 2.93359 6.802V17.802C2.93359 18.0781 3.15745 18.302 3.43359 18.302H14.4336C14.7097 18.302 14.9336 18.0781 14.9336 17.802V6.802C14.9336 6.52586 14.7097 6.302 14.4336 6.302H3.43359Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M17.8985 4.10595C17.8985 4.34275 17.8281 4.53155 17.6873 4.67235C17.5529 4.80675 17.3737 4.87395 17.1497 4.87395C16.8425 4.87395 16.6153 4.74595 16.4681 4.48995C16.4169 4.39395 16.3913 4.26275 16.3913 4.09635C16.3913 3.85955 16.4393 3.67715 16.5353 3.54915C16.6761 3.29955 16.9065 3.10115 17.2265 2.95395C17.5465 2.80035 17.9113 2.72355 18.3209 2.72355C18.7689 2.72355 19.1657 2.77795 19.5113 2.88675C19.8953 3.04035 20.1865 3.23555 20.3849 3.47235C20.6601 3.79875 20.7977 4.17315 20.7977 4.59555C20.7977 5.02435 20.6153 5.42115 20.2505 5.78595C20.0777 5.95875 19.7833 6.19235 19.3673 6.48675C19.1881 6.60835 18.8585 6.85795 18.3785 7.23555L17.8505 7.65795H18.4649C19.3737 7.65795 19.8697 7.64195 19.9529 7.60995C20.0105 7.59075 20.0713 7.44355 20.1353 7.16835C20.1353 7.15555 20.1417 7.11395 20.1545 7.04355C20.1673 6.96675 20.1769 6.89635 20.1833 6.83235C20.1961 6.76835 20.2025 6.73315 20.2025 6.72675H20.7977V6.76515C20.7849 6.79075 20.7337 7.16195 20.6441 7.87875C20.5545 8.58915 20.5065 8.95075 20.5001 8.96355V9.00195H16.3817V8.76195C16.3817 8.59555 16.3849 8.50275 16.3913 8.48355C16.4041 8.46435 16.5673 8.29795 16.8809 7.98435C17.1945 7.66435 17.5337 7.31875 17.8985 6.94755C18.2633 6.57635 18.4969 6.32995 18.5993 6.20835C18.9065 5.85635 19.1177 5.51075 19.2329 5.17155C19.2969 4.98595 19.3289 4.79715 19.3289 4.60515C19.3289 4.22755 19.2105 3.92035 18.9737 3.68355C18.7433 3.44035 18.4361 3.31875 18.0521 3.31875C17.9305 3.31875 17.8505 3.32195 17.8121 3.32835C17.6137 3.37315 17.5145 3.40835 17.5145 3.43395C17.5337 3.45315 17.5593 3.47235 17.5913 3.49155C17.7961 3.62595 17.8985 3.83075 17.8985 4.10595Z",
				fill: "#3A517F"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/SquareRootIcon.tsx
const SquareRootIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "28",
		height: "28",
		viewBox: "0 0 28 28",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M14 13.4167C14 13.1865 14.1865 13 14.4167 13H23.5833C23.8135 13 24 13.1865 24 13.4167V22.5833C24 22.8135 23.8135 23 23.5833 23H14.4167C14.1865 23 14 22.8135 14 22.5833V13.4167Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M15 14V22H23V14H15ZM14.4167 13C14.1865 13 14 13.1865 14 13.4167V22.5833C14 22.8135 14.1865 23 14.4167 23H23.5833C23.8135 23 24 22.8135 24 22.5833V13.4167C24 13.1865 23.8135 13 23.5833 13H14.4167Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M15.2937 4.6C15.3897 4.6 15.4677 4.636 15.5277 4.708C15.5877 4.768 15.6237 4.84 15.6357 4.924V5.032L11.4417 13.726L7.21174 22.474C7.16374 22.558 7.04974 22.6 6.86974 22.6C6.76174 22.6 6.68974 22.582 6.65374 22.546L3.16174 14.95L1.99174 15.796C1.93174 15.796 1.84774 15.748 1.73974 15.652C1.63174 15.544 1.57774 15.454 1.57774 15.382C1.57774 15.334 1.76974 15.154 2.15374 14.842C2.54974 14.53 2.95174 14.224 3.35974 13.924C3.77974 13.612 3.99574 13.45 4.00774 13.438C4.03174 13.414 4.06174 13.402 4.09774 13.402C4.18174 13.402 4.25374 13.462 4.31374 13.582L7.42774 20.386C7.43974 20.386 8.06374 19.108 9.29974 16.552C10.5357 13.996 11.7717 11.422 13.0077 8.83C14.2557 6.238 14.8977 4.912 14.9337 4.852C15.0177 4.684 15.1377 4.6 15.2937 4.6Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M15.2939 4.94775H23.7061",
				stroke: "#3A517F",
				strokeWidth: "0.7",
				strokeLinecap: "round"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/SubscriptIcon.tsx
const SubscriptIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "30",
		height: "30",
		viewBox: "0 0 30 30",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M20 20.05C20 20.0224 20.0224 20 20.05 20H23.95C23.9776 20 24 20.0224 24 20.05V23.95C24 23.9776 23.9776 24 23.95 24H20.05C20.0224 24 20 23.9776 20 23.95V20.05Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M20.05 19H23.95C24.5299 19 25 19.4701 25 20.05V23.95C25 24.5299 24.5299 25 23.95 25H20.05C19.4701 25 19 24.5299 19 23.95V20.05C19 19.4701 19.4701 19 20.05 19ZM20.05 20C20.0224 20 20 20.0224 20 20.05V23.95C20 23.9776 20.0224 24 20.05 24H23.95C23.9776 24 24 23.9776 24 23.95V20.05C24 20.0224 23.9776 20 23.95 20H20.05Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M6 9.5C6 9.22386 6.22386 9 6.5 9H17.5C17.7761 9 18 9.22386 18 9.5V20.5C18 20.7761 17.7761 21 17.5 21H6.5C6.22386 21 6 20.7761 6 20.5V9.5Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M7 10V20H17V10H7ZM6.5 9C6.22386 9 6 9.22386 6 9.5V20.5C6 20.7761 6.22386 21 6.5 21H17.5C17.7761 21 18 20.7761 18 20.5V9.5C18 9.22386 17.7761 9 17.5 9H6.5Z",
				fill: "#7070A9"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/SubscriptSuperscriptIcon.tsx
const SubscriptSuperscriptIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "30",
		height: "26",
		viewBox: "0 0 30 26",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M20 18.05C20 18.0224 20.0224 18 20.05 18H23.95C23.9776 18 24 18.0224 24 18.05V21.95C24 21.9776 23.9776 22 23.95 22H20.05C20.0224 22 20 21.9776 20 21.95V18.05Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M20.05 17H23.95C24.5299 17 25 17.4701 25 18.05V21.95C25 22.5299 24.5299 23 23.95 23H20.05C19.4701 23 19 22.5299 19 21.95V18.05C19 17.4701 19.4701 17 20.05 17ZM20.05 18C20.0224 18 20 18.0224 20 18.05V21.95C20 21.9776 20.0224 22 20.05 22H23.95C23.9776 22 24 21.9776 24 21.95V18.05C24 18.0224 23.9776 18 23.95 18H20.05Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M20 4.05C20 4.02239 20.0224 4 20.05 4H23.95C23.9776 4 24 4.02239 24 4.05V7.95C24 7.97761 23.9776 8 23.95 8H20.05C20.0224 8 20 7.97761 20 7.95V4.05Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M20.05 3H23.95C24.5299 3 25 3.4701 25 4.05V7.95C25 8.5299 24.5299 9 23.95 9H20.05C19.4701 9 19 8.5299 19 7.95V4.05C19 3.4701 19.4701 3 20.05 3ZM20.05 4C20.0224 4 20 4.02239 20 4.05V7.95C20 7.97761 20.0224 8 20.05 8H23.95C23.9776 8 24 7.97761 24 7.95V4.05C24 4.02239 23.9776 4 23.95 4H20.05Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M6 7.5C6 7.22386 6.22386 7 6.5 7H17.5C17.7761 7 18 7.22386 18 7.5V18.5C18 18.7761 17.7761 19 17.5 19H6.5C6.22386 19 6 18.7761 6 18.5V7.5Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M7 8V18H17V8H7ZM6.5 7C6.22386 7 6 7.22386 6 7.5V18.5C6 18.7761 6.22386 19 6.5 19H17.5C17.7761 19 18 18.7761 18 18.5V7.5C18 7.22386 17.7761 7 17.5 7H6.5Z",
				fill: "#7070A9"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/SufixBracketIcon.tsx
const SufixBracketIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "30",
		height: "28",
		viewBox: "0 0 30 28",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M1.91113 10.3333C1.91113 10.1492 2.06037 10 2.24447 10H9.5778C9.76189 10 9.91113 10.1492 9.91113 10.3333V17.6667C9.91113 17.8508 9.76189 18 9.5778 18H2.24447C2.06037 18 1.91113 17.8508 1.91113 17.6667V10.3333Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M2.91113 11V17H8.91113V11H2.91113ZM2.24447 10C2.06037 10 1.91113 10.1492 1.91113 10.3333V17.6667C1.91113 17.8508 2.06037 18 2.24447 18H9.5778C9.76189 18 9.91113 17.8508 9.91113 17.6667V10.3333C9.91113 10.1492 9.76189 10 9.5778 10H2.24447Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M15.9111 10.3333C15.9111 10.1492 16.0604 10 16.2445 10H23.5778C23.7619 10 23.9111 10.1492 23.9111 10.3333V17.6667C23.9111 17.8508 23.7619 18 23.5778 18H16.2445C16.0604 18 15.9111 17.8508 15.9111 17.6667V10.3333Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M16.9111 11V17H22.9111V11H16.9111ZM16.2445 10C16.0604 10 15.9111 10.1492 15.9111 10.3333V17.6667C15.9111 17.8508 16.0604 18 16.2445 18H23.5778C23.7619 18 23.9111 17.8508 23.9111 17.6667V10.3333C23.9111 10.1492 23.7619 10 23.5778 10H16.2445Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M23.8266 5.518L23.8986 5.5C23.9586 5.5 24.0186 5.5 24.0786 5.5H24.2946C24.3786 5.572 24.5466 5.716 24.7986 5.932C26.9586 7.9 28.0386 10.756 28.0386 14.5C28.0386 15.976 27.8646 17.308 27.5166 18.496C26.9646 20.392 26.0586 21.916 24.7986 23.068C24.7146 23.14 24.6186 23.218 24.5106 23.302C24.4026 23.398 24.3306 23.464 24.2946 23.5H24.0786C23.9346 23.5 23.8386 23.488 23.7906 23.464C23.7546 23.44 23.7366 23.38 23.7366 23.284C23.7486 23.272 23.8146 23.194 23.9346 23.05C25.7946 21.118 26.7246 18.268 26.7246 14.5C26.7246 10.732 25.7946 7.882 23.9346 5.95C23.8146 5.806 23.7486 5.728 23.7366 5.716C23.7366 5.62 23.7666 5.554 23.8266 5.518Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M15.9051 23.338C15.9051 23.446 15.7971 23.5 15.5811 23.5H15.3471C15.2631 23.428 15.0951 23.284 14.8431 23.068C12.6831 21.1 11.6031 18.244 11.6031 14.5C11.6031 13.036 11.7771 11.698 12.1251 10.486C12.6771 8.602 13.5831 7.084 14.8431 5.932C14.9271 5.86 15.0231 5.782 15.1311 5.698C15.2391 5.602 15.3111 5.536 15.3471 5.5H15.5811C15.7251 5.5 15.8151 5.518 15.8511 5.554C15.8871 5.59 15.9051 5.626 15.9051 5.662C15.9051 5.71 15.8391 5.8 15.7071 5.932C13.8471 7.9 12.9171 10.756 12.9171 14.5C12.9171 18.244 13.8471 21.1 15.7071 23.068C15.8391 23.2 15.9051 23.29 15.9051 23.338Z",
				fill: "#3A517F"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/SumIcon.tsx
const SumIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "30",
		height: "32",
		viewBox: "0 0 30 32",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M21 12.3333C21 12.1492 21.1492 12 21.3333 12H28.6667C28.8508 12 29 12.1492 29 12.3333V19.6667C29 19.8508 28.8508 20 28.6667 20H21.3333C21.1492 20 21 19.8508 21 19.6667V12.3333Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M22 13V19H28V13H22ZM21.3333 12C21.1492 12 21 12.1492 21 12.3333V19.6667C21 19.8508 21.1492 20 21.3333 20H28.6667C28.8508 20 29 19.8508 29 19.6667V12.3333C29 12.1492 28.8508 12 28.6667 12H21.3333Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M4.08538 8.032C4.11738 8.01067 6.40004 8 10.9334 8H17.7174L18.3734 9.76C18.48 10.048 18.592 10.3573 18.7094 10.688C18.8374 11.0187 18.928 11.264 18.9814 11.424C19.0347 11.5733 19.072 11.68 19.0934 11.744H18.7734L18.4534 11.728C18.2187 11.1093 17.84 10.5707 17.3174 10.112C16.8054 9.64267 16.2134 9.30133 15.5414 9.088C14.9547 8.88533 14.1174 8.74667 13.0294 8.672C12.7094 8.65067 11.104 8.64 8.21338 8.64C6.76271 8.64 6.03738 8.64533 6.03738 8.656C6.06938 8.688 6.94938 9.89333 8.67738 12.272C10.4054 14.64 11.2747 15.8347 11.2854 15.856C11.3494 15.952 11.36 16.032 11.3174 16.096L5.49338 22.992C6.61338 23.0027 7.74938 23.008 8.90138 23.008C9.41338 23.008 9.96271 23.008 10.5494 23.008C11.136 23.008 11.6267 23.0027 12.0214 22.992C12.416 22.992 12.6347 22.992 12.6774 22.992C13.808 22.9493 14.7094 22.832 15.3814 22.64C16.576 22.2987 17.4774 21.648 18.0854 20.688C18.192 20.5173 18.3147 20.256 18.4534 19.904H19.0934C18.9334 20.3627 18.704 21.0453 18.4054 21.952C18.1067 22.8587 17.8774 23.536 17.7174 23.984L10.9334 24C6.41071 24 4.13338 23.9893 4.10138 23.968C4.03738 23.9467 4.00538 23.8987 4.00538 23.824C4.00538 23.792 4.02138 23.7547 4.05338 23.712C4.06404 23.6907 4.56004 23.0987 5.54138 21.936C6.52271 20.7733 7.50404 19.6107 8.48538 18.448L9.95738 16.704C9.95738 16.6933 8.96538 15.328 6.98138 12.608L4.02138 8.528L4.00538 8.352C4.00538 8.18133 4.03204 8.07467 4.08538 8.032Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M10 3.5H12V5.5H10V3.5Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M9 2.5H13V6.5H9V2.5ZM10 3.5V5.5H12V3.5H10Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M10 27H12V29H10V27Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M9 26H13V30H9V26ZM10 27V29H12V27H10Z",
				fill: "#7070A9"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/TildeAboveIcon.tsx
const TildeAboveIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "26",
		height: "26",
		viewBox: "0 0 26 26",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M18.2397 3.394C18.4077 3.394 18.4917 3.592 18.4917 3.988C18.4917 4.204 18.4677 4.432 18.4197 4.672C18.3237 5.272 18.1137 5.812 17.7897 6.292C17.4777 6.76 17.0997 7.102 16.6557 7.318C16.2957 7.498 15.9477 7.588 15.6117 7.588H15.4677C15.1317 7.588 14.8317 7.54 14.5677 7.444C14.0157 7.252 13.2837 6.754 12.3717 5.95C11.7237 5.386 11.2557 5.02 10.9677 4.852C10.4637 4.552 9.97766 4.402 9.50966 4.402C8.96966 4.402 8.49566 4.558 8.08766 4.87C7.69166 5.182 7.39766 5.566 7.20566 6.022C7.09766 6.322 7.02566 6.664 6.98966 7.048C6.96566 7.42 6.88166 7.606 6.73766 7.606C6.56966 7.606 6.48566 7.408 6.48566 7.012C6.48566 6.88 6.49166 6.772 6.50366 6.688C6.59966 5.8 6.88166 5.062 7.34966 4.474C7.81766 3.886 8.40566 3.538 9.11366 3.43C9.23366 3.406 9.35966 3.394 9.49166 3.394C9.71966 3.394 9.90566 3.412 10.0497 3.448C10.3617 3.52 10.6797 3.646 11.0037 3.826C11.3277 4.006 11.5857 4.174 11.7777 4.33C11.9697 4.486 12.2457 4.726 12.6057 5.05C13.2537 5.614 13.7217 5.98 14.0097 6.148C14.5137 6.448 14.9997 6.598 15.4677 6.598C15.9957 6.598 16.4637 6.448 16.8717 6.148C17.1957 5.92 17.4597 5.602 17.6637 5.194C17.8797 4.774 17.9877 4.348 17.9877 3.916C17.9877 3.772 18.0117 3.652 18.0597 3.556C18.1197 3.448 18.1797 3.394 18.2397 3.394Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M7 9.49707C7 9.22093 7.22386 8.99707 7.5 8.99707H18.5C18.7761 8.99707 19 9.22093 19 9.49707V20.4971C19 20.7732 18.7761 20.9971 18.5 20.9971H7.5C7.22386 20.9971 7 20.7732 7 20.4971V9.49707Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M8 9.99707V19.9971H18V9.99707H8ZM7.5 8.99707C7.22386 8.99707 7 9.22093 7 9.49707V20.4971C7 20.7732 7.22386 20.9971 7.5 20.9971H18.5C18.7761 20.9971 19 20.7732 19 20.4971V9.49707C19 9.22093 18.7761 8.99707 18.5 8.99707H7.5Z",
				fill: "#7070A9"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/TildeUnderneathIcon.tsx
const TildeUnderneathIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "28",
		height: "26",
		viewBox: "0 0 28 26",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M19.2397 20.394C19.4077 20.394 19.4917 20.592 19.4917 20.988C19.4917 21.204 19.4677 21.432 19.4197 21.672C19.3237 22.272 19.1137 22.812 18.7897 23.292C18.4777 23.76 18.0997 24.102 17.6557 24.318C17.2957 24.498 16.9477 24.588 16.6117 24.588H16.4677C16.1317 24.588 15.8317 24.54 15.5677 24.444C15.0157 24.252 14.2837 23.754 13.3717 22.95C12.7237 22.386 12.2557 22.02 11.9677 21.852C11.4637 21.552 10.9777 21.402 10.5097 21.402C9.96966 21.402 9.49566 21.558 9.08766 21.87C8.69166 22.182 8.39766 22.566 8.20566 23.022C8.09766 23.322 8.02566 23.664 7.98966 24.048C7.96566 24.42 7.88166 24.606 7.73766 24.606C7.56966 24.606 7.48566 24.408 7.48566 24.012C7.48566 23.88 7.49166 23.772 7.50366 23.688C7.59966 22.8 7.88166 22.062 8.34966 21.474C8.81766 20.886 9.40566 20.538 10.1137 20.43C10.2337 20.406 10.3597 20.394 10.4917 20.394C10.7197 20.394 10.9057 20.412 11.0497 20.448C11.3617 20.52 11.6797 20.646 12.0037 20.826C12.3277 21.006 12.5857 21.174 12.7777 21.33C12.9697 21.486 13.2457 21.726 13.6057 22.05C14.2537 22.614 14.7217 22.98 15.0097 23.148C15.5137 23.448 15.9997 23.598 16.4677 23.598C16.9957 23.598 17.4637 23.448 17.8717 23.148C18.1957 22.92 18.4597 22.602 18.6637 22.194C18.8797 21.774 18.9877 21.348 18.9877 20.916C18.9877 20.772 19.0117 20.652 19.0597 20.556C19.1197 20.448 19.1797 20.394 19.2397 20.394Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M8 7.5C8 7.22386 8.22386 7 8.5 7H19.5C19.7761 7 20 7.22386 20 7.5V18.5C20 18.7761 19.7761 19 19.5 19H8.5C8.22386 19 8 18.7761 8 18.5V7.5Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M9 8V18H19V8H9ZM8.5 7C8.22386 7 8 7.22386 8 7.5V18.5C8 18.7761 8.22386 19 8.5 19H19.5C19.7761 19 20 18.7761 20 18.5V7.5C20 7.22386 19.7761 7 19.5 7H8.5Z",
				fill: "#7070A9"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/TripleIntegralIcon.tsx
const TripleIntegralIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "30",
		height: "31",
		viewBox: "0 0 30 31",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M22 11.3333C22 11.1492 22.1492 11 22.3333 11H29.6667C29.8508 11 30 11.1492 30 11.3333V18.6667C30 18.8508 29.8508 19 29.6667 19H22.3333C22.1492 19 22 18.8508 22 18.6667V11.3333Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M23 12V18H29V12H23ZM22.3333 11C22.1492 11 22 11.1492 22 11.3333V18.6667C22 18.8508 22.1492 19 22.3333 19H29.6667C29.8508 19 30 18.8508 30 18.6667V11.3333C30 11.1492 29.8508 11 29.6667 11H22.3333Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M0.44775 22.06C0.597083 21.9107 0.78375 21.836 1.00775 21.836C1.23175 21.836 1.41842 21.9107 1.56775 22.06C1.71708 22.22 1.79175 22.4067 1.79175 22.62C1.79175 22.94 1.66375 23.164 1.40775 23.292C1.39708 23.3027 1.37042 23.3133 1.32775 23.324C1.28508 23.3453 1.24242 23.3613 1.19975 23.372L1.15175 23.404C1.15175 23.4147 1.17842 23.4467 1.23175 23.5C1.29575 23.5533 1.34908 23.5907 1.39175 23.612C1.56242 23.74 1.77042 23.804 2.01575 23.804C2.21842 23.804 2.38908 23.756 2.52775 23.66C2.78375 23.5107 2.97575 23.2333 3.10375 22.828C3.28508 22.316 3.45575 20.956 3.61575 18.748C3.76508 16.7213 3.92508 15.0147 4.09575 13.628C4.37308 11.4627 4.53308 10.268 4.57575 10.044C4.84242 8.508 5.35975 7.48933 6.12775 6.988C6.39442 6.81733 6.68775 6.7 7.00775 6.636C7.02908 6.636 7.07708 6.636 7.15175 6.636C7.23708 6.62533 7.30642 6.62 7.35975 6.62C7.86108 6.652 8.27708 6.828 8.60775 7.148C8.93842 7.468 9.10375 7.87867 9.10375 8.38C9.10375 8.61467 9.02908 8.80667 8.87975 8.956C8.73042 9.10533 8.54375 9.18 8.31975 9.18C8.09575 9.18 7.90908 9.10533 7.75975 8.956C7.61042 8.796 7.53575 8.60933 7.53575 8.396C7.53575 8.076 7.66375 7.852 7.91975 7.724C7.93042 7.71333 7.95708 7.70267 7.99975 7.692C8.04242 7.67067 8.07975 7.64933 8.11175 7.628L8.17575 7.612C8.17575 7.55867 8.09575 7.48933 7.93575 7.404C7.75442 7.276 7.54642 7.212 7.31175 7.212C6.84242 7.212 6.50108 7.48933 6.28775 8.044C6.15975 8.35333 6.05842 8.78 5.98375 9.324C5.91975 9.85733 5.83442 10.8387 5.72775 12.268C5.57842 14.2733 5.41842 15.9747 5.24775 17.372C5.03442 19.2067 4.87442 20.4013 4.76775 20.956C4.45842 22.6627 3.85042 23.74 2.94375 24.188C2.66642 24.3267 2.36775 24.396 2.04775 24.396C1.27975 24.396 0.73575 24.0653 0.41575 23.404C0.28775 23.18 0.22375 22.924 0.22375 22.636C0.22375 22.4013 0.298417 22.2093 0.44775 22.06ZM5.99975 22.06C6.14908 21.9107 6.33575 21.836 6.55975 21.836C6.78375 21.836 6.97042 21.9107 7.11975 22.06C7.26908 22.22 7.34375 22.4067 7.34375 22.62C7.34375 22.94 7.21575 23.164 6.95975 23.292C6.94908 23.3027 6.92242 23.3133 6.87975 23.324C6.83708 23.3453 6.79975 23.3613 6.76775 23.372L6.70375 23.404C6.70375 23.4147 6.73042 23.4467 6.78375 23.5C6.84775 23.5533 6.90108 23.5907 6.94375 23.612C7.11442 23.74 7.32242 23.804 7.56775 23.804C7.75975 23.804 7.93042 23.756 8.07975 23.66C8.33575 23.5107 8.52775 23.2333 8.65575 22.828C8.83708 22.316 9.00775 20.956 9.16775 18.748C9.31708 16.7213 9.47708 15.0147 9.64775 13.628C9.92508 11.4627 10.0851 10.268 10.1278 10.044C10.3944 8.508 10.9118 7.48933 11.6798 6.988C11.9464 6.81733 12.2398 6.7 12.5598 6.636C12.5811 6.636 12.6291 6.636 12.7038 6.636C12.7891 6.62533 12.8584 6.62 12.9118 6.62C13.4131 6.652 13.8291 6.828 14.1598 7.148C14.4904 7.468 14.6558 7.87867 14.6558 8.38C14.6558 8.61467 14.5811 8.80667 14.4318 8.956C14.2824 9.10533 14.0958 9.18 13.8718 9.18C13.6478 9.18 13.4611 9.10533 13.3118 8.956C13.1624 8.796 13.0878 8.60933 13.0878 8.396C13.0878 8.076 13.2158 7.852 13.4718 7.724C13.4824 7.71333 13.5091 7.70267 13.5518 7.692C13.5944 7.67067 13.6371 7.64933 13.6798 7.628L13.7278 7.612C13.7278 7.55867 13.6478 7.48933 13.4878 7.404C13.3171 7.276 13.1091 7.212 12.8638 7.212C12.3944 7.212 12.0531 7.48933 11.8398 8.044C11.7118 8.35333 11.6104 8.78 11.5358 9.324C11.4718 9.85733 11.3864 10.8387 11.2798 12.268C11.1304 14.2733 10.9704 15.9747 10.7998 17.372C10.5864 19.2067 10.4264 20.4013 10.3198 20.956C10.0104 22.6627 9.40242 23.74 8.49575 24.188C8.21842 24.3267 7.91975 24.396 7.59975 24.396C6.83175 24.396 6.28775 24.0653 5.96775 23.404C5.83975 23.18 5.77575 22.924 5.77575 22.636C5.77575 22.4013 5.85042 22.2093 5.99975 22.06ZM11.5518 22.06C11.7011 21.9107 11.8878 21.836 12.1118 21.836C12.3358 21.836 12.5224 21.9107 12.6718 22.06C12.8211 22.22 12.8958 22.4067 12.8958 22.62C12.8958 22.94 12.7678 23.164 12.5118 23.292C12.5011 23.3027 12.4744 23.3133 12.4318 23.324C12.3891 23.3453 12.3464 23.3613 12.3038 23.372L12.2558 23.404C12.2558 23.4147 12.2824 23.4467 12.3358 23.5C12.3998 23.5533 12.4531 23.5907 12.4958 23.612C12.6664 23.74 12.8744 23.804 13.1198 23.804C13.3118 23.804 13.4824 23.756 13.6318 23.66C13.8878 23.5107 14.0798 23.2333 14.2078 22.828C14.3891 22.316 14.5598 20.956 14.7198 18.748C14.8691 16.7213 15.0291 15.0147 15.1998 13.628C15.4771 11.4627 15.6371 10.268 15.6798 10.044C15.9464 8.508 16.4638 7.48933 17.2318 6.988C17.4984 6.81733 17.7918 6.7 18.1118 6.636C18.1331 6.636 18.1811 6.636 18.2558 6.636C18.3411 6.62533 18.4104 6.62 18.4638 6.62C18.9651 6.652 19.3811 6.828 19.7118 7.148C20.0424 7.468 20.2078 7.87867 20.2078 8.38C20.2078 8.61467 20.1331 8.80667 19.9838 8.956C19.8344 9.10533 19.6478 9.18 19.4238 9.18C19.1998 9.18 19.0131 9.10533 18.8638 8.956C18.7144 8.796 18.6398 8.60933 18.6398 8.396C18.6398 8.076 18.7678 7.852 19.0238 7.724C19.0344 7.71333 19.0611 7.70267 19.1038 7.692C19.1464 7.67067 19.1838 7.64933 19.2158 7.628L19.2798 7.612C19.2798 7.55867 19.1998 7.48933 19.0398 7.404C18.8584 7.276 18.6504 7.212 18.4158 7.212C17.9464 7.212 17.6051 7.48933 17.3918 8.044C17.2638 8.35333 17.1624 8.78 17.0878 9.324C17.0238 9.85733 16.9384 10.8387 16.8318 12.268C16.6824 14.2733 16.5224 15.9747 16.3518 17.372C16.1384 19.2067 15.9784 20.4013 15.8717 20.956C15.5624 22.6627 14.9544 23.74 14.0478 24.188C13.7704 24.3267 13.4718 24.396 13.1518 24.396C12.3838 24.396 11.8398 24.0653 11.5198 23.404C11.3918 23.18 11.3278 22.924 11.3278 22.636C11.3278 22.4013 11.4024 22.2093 11.5518 22.06Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M20 6.5H22V8.5H20V6.5Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M19 5.5H23V9.5H19V5.5ZM20 6.5V8.5H22V6.5H20Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M20 21.5H22V23.5H20V21.5Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M19 20.5H23V24.5H19V20.5ZM20 21.5V23.5H22V21.5H20Z",
				fill: "#7070A9"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/UnderbarIcon.tsx
const UnderbarIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "18",
		height: "26",
		viewBox: "0 0 18 26",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M17 22L1 22",
				stroke: "#3A517F",
				strokeWidth: "0.64",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M3 7.5C3 7.22386 3.22386 7 3.5 7H14.5C14.7761 7 15 7.22386 15 7.5V18.5C15 18.7761 14.7761 19 14.5 19H3.5C3.22386 19 3 18.7761 3 18.5V7.5Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M4 8V18H14V8H4ZM3.5 7C3.22386 7 3 7.22386 3 7.5V18.5C3 18.7761 3.22386 19 3.5 19H14.5C14.7761 19 15 18.7761 15 18.5V7.5C15 7.22386 14.7761 7 14.5 7H3.5Z",
				fill: "#7070A9"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/UnderLeftArrowIcon.tsx
const UnderLeftArrowIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "16",
		height: "30",
		viewBox: "0 0 16 30",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M14.864 22.8787C15.024 22.964 15.104 23.0707 15.104 23.1987C15.104 23.3267 15.024 23.4333 14.864 23.5187H2.64L2.688 23.5667C3.78667 24.4093 4.50667 25.4867 4.848 26.7987C4.912 27.0333 4.944 27.1667 4.944 27.1987C4.944 27.316 4.832 27.3747 4.608 27.3747C4.48 27.3747 4.39467 27.3587 4.352 27.3267C4.32 27.3053 4.29333 27.2413 4.272 27.1347C4.25067 27.06 4.22933 26.9693 4.208 26.8627C4.016 26.084 3.648 25.3907 3.104 24.7827C2.57067 24.1747 1.92533 23.7213 1.168 23.4227C1.008 23.3587 0.912 23.3 0.88 23.2467C0.88 23.108 0.976 23.0173 1.168 22.9747C1.92533 22.676 2.57067 22.2227 3.104 21.6147C3.648 21.0067 4.016 20.3133 4.208 19.5347C4.21867 19.5027 4.22933 19.4547 4.24 19.3907C4.25067 19.3267 4.256 19.284 4.256 19.2627C4.26667 19.2413 4.27733 19.2093 4.288 19.1667C4.30933 19.124 4.33067 19.0973 4.352 19.0867C4.37333 19.0653 4.40533 19.0493 4.448 19.0387C4.49067 19.028 4.544 19.0227 4.608 19.0227C4.832 19.0227 4.944 19.0813 4.944 19.1987C4.944 19.2307 4.912 19.364 4.848 19.5987C4.528 20.868 3.808 21.9453 2.688 22.8307L2.64 22.8787H14.864Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M2 6.5C2 6.22386 2.22386 6 2.5 6H13.5C13.7761 6 14 6.22386 14 6.5V17.5C14 17.7761 13.7761 18 13.5 18H2.5C2.22386 18 2 17.7761 2 17.5V6.5Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M3 7V17H13V7H3ZM2.5 6C2.22386 6 2 6.22386 2 6.5V17.5C2 17.7761 2.22386 18 2.5 18H13.5C13.7761 18 14 17.7761 14 17.5V6.5C14 6.22386 13.7761 6 13.5 6H2.5Z",
				fill: "#7070A9"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/UnderLeftRightArrowIcon.tsx
const UnderLeftRightArrowIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "30",
		height: "30",
		viewBox: "0 0 30 30",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M2.765 23.68H27.229C26.4717 23.1147 25.885 22.432 25.469 21.632C25.2023 21.12 25.0263 20.6133 24.941 20.112C24.941 20.0907 24.9357 20.0693 24.925 20.048C24.925 20.0267 24.925 20.0107 24.925 20C24.925 19.8827 25.0317 19.824 25.245 19.824C25.373 19.824 25.453 19.84 25.485 19.872C25.5277 19.8933 25.5597 19.952 25.581 20.048C25.613 20.2613 25.6717 20.48 25.757 20.704C25.9917 21.4187 26.381 22.0587 26.925 22.624C27.469 23.1787 28.1037 23.5787 28.829 23.824C28.925 23.856 28.973 23.9147 28.973 24C28.973 24.0853 28.925 24.144 28.829 24.176C28.1037 24.4213 27.469 24.8267 26.925 25.392C26.381 25.9467 25.9917 26.5813 25.757 27.296C25.6823 27.52 25.6237 27.7333 25.581 27.936C25.5597 28.0427 25.5277 28.1067 25.485 28.128C25.453 28.16 25.373 28.176 25.245 28.176C25.021 28.176 24.909 28.1173 24.909 28C24.909 27.968 24.941 27.8347 25.005 27.6C25.3357 26.2667 26.077 25.1733 27.229 24.32H2.765L2.813 24.368C3.91167 25.2107 4.63167 26.288 4.973 27.6C5.037 27.8347 5.069 27.968 5.069 28C5.069 28.1173 4.957 28.176 4.733 28.176C4.605 28.176 4.51967 28.16 4.477 28.128C4.445 28.1067 4.41833 28.0427 4.397 27.936C4.37567 27.8613 4.35433 27.7707 4.333 27.664C4.141 26.8853 3.773 26.192 3.229 25.584C2.69567 24.976 2.05033 24.5227 1.293 24.224C1.133 24.16 1.037 24.1013 1.005 24.048C1.005 23.9093 1.101 23.8187 1.293 23.776C2.05033 23.4773 2.69567 23.024 3.229 22.416C3.773 21.808 4.141 21.1147 4.333 20.336C4.34367 20.304 4.35433 20.256 4.365 20.192C4.37567 20.128 4.381 20.0853 4.381 20.064C4.39167 20.0427 4.40233 20.0107 4.413 19.968C4.43433 19.9253 4.45567 19.8987 4.477 19.888C4.49833 19.8667 4.53033 19.8507 4.573 19.84C4.61567 19.8293 4.669 19.824 4.733 19.824C4.957 19.824 5.069 19.8827 5.069 20C5.069 20.032 5.037 20.1653 4.973 20.4C4.653 21.6693 3.933 22.7467 2.813 23.632L2.765 23.68Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M9 8.49707C9 8.22093 9.22386 7.99707 9.5 7.99707H20.5C20.7761 7.99707 21 8.22093 21 8.49707V19.4971C21 19.7732 20.7761 19.9971 20.5 19.9971H9.5C9.22386 19.9971 9 19.7732 9 19.4971V8.49707Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M10 8.99707V18.9971H20V8.99707H10ZM9.5 7.99707C9.22386 7.99707 9 8.22093 9 8.49707V19.4971C9 19.7732 9.22386 19.9971 9.5 19.9971H20.5C20.7761 19.9971 21 19.7732 21 19.4971V8.49707C21 8.22093 20.7761 7.99707 20.5 7.99707H9.5Z",
				fill: "#7070A9"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/UnderlineSegmentIcon.tsx
const UnderlineSegmentIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "22",
		height: "24",
		viewBox: "0 0 22 24",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M5 6.5C5 6.22386 5.22386 6 5.5 6H16.5C16.7761 6 17 6.22386 17 6.5V17.5C17 17.7761 16.7761 18 16.5 18H5.5C5.22386 18 5 17.7761 5 17.5V6.5Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M6 7V17H16V7H6ZM5.5 6C5.22386 6 5 6.22386 5 6.5V17.5C5 17.7761 5.22386 18 5.5 18H16.5C16.7761 18 17 17.7761 17 17.5V6.5C17 6.22386 16.7761 6 16.5 6H5.5Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M19 21L3 21",
				stroke: "#3A517F",
				strokeWidth: "0.64",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M3 20V22",
				stroke: "#3A517F",
				strokeWidth: "0.64",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M19 20V22",
				stroke: "#3A517F",
				strokeWidth: "0.64",
				strokeLinecap: "round"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/UnderRightArrowIcon.tsx
const UnderRightArrowIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "16",
		height: "30",
		viewBox: "0 0 16 30",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M1.12 23.5187C0.970667 23.4441 0.896 23.3374 0.896 23.1987C0.896 23.0601 0.970667 22.9534 1.12 22.8787H13.36C12.6027 22.3134 12.016 21.6307 11.6 20.8307C11.3333 20.3187 11.1573 19.8121 11.072 19.3107C11.072 19.2894 11.0667 19.2681 11.056 19.2467C11.056 19.2254 11.056 19.2094 11.056 19.1987C11.056 19.0814 11.1627 19.0227 11.376 19.0227C11.504 19.0227 11.584 19.0387 11.616 19.0707C11.6587 19.0921 11.6907 19.1507 11.712 19.2467C11.744 19.4601 11.8027 19.6787 11.888 19.9027C12.1227 20.6174 12.512 21.2574 13.056 21.8227C13.6 22.3774 14.2347 22.7774 14.96 23.0227C15.056 23.0547 15.104 23.1134 15.104 23.1987C15.104 23.2841 15.056 23.3427 14.96 23.3747C14.2347 23.6201 13.6 24.0254 13.056 24.5907C12.512 25.1454 12.1227 25.7801 11.888 26.4947C11.8133 26.7187 11.7547 26.9321 11.712 27.1347C11.6907 27.2414 11.6587 27.3054 11.616 27.3267C11.584 27.3587 11.504 27.3747 11.376 27.3747C11.152 27.3747 11.04 27.3161 11.04 27.1987C11.04 27.1667 11.072 27.0334 11.136 26.7987C11.4667 25.4654 12.208 24.3721 13.36 23.5187H1.12Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M2 6.5C2 6.22386 2.22386 6 2.5 6H13.5C13.7761 6 14 6.22386 14 6.5V17.5C14 17.7761 13.7761 18 13.5 18H2.5C2.22386 18 2 17.7761 2 17.5V6.5Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M3 7V17H13V7H3ZM2.5 6C2.22386 6 2 6.22386 2 6.5V17.5C2 17.7761 2.22386 18 2.5 18H13.5C13.7761 18 14 17.7761 14 17.5V6.5C14 6.22386 13.7761 6 13.5 6H2.5Z",
				fill: "#7070A9"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/UnionIcon.tsx
const UnionIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "30",
		height: "31",
		viewBox: "0 0 30 31",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M22 11.3333C22 11.1492 22.1492 11 22.3333 11H29.6667C29.8508 11 30 11.1492 30 11.3333V18.6667C30 18.8508 29.8508 19 29.6667 19H22.3333C22.1492 19 22 18.8508 22 18.6667V11.3333Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M23 12V18H29V12H23ZM22.3333 11C22.1492 11 22 11.1492 22 11.3333V18.6667C22 18.8508 22.1492 19 22.3333 19H29.6667C29.8508 19 30 18.8508 30 18.6667V11.3333C30 11.1492 29.8508 11 29.6667 11H22.3333Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M6.20788 7.5C6.33588 7.5 6.44254 7.532 6.52788 7.596C6.62388 7.64933 6.69321 7.70267 6.73588 7.756C6.77854 7.80933 6.83188 7.89467 6.89588 8.012V13.18L6.91188 18.332L6.94388 18.54C7.10388 19.4893 7.52521 20.2893 8.20788 20.94C8.89054 21.5907 9.73321 21.9853 10.7359 22.124C10.9065 22.1453 11.1039 22.156 11.3279 22.156C12.5972 22.156 13.6852 21.7027 14.5919 20.796C15.1892 20.1773 15.5625 19.4253 15.7119 18.54L15.7439 18.332C15.7439 17.18 15.7492 15.4573 15.7599 13.164C15.7705 10.8707 15.7759 9.15333 15.7759 8.012C15.9145 7.67067 16.1279 7.5 16.4159 7.5C16.7572 7.5 16.9759 7.66 17.0719 7.98C17.0932 8.044 17.1039 9.76133 17.1039 13.132C17.1039 16.5453 17.0985 18.2893 17.0879 18.364C16.9812 19.6653 16.4692 20.7907 15.5519 21.74C14.7519 22.54 13.8239 23.068 12.7679 23.324C12.3412 23.4307 11.8612 23.484 11.3279 23.484C10.7945 23.484 10.3199 23.4307 9.90388 23.324C8.74121 23.0467 7.75454 22.4547 6.94388 21.548C6.13321 20.652 5.67454 19.5907 5.56788 18.364C5.55721 18.2893 5.55188 16.5453 5.55188 13.132C5.55188 9.76133 5.56254 8.044 5.58388 7.98C5.65854 7.66 5.86654 7.5 6.20788 7.5Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M20 6.5H22V8.5H20V6.5Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M19 5.5H23V9.5H19V5.5ZM20 6.5V8.5H22V6.5H20Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M20 21.5H22V23.5H20V21.5Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M19 20.5H23V24.5H19V20.5ZM20 21.5V23.5H22V21.5H20Z",
				fill: "#7070A9"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/Vector-1X2Icon.tsx
const Vector1X2Icon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "24",
		height: "20",
		viewBox: "0 0 24 20",
		...props,
		children: [
			/* @__PURE__ */ jsx("rect", {
				x: "6",
				y: "8.0249",
				width: "5",
				height: "5",
				rx: "0.55",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("rect", {
				x: "6",
				y: "8.0249",
				width: "5",
				height: "5",
				rx: "0.55",
				stroke: "#7070A9",
				fill: "none"
			}),
			/* @__PURE__ */ jsx("rect", {
				x: "13",
				y: "8.0249",
				width: "5",
				height: "5",
				rx: "0.55",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("rect", {
				x: "13",
				y: "8.0249",
				width: "5",
				height: "5",
				rx: "0.55",
				stroke: "#7070A9",
				fill: "none"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M20.5 8C20.5 7.72386 20.2761 7.5 20 7.5V6.5C20.8284 6.5 21.5 7.17157 21.5 8V13C21.5 13.8284 20.8284 14.5 20 14.5V13.5C20.2761 13.5 20.5 13.2761 20.5 13V8Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M3.5 8C3.5 7.72386 3.72386 7.5 4 7.5V6.5C3.17157 6.5 2.5 7.17157 2.5 8V13C2.5 13.8284 3.17157 14.5 4 14.5V13.5C3.72386 13.5 3.5 13.2761 3.5 13V8Z",
				fill: "#3A517F"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/Vector-1X3Icon.tsx
const Vector1X3Icon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "30",
		height: "22",
		viewBox: "0 0 30 22",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M6 9.5749C6 9.54729 6.02239 9.5249 6.05 9.5249H9.95C9.97761 9.5249 10 9.54729 10 9.5749V13.4749C10 13.5025 9.97761 13.5249 9.95 13.5249H6.05C6.02239 13.5249 6 13.5025 6 13.4749V9.5749Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M6.05 8.5249H9.95C10.5299 8.5249 11 8.995 11 9.5749V13.4749C11 14.0548 10.5299 14.5249 9.95 14.5249H6.05C5.4701 14.5249 5 14.0548 5 13.4749V9.5749C5 8.995 5.4701 8.5249 6.05 8.5249ZM6.05 9.5249C6.02239 9.5249 6 9.54729 6 9.5749V13.4749C6 13.5025 6.02239 13.5249 6.05 13.5249H9.95C9.97761 13.5249 10 13.5025 10 13.4749V9.5749C10 9.54729 9.97761 9.5249 9.95 9.5249H6.05Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M13 9.5749C13 9.54729 13.0224 9.5249 13.05 9.5249H16.95C16.9776 9.5249 17 9.54729 17 9.5749V13.4749C17 13.5025 16.9776 13.5249 16.95 13.5249H13.05C13.0224 13.5249 13 13.5025 13 13.4749V9.5749Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M13.05 8.5249H16.95C17.5299 8.5249 18 8.995 18 9.5749V13.4749C18 14.0548 17.5299 14.5249 16.95 14.5249H13.05C12.4701 14.5249 12 14.0548 12 13.4749V9.5749C12 8.995 12.4701 8.5249 13.05 8.5249ZM13.05 9.5249C13.0224 9.5249 13 9.54729 13 9.5749V13.4749C13 13.5025 13.0224 13.5249 13.05 13.5249H16.95C16.9776 13.5249 17 13.5025 17 13.4749V9.5749C17 9.54729 16.9776 9.5249 16.95 9.5249H13.05Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M20 9.5749C20 9.54729 20.0224 9.5249 20.05 9.5249H23.95C23.9776 9.5249 24 9.54729 24 9.5749V13.4749C24 13.5025 23.9776 13.5249 23.95 13.5249H20.05C20.0224 13.5249 20 13.5025 20 13.4749V9.5749Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M20.05 8.5249H23.95C24.5299 8.5249 25 8.995 25 9.5749V13.4749C25 14.0548 24.5299 14.5249 23.95 14.5249H20.05C19.4701 14.5249 19 14.0548 19 13.4749V9.5749C19 8.995 19.4701 8.5249 20.05 8.5249ZM20.05 9.5249C20.0224 9.5249 20 9.54729 20 9.5749V13.4749C20 13.5025 20.0224 13.5249 20.05 13.5249H23.95C23.9776 13.5249 24 13.5025 24 13.4749V9.5749C24 9.54729 23.9776 9.5249 23.95 9.5249H20.05Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M27.5 10C27.5 9.17157 26.8284 8.5 26 8.5V7.5C27.3807 7.5 28.5 8.61929 28.5 10V13C28.5 14.3807 27.3807 15.5 26 15.5V14.5C26.8284 14.5 27.5 13.8284 27.5 13V10Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M2.5 10C2.5 9.17157 3.17157 8.5 4 8.5V7.5C2.61929 7.5 1.5 8.61929 1.5 10V13C1.5 14.3807 2.61929 15.5 4 15.5V14.5C3.17157 14.5 2.5 13.8284 2.5 13V10Z",
				fill: "#3A517F"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/Vector-2X1Icon.tsx
const Vector2X1Icon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "26",
		height: "22",
		viewBox: "0 0 26 22",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M11.0957 5.5749C11.0957 5.54729 11.1181 5.5249 11.1457 5.5249H15.0457C15.0733 5.5249 15.0957 5.54729 15.0957 5.5749V9.4749C15.0957 9.50252 15.0733 9.5249 15.0457 9.5249H11.1457C11.1181 9.5249 11.0957 9.50252 11.0957 9.4749V5.5749Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M11.1457 4.5249H15.0457C15.6256 4.5249 16.0957 4.995 16.0957 5.5749V9.4749C16.0957 10.0548 15.6256 10.5249 15.0457 10.5249H11.1457C10.5658 10.5249 10.0957 10.0548 10.0957 9.4749V5.5749C10.0957 4.995 10.5658 4.5249 11.1457 4.5249ZM11.1457 5.5249C11.1181 5.5249 11.0957 5.54729 11.0957 5.5749V9.4749C11.0957 9.50252 11.1181 9.5249 11.1457 9.5249H15.0457C15.0733 9.5249 15.0957 9.50252 15.0957 9.4749V5.5749C15.0957 5.54729 15.0733 5.5249 15.0457 5.5249H11.1457Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M11.0957 12.5251C11.0957 12.4975 11.1181 12.4751 11.1457 12.4751H15.0457C15.0733 12.4751 15.0957 12.4975 15.0957 12.5251V16.4251C15.0957 16.4527 15.0733 16.4751 15.0457 16.4751H11.1457C11.1181 16.4751 11.0957 16.4527 11.0957 16.4251V12.5251Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M11.1457 11.4751H15.0457C15.6256 11.4751 16.0957 11.9452 16.0957 12.5251V16.4251C16.0957 17.005 15.6256 17.4751 15.0457 17.4751H11.1457C10.5658 17.4751 10.0957 17.005 10.0957 16.4251V12.5251C10.0957 11.9452 10.5658 11.4751 11.1457 11.4751ZM11.1457 12.4751C11.1181 12.4751 11.0957 12.4975 11.0957 12.5251V16.4251C11.0957 16.4527 11.1181 16.4751 11.1457 16.4751H15.0457C15.0733 16.4751 15.0957 16.4527 15.0957 16.4251V12.5251C15.0957 12.4975 15.0733 12.4751 15.0457 12.4751H11.1457Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M18.9482 5.53217C18.9482 4.89686 18.4332 4.38184 17.7979 4.38184V3.38184C18.9855 3.38184 19.9482 4.34457 19.9482 5.53217V16.4676C19.9482 17.6552 18.9854 18.6179 17.7979 18.6179V17.6179C18.4332 17.6179 18.9482 17.1029 18.9482 16.4676V5.53217Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M7.24419 5.53217C7.24419 4.89686 7.75922 4.38184 8.39453 4.38184V3.38184C7.20693 3.38184 6.24419 4.34457 6.24419 5.53217V16.4676C6.24419 17.6552 7.20693 18.6179 8.39453 18.6179V17.6179C7.75922 17.6179 7.24419 17.1029 7.24419 16.4676V5.53217Z",
				fill: "#3A517F"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/Vector-2X2Icon.tsx
const Vector2X2Icon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "24",
		height: "22",
		viewBox: "0 0 24 22",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M6.5 5.5749C6.5 5.54729 6.52239 5.5249 6.55 5.5249H10.45C10.4776 5.5249 10.5 5.54729 10.5 5.5749V9.4749C10.5 9.50252 10.4776 9.5249 10.45 9.5249H6.55C6.52239 9.5249 6.5 9.50252 6.5 9.4749V5.5749Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M6.55 4.5249H10.45C11.0299 4.5249 11.5 4.995 11.5 5.5749V9.4749C11.5 10.0548 11.0299 10.5249 10.45 10.5249H6.55C5.9701 10.5249 5.5 10.0548 5.5 9.4749V5.5749C5.5 4.995 5.9701 4.5249 6.55 4.5249ZM6.55 5.5249C6.52239 5.5249 6.5 5.54729 6.5 5.5749V9.4749C6.5 9.50252 6.52239 9.5249 6.55 9.5249H10.45C10.4776 9.5249 10.5 9.50252 10.5 9.4749V5.5749C10.5 5.54729 10.4776 5.5249 10.45 5.5249H6.55Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M13.5 5.5749C13.5 5.54729 13.5224 5.5249 13.55 5.5249H17.45C17.4776 5.5249 17.5 5.54729 17.5 5.5749V9.4749C17.5 9.50252 17.4776 9.5249 17.45 9.5249H13.55C13.5224 9.5249 13.5 9.50252 13.5 9.4749V5.5749Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M13.55 4.5249H17.45C18.0299 4.5249 18.5 4.995 18.5 5.5749V9.4749C18.5 10.0548 18.0299 10.5249 17.45 10.5249H13.55C12.9701 10.5249 12.5 10.0548 12.5 9.4749V5.5749C12.5 4.995 12.9701 4.5249 13.55 4.5249ZM13.55 5.5249C13.5224 5.5249 13.5 5.54729 13.5 5.5749V9.4749C13.5 9.50252 13.5224 9.5249 13.55 9.5249H17.45C17.4776 9.5249 17.5 9.50252 17.5 9.4749V5.5749C17.5 5.54729 17.4776 5.5249 17.45 5.5249H13.55Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M6.5 12.5251C6.5 12.4975 6.52239 12.4751 6.55 12.4751H10.45C10.4776 12.4751 10.5 12.4975 10.5 12.5251V16.4251C10.5 16.4527 10.4776 16.4751 10.45 16.4751H6.55C6.52239 16.4751 6.5 16.4527 6.5 16.4251V12.5251Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M6.55 11.4751H10.45C11.0299 11.4751 11.5 11.9452 11.5 12.5251V16.4251C11.5 17.005 11.0299 17.4751 10.45 17.4751H6.55C5.9701 17.4751 5.5 17.005 5.5 16.4251V12.5251C5.5 11.9452 5.9701 11.4751 6.55 11.4751ZM6.55 12.4751C6.52239 12.4751 6.5 12.4975 6.5 12.5251V16.4251C6.5 16.4527 6.52239 16.4751 6.55 16.4751H10.45C10.4776 16.4751 10.5 16.4527 10.5 16.4251V12.5251C10.5 12.4975 10.4776 12.4751 10.45 12.4751H6.55Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M13.5 12.5251C13.5 12.4975 13.5224 12.4751 13.55 12.4751H17.45C17.4776 12.4751 17.5 12.4975 17.5 12.5251V16.4251C17.5 16.4527 17.4776 16.4751 17.45 16.4751H13.55C13.5224 16.4751 13.5 16.4527 13.5 16.4251V12.5251Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M13.55 11.4751H17.45C18.0299 11.4751 18.5 11.9452 18.5 12.5251V16.4251C18.5 17.005 18.0299 17.4751 17.45 17.4751H13.55C12.9701 17.4751 12.5 17.005 12.5 16.4251V12.5251C12.5 11.9452 12.9701 11.4751 13.55 11.4751ZM13.55 12.4751C13.5224 12.4751 13.5 12.4975 13.5 12.5251V16.4251C13.5 16.4527 13.5224 16.4751 13.55 16.4751H17.45C17.4776 16.4751 17.5 16.4527 17.5 16.4251V12.5251C17.5 12.4975 17.4776 12.4751 17.45 12.4751H13.55Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M20.7558 5.53217C20.7558 4.89686 20.2408 4.38184 19.6055 4.38184V3.38184C20.7931 3.38184 21.7558 4.34457 21.7558 5.53217V16.4676C21.7558 17.6552 20.7931 18.6179 19.6055 18.6179V17.6179C20.2408 17.6179 20.7558 17.1029 20.7558 16.4676V5.53217Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M3.24419 5.53217C3.24419 4.89686 3.75922 4.38184 4.39453 4.38184V3.38184C3.20693 3.38184 2.24419 4.34457 2.24419 5.53217V16.4676C2.24419 17.6552 3.20693 18.6179 4.39453 18.6179V17.6179C3.75922 17.6179 3.24419 17.1029 3.24419 16.4676V5.53217Z",
				fill: "#3A517F"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/Vector-2X3Icon.tsx
const Vector2X3Icon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "28",
		height: "24",
		viewBox: "0 0 28 24",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M5 6.5749C5 6.54729 5.02239 6.5249 5.05 6.5249H8.95C8.97761 6.5249 9 6.54729 9 6.5749V10.4749C9 10.5025 8.97761 10.5249 8.95 10.5249H5.05C5.02239 10.5249 5 10.5025 5 10.4749V6.5749Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M5.05 5.5249H8.95C9.5299 5.5249 10 5.995 10 6.5749V10.4749C10 11.0548 9.5299 11.5249 8.95 11.5249H5.05C4.4701 11.5249 4 11.0548 4 10.4749V6.5749C4 5.995 4.4701 5.5249 5.05 5.5249ZM5.05 6.5249C5.02239 6.5249 5 6.54729 5 6.5749V10.4749C5 10.5025 5.02239 10.5249 5.05 10.5249H8.95C8.97761 10.5249 9 10.5025 9 10.4749V6.5749C9 6.54729 8.97761 6.5249 8.95 6.5249H5.05Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M12 6.5749C12 6.54729 12.0224 6.5249 12.05 6.5249H15.95C15.9776 6.5249 16 6.54729 16 6.5749V10.4749C16 10.5025 15.9776 10.5249 15.95 10.5249H12.05C12.0224 10.5249 12 10.5025 12 10.4749V6.5749Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12.05 5.5249H15.95C16.5299 5.5249 17 5.995 17 6.5749V10.4749C17 11.0548 16.5299 11.5249 15.95 11.5249H12.05C11.4701 11.5249 11 11.0548 11 10.4749V6.5749C11 5.995 11.4701 5.5249 12.05 5.5249ZM12.05 6.5249C12.0224 6.5249 12 6.54729 12 6.5749V10.4749C12 10.5025 12.0224 10.5249 12.05 10.5249H15.95C15.9776 10.5249 16 10.5025 16 10.4749V6.5749C16 6.54729 15.9776 6.5249 15.95 6.5249H12.05Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M19 6.5749C19 6.54729 19.0224 6.5249 19.05 6.5249H22.95C22.9776 6.5249 23 6.54729 23 6.5749V10.4749C23 10.5025 22.9776 10.5249 22.95 10.5249H19.05C19.0224 10.5249 19 10.5025 19 10.4749V6.5749Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M19.05 5.5249H22.95C23.5299 5.5249 24 5.995 24 6.5749V10.4749C24 11.0548 23.5299 11.5249 22.95 11.5249H19.05C18.4701 11.5249 18 11.0548 18 10.4749V6.5749C18 5.995 18.4701 5.5249 19.05 5.5249ZM19.05 6.5249C19.0224 6.5249 19 6.54729 19 6.5749V10.4749C19 10.5025 19.0224 10.5249 19.05 10.5249H22.95C22.9776 10.5249 23 10.5025 23 10.4749V6.5749C23 6.54729 22.9776 6.5249 22.95 6.5249H19.05Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M5 13.5251C5 13.4975 5.02239 13.4751 5.05 13.4751H8.95C8.97761 13.4751 9 13.4975 9 13.5251V17.4251C9 17.4527 8.97761 17.4751 8.95 17.4751H5.05C5.02239 17.4751 5 17.4527 5 17.4251V13.5251Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M5.05 12.4751H8.95C9.5299 12.4751 10 12.9452 10 13.5251V17.4251C10 18.005 9.5299 18.4751 8.95 18.4751H5.05C4.4701 18.4751 4 18.005 4 17.4251V13.5251C4 12.9452 4.4701 12.4751 5.05 12.4751ZM5.05 13.4751C5.02239 13.4751 5 13.4975 5 13.5251V17.4251C5 17.4527 5.02239 17.4751 5.05 17.4751H8.95C8.97761 17.4751 9 17.4527 9 17.4251V13.5251C9 13.4975 8.97761 13.4751 8.95 13.4751H5.05Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M12 13.5251C12 13.4975 12.0224 13.4751 12.05 13.4751H15.95C15.9776 13.4751 16 13.4975 16 13.5251V17.4251C16 17.4527 15.9776 17.4751 15.95 17.4751H12.05C12.0224 17.4751 12 17.4527 12 17.4251V13.5251Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12.05 12.4751H15.95C16.5299 12.4751 17 12.9452 17 13.5251V17.4251C17 18.005 16.5299 18.4751 15.95 18.4751H12.05C11.4701 18.4751 11 18.005 11 17.4251V13.5251C11 12.9452 11.4701 12.4751 12.05 12.4751ZM12.05 13.4751C12.0224 13.4751 12 13.4975 12 13.5251V17.4251C12 17.4527 12.0224 17.4751 12.05 17.4751H15.95C15.9776 17.4751 16 17.4527 16 17.4251V13.5251C16 13.4975 15.9776 13.4751 15.95 13.4751H12.05Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M19 13.5251C19 13.4975 19.0224 13.4751 19.05 13.4751H22.95C22.9776 13.4751 23 13.4975 23 13.5251V17.4251C23 17.4527 22.9776 17.4751 22.95 17.4751H19.05C19.0224 17.4751 19 17.4527 19 17.4251V13.5251Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M19.05 12.4751H22.95C23.5299 12.4751 24 12.9452 24 13.5251V17.4251C24 18.005 23.5299 18.4751 22.95 18.4751H19.05C18.4701 18.4751 18 18.005 18 17.4251V13.5251C18 12.9452 18.4701 12.4751 19.05 12.4751ZM19.05 13.4751C19.0224 13.4751 19 13.4975 19 13.5251V17.4251C19 17.4527 19.0224 17.4751 19.05 17.4751H22.95C22.9776 17.4751 23 17.4527 23 17.4251V13.5251C23 13.4975 22.9776 13.4751 22.95 13.4751H19.05Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M26.2558 6.53217C26.2558 5.89686 25.7408 5.38184 25.1055 5.38184V4.38184C26.2931 4.38184 27.2558 5.34457 27.2558 6.53217V17.4676C27.2558 18.6552 26.2931 19.6179 25.1055 19.6179V18.6179C25.7408 18.6179 26.2558 18.1029 26.2558 17.4676V6.53217Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M1.74419 6.53217C1.74419 5.89686 2.25922 5.38184 2.89453 5.38184V4.38184C1.70693 4.38184 0.744193 5.34457 0.744193 6.53217V17.4676C0.744193 18.6552 1.70693 19.6179 2.89453 19.6179V18.6179C2.25922 18.6179 1.74419 18.1029 1.74419 17.4676V6.53217Z",
				fill: "#3A517F"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/Vector-3X1Icon.tsx
const Vector3X1Icon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "26",
		height: "26",
		viewBox: "0 0 26 26",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M18.8525 4.59565C18.8525 3.96034 18.3375 3.44531 17.7021 3.44531V2.44531C18.8897 2.44531 19.8525 3.40805 19.8525 4.59565V21.4042C19.8525 22.5918 18.8897 23.5545 17.7021 23.5545V22.5545C18.3375 22.5545 18.8525 22.0395 18.8525 21.4042V4.59565Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M7.14751 4.59565C7.14751 3.96034 7.66254 3.44531 8.29785 3.44531V2.44531C7.11025 2.44531 6.14751 3.40805 6.14751 4.59565V21.4042C6.14751 22.5918 7.11025 23.5545 8.29785 23.5545V22.5545C7.66254 22.5545 7.14751 22.0395 7.14751 21.4042V4.59565Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M11.0957 4.0998C11.0957 4.07219 11.1181 4.0498 11.1457 4.0498H15.0457C15.0733 4.0498 15.0957 4.07219 15.0957 4.0998V7.9998C15.0957 8.02742 15.0733 8.0498 15.0457 8.0498H11.1457C11.1181 8.0498 11.0957 8.02742 11.0957 7.9998V4.0998Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M11.1457 3.0498H15.0457C15.6256 3.0498 16.0957 3.51991 16.0957 4.0998V7.9998C16.0957 8.5797 15.6256 9.0498 15.0457 9.0498H11.1457C10.5658 9.0498 10.0957 8.5797 10.0957 7.9998V4.0998C10.0957 3.5199 10.5658 3.0498 11.1457 3.0498ZM11.1457 4.0498C11.1181 4.0498 11.0957 4.07219 11.0957 4.0998V7.9998C11.0957 8.02742 11.1181 8.0498 11.1457 8.0498H15.0457C15.0733 8.0498 15.0957 8.02742 15.0957 7.9998V4.0998C15.0957 4.07219 15.0733 4.0498 15.0457 4.0498H11.1457Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M11.0957 11.05C11.0957 11.0224 11.1181 11 11.1457 11H15.0457C15.0733 11 15.0957 11.0224 15.0957 11.05V14.95C15.0957 14.9776 15.0733 15 15.0457 15H11.1457C11.1181 15 11.0957 14.9776 11.0957 14.95V11.05Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M11.1457 10H15.0457C15.6256 10 16.0957 10.4701 16.0957 11.05V14.95C16.0957 15.5299 15.6256 16 15.0457 16H11.1457C10.5658 16 10.0957 15.5299 10.0957 14.95V11.05C10.0957 10.4701 10.5658 10 11.1457 10ZM11.1457 11C11.1181 11 11.0957 11.0224 11.0957 11.05V14.95C11.0957 14.9776 11.1181 15 11.1457 15H15.0457C15.0733 15 15.0957 14.9776 15.0957 14.95V11.05C15.0957 11.0224 15.0733 11 15.0457 11H11.1457Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M11.0957 18.0002C11.0957 17.9726 11.1181 17.9502 11.1457 17.9502H15.0457C15.0733 17.9502 15.0957 17.9726 15.0957 18.0002V21.9002C15.0957 21.9278 15.0733 21.9502 15.0457 21.9502H11.1457C11.1181 21.9502 11.0957 21.9278 11.0957 21.9002V18.0002Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M11.1457 16.9502H15.0457C15.6256 16.9502 16.0957 17.4203 16.0957 18.0002V21.9002C16.0957 22.4801 15.6256 22.9502 15.0457 22.9502H11.1457C10.5658 22.9502 10.0957 22.4801 10.0957 21.9002V18.0002C10.0957 17.4203 10.5658 16.9502 11.1457 16.9502ZM11.1457 17.9502C11.1181 17.9502 11.0957 17.9726 11.0957 18.0002V21.9002C11.0957 21.9278 11.1181 21.9502 11.1457 21.9502H15.0457C15.0733 21.9502 15.0957 21.9278 15.0957 21.9002V18.0002C15.0957 17.9726 15.0733 17.9502 15.0457 17.9502H11.1457Z",
				fill: "#7070A9"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/Vector-3X3Icon.tsx
const Vector3X3Icon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "28",
		height: "26",
		viewBox: "0 0 28 26",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M5 4.15449C5 4.12688 5.02239 4.10449 5.05 4.10449H8.95C8.97761 4.10449 9 4.12688 9 4.15449V8.05449C9 8.08211 8.97761 8.10449 8.95 8.10449H5.05C5.02239 8.10449 5 8.08211 5 8.05449V4.15449Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M5.05 3.10449H8.95C9.5299 3.10449 10 3.57459 10 4.15449V8.05449C10 8.63439 9.5299 9.10449 8.95 9.10449H5.05C4.4701 9.10449 4 8.63439 4 8.05449V4.15449C4 3.57459 4.4701 3.10449 5.05 3.10449ZM5.05 4.10449C5.02239 4.10449 5 4.12688 5 4.15449V8.05449C5 8.08211 5.02239 8.10449 5.05 8.10449H8.95C8.97761 8.10449 9 8.08211 9 8.05449V4.15449C9 4.12688 8.97761 4.10449 8.95 4.10449H5.05Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M12 4.15449C12 4.12688 12.0224 4.10449 12.05 4.10449H15.95C15.9776 4.10449 16 4.12688 16 4.15449V8.05449C16 8.08211 15.9776 8.10449 15.95 8.10449H12.05C12.0224 8.10449 12 8.08211 12 8.05449V4.15449Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12.05 3.10449H15.95C16.5299 3.10449 17 3.57459 17 4.15449V8.05449C17 8.63439 16.5299 9.10449 15.95 9.10449H12.05C11.4701 9.10449 11 8.63439 11 8.05449V4.15449C11 3.57459 11.4701 3.10449 12.05 3.10449ZM12.05 4.10449C12.0224 4.10449 12 4.12688 12 4.15449V8.05449C12 8.08211 12.0224 8.10449 12.05 8.10449H15.95C15.9776 8.10449 16 8.08211 16 8.05449V4.15449C16 4.12688 15.9776 4.10449 15.95 4.10449H12.05Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M19 4.15449C19 4.12688 19.0224 4.10449 19.05 4.10449H22.95C22.9776 4.10449 23 4.12688 23 4.15449V8.05449C23 8.08211 22.9776 8.10449 22.95 8.10449H19.05C19.0224 8.10449 19 8.08211 19 8.05449V4.15449Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M19.05 3.10449H22.95C23.5299 3.10449 24 3.57459 24 4.15449V8.05449C24 8.63439 23.5299 9.10449 22.95 9.10449H19.05C18.4701 9.10449 18 8.63439 18 8.05449V4.15449C18 3.57459 18.4701 3.10449 19.05 3.10449ZM19.05 4.10449C19.0224 4.10449 19 4.12688 19 4.15449V8.05449C19 8.08211 19.0224 8.10449 19.05 8.10449H22.95C22.9776 8.10449 23 8.08211 23 8.05449V4.15449C23 4.12688 22.9776 4.10449 22.95 4.10449H19.05Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M5 11.1047C5 11.0771 5.02239 11.0547 5.05 11.0547H8.95C8.97761 11.0547 9 11.0771 9 11.1047V15.0047C9 15.0323 8.97761 15.0547 8.95 15.0547H5.05C5.02239 15.0547 5 15.0323 5 15.0047V11.1047Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M5.05 10.0547H8.95C9.5299 10.0547 10 10.5248 10 11.1047V15.0047C10 15.5846 9.5299 16.0547 8.95 16.0547H5.05C4.4701 16.0547 4 15.5846 4 15.0047V11.1047C4 10.5248 4.4701 10.0547 5.05 10.0547ZM5.05 11.0547C5.02239 11.0547 5 11.0771 5 11.1047V15.0047C5 15.0323 5.02239 15.0547 5.05 15.0547H8.95C8.97761 15.0547 9 15.0323 9 15.0047V11.1047C9 11.0771 8.97761 11.0547 8.95 11.0547H5.05Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M12 11.1047C12 11.0771 12.0224 11.0547 12.05 11.0547H15.95C15.9776 11.0547 16 11.0771 16 11.1047V15.0047C16 15.0323 15.9776 15.0547 15.95 15.0547H12.05C12.0224 15.0547 12 15.0323 12 15.0047V11.1047Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12.05 10.0547H15.95C16.5299 10.0547 17 10.5248 17 11.1047V15.0047C17 15.5846 16.5299 16.0547 15.95 16.0547H12.05C11.4701 16.0547 11 15.5846 11 15.0047V11.1047C11 10.5248 11.4701 10.0547 12.05 10.0547ZM12.05 11.0547C12.0224 11.0547 12 11.0771 12 11.1047V15.0047C12 15.0323 12.0224 15.0547 12.05 15.0547H15.95C15.9776 15.0547 16 15.0323 16 15.0047V11.1047C16 11.0771 15.9776 11.0547 15.95 11.0547H12.05Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M19 11.1047C19 11.0771 19.0224 11.0547 19.05 11.0547H22.95C22.9776 11.0547 23 11.0771 23 11.1047V15.0047C23 15.0323 22.9776 15.0547 22.95 15.0547H19.05C19.0224 15.0547 19 15.0323 19 15.0047V11.1047Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M19.05 10.0547H22.95C23.5299 10.0547 24 10.5248 24 11.1047V15.0047C24 15.5846 23.5299 16.0547 22.95 16.0547H19.05C18.4701 16.0547 18 15.5846 18 15.0047V11.1047C18 10.5248 18.4701 10.0547 19.05 10.0547ZM19.05 11.0547C19.0224 11.0547 19 11.0771 19 11.1047V15.0047C19 15.0323 19.0224 15.0547 19.05 15.0547H22.95C22.9776 15.0547 23 15.0323 23 15.0047V11.1047C23 11.0771 22.9776 11.0547 22.95 11.0547H19.05Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M5 18.0549C5 18.0273 5.02239 18.0049 5.05 18.0049H8.95C8.97761 18.0049 9 18.0273 9 18.0549V21.9549C9 21.9825 8.97761 22.0049 8.95 22.0049H5.05C5.02239 22.0049 5 21.9825 5 21.9549V18.0549Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M5.05 17.0049H8.95C9.5299 17.0049 10 17.475 10 18.0549V21.9549C10 22.5348 9.5299 23.0049 8.95 23.0049H5.05C4.4701 23.0049 4 22.5348 4 21.9549V18.0549C4 17.475 4.4701 17.0049 5.05 17.0049ZM5.05 18.0049C5.02239 18.0049 5 18.0273 5 18.0549V21.9549C5 21.9825 5.02239 22.0049 5.05 22.0049H8.95C8.97761 22.0049 9 21.9825 9 21.9549V18.0549C9 18.0273 8.97761 18.0049 8.95 18.0049H5.05Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M12 18.0549C12 18.0273 12.0224 18.0049 12.05 18.0049H15.95C15.9776 18.0049 16 18.0273 16 18.0549V21.9549C16 21.9825 15.9776 22.0049 15.95 22.0049H12.05C12.0224 22.0049 12 21.9825 12 21.9549V18.0549Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12.05 17.0049H15.95C16.5299 17.0049 17 17.475 17 18.0549V21.9549C17 22.5348 16.5299 23.0049 15.95 23.0049H12.05C11.4701 23.0049 11 22.5348 11 21.9549V18.0549C11 17.475 11.4701 17.0049 12.05 17.0049ZM12.05 18.0049C12.0224 18.0049 12 18.0273 12 18.0549V21.9549C12 21.9825 12.0224 22.0049 12.05 22.0049H15.95C15.9776 22.0049 16 21.9825 16 21.9549V18.0549C16 18.0273 15.9776 18.0049 15.95 18.0049H12.05Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M19 18.0549C19 18.0273 19.0224 18.0049 19.05 18.0049H22.95C22.9776 18.0049 23 18.0273 23 18.0549V21.9549C23 21.9825 22.9776 22.0049 22.95 22.0049H19.05C19.0224 22.0049 19 21.9825 19 21.9549V18.0549Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M19.05 17.0049H22.95C23.5299 17.0049 24 17.475 24 18.0549V21.9549C24 22.5348 23.5299 23.0049 22.95 23.0049H19.05C18.4701 23.0049 18 22.5348 18 21.9549V18.0549C18 17.475 18.4701 17.0049 19.05 17.0049ZM19.05 18.0049C19.0224 18.0049 19 18.0273 19 18.0549V21.9549C19 21.9825 19.0224 22.0049 19.05 22.0049H22.95C22.9776 22.0049 23 21.9825 23 21.9549V18.0549C23 18.0273 22.9776 18.0049 22.95 18.0049H19.05Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M26.277 4.15C26.277 3.79101 25.9859 3.5 25.627 3.5V2.5C26.5382 2.5 27.277 3.23873 27.277 4.15V21.9592C27.277 22.8705 26.5382 23.6092 25.627 23.6092V22.6092C25.9859 22.6092 26.277 22.3182 26.277 21.9592V4.15Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M1.72305 4.15C1.72305 3.79101 2.01406 3.5 2.37305 3.5V2.5C1.46178 2.5 0.723047 3.23873 0.723047 4.15V21.9592C0.723047 22.8705 1.46178 23.6092 2.37305 23.6092V22.6092C2.01406 22.6092 1.72305 22.3182 1.72305 21.9592V4.15Z",
				fill: "#3A517F"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/Vector-4X1Icon.tsx
const Vector4X1Icon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "22",
		height: "28",
		viewBox: "0 0 22 28",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M16.8525 2.2375C16.8525 1.60218 16.3375 1.08716 15.7021 1.08716V0.0871582C16.8897 0.0871582 17.8525 1.0499 17.8525 2.2375V25.7624C17.8525 26.95 16.8897 27.9127 15.7021 27.9127V26.9127C16.3375 26.9127 16.8525 26.3977 16.8525 25.7624V2.2375Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M5.14751 2.2375C5.14751 1.60218 5.66254 1.08716 6.29785 1.08716V0.0871582C5.11025 0.0871582 4.14751 1.0499 4.14751 2.2375V25.7624C4.14751 26.95 5.11025 27.9127 6.29785 27.9127V26.9127C5.66254 26.9127 5.14751 26.3977 5.14751 25.7624V2.2375Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M9.0957 8.5749C9.0957 8.54729 9.11809 8.5249 9.1457 8.5249H13.0457C13.0733 8.5249 13.0957 8.54729 13.0957 8.5749V12.4749C13.0957 12.5025 13.0733 12.5249 13.0457 12.5249H9.1457C9.11809 12.5249 9.0957 12.5025 9.0957 12.4749V8.5749Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M9.1457 7.5249H13.0457C13.6256 7.5249 14.0957 7.995 14.0957 8.5749V12.4749C14.0957 13.0548 13.6256 13.5249 13.0457 13.5249H9.1457C8.5658 13.5249 8.0957 13.0548 8.0957 12.4749V8.5749C8.0957 7.995 8.56581 7.5249 9.1457 7.5249ZM9.1457 8.5249C9.11809 8.5249 9.0957 8.54729 9.0957 8.5749V12.4749C9.0957 12.5025 9.11809 12.5249 9.1457 12.5249H13.0457C13.0733 12.5249 13.0957 12.5025 13.0957 12.4749V8.5749C13.0957 8.54729 13.0733 8.5249 13.0457 8.5249H9.1457Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M9.0957 1.62471C9.0957 1.59709 9.11809 1.57471 9.1457 1.57471H13.0457C13.0733 1.57471 13.0957 1.59709 13.0957 1.62471V5.52471C13.0957 5.55232 13.0733 5.57471 13.0457 5.57471H9.1457C9.11809 5.57471 9.0957 5.55232 9.0957 5.52471V1.62471Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M9.1457 0.574707H13.0457C13.6256 0.574707 14.0957 1.04481 14.0957 1.62471V5.52471C14.0957 6.10461 13.6256 6.57471 13.0457 6.57471H9.1457C8.5658 6.57471 8.0957 6.1046 8.0957 5.52471V1.62471C8.0957 1.04481 8.56581 0.574707 9.1457 0.574707ZM9.1457 1.57471C9.11809 1.57471 9.0957 1.59709 9.0957 1.62471V5.52471C9.0957 5.55232 9.11809 5.57471 9.1457 5.57471H13.0457C13.0733 5.57471 13.0957 5.55232 13.0957 5.52471V1.62471C13.0957 1.59709 13.0733 1.57471 13.0457 1.57471H9.1457Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M9.0957 15.5251C9.0957 15.4975 9.11809 15.4751 9.1457 15.4751H13.0457C13.0733 15.4751 13.0957 15.4975 13.0957 15.5251V19.4251C13.0957 19.4527 13.0733 19.4751 13.0457 19.4751H9.1457C9.11809 19.4751 9.0957 19.4527 9.0957 19.4251V15.5251Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M9.1457 14.4751H13.0457C13.6256 14.4751 14.0957 14.9452 14.0957 15.5251V19.4251C14.0957 20.005 13.6256 20.4751 13.0457 20.4751H9.1457C8.5658 20.4751 8.0957 20.005 8.0957 19.4251V15.5251C8.0957 14.9452 8.56581 14.4751 9.1457 14.4751ZM9.1457 15.4751C9.11809 15.4751 9.0957 15.4975 9.0957 15.5251V19.4251C9.0957 19.4527 9.11809 19.4751 9.1457 19.4751H13.0457C13.0733 19.4751 13.0957 19.4527 13.0957 19.4251V15.5251C13.0957 15.4975 13.0733 15.4751 13.0457 15.4751H9.1457Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M9.0957 22.4753C9.0957 22.4477 9.11809 22.4253 9.1457 22.4253H13.0457C13.0733 22.4253 13.0957 22.4477 13.0957 22.4753V26.3753C13.0957 26.4029 13.0733 26.4253 13.0457 26.4253H9.1457C9.11809 26.4253 9.0957 26.4029 9.0957 26.3753V22.4753Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M9.1457 21.4253H13.0457C13.6256 21.4253 14.0957 21.8954 14.0957 22.4753V26.3753C14.0957 26.9552 13.6256 27.4253 13.0457 27.4253H9.1457C8.5658 27.4253 8.0957 26.9552 8.0957 26.3753V22.4753C8.0957 21.8954 8.56581 21.4253 9.1457 21.4253ZM9.1457 22.4253C9.11809 22.4253 9.0957 22.4477 9.0957 22.4753V26.3753C9.0957 26.4029 9.11809 26.4253 9.1457 26.4253H13.0457C13.0733 26.4253 13.0957 26.4029 13.0957 26.3753V22.4753C13.0957 22.4477 13.0733 22.4253 13.0457 22.4253H9.1457Z",
				fill: "#7070A9"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/Vector-4X4Icon.tsx
const Vector4X4Icon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "28",
		height: "22",
		viewBox: "0 0 28 22",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M5.5 2.5H7.5V4.5H5.5V2.5Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M4.5 1.5H8.5V5.5H4.5V1.5ZM5.5 2.5V4.5H7.5V2.5H5.5Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M10.5 2.5H12.5V4.5H10.5V2.5Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M9.5 1.5H13.5V5.5H9.5V1.5ZM10.5 2.5V4.5H12.5V2.5H10.5Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M15.5 2.5H17.5V4.5H15.5V2.5Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M14.5 1.5H18.5V5.5H14.5V1.5ZM15.5 2.5V4.5H17.5V2.5H15.5Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M20.5 2.5H22.5V4.5H20.5V2.5Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M19.5 1.5H23.5V5.5H19.5V1.5ZM20.5 2.5V4.5H22.5V2.5H20.5Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M5.5 7.5H7.5V9.5H5.5V7.5Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M4.5 6.5H8.5V10.5H4.5V6.5ZM5.5 7.5V9.5H7.5V7.5H5.5Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M10.5 7.5H12.5V9.5H10.5V7.5Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M9.5 6.5H13.5V10.5H9.5V6.5ZM10.5 7.5V9.5H12.5V7.5H10.5Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M15.5 7.5H17.5V9.5H15.5V7.5Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M14.5 6.5H18.5V10.5H14.5V6.5ZM15.5 7.5V9.5H17.5V7.5H15.5Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M20.5 7.5H22.5V9.5H20.5V7.5Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M19.5 6.5H23.5V10.5H19.5V6.5ZM20.5 7.5V9.5H22.5V7.5H20.5Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M5.5 12.5H7.5V14.5H5.5V12.5Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M4.5 11.5H8.5V15.5H4.5V11.5ZM5.5 12.5V14.5H7.5V12.5H5.5Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M10.5 12.5H12.5V14.5H10.5V12.5Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M9.5 11.5H13.5V15.5H9.5V11.5ZM10.5 12.5V14.5H12.5V12.5H10.5Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M15.5 12.5H17.5V14.5H15.5V12.5Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M14.5 11.5H18.5V15.5H14.5V11.5ZM15.5 12.5V14.5H17.5V12.5H15.5Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M20.5 12.5H22.5V14.5H20.5V12.5Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M19.5 11.5H23.5V15.5H19.5V11.5ZM20.5 12.5V14.5H22.5V12.5H20.5Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M5.5 17.5H7.5V19.5H5.5V17.5Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M4.5 16.5H8.5V20.5H4.5V16.5ZM5.5 17.5V19.5H7.5V17.5H5.5Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M10.5 17.5H12.5V19.5H10.5V17.5Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M9.5 16.5H13.5V20.5H9.5V16.5ZM10.5 17.5V19.5H12.5V17.5H10.5Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M15.5 17.5H17.5V19.5H15.5V17.5Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M14.5 16.5H18.5V20.5H14.5V16.5ZM15.5 17.5V19.5H17.5V17.5H15.5Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M20.5 17.5H22.5V19.5H20.5V17.5Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M19.5 16.5H23.5V20.5H19.5V16.5ZM20.5 17.5V19.5H22.5V17.5H20.5Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M25.898 2.62009C25.898 2.26111 25.607 1.97009 25.248 1.97009V0.970093C26.1593 0.970093 26.898 1.70882 26.898 2.62009V19.38C26.898 20.2912 26.1593 21.03 25.248 21.03V20.03C25.607 20.03 25.898 19.739 25.898 19.38V2.62009Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M2.10195 2.62009C2.10195 2.26111 2.39297 1.97009 2.75195 1.97009V0.970093C1.84068 0.970093 1.10195 1.70882 1.10195 2.62009V19.3799C1.10195 20.2912 1.84068 21.0299 2.75195 21.0299V20.0299C2.39297 20.0299 2.10195 19.7389 2.10195 19.3799V2.62009Z",
				fill: "#3A517F"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/Vector-5X5Icon.tsx
const Vector5X5Icon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "32",
		height: "30",
		viewBox: "0 0 32 30",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M5 3.94531H7V5.94531H5V3.94531Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M4 2.94531H8V6.94531H4V2.94531ZM5 3.94531V5.94531H7V3.94531H5Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M10 3.94531H12V5.94531H10V3.94531Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M9 2.94531H13V6.94531H9V2.94531ZM10 3.94531V5.94531H12V3.94531H10Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M15 3.94531H17V5.94531H15V3.94531Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M14 2.94531H18V6.94531H14V2.94531ZM15 3.94531V5.94531H17V3.94531H15Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M20 3.94531H22V5.94531H20V3.94531Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M19 2.94531H23V6.94531H19V2.94531ZM20 3.94531V5.94531H22V3.94531H20Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M25 3.94531H27V5.94531H25V3.94531Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M24 2.94531H28V6.94531H24V2.94531ZM25 3.94531V5.94531H27V3.94531H25Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M5 8.94531H7V10.9453H5V8.94531Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M4 7.94531H8V11.9453H4V7.94531ZM5 8.94531V10.9453H7V8.94531H5Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M10 8.94531H12V10.9453H10V8.94531Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M9 7.94531H13V11.9453H9V7.94531ZM10 8.94531V10.9453H12V8.94531H10Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M15 8.94531H17V10.9453H15V8.94531Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M14 7.94531H18V11.9453H14V7.94531ZM15 8.94531V10.9453H17V8.94531H15Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M20 8.94531H22V10.9453H20V8.94531Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M19 7.94531H23V11.9453H19V7.94531ZM20 8.94531V10.9453H22V8.94531H20Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M25 8.94531H27V10.9453H25V8.94531Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M24 7.94531H28V11.9453H24V7.94531ZM25 8.94531V10.9453H27V8.94531H25Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M5 13.9453H7V15.9453H5V13.9453Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M4 12.9453H8V16.9453H4V12.9453ZM5 13.9453V15.9453H7V13.9453H5Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M10 13.9453H12V15.9453H10V13.9453Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M9 12.9453H13V16.9453H9V12.9453ZM10 13.9453V15.9453H12V13.9453H10Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M15 13.9453H17V15.9453H15V13.9453Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M14 12.9453H18V16.9453H14V12.9453ZM15 13.9453V15.9453H17V13.9453H15Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M20 13.9453H22V15.9453H20V13.9453Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M19 12.9453H23V16.9453H19V12.9453ZM20 13.9453V15.9453H22V13.9453H20Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M25 13.9453H27V15.9453H25V13.9453Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M24 12.9453H28V16.9453H24V12.9453ZM25 13.9453V15.9453H27V13.9453H25Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M5 18.9453H7V20.9453H5V18.9453Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M4 17.9453H8V21.9453H4V17.9453ZM5 18.9453V20.9453H7V18.9453H5Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M10 18.9453H12V20.9453H10V18.9453Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M9 17.9453H13V21.9453H9V17.9453ZM10 18.9453V20.9453H12V18.9453H10Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M15 18.9453H17V20.9453H15V18.9453Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M14 17.9453H18V21.9453H14V17.9453ZM15 18.9453V20.9453H17V18.9453H15Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M20 18.9453H22V20.9453H20V18.9453Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M19 17.9453H23V21.9453H19V17.9453ZM20 18.9453V20.9453H22V18.9453H20Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M25 18.9453H27V20.9453H25V18.9453Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M24 17.9453H28V21.9453H24V17.9453ZM25 18.9453V20.9453H27V18.9453H25Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M5 23.9453H7V25.9453H5V23.9453Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M4 22.9453H8V26.9453H4V22.9453ZM5 23.9453V25.9453H7V23.9453H5Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M10 23.9453H12V25.9453H10V23.9453Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M9 22.9453H13V26.9453H9V22.9453ZM10 23.9453V25.9453H12V23.9453H10Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M15 23.9453H17V25.9453H15V23.9453Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M14 22.9453H18V26.9453H14V22.9453ZM15 23.9453V25.9453H17V23.9453H15Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M20 23.9453H22V25.9453H20V23.9453Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M19 22.9453H23V26.9453H19V22.9453ZM20 23.9453V25.9453H22V23.9453H20Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M25 23.9453H27V25.9453H25V23.9453Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M24 22.9453H28V26.9453H24V22.9453ZM25 23.9453V25.9453H27V23.9453H25Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M29.8746 3.79893C29.8746 3.43994 29.5836 3.14893 29.2246 3.14893V2.14893C30.1359 2.14893 30.8746 2.88766 30.8746 3.79893V26.2009C30.8746 27.1122 30.1359 27.8509 29.2246 27.8509V26.8509C29.5836 26.8509 29.8746 26.5599 29.8746 26.2009V3.79893Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M2.12441 3.79893C2.12441 3.43994 2.41543 3.14893 2.77441 3.14893V2.14893C1.86314 2.14893 1.12441 2.88766 1.12441 3.79893V26.2009C1.12441 27.1122 1.86314 27.8509 2.77441 27.8509V26.8509C2.41543 26.8509 2.12441 26.5599 2.12441 26.2009V3.79893Z",
				fill: "#3A517F"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/VectorComma-1X2Icon.tsx
const VectorComma1X2Icon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "26",
		height: "26",
		viewBox: "0 0 26 26",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M4.84966 7.53254C4.84966 6.89723 5.36469 6.3822 6 6.3822V5.3822C4.8124 5.3822 3.84966 6.34494 3.84966 7.53254V18.468C3.84966 19.6556 4.8124 20.6183 6 20.6183V19.6183C5.36468 19.6183 4.84966 19.1033 4.84966 18.468V7.53254Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M7 11.0502C7 11.0226 7.02239 11.0002 7.05 11.0002H10.95C10.9776 11.0002 11 11.0226 11 11.0502V14.9502C11 14.9779 10.9776 15.0002 10.95 15.0002H7.05C7.02239 15.0002 7 14.9779 7 14.9502V11.0502Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M7.05 10.0002H10.95C11.5299 10.0002 12 10.4703 12 11.0502V14.9502C12 15.5301 11.5299 16.0002 10.95 16.0002H7.05C6.4701 16.0002 6 15.5301 6 14.9502V11.0502C6 10.4703 6.4701 10.0002 7.05 10.0002ZM7.05 11.0002C7.02239 11.0002 7 11.0226 7 11.0502V14.9502C7 14.9779 7.02239 15.0002 7.05 15.0002H10.95C10.9776 15.0002 11 14.9779 11 14.9502V11.0502C11 11.0226 10.9776 11.0002 10.95 11.0002H7.05Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M12.152 16.2962C12.008 16.1522 11.936 15.9802 11.936 15.7802C11.936 15.5802 12 15.4082 12.128 15.2642C12.264 15.1202 12.436 15.0482 12.644 15.0482C12.948 15.0482 13.168 15.1762 13.304 15.4322C13.448 15.6882 13.52 16.0122 13.52 16.4042C13.52 16.5562 13.512 16.6962 13.496 16.8242C13.384 17.5362 13.092 18.1482 12.62 18.6602C12.508 18.7722 12.436 18.8282 12.404 18.8282C12.38 18.8282 12.336 18.7962 12.272 18.7322C12.208 18.6682 12.164 18.6202 12.14 18.5882C12.132 18.5482 12.172 18.4802 12.26 18.3842C12.756 17.8802 13.028 17.2642 13.076 16.5362V16.3922C13.068 16.3922 13.044 16.4042 13.004 16.4282C12.9 16.4762 12.792 16.5002 12.68 16.5002C12.472 16.5002 12.296 16.4322 12.152 16.2962Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M15 11.0502C15 11.0226 15.0224 11.0002 15.05 11.0002H18.95C18.9776 11.0002 19 11.0226 19 11.0502V14.9502C19 14.9779 18.9776 15.0002 18.95 15.0002H15.05C15.0224 15.0002 15 14.9779 15 14.9502V11.0502Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M15.05 10.0002H18.95C19.5299 10.0002 20 10.4703 20 11.0502V14.9502C20 15.5301 19.5299 16.0002 18.95 16.0002H15.05C14.4701 16.0002 14 15.5301 14 14.9502V11.0502C14 10.4703 14.4701 10.0002 15.05 10.0002ZM15.05 11.0002C15.0224 11.0002 15 11.0226 15 11.0502V14.9502C15 14.9779 15.0224 15.0002 15.05 15.0002H18.95C18.9776 15.0002 19 14.9779 19 14.9502V11.0502C19 11.0226 18.9776 11.0002 18.95 11.0002H15.05Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M21.1503 7.53254C21.1503 6.89723 20.6353 6.3822 20 6.3822V5.3822C21.1876 5.3822 22.1503 6.34494 22.1503 7.53254V18.468C22.1503 19.6556 21.1876 20.6183 20 20.6183V19.6183C20.6353 19.6183 21.1503 19.1033 21.1503 18.468V7.53254Z",
				fill: "#3A517F"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/VectorComma-1X3Icon.tsx
const VectorComma1X3Icon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "28",
		height: "26",
		viewBox: "0 0 28 26",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M1.84966 7.53254C1.84966 6.89723 2.36469 6.3822 3 6.3822V5.3822C1.8124 5.3822 0.849661 6.34494 0.849661 7.53254V18.468C0.849661 19.6556 1.8124 20.6183 3 20.6183V19.6183C2.36468 19.6183 1.84966 19.1033 1.84966 18.468V7.53254Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M4 11.0502C4 11.0226 4.02239 11.0002 4.05 11.0002H7.95C7.97761 11.0002 8 11.0226 8 11.0502V14.9502C8 14.9779 7.97761 15.0002 7.95 15.0002H4.05C4.02239 15.0002 4 14.9779 4 14.9502V11.0502Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M4.05 10.0002H7.95C8.5299 10.0002 9 10.4703 9 11.0502V14.9502C9 15.5301 8.5299 16.0002 7.95 16.0002H4.05C3.4701 16.0002 3 15.5301 3 14.9502V11.0502C3 10.4703 3.4701 10.0002 4.05 10.0002ZM4.05 11.0002C4.02239 11.0002 4 11.0226 4 11.0502V14.9502C4 14.9779 4.02239 15.0002 4.05 15.0002H7.95C7.97761 15.0002 8 14.9779 8 14.9502V11.0502C8 11.0226 7.97761 11.0002 7.95 11.0002H4.05Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M9.152 16.2962C9.008 16.1522 8.936 15.9802 8.936 15.7802C8.936 15.5802 9 15.4082 9.128 15.2642C9.264 15.1202 9.436 15.0482 9.644 15.0482C9.948 15.0482 10.168 15.1762 10.304 15.4322C10.448 15.6882 10.52 16.0122 10.52 16.4042C10.52 16.5562 10.512 16.6962 10.496 16.8242C10.384 17.5362 10.092 18.1482 9.62 18.6602C9.508 18.7722 9.436 18.8282 9.404 18.8282C9.38 18.8282 9.336 18.7962 9.272 18.7322C9.208 18.6682 9.164 18.6202 9.14 18.5882C9.132 18.5482 9.172 18.4802 9.26 18.3842C9.756 17.8802 10.028 17.2642 10.076 16.5362V16.3922C10.068 16.3922 10.044 16.4042 10.004 16.4282C9.9 16.4762 9.792 16.5002 9.68 16.5002C9.472 16.5002 9.296 16.4322 9.152 16.2962Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M12 11.0502C12 11.0226 12.0224 11.0002 12.05 11.0002H15.95C15.9776 11.0002 16 11.0226 16 11.0502V14.9502C16 14.9779 15.9776 15.0002 15.95 15.0002H12.05C12.0224 15.0002 12 14.9779 12 14.9502V11.0502Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12.05 10.0002H15.95C16.5299 10.0002 17 10.4703 17 11.0502V14.9502C17 15.5301 16.5299 16.0002 15.95 16.0002H12.05C11.4701 16.0002 11 15.5301 11 14.9502V11.0502C11 10.4703 11.4701 10.0002 12.05 10.0002ZM12.05 11.0002C12.0224 11.0002 12 11.0226 12 11.0502V14.9502C12 14.9779 12.0224 15.0002 12.05 15.0002H15.95C15.9776 15.0002 16 14.9779 16 14.9502V11.0502C16 11.0226 15.9776 11.0002 15.95 11.0002H12.05Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M17.152 16.2962C17.008 16.1522 16.936 15.9802 16.936 15.7802C16.936 15.5802 17 15.4082 17.128 15.2642C17.264 15.1202 17.436 15.0482 17.644 15.0482C17.948 15.0482 18.168 15.1762 18.304 15.4322C18.448 15.6882 18.52 16.0122 18.52 16.4042C18.52 16.5562 18.512 16.6962 18.496 16.8242C18.384 17.5362 18.092 18.1482 17.62 18.6602C17.508 18.7722 17.436 18.8282 17.404 18.8282C17.38 18.8282 17.336 18.7962 17.272 18.7322C17.208 18.6682 17.164 18.6202 17.14 18.5882C17.132 18.5482 17.172 18.4802 17.26 18.3842C17.756 17.8802 18.028 17.2642 18.076 16.5362V16.3922C18.068 16.3922 18.044 16.4042 18.004 16.4282C17.9 16.4762 17.792 16.5002 17.68 16.5002C17.472 16.5002 17.296 16.4322 17.152 16.2962Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M20 11.0502C20 11.0226 20.0224 11.0002 20.05 11.0002H23.95C23.9776 11.0002 24 11.0226 24 11.0502V14.9502C24 14.9779 23.9776 15.0002 23.95 15.0002H20.05C20.0224 15.0002 20 14.9779 20 14.9502V11.0502Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M20.05 10.0002H23.95C24.5299 10.0002 25 10.4703 25 11.0502V14.9502C25 15.5301 24.5299 16.0002 23.95 16.0002H20.05C19.4701 16.0002 19 15.5301 19 14.9502V11.0502C19 10.4703 19.4701 10.0002 20.05 10.0002ZM20.05 11.0002C20.0224 11.0002 20 11.0226 20 11.0502V14.9502C20 14.9779 20.0224 15.0002 20.05 15.0002H23.95C23.9776 15.0002 24 14.9779 24 14.9502V11.0502C24 11.0226 23.9776 11.0002 23.95 11.0002H20.05Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M26.1503 7.53254C26.1503 6.89723 25.6353 6.3822 25 6.3822V5.3822C26.1876 5.3822 27.1503 6.34494 27.1503 7.53254V18.468C27.1503 19.6556 26.1876 20.6183 25 20.6183V19.6183C25.6353 19.6183 26.1503 19.1033 26.1503 18.468V7.53254Z",
				fill: "#3A517F"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/icons/VerticalBarIcon.tsx
const VerticalBarIcon = (props) => {
	return /* @__PURE__ */ jsxs("svg", {
		width: "24",
		height: "28",
		viewBox: "0 0 24 28",
		...props,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M3.85223 23.23C3.76823 23.398 3.64823 23.482 3.49223 23.482C3.33623 23.482 3.21623 23.398 3.13223 23.23V14.482L3.15023 5.734C3.27023 5.578 3.38423 5.5 3.49223 5.5C3.64823 5.5 3.76823 5.59 3.85223 5.77V23.23Z",
				fill: "#3A517F"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M7 9.33333C7 9.14924 7.14924 9 7.33333 9H14.6667C14.8508 9 15 9.14924 15 9.33333V16.6667C15 16.8508 14.8508 17 14.6667 17H7.33333C7.14924 17 7 16.8508 7 16.6667V9.33333Z",
				fill: "#8C8CBA"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M8 10V16H14V10H8ZM7.33333 9C7.14924 9 7 9.14924 7 9.33333V16.6667C7 16.8508 7.14924 17 7.33333 17H14.6667C14.8508 17 15 16.8508 15 16.6667V9.33333C15 9.14924 14.8508 9 14.6667 9H7.33333Z",
				fill: "#7070A9"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M20.862 23.23C20.778 23.398 20.658 23.482 20.502 23.482C20.346 23.482 20.226 23.398 20.142 23.23V14.482L20.16 5.734C20.28 5.578 20.394 5.5 20.502 5.5C20.658 5.5 20.778 5.59 20.862 5.77V23.23Z",
				fill: "#3A517F"
			})
		]
	});
};
//#endregion
//#region src/extensions/math/components/MathEditor/keys/arrows.tsx
const downArrow = {
	text: "↓",
	label: "down arrow",
	mathLiveCommand: "\\downarrow",
	latexCommand: "\\downarrow"
};
const upArrow = {
	text: "↑",
	label: "up arrow",
	mathLiveCommand: "\\uparrow"
};
const leftArrow = {
	text: "←",
	label: "left arrow",
	mathLiveCommand: "\\leftarrow"
};
const rightArrow = {
	text: "→",
	label: "right arrow",
	mathLiveCommand: "\\rightarrow"
};
const leftRightArrow = {
	text: "⟷",
	label: "left right arrow",
	mathLiveCommand: "\\longleftrightarrow"
};
const equilibrium = {
	text: "⇌",
	label: "equilibrium",
	mathLiveCommand: "\\rightleftharpoons"
};
const longLeftArrow = {
	text: "⟸",
	label: "long left arrow",
	mathLiveCommand: "\\Longleftarrow",
	tooltipLabel: "implies"
};
const longRightArrow = {
	text: "⟹",
	label: "long right arrow",
	mathLiveCommand: "\\Longrightarrow",
	tooltipLabel: "implies"
};
const longleftrightArrow = {
	text: "⟺",
	label: "if and only if",
	mathLiveCommand: "\\Longleftrightarrow"
};
const overleftArrow = {
	renderChildren: () => /* @__PURE__ */ jsx(OverLeftArrowIcon, {}),
	label: "over left arrow",
	mathLiveCommand: "\\overleftarrow",
	tooltipLabel: ""
};
const overleftrightArrow = {
	renderChildren: () => /* @__PURE__ */ jsx(OverLeftRightArrowIcon, {}),
	label: "over left right arrow",
	mathLiveCommand: "\\overleftrightarrow",
	tooltipLabel: ""
};
const overrightArrow = {
	renderChildren: () => /* @__PURE__ */ jsx(OverRightArrowIcon, {}),
	label: "over right arrow",
	mathLiveCommand: "\\overrightarrow",
	tooltipLabel: ""
};
const underleftArrow = {
	renderChildren: () => /* @__PURE__ */ jsx(UnderLeftArrowIcon, {}),
	label: "under left arrow",
	mathLiveCommand: "\\underleftarrow",
	tooltipLabel: ""
};
const underleftrightArrow = {
	renderChildren: () => /* @__PURE__ */ jsx(UnderLeftRightArrowIcon, {}),
	label: "under left right arrow",
	mathLiveCommand: "\\underleftrightarrow",
	tooltipLabel: ""
};
const underrightArrow = {
	renderChildren: () => /* @__PURE__ */ jsx(UnderRightArrowIcon, {}),
	label: "under right arrow",
	mathLiveCommand: "\\underrightarrow",
	tooltipLabel: ""
};
const leftArrowBetween = {
	renderChildren: () => /* @__PURE__ */ jsx(LeftArrowBetweenIcon, {}),
	label: "left arrow between",
	mathLiveCommand: "\\xleftarrow[\\placeholder{}]{\\placeholder{}}",
	tooltip: false
};
const rightArrowBetween = {
	renderChildren: () => /* @__PURE__ */ jsx(RightArrowBetweenIcon, {}),
	label: "right arrow between",
	mathLiveCommand: "\\xrightarrow[\\placeholder{}]{\\placeholder{}}",
	tooltip: false
};
//#endregion
//#region src/extensions/math/components/MathEditor/keys/functions.tsx
const square = {
	label: "square",
	renderChildren: () => /* @__PURE__ */ jsx(SquareIcon, {}),
	mathLiveCommand: "^2"
};
const power = {
	label: "power",
	renderChildren: () => /* @__PURE__ */ jsx(PowerIcon, {}),
	mathLiveCommand: "^{\\placeholder{}}",
	tooltipCommand: "x^y"
};
const squareRoot = {
	label: "square root",
	renderChildren: () => /* @__PURE__ */ jsx(SquareRootIcon, {}),
	mathLiveCommand: "\\sqrt",
	latexCommand: "\\sqrt{\\placeholder{}}",
	tooltipCommand: "\\sqrt"
};
const root = {
	label: "root",
	renderChildren: () => /* @__PURE__ */ jsx(RootIcon, {}),
	mathLiveCommand: "\\sqrt[\\placeholder{}]{\\placeholder{}}",
	tooltipCommand: "\\sqrt[x]{y}"
};
const subscript = {
	label: "subscript",
	renderChildren: () => /* @__PURE__ */ jsx(SubscriptIcon, {}),
	mathLiveCommand: "_{\\placeholder{}}",
	tooltipCommand: "x_{y}"
};
const subscriptSuperscript = {
	label: "subscript superscript",
	renderChildren: () => /* @__PURE__ */ jsx(SubscriptSuperscriptIcon, {}),
	mathLiveCommand: "_{\\placeholder{}}^{\\placeholder{}}",
	tooltipCommand: "x_{y}^z"
};
const exponential = {
	label: "exponential function",
	renderChildren: () => /* @__PURE__ */ jsx(ExponentialIcon, {}),
	mathLiveCommand: "\\exponentialE^{\\placeholder{}}",
	tooltipCommand: "\\exponentialE^{x}"
};
const naturalLog = {
	label: "natural log",
	renderChildren: () => /* @__PURE__ */ jsx(NaturalLogIcon, {}),
	mathLiveCommand: "\\ln{\\placeholder{}",
	tooltipCommand: "\\ln"
};
const logarithm = {
	label: "logarithm",
	renderChildren: () => /* @__PURE__ */ jsx(LogarithmIcon, {}),
	mathLiveCommand: "\\log_{\\placeholder{}}{\\placeholder{}}",
	tooltipCommand: "\\log_{x}"
};
const log10 = {
	label: "log10",
	renderChildren: () => /* @__PURE__ */ jsx(Log10Icon, {}),
	mathLiveCommand: "\\log_{10}{\\placeholder{}}",
	tooltipCommand: "\\log_{10}"
};
const sine = {
	label: "sine",
	text: "sin",
	mathLiveCommand: "\\sin",
	size: "small"
};
const cosine = {
	label: "cosine",
	text: "cos",
	mathLiveCommand: "\\cos",
	size: "small"
};
const tangent = {
	label: "tangent",
	text: "tan",
	mathLiveCommand: "\\tan",
	size: "small"
};
const cotangent = {
	label: "cotangent",
	text: "cot",
	mathLiveCommand: "\\cot",
	size: "small"
};
const secant = {
	label: "secant",
	text: "sec",
	mathLiveCommand: "\\sec",
	size: "small"
};
const cosecant = {
	label: "cosecant",
	text: "csc",
	mathLiveCommand: "\\csc",
	size: "small"
};
const inverseSine = {
	label: "inverse sine",
	renderChildren: () => /* @__PURE__ */ jsx(InverseSineIcon, {}),
	mathLiveCommand: "\\sin^{-1}"
};
const inverseCosine = {
	label: "inverse cosine",
	renderChildren: () => /* @__PURE__ */ jsx(InverseCosineIcon, {}),
	mathLiveCommand: "\\cos^{-1}"
};
const inverseTan = {
	label: "inverse tangent",
	renderChildren: () => /* @__PURE__ */ jsx(InverseTanIcon, {}),
	mathLiveCommand: "\\tan^{-1}"
};
const inverseCotTan = {
	label: "inverse cotangent",
	renderChildren: () => /* @__PURE__ */ jsx(InverseCotTanIcon, {}),
	mathLiveCommand: "\\cot^{-1}"
};
const inverseSec = {
	label: "inverse secant",
	renderChildren: () => /* @__PURE__ */ jsx(InverseSecIcon, {}),
	mathLiveCommand: "\\sec^{-1}"
};
const inverseCosec = {
	label: "inverse cosecant",
	renderChildren: () => /* @__PURE__ */ jsx(InverseCosecIcon, {}),
	mathLiveCommand: "\\csc^{-1}"
};
const sinh = {
	label: "sinh",
	text: "sinh",
	mathLiveCommand: "\\sinh",
	size: "small"
};
const cosh = {
	label: "cosh",
	text: "cosh",
	mathLiveCommand: "\\cosh",
	size: "small"
};
const tanh = {
	label: "tanh",
	text: "tanh",
	mathLiveCommand: "\\tanh",
	size: "small"
};
const coth = {
	label: "coth",
	text: "coth",
	mathLiveCommand: "\\coth",
	size: "small"
};
const degree = {
	label: "degree",
	text: "º",
	mathLiveCommand: "\\degree",
	size: "small"
};
const verticalBars = {
	label: "vertical bars",
	renderChildren: () => /* @__PURE__ */ jsx(VerticalBarIcon, {}),
	mathLiveCommand: "\\left|{\\placeholder{}}\\right|",
	tooltipLabel: "vertical bars",
	tooltipCommand: "\\left|\\right|"
};
const ceiling = {
	label: "ceiling function",
	renderChildren: () => /* @__PURE__ */ jsx(CeilingIcon, {}),
	mathLiveCommand: "\\lceil{\\placeholder{}}\\rceil",
	tooltipLabel: "ceiling function",
	tooltipCommand: "\\lceil\\rceil"
};
const floor = {
	label: "floor function",
	renderChildren: () => /* @__PURE__ */ jsx(FloorIcon, {}),
	mathLiveCommand: "\\lfloor{\\placeholder{}}\\rfloor",
	tooltipLabel: "floor function",
	tooltipCommand: "\\lfloor\\rfloor"
};
const verticalBar$1 = {
	label: "vertical bar",
	text: "|",
	mathLiveCommand: "\\mid",
	tooltip: false
};
const lAngle = {
	label: "left angle bracket",
	text: "⟨",
	mathLiveCommand: "\\langle"
};
const rAngle = {
	label: "right angle bracket",
	text: "⟩",
	mathLiveCommand: "\\rangle"
};
//#endregion
//#region src/extensions/math/components/MathEditor/keys/greek.tsx
const lowerAlpha = {
	renderChildren: () => /* @__PURE__ */ jsx("i", { children: "α" }),
	label: "alpha",
	mathLiveCommand: "\\alpha",
	kind: "math"
};
const lowerBeta = {
	renderChildren: () => /* @__PURE__ */ jsx("i", { children: "β" }),
	label: "beta",
	mathLiveCommand: "\\beta",
	kind: "math"
};
const lowerGamma = {
	renderChildren: () => /* @__PURE__ */ jsx("i", { children: "γ" }),
	label: "gamma",
	mathLiveCommand: "\\gamma",
	kind: "math"
};
const lowerDelta = {
	renderChildren: () => /* @__PURE__ */ jsx("i", { children: "δ" }),
	label: "delta",
	mathLiveCommand: "\\delta",
	kind: "math"
};
const lowerEpsilon = {
	renderChildren: () => /* @__PURE__ */ jsx("i", { children: "ϵ" }),
	label: "epsilon",
	mathLiveCommand: "\\epsilon",
	kind: "math"
};
const lowerZeta = {
	renderChildren: () => /* @__PURE__ */ jsx("i", { children: "ζ" }),
	label: "zeta",
	mathLiveCommand: "\\zeta",
	kind: "math"
};
const lowerEta = {
	renderChildren: () => /* @__PURE__ */ jsx("i", { children: "η" }),
	label: "eta",
	mathLiveCommand: "\\eta",
	kind: "math"
};
const lowerTheta = {
	renderChildren: () => /* @__PURE__ */ jsx("i", { children: "θ" }),
	label: "theta",
	mathLiveCommand: "\\theta",
	kind: "math"
};
const lowerIota = {
	renderChildren: () => /* @__PURE__ */ jsx("i", { children: "ι" }),
	label: "iota",
	mathLiveCommand: "\\iota",
	kind: "math"
};
const lowerKappa = {
	renderChildren: () => /* @__PURE__ */ jsx("i", { children: "κ" }),
	label: "kappa",
	mathLiveCommand: "\\kappa",
	kind: "math"
};
const lowerLambda = {
	renderChildren: () => /* @__PURE__ */ jsx("i", { children: "λ" }),
	label: "lambda",
	mathLiveCommand: "\\lambda",
	kind: "math"
};
const lowerMu = {
	renderChildren: () => /* @__PURE__ */ jsx("i", { children: "μ" }),
	label: "mu",
	mathLiveCommand: "\\mu",
	kind: "math"
};
const lowerNu = {
	renderChildren: () => /* @__PURE__ */ jsx("i", { children: "ν" }),
	label: "nu",
	mathLiveCommand: "\\nu",
	kind: "math"
};
const lowerXi = {
	renderChildren: () => /* @__PURE__ */ jsx("i", { children: "ξ" }),
	label: "xi",
	mathLiveCommand: "\\xi",
	kind: "math"
};
const lowerOmicron = {
	renderChildren: () => /* @__PURE__ */ jsx("i", { children: "ο" }),
	label: "omicron",
	mathLiveCommand: "\\omicron",
	kind: "math"
};
const lowerPi = {
	renderChildren: () => /* @__PURE__ */ jsx("i", { children: "π" }),
	label: "pi",
	mathLiveCommand: "\\pi",
	kind: "math"
};
const lowerRho = {
	renderChildren: () => /* @__PURE__ */ jsx("i", { children: "ρ" }),
	label: "rho",
	mathLiveCommand: "\\rho",
	kind: "math"
};
const lowerSigma = {
	renderChildren: () => /* @__PURE__ */ jsx("i", { children: "σ" }),
	label: "sigma",
	mathLiveCommand: "\\sigma",
	kind: "math"
};
const lowerTau = {
	renderChildren: () => /* @__PURE__ */ jsx("i", { children: "τ" }),
	label: "tau",
	mathLiveCommand: "\\tau",
	kind: "math"
};
const lowerUpsilon = {
	renderChildren: () => /* @__PURE__ */ jsx("i", { children: "υ" }),
	label: "upsilon",
	mathLiveCommand: "\\upsilon",
	kind: "math"
};
const lowerPhi = {
	renderChildren: () => /* @__PURE__ */ jsx("i", { children: "ϕ" }),
	label: "phi",
	mathLiveCommand: "\\phi",
	kind: "math"
};
const lowerChi = {
	renderChildren: () => /* @__PURE__ */ jsx("i", { children: "χ" }),
	label: "chi",
	mathLiveCommand: "\\chi",
	kind: "math"
};
const lowerPsi = {
	renderChildren: () => /* @__PURE__ */ jsx("i", { children: "ψ" }),
	label: "psi",
	mathLiveCommand: "\\psi",
	kind: "math"
};
const lowerOmega = {
	renderChildren: () => /* @__PURE__ */ jsx("i", { children: "ω" }),
	label: "omega",
	mathLiveCommand: "\\omega",
	kind: "math"
};
const upperAlpha = {
	text: "A",
	label: "Alpha",
	mathLiveCommand: "\\Alpha"
};
const upperBeta = {
	text: "B",
	label: "Beta",
	mathLiveCommand: "\\Beta"
};
const upperGamma = {
	text: "Γ",
	label: "Gamma",
	mathLiveCommand: "\\Gamma"
};
const upperDelta = {
	text: "Δ",
	label: "Delta",
	mathLiveCommand: "\\Delta"
};
const upperEpsilon = {
	text: "E",
	label: "Epsilon",
	mathLiveCommand: "\\Epsilon"
};
const upperZeta = {
	text: "Z",
	label: "Zeta",
	mathLiveCommand: "\\Zeta"
};
const upperEta = {
	text: "H",
	label: "Eta",
	mathLiveCommand: "\\Eta"
};
const upperTheta = {
	text: "Θ",
	label: "Theta",
	mathLiveCommand: "\\Theta"
};
const upperIota = {
	text: "I",
	label: "Iota",
	mathLiveCommand: "\\Iota"
};
const upperKappa = {
	text: "K",
	label: "Kappa",
	mathLiveCommand: "\\Kappa"
};
const upperLambda = {
	text: "Λ",
	label: "Lambda",
	mathLiveCommand: "\\Lambda"
};
const upperMu = {
	text: "M",
	label: "Mu",
	mathLiveCommand: "\\Mu"
};
const upperNu = {
	text: "N",
	label: "Nu",
	mathLiveCommand: "\\Nu"
};
const upperXi = {
	text: "Ξ",
	label: "Xi",
	mathLiveCommand: "\\Xi"
};
const upperOmicron = {
	text: "O",
	label: "Omicron",
	mathLiveCommand: "\\Omicron"
};
const upperPi = {
	text: "Π",
	label: "Pi",
	mathLiveCommand: "\\Pi"
};
const upperRho = {
	text: "P",
	label: "Rho",
	mathLiveCommand: "\\Rho"
};
const upperSigma = {
	text: "Σ",
	label: "Sigma",
	mathLiveCommand: "\\Sigma"
};
const upperTau = {
	text: "T",
	label: "Tau",
	mathLiveCommand: "\\Tau"
};
const upperUpsilon = {
	text: "Υ",
	label: "Upsilon",
	mathLiveCommand: "\\Upsilon"
};
const upperPhi = {
	text: "Φ",
	label: "Phi",
	mathLiveCommand: "\\Phi"
};
const upperChi = {
	text: "X",
	label: "Chi",
	mathLiveCommand: "\\Chi"
};
const upperPsi = {
	text: "Ψ",
	label: "Psi",
	mathLiveCommand: "\\Psi"
};
const upperOmega = {
	text: "Ω",
	label: "Omega",
	mathLiveCommand: "\\Omega"
};
const varKappa = {
	renderChildren: () => /* @__PURE__ */ jsx("i", { children: "ϰ" }),
	label: "varkappa",
	mathLiveCommand: "\\varkappa",
	kind: "math"
};
const varTheta = {
	renderChildren: () => /* @__PURE__ */ jsx("i", { children: "ϑ" }),
	label: "vartheta",
	mathLiveCommand: "\\vartheta",
	kind: "math"
};
const varPi = {
	renderChildren: () => /* @__PURE__ */ jsx("i", { children: "ϖ" }),
	label: "varpi",
	mathLiveCommand: "\\varpi",
	kind: "math"
};
const varRho = {
	renderChildren: () => /* @__PURE__ */ jsx("i", { children: "ϱ" }),
	label: "varrho",
	mathLiveCommand: "\\varrho",
	kind: "math"
};
const varSigma = {
	renderChildren: () => /* @__PURE__ */ jsx("i", { children: "ς" }),
	label: "varsigma",
	mathLiveCommand: "\\varsigma",
	kind: "math"
};
const varPhi = {
	renderChildren: () => /* @__PURE__ */ jsx("i", { children: "φ" }),
	label: "varphi",
	mathLiveCommand: "\\varphi",
	kind: "math"
};
//#endregion
//#region src/extensions/math/components/MathEditor/keys/matrices.tsx
const vectorComma1X2 = {
	label: "1x2 comma vector",
	renderChildren: () => /* @__PURE__ */ jsx(VectorComma1X2Icon, {}),
	mathLiveCommand: "\\begin{bmatrix}{\\placeholder{}},{\\placeholder{}}\\end{bmatrix}",
	latexCommand: "\\begin{bmatrix}{\\placeholder{}},{\\placeholder{}}\\end{bmatrix}",
	tooltipCommand: "\\begin{bmatrix}x,y\\end{bmatrix}",
	tooltipLabel: "1x2 vector"
};
const vectorComma1X3 = {
	label: "1x3 comma vector",
	renderChildren: () => /* @__PURE__ */ jsx(VectorComma1X3Icon, {}),
	mathLiveCommand: "\\begin{bmatrix}{\\placeholder{}},{\\placeholder{}},{\\placeholder{}}\\end{bmatrix}",
	tooltipCommand: "",
	tooltipLabel: "1x3 vector"
};
const vector1X2 = {
	label: "1x2 vector",
	renderChildren: () => /* @__PURE__ */ jsx(Vector1X2Icon, {}),
	mathLiveCommand: "\\begin{bmatrix}{\\placeholder{}}&{\\placeholder{}}\\end{bmatrix}",
	tooltipCommand: "\\begin{bmatrix}x&y\\end{bmatrix}"
};
const vector1X3 = {
	label: "1x3 vector",
	renderChildren: () => /* @__PURE__ */ jsx(Vector1X3Icon, {}),
	mathLiveCommand: "\\begin{bmatrix}{\\placeholder{}}&{\\placeholder{}}&{\\placeholder{}}\\end{bmatrix}",
	tooltipCommand: ""
};
const vector2X1 = {
	label: "2x1 vector",
	renderChildren: () => /* @__PURE__ */ jsx(Vector2X1Icon, {}),
	mathLiveCommand: "\\begin{bmatrix}{\\placeholder{}} \\\\ {\\placeholder{}}\\end{bmatrix}",
	tooltipCommand: ""
};
const vector3X1 = {
	label: "3x1 vector",
	renderChildren: () => /* @__PURE__ */ jsx(Vector3X1Icon, {}),
	mathLiveCommand: "\\begin{bmatrix}{\\placeholder{}} \\\\ {\\placeholder{}} \\\\ {\\placeholder{}}\\end{bmatrix}",
	tooltipCommand: ""
};
const vector4X1 = {
	label: "4x1 vector",
	renderChildren: () => /* @__PURE__ */ jsx(Vector4X1Icon, {}),
	mathLiveCommand: "\\begin{bmatrix}{\\placeholder{}} \\\\ {\\placeholder{}} \\\\ {\\placeholder{}} \\\\ {\\placeholder{}}\\end{bmatrix}",
	tooltipCommand: ""
};
const vector2X2 = {
	label: "2x2 vector",
	renderChildren: () => /* @__PURE__ */ jsx(Vector2X2Icon, {}),
	mathLiveCommand: "\\begin{bmatrix}{\\placeholder{}}&{\\placeholder{}} \\\\ {\\placeholder{}}&{\\placeholder{}}\\end{bmatrix}",
	tooltipCommand: "\\begin{bmatrix}x&y\\\\a&b\\end{bmatrix}"
};
const vector2X3 = {
	label: "2x3 vector",
	renderChildren: () => /* @__PURE__ */ jsx(Vector2X3Icon, {}),
	mathLiveCommand: "\\begin{bmatrix}{\\placeholder{}}&{\\placeholder{}}&{\\placeholder{}} \\\\ {\\placeholder{}}&{\\placeholder{}}&{\\placeholder{}}\\end{bmatrix}",
	tooltipCommand: ""
};
const vector3X3 = {
	label: "3x3 vector",
	renderChildren: () => /* @__PURE__ */ jsx(Vector3X3Icon, {}),
	mathLiveCommand: "\\begin{bmatrix}{\\placeholder{}}&{\\placeholder{}}&{\\placeholder{}} \\\\ {\\placeholder{}}&{\\placeholder{}}&{\\placeholder{}} \\\\ {\\placeholder{}}&{\\placeholder{}}&{\\placeholder{}}\\end{bmatrix}",
	tooltipCommand: ""
};
const vector4X4 = {
	label: "4x4 vector",
	renderChildren: () => /* @__PURE__ */ jsx(Vector4X4Icon, {}),
	mathLiveCommand: "\\begin{bmatrix}{\\placeholder{}}&{\\placeholder{}}&{\\placeholder{}}&{\\placeholder{}} \\\\ {\\placeholder{}}&{\\placeholder{}}&{\\placeholder{}}&{\\placeholder{}}\\\\ {\\placeholder{}}&{\\placeholder{}}&{\\placeholder{}}&{\\placeholder{}}\\\\ {\\placeholder{}}&{\\placeholder{}}&{\\placeholder{}}&{\\placeholder{}}\\end{bmatrix}",
	tooltipCommand: ""
};
const vector5X5 = {
	label: "5x5 vector",
	renderChildren: () => /* @__PURE__ */ jsx(Vector5X5Icon, {}),
	mathLiveCommand: "\\begin{bmatrix}{\\placeholder{}}&{\\placeholder{}}&{\\placeholder{}}&{\\placeholder{}}&{\\placeholder{}} \\\\ {\\placeholder{}}&{\\placeholder{}}&{\\placeholder{}}&{\\placeholder{}}&{\\placeholder{}}\\\\ {\\placeholder{}}&{\\placeholder{}}&{\\placeholder{}}&{\\placeholder{}}&{\\placeholder{}}\\\\ {\\placeholder{}}&{\\placeholder{}}&{\\placeholder{}}&{\\placeholder{}}&{\\placeholder{}}\\\\ {\\placeholder{}}&{\\placeholder{}}&{\\placeholder{}}&{\\placeholder{}}&{\\placeholder{}}\\end{bmatrix}",
	tooltipCommand: ""
};
const openBracketFraction = {
	label: "open bracket fraction",
	renderChildren: () => /* @__PURE__ */ jsx(OpenBracketFractionIcon, {}),
	mathLiveCommand: "\\lbrace\\frac{\\placeholder{}}{\\placeholder{}}",
	tooltip: false
};
const horizontalDots = {
	label: "horizontal dots",
	mathLiveCommand: "\\ldots",
	text: "…",
	kind: "script"
};
const verticalDots = {
	label: "vertical dots",
	mathLiveCommand: "\\vdots",
	text: "⋮"
};
const diagonalDots = {
	label: "diagonal dots",
	mathLiveCommand: "\\ddots",
	text: "⋱"
};
//#endregion
//#region src/extensions/math/components/MathEditor/keys/misc.tsx
const overbar = {
	label: "overbar",
	renderChildren: () => /* @__PURE__ */ jsx(OverbarIcon, {}),
	mathLiveCommand: "\\overline"
};
const underbar = {
	label: "underbar",
	renderChildren: () => /* @__PURE__ */ jsx(UnderbarIcon, {}),
	mathLiveCommand: "\\underline"
};
const hat = {
	label: "hat",
	renderChildren: () => /* @__PURE__ */ jsx(HatIcon, {}),
	mathLiveCommand: "\\hat"
};
const tildeAbove = {
	label: "tilde above",
	renderChildren: () => /* @__PURE__ */ jsx(TildeAboveIcon, {}),
	mathLiveCommand: "\\tilde"
};
const tildeUnderneath = {
	label: "tilde underneath",
	renderChildren: () => /* @__PURE__ */ jsx(TildeUnderneathIcon, {}),
	mathLiveCommand: "\\utilde"
};
const overlineSegment = {
	label: "overline segment",
	renderChildren: () => /* @__PURE__ */ jsx(OverlineSegmentIcon, {}),
	mathLiveCommand: "\\overlinesegment",
	tooltipLabel: ""
};
const underlineSegment = {
	label: "underline segment",
	renderChildren: () => /* @__PURE__ */ jsx(UnderlineSegmentIcon, {}),
	mathLiveCommand: "\\underlinesegment",
	tooltipLabel: ""
};
const therefore = {
	text: "∴",
	label: "therefore",
	mathLiveCommand: "\\therefore"
};
const because = {
	text: "∵",
	label: "because",
	mathLiveCommand: "\\because"
};
const infinity = {
	label: "infinity",
	text: "∞",
	mathLiveCommand: "\\infin"
};
const proportionality = {
	label: "proportionality",
	text: "∝",
	mathLiveCommand: "\\propto"
};
const functionComposition = {
	label: "function composition",
	text: "∘",
	mathLiveCommand: "\\circ"
};
const forAll = {
	label: "for all",
	text: "∀",
	mathLiveCommand: "\\forall"
};
const thereExist = {
	label: "there exist",
	text: "∃",
	mathLiveCommand: "\\exist"
};
const thereNotExist = {
	label: "there does not exist",
	renderChildren: () => /* @__PURE__ */ jsx(NotExistsIcon, {}),
	mathLiveCommand: "\\nexists"
};
const aleph = {
	label: "Aleph number",
	text: "ℵ",
	mathLiveCommand: "\\aleph"
};
const imaginaryUnit = {
	label: "imaginary unit",
	text: "i",
	mathLiveCommand: "\\imaginaryI"
};
const naturalNumbers = {
	label: "Natural numbers",
	text: "N",
	mathLiveCommand: "\\N",
	kind: "ams"
};
const primeNumbers = {
	label: "Prime numbers",
	text: "P",
	mathLiveCommand: "\\P",
	kind: "ams"
};
const integers = {
	label: "Integers",
	text: "Z",
	mathLiveCommand: "\\Z",
	kind: "ams"
};
const rationalNumbers = {
	label: "Rational numbers",
	text: "Q",
	mathLiveCommand: "\\Q",
	kind: "ams"
};
const realNumbers = {
	label: "Real numbers",
	text: "R",
	mathLiveCommand: "\\R",
	kind: "ams"
};
const complexNumbers = {
	label: "Complex numbers",
	text: "C",
	mathLiveCommand: "\\C",
	kind: "ams"
};
const hamilton = {
	label: "Hamilton",
	text: "H",
	mathLiveCommand: "\\mathbb{H}",
	kind: "ams"
};
const halmos = {
	label: "Halmos",
	text: "■",
	mathLiveCommand: "\\blacksquare",
	kind: "ams"
};
const dagger = {
	label: "dagger",
	text: "†",
	mathLiveCommand: "\\dag"
};
const roundBracket = {
	label: "round brackets",
	renderChildren: () => /* @__PURE__ */ jsx(RoundBracketIcon, {}),
	mathLiveCommand: "\\left({\\placeholder{}}\\right)",
	tooltipCommand: ""
};
const sufixBracket = {
	label: "sufix brackets",
	renderChildren: () => /* @__PURE__ */ jsx(SufixBracketIcon, {}),
	mathLiveCommand: "{\\placeholder{}}\\left({\\placeholder{}}\\right)",
	tooltip: false
};
const squareBracket = {
	label: "square brackets",
	renderChildren: () => /* @__PURE__ */ jsx(SquareBracketIcon, {}),
	mathLiveCommand: "\\left[{\\placeholder{}}\\right]",
	tooltipCommand: ""
};
const curlyBracket = {
	label: "curly brackets",
	renderChildren: () => /* @__PURE__ */ jsx(CurlyBracketIcon, {}),
	mathLiveCommand: "\\left\\{{\\placeholder{}}\\right\\}",
	tooltipCommand: ""
};
//#endregion
//#region src/extensions/math/components/MathEditor/keys/operations.tsx
const plus = {
	text: "+",
	label: "plus",
	mathLiveCommand: "+"
};
const minus = {
	text: "-",
	label: "minus",
	mathLiveCommand: "-"
};
const multiply = {
	text: "×",
	label: "multiply",
	mathLiveCommand: "\\times"
};
const divide = {
	text: "÷",
	label: "divide",
	mathLiveCommand: "\\div"
};
const plusOrMinus = {
	text: "±",
	label: "plus or minus",
	mathLiveCommand: "\\pm"
};
const minusOrPlus = {
	text: "∓",
	label: "minus or plus",
	mathLiveCommand: "\\mp"
};
const dotProduct = {
	text: "⋅",
	label: "dot product",
	mathLiveCommand: "\\cdot"
};
const fraction = {
	label: "fraction",
	renderChildren: () => /* @__PURE__ */ jsx(FractionIcon, {}),
	mathLiveCommand: "\\frac{\\placeholder{}}{\\placeholder{}}",
	tooltipCommand: "\\frac{x}{y}"
};
const niceFraction = {
	label: "nice fraction",
	renderChildren: () => /* @__PURE__ */ jsx(NiceFractionIcon, {}),
	mathLiveCommand: "\\placeholder{}/\\placeholder{}",
	tooltipCommand: "{x}/{y}",
	tooltipLabel: "fraction"
};
const bracketedFraction = {
	label: "bracketed fraction",
	renderChildren: () => /* @__PURE__ */ jsx(BracketedFractionIcon, {}),
	mathLiveCommand: "\\left(\\frac{\\placeholder{}}{\\placeholder{}}\\right)",
	tooltip: false
};
const limitFunction = {
	label: "limit function",
	renderChildren: () => /* @__PURE__ */ jsx(LimitIcon, {}),
	mathLiveCommand: "\\lim_{\\placeholder{}\\to \\placeholder{}}",
	tooltipCommand: "\\lim_{x \\to y}"
};
const derivativeFunction = {
	label: "derivative function",
	renderChildren: () => /* @__PURE__ */ jsx(DerivativeIcon, {}),
	mathLiveCommand: "\\frac{\\differentialD\\placeholder{}}{\\differentialD x}",
	tooltipCommand: "\\frac{dy}{dx}",
	tooltipLabel: "derivative"
};
const partialDerivativeFunction = {
	label: "partial derivative function",
	renderChildren: () => /* @__PURE__ */ jsx(PartialDerivativeIcon, {}),
	mathLiveCommand: "\\pdiff{\\placeholder{}}{\\placeholder{}}",
	tooltipCommand: "\\pdiff{}{}",
	tooltipLabel: "partial derivative"
};
const derivativeSymbols = {
	label: "derivative symbols",
	text: "∂",
	mathLiveCommand: "\\partial",
	tooltipLabel: "derivative"
};
const integral = {
	label: "integral",
	renderChildren: () => /* @__PURE__ */ jsx(IntegralIcon, {}),
	mathLiveCommand: "\\int_{\\placeholder{}}^{\\placeholder{}}{\\placeholder{}}",
	tooltipCommand: "\\int"
};
const doubleIntegral = {
	label: "double integral",
	renderChildren: () => /* @__PURE__ */ jsx(DoubleIntegralIcon, {}),
	mathLiveCommand: "\\iint_{\\placeholder{}}^{\\placeholder{}}{\\placeholder{}}",
	tooltipCommand: "\\iint"
};
const tripleIntegral = {
	label: "triple integral",
	renderChildren: () => /* @__PURE__ */ jsx(TripleIntegralIcon, {}),
	mathLiveCommand: "\\iiint_{\\placeholder{}}^{\\placeholder{}}{\\placeholder{}}",
	tooltipCommand: "\\iiint"
};
const contourIntegral = {
	label: "contour integral",
	text: "∮",
	mathLiveCommand: "\\oint",
	kind: "size1"
};
const del = {
	label: "del",
	text: "∇",
	mathLiveCommand: "\\nabla"
};
const setDifference = {
	label: "set difference",
	text: "∖",
	mathLiveCommand: "\\setminus"
};
const dot = {
	label: "dot",
	renderChildren: () => /* @__PURE__ */ jsx(DotIcon, {}),
	mathLiveCommand: "\\dot{\\placeholder{}}",
	tooltipLabel: "derivative",
	tooltipCommand: "\\dot"
};
const ddot = {
	label: "ddot",
	renderChildren: () => /* @__PURE__ */ jsx(DDotIcon, {}),
	mathLiveCommand: "\\ddot{\\placeholder{}}",
	tooltipLabel: "partial derivative",
	tooltipCommand: "\\ddot"
};
const summation = {
	label: "summation",
	renderChildren: () => /* @__PURE__ */ jsx(SumIcon, {}),
	mathLiveCommand: "\\sum_{\\placeholder{}}^{\\placeholder{}}{\\placeholder{}}",
	tooltipCommand: "\\sum"
};
const coproduct = {
	label: "coproduct",
	renderChildren: () => /* @__PURE__ */ jsx(CoproductIcon, {}),
	mathLiveCommand: "\\coprod_{\\placeholder{}}^{\\placeholder{}}{\\placeholder{}}",
	tooltipCommand: "\\coprod"
};
const product = {
	label: "product",
	renderChildren: () => /* @__PURE__ */ jsx(ProductIcon, {}),
	mathLiveCommand: "\\prod_{\\placeholder{}}^{\\placeholder{}}{\\placeholder{}}",
	tooltipCommand: "\\prod"
};
const union = {
	label: "union",
	renderChildren: () => /* @__PURE__ */ jsx(UnionIcon, {}),
	mathLiveCommand: "\\bigcup_{\\placeholder{}}^{\\placeholder{}}{\\placeholder{}}",
	tooltipCommand: "\\bigcup"
};
const intersection = {
	label: "intersection",
	renderChildren: () => /* @__PURE__ */ jsx(IntersectionIcon, {}),
	mathLiveCommand: "\\bigcap_{\\placeholder{}}^{\\placeholder{}}{\\placeholder{}}",
	tooltipCommand: "\\bigcap"
};
const unionSymbol = {
	label: "union symbol",
	text: "∪",
	mathLiveCommand: "\\cup",
	tooltipLabel: "union"
};
const intersectionSymbol = {
	label: "intersection symbol",
	text: "∩",
	mathLiveCommand: "\\cap",
	tooltipLabel: "intersection"
};
const subset = {
	label: "subset",
	text: "⊂",
	mathLiveCommand: "\\subset",
	kind: "ams"
};
const superset = {
	label: "superset",
	text: "⊃",
	mathLiveCommand: "\\supset",
	kind: "ams"
};
const subsetEq = {
	label: "subset;equal to",
	text: "⊆",
	mathLiveCommand: "\\subseteq",
	kind: "ams"
};
const supersetEq = {
	label: "superset;equal to",
	text: "⊇",
	mathLiveCommand: "\\supseteq",
	kind: "ams"
};
const subsetNotEq = {
	label: "subset of;not equal to",
	text: "⊊",
	mathLiveCommand: "\\subsetneq",
	kind: "ams"
};
const supersetNotEq = {
	label: "superset of;not equal to",
	text: "⊋",
	mathLiveCommand: "\\supsetneq",
	kind: "ams"
};
const notSuperset = {
	label: "not superset",
	text: "⊉",
	mathLiveCommand: "\\nsupseteq",
	kind: "ams"
};
const notSubset = {
	label: "not subset",
	text: "⊈",
	mathLiveCommand: "\\nsubseteq",
	kind: "ams"
};
const disjointUnion = {
	label: "disjoint union",
	text: "⊔",
	mathLiveCommand: "\\sqcup",
	kind: "ams"
};
const or = {
	label: "or",
	text: "∨",
	mathLiveCommand: "\\lor",
	kind: "ams"
};
const and = {
	label: "and",
	text: "∧",
	mathLiveCommand: "\\land",
	kind: "ams"
};
const elementOf = {
	label: "element of",
	text: "∈",
	mathLiveCommand: "\\in",
	kind: "ams"
};
const notElementOf = {
	label: "not an element of",
	renderChildren: () => /* @__PURE__ */ jsx(NotElementOfIcon, {}),
	mathLiveCommand: "\\notin"
};
const symmetricDifference = {
	label: "symmetric difference",
	text: "⊖",
	mathLiveCommand: "\\ominus",
	kind: "ams"
};
const directSum = {
	label: "direct sum",
	text: "⊕",
	mathLiveCommand: "\\oplus",
	kind: "ams"
};
const tensorProduct = {
	label: "tensor product",
	text: "⊗",
	mathLiveCommand: "\\otimes",
	kind: "ams"
};
const emptySet = {
	label: "empty set",
	text: "∅",
	mathLiveCommand: "\\varnothing",
	kind: "ams"
};
//#endregion
//#region src/extensions/math/components/MathEditor/keys/relations.tsx
const equal = {
	text: "=",
	label: "equal",
	mathLiveCommand: "=",
	latexCommand: "="
};
const notEqualTo = {
	label: "not equal to",
	renderChildren: () => /* @__PURE__ */ jsx(NotEqualIcon, {}),
	mathLiveCommand: "\\ne"
};
const lessThan = {
	label: "less than",
	text: "<",
	mathLiveCommand: "<"
};
const greaterThan = {
	label: "greater than",
	text: ">",
	mathLiveCommand: ">"
};
const lessThanOrEqual = {
	label: "less than or equal",
	text: "≤",
	mathLiveCommand: "\\leq"
};
const greaterThanOrEqual = {
	label: "greater than or equal",
	text: "≥",
	mathLiveCommand: "\\geq"
};
//#endregion
//#region src/extensions/math/components/MathEditor/keys/keys.ts
const keys = {
	Popular: [
		plus,
		minus,
		plusOrMinus,
		multiply,
		dotProduct,
		divide,
		therefore,
		equal,
		notEqualTo,
		lessThan,
		greaterThan,
		lessThanOrEqual,
		greaterThanOrEqual,
		lowerPi,
		infinity,
		proportionality,
		upperDelta,
		niceFraction,
		fraction,
		square,
		power,
		squareRoot,
		root,
		subscript,
		subscriptSuperscript,
		derivativeFunction,
		integral,
		sine,
		cosine,
		tangent,
		lowerAlpha,
		lowerBeta,
		lowerGamma,
		lowerTheta,
		roundBracket,
		sufixBracket,
		squareBracket,
		curlyBracket,
		bracketedFraction
	],
	Functions: [
		square,
		power,
		squareRoot,
		root,
		exponential,
		naturalLog,
		logarithm,
		log10,
		subscript,
		subscriptSuperscript,
		sine,
		cosine,
		tangent,
		cotangent,
		secant,
		cosecant,
		inverseSine,
		inverseCosine,
		inverseTan,
		inverseCotTan,
		inverseSec,
		inverseCosec,
		sinh,
		cosh,
		tanh,
		coth,
		lowerTheta,
		degree,
		verticalBars,
		ceiling,
		floor,
		verticalBar$1,
		lAngle,
		rAngle
	],
	Operations: [
		plusOrMinus,
		minusOrPlus,
		multiply,
		dotProduct,
		divide,
		fraction,
		niceFraction,
		bracketedFraction,
		limitFunction,
		derivativeFunction,
		partialDerivativeFunction,
		derivativeSymbols,
		integral,
		doubleIntegral,
		tripleIntegral,
		contourIntegral,
		del,
		setDifference,
		dot,
		ddot,
		summation,
		coproduct,
		product,
		union,
		intersection,
		unionSymbol,
		intersectionSymbol,
		subset,
		superset,
		subsetEq,
		supersetEq,
		subsetNotEq,
		supersetNotEq,
		notSubset,
		notSuperset,
		disjointUnion,
		and,
		or,
		elementOf,
		notElementOf,
		symmetricDifference,
		directSum,
		tensorProduct,
		emptySet
	],
	Greek: [
		lowerAlpha,
		lowerBeta,
		lowerGamma,
		lowerDelta,
		lowerEpsilon,
		lowerZeta,
		lowerEta,
		lowerTheta,
		lowerIota,
		lowerKappa,
		lowerLambda,
		lowerMu,
		lowerNu,
		lowerXi,
		lowerOmicron,
		lowerPi,
		lowerRho,
		lowerSigma,
		lowerTau,
		lowerUpsilon,
		lowerPhi,
		lowerChi,
		lowerPsi,
		lowerOmega,
		upperAlpha,
		upperBeta,
		upperGamma,
		upperDelta,
		upperEpsilon,
		upperZeta,
		upperEta,
		upperTheta,
		upperIota,
		upperKappa,
		upperLambda,
		upperMu,
		upperNu,
		upperXi,
		upperOmicron,
		upperPi,
		upperRho,
		upperSigma,
		upperTau,
		upperUpsilon,
		upperPhi,
		upperChi,
		upperPsi,
		upperOmega,
		varKappa,
		varTheta,
		varPi,
		varRho,
		varSigma,
		varPhi
	],
	Relations: [
		lessThan,
		greaterThan,
		lessThanOrEqual,
		greaterThanOrEqual,
		notEqualTo,
		{
			label: "approximately",
			text: "≈",
			mathLiveCommand: "\\approx"
		},
		{
			label: "less or simillar",
			text: "≲",
			mathLiveCommand: "\\lesssim",
			kind: "ams"
		},
		{
			label: "greater or simillar",
			text: "≳",
			mathLiveCommand: "\\gtrsim",
			kind: "ams"
		},
		{
			label: "lesser lesser than",
			text: "≪",
			mathLiveCommand: "\\ll",
			kind: "ams"
		},
		{
			label: "greater greater than",
			text: "≫",
			mathLiveCommand: "\\gg",
			kind: "ams"
		},
		{
			label: "not lesser than",
			text: "≮",
			mathLiveCommand: "\\nless",
			kind: "ams"
		},
		{
			label: "not greater than",
			text: "≯",
			mathLiveCommand: "\\ngtr",
			kind: "ams"
		},
		{
			label: "not lesser than or equal",
			text: "≰",
			mathLiveCommand: "\\nleq",
			kind: "ams"
		},
		{
			label: "not greater than or equal",
			text: "≱",
			mathLiveCommand: "\\ngeq",
			kind: "ams"
		},
		{
			label: "congruent",
			text: "≅",
			mathLiveCommand: "\\cong",
			kind: "ams"
		},
		{
			label: "similar or equal",
			text: "≃",
			mathLiveCommand: "\\backsimeq",
			kind: "ams"
		},
		{
			label: "approximately equal",
			text: "≊",
			mathLiveCommand: "\\approxeq",
			kind: "ams"
		},
		{
			label: "defined as",
			text: "≐",
			mathLiveCommand: "\\doteq"
		},
		{
			label: "asymptotic",
			text: "≍",
			mathLiveCommand: "\\asymp"
		},
		{
			label: "vertical bar",
			text: "∣",
			mathLiveCommand: "\\mid"
		},
		{
			label: "does not divide",
			text: "∤",
			mathLiveCommand: "\\nmid",
			kind: "ams"
		},
		{
			label: "parallel",
			text: "∥",
			mathLiveCommand: "\\parallel"
		},
		{
			label: "not parallel",
			text: "∦",
			mathLiveCommand: "\\nparallel",
			kind: "ams"
		},
		{
			label: "perpendicular",
			text: "⊥",
			mathLiveCommand: "\\perp"
		},
		{
			label: "turnstile",
			text: "⊢",
			mathLiveCommand: "\\vdash"
		},
		{
			label: "double turnstile",
			text: "⊨",
			mathLiveCommand: "\\vDash"
		},
		{
			label: "down tack",
			text: "⊤",
			mathLiveCommand: "\\top"
		},
		{
			label: "equal by definitiion",
			text: "≜",
			mathLiveCommand: "\\triangleq",
			kind: "ams"
		}
	],
	Arrows: [
		downArrow,
		upArrow,
		leftArrow,
		rightArrow,
		leftRightArrow,
		equilibrium,
		longLeftArrow,
		longRightArrow,
		longleftrightArrow,
		overleftArrow,
		overrightArrow,
		overleftrightArrow,
		underleftArrow,
		underrightArrow,
		underleftrightArrow,
		leftArrowBetween,
		rightArrowBetween
	],
	Matrices: [
		vectorComma1X2,
		vectorComma1X3,
		vector1X2,
		vector1X3,
		vector2X1,
		vector3X1,
		vector4X1,
		vector2X2,
		vector2X3,
		vector3X3,
		vector4X4,
		vector5X5,
		openBracketFraction,
		horizontalDots,
		diagonalDots,
		verticalDots
	],
	Misc: [
		overbar,
		underbar,
		hat,
		tildeAbove,
		tildeUnderneath,
		overlineSegment,
		underlineSegment,
		therefore,
		because,
		dotProduct,
		infinity,
		proportionality,
		functionComposition,
		lowerPhi,
		forAll,
		thereExist,
		thereNotExist,
		aleph,
		imaginaryUnit,
		naturalNumbers,
		primeNumbers,
		integers,
		rationalNumbers,
		complexNumbers,
		realNumbers,
		hamilton,
		halmos,
		dagger
	]
};
//#endregion
//#region src/extensions/math/components/MathEditor/keys/types.ts
const KEY_CATEGORIES = [
	"Popular",
	"Functions",
	"Operations",
	"Greek",
	"Relations",
	"Arrows",
	"Matrices",
	"Misc"
];
//#endregion
//#region src/extensions/math/components/MathEditor/MathKeyboardKey.tsx
function MathKeyboardKey(props) {
	const { tooltip = true, tooltipLabel, tooltipCommand, ...rest } = props;
	if (!tooltip) return /* @__PURE__ */ jsx(ButtonRoot, { ...rest });
	return /* @__PURE__ */ jsx(Tooltip, {
		size: "sm",
		width: "auto",
		delayDuration: 300,
		content: /* @__PURE__ */ jsxs(MathTooltip, {
			kind: "systemSm",
			as: "span",
			children: [tooltipLabel, tooltipCommand && tooltipCommand !== "" ? /* @__PURE__ */ jsx(MathTooltipCommand, { children: tooltipCommand }) : null]
		}),
		children: /* @__PURE__ */ jsx(ButtonRoot, { ...rest })
	});
}
const MathTooltip = styled(Text$1)`
  display: inline-flex;
  align-items: center;
  gap: 2px;
`;
const MathTooltipCommand = styled.span`
  background-color: ${colors.grey100};
  border-radius: 2px;
  padding: 2px 6px;
`;
const ButtonRoot = styled.button`
  width: 36px;
  height: 36px;
  padding: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 3px;
  border: none;
  outline: 0;
  position: relative;
  cursor: pointer;

  background: ${colors.white200};
  border: 0.75px solid ${colors.grey200};
  fill: rgba(58, 81, 127, 1);
  color: rgba(58, 81, 127, 1);

  font-family: ${(p) => getFontFamily(p)};
  font-style: normal;
  font-weight: ${(p) => p.size === "small" ? "700" : "400"};
  font-size: ${(p) => p.size === "small" ? "12px" : "18px"};
  line-height: ${(p) => p.size === "small" ? "18px" : "26px"};
  letter-spacing: -0.3px;

  &:not(:disabled) {
    &:hover {
      background: #e6eaf2;
    }
    &:active,
    &:focus {
      outline: 1.3px solid ${(p) => p.theme.primaryColor};
    }
  }
`;
function getFontFamily(p) {
	switch (p.kind) {
		case "math": return "KaTeX_Math";
		case "ams": return "KaTeX_AMS";
		case "script": return "KaTeX_Script";
		case "size1": return "KaTeX_Size1";
		default: return "KaTeX_Main";
	}
}
//#endregion
//#region src/extensions/math/components/MathEditor/MathKeyboard.tsx
function MathKeyboard({ executeCommand }) {
	const [category, setCategory] = useState(KEY_CATEGORIES[0]);
	const categoryCommands = keys[category];
	return /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsx(Tabs.Root, {
		value: category,
		onValueChange: (categoryValue) => {
			setCategory(categoryValue);
		},
		children: /* @__PURE__ */ jsx(StyledTabsList, { children: KEY_CATEGORIES.map((name) => /* @__PURE__ */ jsx(StyledTabTrigger, {
			value: name,
			kind: "primary",
			children: name
		}, name)) })
	}), /* @__PURE__ */ jsx(KeyboardContainer, { children: /* @__PURE__ */ jsx(KeyboardKeysContainer, { children: categoryCommands?.map?.(({ label, text, renderChildren, mathLiveCommand, latexCommand, tooltip, tooltipCommand, tooltipLabel, kind, size }) => /* @__PURE__ */ jsx(MathKeyboardKey, {
		tooltip,
		tooltipCommand: tooltipCommand ?? mathLiveCommand,
		tooltipLabel: tooltipLabel ?? label,
		kind,
		size,
		onClick: () => executeCommand({
			selector: "insert",
			mathLiveCommand,
			latexCommand
		}),
		children: renderChildren ? renderChildren() : text
	}, label)) }) })] });
}
const StyledTabsList = styled(Tabs.List)`
  width: 100%;
  display: flex;
`;
const StyledTabTrigger = styled(Tabs.Trigger)`
  min-width: unset;
  flex: 1 1 0px;

  &[data-state="active"] {
    color: ${(p) => p.theme.colors.grey500};
    font-weight: 600;
  }
  &[data-state="inactive"] {
    font-weight: normal;
  }
`;
const KeyboardContainer = styled.div`
  min-height: 116px;
`;
const KeyboardKeysContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;
//#endregion
//#region src/extensions/math/components/MathEditor/MathStyle.tsx
/**
* Formatting menus for the math equation.
*/
function MathStyle(props) {
	const { disabled, executeCommand } = props;
	const onColorChange = (color) => {
		if (!disabled) executeCommand({
			selector: "applyStyle",
			mathLiveCommand: { color: tinycolor(color).toRgbString() }
		});
	};
	const onHighlightChange = (color) => {
		if (!disabled) executeCommand({
			selector: "applyStyle",
			mathLiveCommand: { backgroundColor: color }
		});
	};
	return /* @__PURE__ */ jsxs(MathStyleRoot, { children: [/* @__PURE__ */ jsx(ColorPickerMenu, {
		title: "Text colour",
		"aria-label": "Text colour",
		disabled,
		pickerProps: {
			onChange: onColorChange,
			pallete: [
				colors.red500,
				colors.orange500,
				colors.yellow500,
				colors.green500,
				colors.cyan500,
				colors.blue500,
				colors.indigo500,
				colors.purple500,
				colors.pink500,
				"#730D1E",
				"#0D2F73",
				"#5B6F98",
				"#5973A65C",
				"#0F172E"
			]
		},
		side: "bottom",
		align: "end",
		autoFocus: false
	}), /* @__PURE__ */ jsx(ColorPickerMenu, {
		title: "Highlight colour",
		"aria-label": "Highlight colour",
		iconName: "Highlight",
		disabled,
		pickerProps: {
			onChange: onHighlightChange,
			pallete: [
				"#FF4D6A",
				"#F7C243",
				"#F7EC6E",
				"#BCE06E",
				"#70E292",
				"#78D1FA",
				"#7580F0",
				"#AF91F8",
				"#F1A4F4",
				"#5973A626"
			]
		},
		side: "bottom",
		align: "end",
		autoFocus: false
	})] });
}
const MathStyleRoot = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 4px;
`;
//#endregion
//#region src/extensions/math/components/MathEditor/MathEditor.tsx
/**
* Component to edit and format a math equation through various input methods.
*
* The equation is rendered and edited using the MathLive web component
* `math-live`. The equation state is managed by that web component. When the
* editing actions are done and "confirmed", the `props.onUpdateEquation`
* callback will be called with the latest value.
*
* The equation can also be editing directly using a LaTeX text input.
*/
function MathEditor({ defaultValue = "", onUpdateEquation, onClose, onPreCancel }) {
	const [showLatex, setShowLatex] = useState(false);
	const [currentFocus, setCurrentFocus] = useState();
	const mathViewRef = useRef(null);
	const textAreaRef = useRef(null);
	const editorRef = useRef(null);
	const onLatexFocus = useCallback(() => {
		setCurrentFocus("textarea");
	}, [setCurrentFocus]);
	const onMathViewFocus = useCallback(() => {
		setCurrentFocus("mathlive");
	}, [setCurrentFocus]);
	const executeCommand = useCallback(({ selector, latexCommand, mathLiveCommand }) => {
		if (currentFocus === "mathlive") mathViewRef.current?.executeCommand([
			selector,
			mathLiveCommand,
			{ focus: true }
		]);
		else if (mathViewRef?.current && textAreaRef?.current && mathLiveCommand && currentFocus === "textarea") {
			const command = latexCommand ?? mathLiveCommand;
			if (selector === "insert" && typeof command === "string") {
				const cursorStartPosition = textAreaRef.current.selectionStart;
				const cursorEndPosition = textAreaRef.current.selectionEnd;
				const textBeforeCursor = textAreaRef.current.value.substring(0, cursorStartPosition);
				const textAfterCursor = textAreaRef.current.value.substring(cursorEndPosition, textAreaRef.current.value.length);
				const newEquation = textBeforeCursor + command + textAfterCursor;
				textAreaRef.current.value = newEquation;
				textAreaRef.current.setSelectionRange(cursorStartPosition + command.length, cursorStartPosition + command.length);
				mathViewRef.current.setValue(newEquation, { suppressChangeNotifications: true });
			}
		}
	}, [currentFocus]);
	const onMathInput = useCallback(() => {
		if (mathViewRef.current) {
			const newEquation = mathViewRef.current.value;
			if (textAreaRef.current) textAreaRef.current.value = newEquation;
		}
	}, []);
	const onTextAreaInput = useCallback((e) => {
		const target = e.target;
		if (target.value && textAreaRef.current && mathViewRef.current) {
			const newEquation = target.value;
			mathViewRef.current.setValue(newEquation, { suppressChangeNotifications: true });
		}
	}, []);
	useEffect(() => {
		mathViewRef.current?.setValue(defaultValue);
		if (textAreaRef.current) textAreaRef.current.value = defaultValue;
	}, [defaultValue]);
	useEffect(() => {
		if (showLatex) requestAnimationFrame(() => {
			if (textAreaRef.current && mathViewRef.current) {
				textAreaRef.current.value = mathViewRef.current.value;
				if (textAreaRef.current !== document.activeElement) textAreaRef.current.focus();
			}
		});
		else if (!mathViewRef.current?.hasFocus()) mathViewRef.current?.focus();
	}, [showLatex]);
	useEffect(() => {
		if (currentFocus === "mathlive" && !mathViewRef.current?.hasFocus() && mathViewRef.current !== document.activeElement) mathViewRef.current?.focus();
		if (currentFocus === "textarea" && textAreaRef.current && textAreaRef.current !== document.activeElement) textAreaRef.current.focus();
	}, [currentFocus]);
	return /* @__PURE__ */ jsxs(EditorRoot, {
		ref: editorRef,
		onKeyDown: (e) => {
			if (e.key === "Escape") onClose();
		},
		children: [
			/* @__PURE__ */ jsx(MathStyle, {
				executeCommand,
				disabled: currentFocus !== "mathlive"
			}),
			/* @__PURE__ */ jsx(MathKeyboard, { executeCommand }),
			/* @__PURE__ */ jsx(StyledMathView, {
				defaultValue,
				onInput: onMathInput,
				ref: mathViewRef,
				plonkSound: void 0,
				keypressSound: void 0,
				onFocus: onMathViewFocus,
				virtualKeyboardMode: "off",
				onVirtualKeyboardToggle: () => {
					mathViewRef.current?.executeCommand("hideVirtualKeyboard");
				}
			}),
			/* @__PURE__ */ jsx(Switch, {
				label: "Show LaTeX",
				checked: showLatex,
				onCheckedChange: () => setShowLatex(!showLatex)
			}),
			showLatex && /* @__PURE__ */ jsx(LatexTextArea, {
				ref: textAreaRef,
				autoCapitalize: "off",
				autoComplete: "off",
				spellCheck: "false",
				rows: 2,
				autoCorrect: "off",
				defaultValue,
				onInput: onTextAreaInput,
				onFocus: onLatexFocus,
				"data-gramm": "false",
				"data-gramm_editor": "false",
				"data-enable-grammarly": "false"
			}),
			/* @__PURE__ */ jsxs(Footer, { children: [/* @__PURE__ */ jsx(LinkButton, {
				onClick: () => window.open("https://support.cadmus.io/students/advanced-tips-equations", "_blank"),
				children: "Advanced Tips"
			}), /* @__PURE__ */ jsxs(ButtonWrapper, { children: [/* @__PURE__ */ jsx(Button, {
				onMouseEnter: () => onPreCancel(true),
				onMouseLeave: () => onPreCancel(false),
				onClick: onClose,
				kind: "outline",
				children: "Cancel"
			}), /* @__PURE__ */ jsx(Button, {
				onClick: () => {
					if (mathViewRef.current) onUpdateEquation(mathViewRef.current.value);
				},
				kind: "primary",
				children: defaultValue === "" ? "Insert" : "Done"
			})] })] })
		]
	});
}
const LatexTextArea = styled.textarea`
  resize: vertical;
  font-family: ibm-plex-mono, ui-monospace, monospace;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;

  border: 1px solid ${colors.grey300};
  border-radius: 3px;
  padding: 8px 16px;
  box-sizing: border-box;
  background: rgba(244, 245, 248, 0.5);
  &:focus {
    outline: 1.3px solid ${(p) => p.theme.primaryColor};
  }
`;
const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;
const ButtonWrapper = styled.div`
  display: flex;
  gap: 12px;
`;
const StyledMathView = styled(MathView)`
  width: 100%;
  border: 1px solid ${colors.grey300};
  border-radius: 3px;
  padding: 16px;
  box-sizing: border-box;
  background: rgba(244, 245, 248, 0.5);
  &:focus {
    outline: 1.3px solid ${(p) => p.theme.primaryColor};
  }
  /* see https://stackoverflow.com/a/68538644 */
  & ~ grammarly-extension {
    display: none;
  }
`;
const EditorRoot = styled.div`
  display: flex;
  flex-direction: column;
  padding: 4px 16px;
  gap: 12px;
  background: white;
  border-radius: 3px;
  outline: none;
  box-sizing: border-box;
  border: 1px solid ${colors.grey300};
  width: 750px;
  box-shadow:
    1px 2px 0px ${colors.grey50},
    0px 0px 4px ${colors.grey50},
    0px 5px 18px ${colors.grey50};
`;
//#endregion
//#region src/extensions/math/math-menu-component.tsx
const shouldShow = ({ state }) => {
	const mathMenuTarget = MathMenuPluginKey.getState(state);
	return !!(mathMenuTarget && isNodeSelection(state.selection) && mathMenuTarget.node === state.selection.node);
};
/**
* Component rendering the Equations Editor component as a floating menu.
*/
function MathMenuComponent(props) {
	const { editor, portalId } = props;
	const lastTarget = useRef(null);
	const getBoundingClientRect = useCallback(() => {
		const { state, view } = editor;
		const { selection, doc } = state;
		const { from, to } = selection;
		if (isNodeSelection(selection)) {
			const PMNode = doc.nodeAt(from);
			let node = view.nodeDOM(from);
			if (PMNode?.isInline) {
				const $from = doc.resolve(from);
				node = view.nodeDOM($from.before($from.depth));
			}
			if (node) return node.getBoundingClientRect();
		}
		return posToDOMRect(view, from, to);
	}, [editor]);
	const { mathMenuTarget } = useEditorState$1({
		editor,
		selector: (ctx) => ({ mathMenuTarget: MathMenuPluginKey.getState(ctx.editor.state) })
	});
	useEffect(() => {
		lastTarget.current = mathMenuTarget;
	}, [mathMenuTarget]);
	const onUpdateEquation = useCallback((newEquation) => {
		if (mathMenuTarget) editor.commands.updateEquation(newEquation);
	}, [mathMenuTarget, editor]);
	const onPreCancel = useCallback((show) => {
		const equation = mathMenuTarget?.node.attrs.equation;
		if (mathMenuTarget && equation === "") editor.commands.predeleteHighlightEquation(mathMenuTarget.pos, show);
	}, [editor, mathMenuTarget]);
	const onClose = useCallback((editor) => {
		let chain = editor.chain();
		if (lastTarget.current) {
			chain = chain.predeleteHighlightEquation(lastTarget.current.pos, false);
			if (editor.state.doc.nodeAt(lastTarget.current.pos)?.attrs.equation === "") chain = chain.deleteEquation(lastTarget.current.pos);
		}
		chain.dismissMenu().run();
	}, []);
	const onCancel = useCallback(() => {
		let chain = editor.chain();
		if (mathMenuTarget) {
			chain = chain.predeleteHighlightEquation(mathMenuTarget.pos, false);
			if (mathMenuTarget.node.attrs.equation === "") chain = chain.deleteEquation();
		}
		chain.dismissMenu().focus().run();
	}, [editor, mathMenuTarget]);
	return /* @__PURE__ */ jsx(FloatingMenuComponent, {
		pluginKey: "mathFloatingMenu",
		portalId,
		editor,
		shouldShow,
		getBoundingClientRect,
		isAsync: true,
		onClose,
		modal: true,
		children: /* @__PURE__ */ jsx(MathEditor, {
			onUpdateEquation,
			defaultValue: mathMenuTarget?.node.attrs.equation,
			onClose: onCancel,
			onPreCancel
		})
	});
}
//#endregion
//#region src/extensions/placeholder/placeholder.ts
const PlaceholderPluginKey = new PluginKey("placeholder");
/**
* Define a standard way to add placeholder for a block
*/
const Placeholder = Extension.create({
	name: "placeholder",
	addStorage() {
		return { placeholders: /* @__PURE__ */ new Map() };
	},
	addProseMirrorPlugins() {
		const { storage, editor } = this;
		return [new Plugin({
			key: PlaceholderPluginKey,
			props: { decorations: (state) => {
				const { doc } = state;
				const decorations = [];
				doc.descendants((node, pos, parent) => {
					storage.placeholders.forEach(({ check, decoration }) => {
						if (editor.isEditable && parent && check(state.selection, node, pos, parent)) {
							const deco = decoration(node, pos);
							if (deco) decorations.push(deco);
						}
					});
					return true;
				});
				return DecorationSet.create(doc, decorations);
			} }
		})];
	}
});
//#endregion
//#region src/extensions/selection/selection-plugin.ts
const SelectionPluginKey = new PluginKey("Selection");
/**
* Create a Plugin that automatically decorates the current text selection
* with selection styling.
*/
function SelectionPlugin(editor) {
	return new Plugin({
		key: SelectionPluginKey,
		props: { 
		/**
		* Adds decorations to the current text selection
		*/
decorations(editorState) {
			const { selection } = editorState;
			if (selection.empty || selection.from === selection.to || editor.isFocused || isNodeSelection(selection) || editor.view.dragging) return DecorationSet.empty;
			const decoration = Decoration.inline(selection.from, selection.to, { class: "selection-highlight" }, {
				inclusiveStart: true,
				inclusiveEnd: true
			});
			return DecorationSet.create(editorState.doc, [decoration]);
		} }
	});
}
//#endregion
//#region src/extensions/selection/selection.ts
const Selection$1 = Extension.create({
	name: "selection",
	priority: 1e3,
	addProseMirrorPlugins() {
		const { editor } = this;
		return [SelectionPlugin(editor)];
	}
});
//#endregion
//#region src/extensions/shortcuts/shortcuts.ts
/**
* Extension to add global custom input rules and keyboard shortcuts
* that are not set inside the tiptap's default extensions.
*/
const Shortcuts = Extension.create({
	name: "shortcuts",
	addKeyboardShortcuts() {
		return {
			"Mod-/": ({ editor }) => editor.commands.setParagraph(),
			"Mod-Alt-5": ({ editor }) => editor.commands.toggleBlockquote(),
			"Mod-Alt-s": ({ editor }) => editor.commands.toggleStrike()
		};
	},
	addInputRules() {
		return [textblockTypeInputRule({
			find: /* @__PURE__ */ new RegExp("^/\\s$"),
			type: this.editor.schema.node("paragraph").type
		})];
	},
	addProseMirrorPlugins() {
		return [new Plugin({ props: { handleKeyDown(_view, event) {
			if (keyName(event) === "Tab") {
				event.stopPropagation();
				event.preventDefault();
			}
			return false;
		} } })];
	}
});
//#endregion
//#region src/extensions/space-fix/space-fix.ts
const SpaceFixPluginKey = new PluginKey("space-fix-plugin");
/**
* Safari and firefox have issue with justified text on a contenteditable with
* a `white-space: normal;`` for the whole block. To get around this, the block
* need to keep style `white-space: pre-wrap` and then decorate the group of white
* space to have `white-space: normal` to make justified text possible
* issue is described on https://github.com/ueberdosis/tiptap/issues/2549 and adapted solution from https://github.com/ProseMirror/prosemirror/issues/857#issuecomment-625502056
*/
const SpaceFix = Extension.create({
	name: "space-fix",
	addProseMirrorPlugins() {
		const firefox = typeof window !== "undefined" && /Firefox/.test(window.navigator.userAgent);
		const safari = typeof window !== "undefined" && /^((?!chrome|android).)*safari/i.test(window.navigator.userAgent);
		return [new Plugin({
			key: SpaceFixPluginKey,
			props: { decorations(state) {
				const decorations = [];
				const doc = state.doc;
				let start, match, length;
				const spaces = /\s+/g;
				doc.nodesBetween(0, doc.content.size, (node, position, parent) => {
					const fixCondition = firefox || safari || /text-align/.test(parent && parent.attrs && parent.attrs.style || "");
					if (node.type.isText && fixCondition) {
						const text = node.text || "";
						while ((match = spaces.exec(text)) !== null) {
							start = position + match.index;
							length = match[0].length;
							if (match.index + length < match.input.length) for (let i = 0; i <= length - 1; i += 2) decorations.push(Decoration.inline(start + i, start + i + 1, { style: "white-space: normal" }));
						}
					}
				});
				return DecorationSet.create(doc, decorations);
			} }
		})];
	}
});
//#endregion
//#region src/extensions/cadmus-kit/cadmus-kit.ts
const CadmusKit = Extension.create({
	name: "cadmusKit",
	addProseMirrorPlugins() {
		return [new Plugin({ props: { attributes: () => {
			const editable = this.options.editable ?? true;
			const attributes = {
				id: `cadmus-editor-${this.options.editorId}`,
				translate: "no",
				"aria-label": `${this.options.editorA11yLabel}${editable ? ". Press Escape to blur the editor and tab away to the next element. Press alt + / to move focus to the toolbar." : ""}`
			};
			if (editable) {
				attributes.role = "textbox";
				attributes["aria-multiline"] = "true";
			}
			return attributes;
		} } })];
	},
	addKeyboardShortcuts() {
		return {
			"Mod-a": () => this.editor.commands.selectAll(),
			Escape: () => this.editor.commands.blur(),
			"Alt-/": () => {
				document.getElementById("cadmus-editor-toolbar")?.focus();
				return true;
			}
		};
	},
	addExtensions() {
		const { enableHyperlink = true, enableImage = true, enableAudio = true, enableVideo = true, enableManual = true } = this.options;
		const extensions = [
			Document,
			Heading.configure({ levels: [
				1,
				2,
				3,
				4
			] }),
			HardBreak,
			Paragraph,
			Bold,
			Italic,
			Strike,
			Text,
			AtomSelection,
			Placeholder,
			FloatingMenuExtension,
			MathExtension,
			Table,
			List,
			Blockquote,
			EditorPlaceholder.configure({
				titlePlaceholder: this.options.titlePlaceholder,
				contentPlaceholder: this.options.contentPlaceholder,
				referencesPlaceholder: this.options.referencesPlaceholder,
				singleLinePlaceholder: this.options.singleLinePlaceholder
			}),
			Emoji,
			EmptyMediaNode.configure({ nodeNames: [
				...enableImage ? ["image"] : [],
				...enableAudio ? ["audio"] : [],
				...enableVideo ? ["video"] : []
			] }),
			ListItem,
			BulletList,
			OrderedList,
			enableHyperlink ? this.options.onOpenLink ? Hyperlink.configure({ onOpenLink: this.options.onOpenLink }) : Hyperlink : null,
			this.options.enableHangingIndent ? Indentation.configure({
				specialTypes: ["paragraph"],
				levelTypes: [],
				indentationStyles: ["hanging"],
				defaultIndentation: "hanging"
			}) : Indentation,
			this.options.enableFootnoting ? Footnote : null,
			this.options.enableCommenting ? Thread : null,
			this.options.enableSelectionHighlight ? Selection$1 : null,
			Superscript,
			Subscript,
			TextAlign.configure({ types: [
				"paragraph",
				"heading",
				"image"
			] }),
			Underline,
			Highlight,
			TextStyle,
			TextColor,
			TaskItem,
			TaskList,
			this.options.enableBlanks ? Blank : null,
			PasteChip.configure({ enableManual }),
			enableImage ? Image : null,
			enableAudio ? Audio : null,
			enableVideo ? Video : null,
			TrailingNode.configure({ minBlocks: this.options.minBlocks ?? 1 }),
			SpaceFix,
			HiddenCharacters,
			Shortcuts,
			History.configure({ getTime: this.options.getTime }),
			BlockTextVisibility.configure({ types: ["tableCaption", "tableFootnote"] }),
			BlockBackground.configure({ types: [
				"table",
				"tableCell",
				"tableHeader"
			] }),
			Paste.configure({
				editorId: this.options.editorId,
				annotatePaste: this.options.enablePasteAnnotations ?? false,
				getTime: this.options.getTime
			}),
			Telemetry.configure({
				editorId: this.options.editorId,
				onSave: this.options.onSave,
				suggestionClient: this.options.suggestionClient,
				onEditorEvent: this.options.onEditorEvent,
				withCharacterCount: this.options.enableCharacterCount,
				withSummary: this.options.enableSummary
			}),
			CodeBlock,
			Code,
			this.options.version !== void 0 ? Collab.configure({
				version: this.options.version,
				clientId: this.options.clientId,
				presence: this.options.collabPresence
			}) : null
		].flatMap((f) => f ? [f] : []);
		const { suggestionClient } = this.options;
		if (suggestionClient) {
			const suggestion = Suggestion.configure({
				client: suggestionClient,
				spellCheckSource: this.options.enableBrowserSpellCheck ? "browser" : this.options.disableCadmusSpellCheck ? null : "cadmus"
			});
			extensions.push(suggestion);
		}
		const { imageAPIBase, mediaAPIBase = imageAPIBase, assessmentId, workId, userRole, userId, tenant, enableMultipartUpload } = this.options;
		if (mediaAPIBase && tenant && assessmentId && userRole && userId && (enableImage || enableAudio || enableVideo)) {
			const mediaUploader = MediaUploader.configure({
				mediaAPIBase,
				tenant,
				assessmentId,
				workId,
				userRole,
				userId,
				enableMultipartUpload: enableMultipartUpload ?? false
			});
			extensions.push(mediaUploader);
		}
		return extensions;
	}
});
//#endregion
//#region src/core/helpers/hasExtension.ts
function hasExtension(editor, extensionName) {
	if (Object.hasOwn) return Object.hasOwn(editor.storage, extensionName);
	if (Object.prototype.hasOwnProperty.call) return Object.prototype.hasOwnProperty.call(editor.storage, extensionName);
	if (Object.getOwnPropertyDescriptor) return !!Object.getOwnPropertyDescriptor(editor.storage, extensionName);
	return false;
}
//#endregion
//#region src/extensions/autolink/autolink.ts
const Autolink = Mark.create({
	name: "link",
	priority: 1e3,
	inclusive: false,
	excludes: "_",
	addOptions() {
		return {
			HTMLAttributes: {
				target: "_blank",
				rel: "noopener noreferrer nofollow",
				["data-cadmus-link"]: "true"
			},
			onOpenLink: openLink,
			openOnClickRequiresModifier: true
		};
	},
	addAttributes() {
		return {
			href: { default: null },
			target: { default: this.options.HTMLAttributes.target }
		};
	},
	parseHTML() {
		return [{ tag: "a[href]:not([href *= 'javascript:' i])" }];
	},
	renderHTML({ HTMLAttributes }) {
		const href = HTMLAttributes.href;
		const attrs = { ...HTMLAttributes };
		attrs.href = getValidURL(href);
		return [
			"a",
			mergeAttributes(this.options.HTMLAttributes, attrs),
			0
		];
	},
	addCommands() {
		return {
			setLink: (href) => ({ commands }) => {
				return commands.setMark(this.name, { href });
			},
			unsetLink: () => ({ commands }) => {
				return commands.unsetMark(this.name, { extendEmptyMarkRange: true });
			},
			updateLink: (href) => ({ state, dispatch, commands, chain }) => {
				if (dispatch) {
					const attrs = getMarkAttributes(state, this.name);
					const isValid = isValidURL(href);
					href = /^https?/.test(href) ? href : `https://${href}`;
					if (attrs.href !== void 0) if (isValid) return chain().extendMarkRange(this.name, attrs).updateAttributes(this.name, { href }).run();
					else return chain().extendMarkRange(this.name, attrs).unsetLink().run();
					if (isValid) return commands.setLink(href);
				}
				return true;
			}
		};
	},
	addInputRules() {
		return [new InputRule({
			find: buildRegex(BASE_URL_REGEX, "\\[(.*)\\]\\((", ")\\)$", "ui"),
			handler: ({ state, match, range }) => {
				const { from, to } = range;
				const text = match[1];
				const href = /^https?/.test(match[2]) ? match[2] : `https://${match[2]}`;
				const mark = this.type.create({ href });
				state.tr.replaceWith(from, to, this.editor.schema.text(text, [mark]));
			}
		}), new InputRule({
			find: buildRegex(BASE_URL_REGEX, "", "$", "ui"),
			handler: ({ state, match, range }) => {
				const { from, to } = range;
				const href = /^https?/.test(match[0]) ? match[0] : `https://${match[0]}`;
				const mark = this.type.create({ href });
				state.tr.replaceWith(from, to, this.editor.schema.text(match[0], [mark]));
			}
		})];
	},
	addProseMirrorPlugins() {
		return [
			NodePasteRule(buildRegex(BASE_URL_REGEX, "\\[(.*)\\]\\((", ")\\)", "gui"), (_node, match) => {
				const text = match[1];
				const href = /^https?/.test(match[2]) ? match[2] : `https://${match[2]}`;
				const mark = this.type.create({ href });
				return this.editor.schema.text(text, [mark]);
			}),
			NodePasteRule(buildRegex(BASE_URL_REGEX, "", "", "gui"), (_node, match) => {
				const href = /^https?/.test(match[0]) ? match[0] : `https://${match[0]}`;
				const mark = this.type.create({ href });
				return this.editor.schema.text(match[0], [mark]);
			}),
			new Plugin({
				key: new PluginKey("hyperlinkClickHandler"),
				props: { handleClick: (view, pos, event) => {
					const link = event.target.closest("a");
					if (link && link.href) {
						const modifierDown = event.metaKey || event.ctrlKey;
						if (this.options.openOnClickRequiresModifier && !modifierDown) return false;
						this.options.onOpenLink(link.href);
						return true;
					}
					return false;
				} }
			})
		];
	}
});
//#endregion
//#region src/extensions/cadmus-kit/cadmus-kit-slim.ts
/**
* A slim editor kit extension for handling inline rich text formatting
* (bold, italic, etc.). This extension is designed to be used for simpler
* editors such as footnotes.
*
* @example
* const editor = useEditor({
*   content,
*   extensions: [
*     SlimKit.configure({
*       editorId: "footnote-editor-123",
*       editorA11yLabel: "Assessment footnotes",
*       isSingleBlock: true,
*     }),
*   ],
* });
*
*/
const SlimKit = Extension.create({
	name: "cadmusSlimKit",
	addProseMirrorPlugins() {
		const isEditable = this.options.editable !== false;
		return [new Plugin({ props: { attributes: () => {
			return {
				role: isEditable ? "textbox" : "",
				"aria-multiline": "true",
				translate: "no",
				id: this.options.editorId,
				"aria-label": `${this.options.editorA11yLabel} ${isEditable ? "Press Escape to blur the editor and tab away to the next element. Press alt + / to move focus to the toolbar." : ""}`
			};
		} } })];
	},
	addKeyboardShortcuts() {
		const extraCallbacks = {};
		if (this.options.customKeyboardShortcuts) for (const [key, callback] of Object.entries(this.options.customKeyboardShortcuts)) extraCallbacks[key] = () => {
			callback(this.editor);
			return true;
		};
		return {
			"Mod-a": () => this.editor.commands.selectAll(),
			Escape: () => this.editor.commands.blur(),
			"Alt-/": () => {
				document.getElementById("cadmus-editor-toolbar")?.focus();
				return true;
			},
			...extraCallbacks
		};
	},
	addExtensions() {
		return [
			this.options.isSingleBlock ? SingleBlockDocument : SlimDocument,
			Paragraph,
			Text,
			Bold,
			Italic,
			Underline,
			Strike,
			History,
			EditorPlaceholder.configure({
				contentPlaceholder: this.options.contentPlaceholder,
				singleLinePlaceholder: this.options.singleLinePlaceholder
			}),
			...this.options.enableAutolink ? [Autolink] : [],
			...this.options.enableLists ? [
				List,
				ListItem,
				BulletList,
				OrderedList
			] : [],
			...this.options.enableScripts ? [Superscript, Subscript] : []
		].filter(Boolean);
	}
});
/**
* Check if the editor was initialized with the `SlimKit` extension.
* The extensions of the editor can be accessed via `editor.storage`.
*/
function isSlimEditor(editor) {
	return hasExtension(editor, "cadmusSlimKit");
}
//#endregion
//#region src/react/CadmusEditorContent.tsx
/**
* Cadmus styled wrapper of the `EditorContent` component with additional React
* components and menus needed by the editor extensions.
*/
function CadmusEditorContent(props) {
	const { editor, onOpenManualPreset, pageMode = true, fullWidth = false, ...divProps } = props;
	useEffect(() => {
		if (editor && onOpenManualPreset) {
			const handleManualPreset = ({ transaction }) => {
				const preset = transaction.getMeta("openManualPreset");
				if (preset) onOpenManualPreset(preset);
			};
			editor.on("transaction", handleManualPreset);
			return () => {
				editor.off("transaction", handleManualPreset);
			};
		}
	}, [editor, onOpenManualPreset]);
	return /* @__PURE__ */ jsx(CadmusEditorWrapper, {
		"data-page-mode": pageMode,
		fullWidth,
		...divProps,
		children: /* @__PURE__ */ jsx(EditorContent, { editor })
	});
}
//#endregion
//#region src/react/CadmusEditorMenus.tsx
/**
* Renders shared React floating menus for the nodes and plugins used within the
* Cadmus Editor, within a single Portal.
*
* Does not render if the editor is not editable or if it's a slim editor.
*/
function CadmusEditorMenus(props) {
	const { editor } = props;
	const portalId = useId();
	if (!editor || !editor.isEditable || isSlimEditor(editor)) return null;
	return /* @__PURE__ */ jsxs(Fragment$1, { children: [
		/* @__PURE__ */ jsx(ImageMenuComponent, {
			editor,
			portalId
		}),
		/* @__PURE__ */ jsx(CodeBlockMenuComponent, {
			editor,
			portalId
		}),
		/* @__PURE__ */ jsx(SuggestionMenuComponent, {
			editor,
			portalId
		}),
		/* @__PURE__ */ jsx(HyperlinkMenuComponent, {
			editor,
			portalId
		}),
		/* @__PURE__ */ jsx(TableMenuComponent, {
			editor,
			portalId
		}),
		/* @__PURE__ */ jsx(MathMenuComponent, {
			editor,
			portalId
		}),
		/* @__PURE__ */ jsx("div", {
			id: portalId,
			style: { display: "hidden" }
		})
	] });
}
//#endregion
//#region src/react/slim-editor-content/slim-editor-wrapper.tsx
const SlimEditorWrapper = styled.div`
  /* Grow to occupy full height */
  flex: 1;
  position: relative;
  white-space: pre-wrap;
  word-wrap: break-word;
  font-family: ${fontFamilySans};

  p {
    margin-block-start: 0;
    margin-block-end: 0;
  }

  a,
  a:any-link {
    color: ${(p) => p.theme.text.accent};
  }

  .selected-link {
    color: ${(p) => p.theme.text.accent};
    text-decoration: underline;
  }

  & .ProseMirror {
    outline: 0;
  }

  .outer-placeholder {
    white-space: nowrap;
    color: ${(p) => p.theme.colors.grey500};
  }
`;
//#endregion
//#region src/react/slim-editor-content/slim-editor-content.tsx
/**
* Cadmus styled wrapper of the `EditorContent` component for the slim editor.
*/
function SlimEditorContent(props) {
	const { editor, ...divProps } = props;
	return /* @__PURE__ */ jsx(SlimEditorWrapper, {
		...divProps,
		children: /* @__PURE__ */ jsx(EditorContent, { editor })
	});
}
//#endregion
//#region src/react/useControlButtonState.ts
function useControlButtonState(props) {
	const { editor, isActive, isDisabled, onClick, ...rest } = props;
	const { active, disabled } = useEditorState$1({
		editor,
		selector: (ctx) => ({
			active: rest.active ?? isActive?.(ctx.editor) ?? false,
			disabled: rest.disabled ?? isDisabled?.(ctx.editor) ?? true
		})
	});
	return useMemo(() => ({
		active,
		disabled,
		onClick,
		...rest
	}), [
		active,
		disabled,
		onClick,
		rest
	]);
}
//#endregion
//#region src/react/Controlbar.tsx
function isGloballyDisabled(editor) {
	return !!MathMenuPluginKey.getState(editor.state);
}
function Controlbar(props) {
	const { editor, className, disabled = false, isLockDownBrowser = false, displayFootnoteButton = false, displayThreadButton = false, displayRevealHiddenCharsButton = false, collaborators, onCreateThread } = props;
	const [activeMediaType, setActiveMediaType] = useState("image");
	const fileInputRef = useRef(null);
	const openFilePicker = (mediaType) => {
		setActiveMediaType(mediaType);
		if (!fileInputRef.current) return;
		fileInputRef.current.accept = ALLOWED_MIME_TYPES[mediaType].join(",");
		fileInputRef.current.click();
	};
	const undo = useControlButtonState({
		editor,
		isDisabled: (editor) => {
			const undoSize = undoDepth(editor.state);
			return isGloballyDisabled(editor) || (undoSize ? undoSize === 0 : true);
		},
		active: false,
		onClick: () => editor.chain().focus().undo().run()
	});
	const redo = useControlButtonState({
		editor,
		onClick: () => editor.chain().focus().redo().run(),
		active: false,
		isDisabled: (editor) => {
			const redoSize = redoDepth(editor.state);
			return isGloballyDisabled(editor) || disabled || (redoSize ? redoSize === 0 : true);
		}
	});
	const paragraph = useParagraphProps(editor, disabled);
	const bold = useControlButtonState({
		editor,
		isActive: (editor) => editor.isActive("bold") ?? false,
		isDisabled: (editor) => !editor.schema.marks.bold || isGloballyDisabled(editor) || disabled,
		onClick: () => editor.chain().focus().toggleBold().run()
	});
	const italic = useControlButtonState({
		editor,
		isActive: (editor) => editor.isActive("italic") ?? false,
		isDisabled: (editor) => !editor.schema.marks.italic || isGloballyDisabled(editor) || disabled,
		onClick: () => editor.chain().focus().toggleItalic().run()
	});
	const underline = useControlButtonState({
		editor,
		isActive: (editor) => editor.isActive("underline") ?? false,
		isDisabled: (editor) => !editor.schema.marks.underline || isGloballyDisabled(editor) || disabled,
		onClick: () => editor.chain().focus().toggleUnderline().run()
	});
	const strikethrough = useControlButtonState({
		editor,
		isActive: (editor) => editor.isActive("strike") ?? false,
		isDisabled: (editor) => !editor.schema.marks.strike || isGloballyDisabled(editor) || disabled,
		onClick: () => editor.chain().focus().toggleStrike().run()
	});
	const superscript = useControlButtonState({
		editor,
		isActive: (editor) => editor.isActive("superscript") ?? false,
		isDisabled: (editor) => !editor.schema.marks.superscript || isGloballyDisabled(editor) || disabled,
		onClick: () => editor.chain().focus().toggleSuperscript().run()
	});
	const subscript = useControlButtonState({
		editor,
		isActive: (editor) => editor.isActive("subscript") ?? false,
		isDisabled: (editor) => !editor.schema.marks.subscript || isGloballyDisabled(editor) || disabled,
		onClick: () => editor.chain().focus().toggleSubscript().run()
	});
	const leftAlign = useControlButtonState({
		editor,
		isActive: (editor) => editor.isActive({ textAlign: "left" }) ?? false,
		isDisabled: (editor) => !(editor.can().setTextAlign?.("left") ?? false) || isGloballyDisabled(editor) || disabled,
		onClick: () => editor.chain().focus().setTextAlign("left").run()
	});
	const centerAlign = useControlButtonState({
		editor,
		isActive: (editor) => editor.isActive({ textAlign: "center" }) ?? false,
		isDisabled: (editor) => !(editor.can().setTextAlign?.("center") ?? false) || isGloballyDisabled(editor) || disabled,
		onClick: () => editor.chain().focus().setTextAlign("center").run()
	});
	const rightAlign = useControlButtonState({
		editor,
		isActive: (editor) => editor.isActive({ textAlign: "right" }) ?? false,
		isDisabled: (editor) => !(editor.can().setTextAlign?.("right") ?? false) || isGloballyDisabled(editor) || disabled,
		onClick: () => editor.chain().focus().setTextAlign("right").run()
	});
	const justifyAlign = useControlButtonState({
		editor,
		isActive: (editor) => editor.isActive({ textAlign: "justify" }) ?? false,
		isDisabled: (editor) => !(editor.can().setTextAlign?.("justify") ?? false) || isGloballyDisabled(editor) || disabled,
		onClick: () => editor.chain().focus().setTextAlign("justify").run()
	});
	const orderedList = useControlButtonState({
		editor,
		isActive: (editor) => editor.isActive("orderedList") ?? false,
		isDisabled: (editor) => !editor.schema.nodes.orderedList || isGloballyDisabled(editor) || disabled,
		onClick: () => editor.chain().focus().toggleOrderedList().run()
	});
	const unorderedList = useControlButtonState({
		editor,
		isActive: (editor) => editor.isActive("bulletList") ?? false,
		isDisabled: (editor) => !editor.schema.nodes.bulletList || isGloballyDisabled(editor) || disabled,
		onClick: () => editor.chain().focus().toggleBulletList().run()
	});
	const checkList = useControlButtonState({
		editor,
		isActive: (editor) => editor.isActive("taskList") ?? false,
		isDisabled: (editor) => !editor.schema.nodes.taskList || isGloballyDisabled(editor) || disabled,
		onClick: () => editor.chain().focus().toggleTaskList().run()
	});
	const highlightColor = {
		...useEditorState$1({
			editor,
			selector: (ctx) => ({
				activeColor: ctx.editor.getAttributes("highlight")?.color ?? DEFAULT_HIGHLIGHT_COLOR,
				disabled: !ctx.editor.schema.marks.highlight || isGloballyDisabled(editor) || disabled
			})
		}),
		onChange: (color) => color === DEFAULT_HIGHLIGHT_COLOR ? editor.chain().focus().unsetHighlight().run() : editor.chain().focus().toggleHighlight({ color }).run()
	};
	const textColor = {
		...useEditorState$1({
			editor,
			selector: (ctx) => ({
				activeColor: ctx.editor.getAttributes("textStyle")?.color ?? DEFAULT_TEXT_COLOR,
				disabled: !ctx.editor.schema.marks.textStyle?.spec?.attrs?.color || isGloballyDisabled(editor) || disabled
			})
		}),
		onChange: (color) => color === DEFAULT_TEXT_COLOR ? editor.chain().focus().unsetTextColor().run() : editor.chain().focus().setTextColor(color).run()
	};
	const image = useControlButtonState({
		editor,
		onClick: () => openFilePicker("image"),
		active: false,
		isDisabled: (editor) => !editor.schema.nodes.image || isGloballyDisabled(editor) || disabled,
		disabledMessage: !editor.schema.nodes.image && isLockDownBrowser ? "Disabled for LockDown Browser exams" : ""
	});
	const audio = useControlButtonState({
		editor,
		onClick: () => openFilePicker("audio"),
		active: false,
		isDisabled: (editor) => !editor.schema.nodes.audio || isGloballyDisabled(editor) || disabled,
		disabledMessage: !editor.schema.nodes.audio && isLockDownBrowser ? "Disabled for LockDown Browser exams" : ""
	});
	const video = useControlButtonState({
		editor,
		onClick: () => openFilePicker("video"),
		active: false,
		isDisabled: (editor) => !editor.schema.nodes.video || isGloballyDisabled(editor) || disabled,
		disabledMessage: !editor.schema.nodes.video && isLockDownBrowser ? "Disabled for LockDown Browser exams" : ""
	});
	const onFileInputChange = (event, mediaType) => {
		const files = event.target.files;
		if (files) insertMedia(editor, Array.from(files).map((f) => [f, ""]), mediaType);
		if (fileInputRef.current) fileInputRef.current.value = "";
	};
	const indent = useControlButtonState({
		editor,
		active: false,
		isDisabled: (editor) => !(editor.can().increaseIndent?.() ?? false) || isGloballyDisabled(editor) || disabled,
		onClick: () => editor.commands.increaseIndent()
	});
	const outdent = useControlButtonState({
		editor,
		active: false,
		isDisabled: (editor) => !(editor.can().decreaseIndent?.() ?? false) || isGloballyDisabled(editor) || disabled,
		onClick: () => editor.commands.decreaseIndent()
	});
	const firstLineIndent = useControlButtonState({
		editor,
		onClick: () => editor.commands.toggleIndentStyle("firstLine"),
		isActive: (editor) => editor.isActive({ indentSpecial: "firstLine" }),
		isDisabled: (editor) => !(getEnabledIndentStyles(editor) ?? []).includes("firstLine") || isGloballyDisabled(editor) || disabled
	});
	const hangingIndent = useControlButtonState({
		editor,
		onClick: () => editor.commands.toggleIndentStyle("hanging"),
		isActive: (editor) => editor.isActive({ indentSpecial: "hanging" }),
		isDisabled: (editor) => !(getEnabledIndentStyles(editor) ?? []).includes("hanging") || isGloballyDisabled(editor) || disabled
	});
	const normalIndent = useControlButtonState({
		editor,
		onClick: () => editor.commands.setIndentStyle("normal", 0),
		active: false,
		isDisabled: (editor) => !((getEnabledIndentStyles(editor) ?? []).includes("normal") && editor.can().setIndentStyle("normal", 0)) || isGloballyDisabled(editor) || disabled
	});
	const link = useControlButtonState({
		editor,
		active: false,
		isDisabled: (editor) => !(editor.can().toggleLink?.() ?? false) || isGloballyDisabled(editor) || disabled || isLockDownBrowser,
		onClick: () => editor.chain().toggleLink().focus().run(),
		disabledMessage: isLockDownBrowser ? "Disabled for LockDown Browser exams" : ""
	});
	const codeBlock = useControlButtonState({
		editor,
		isActive: (editor) => editor.isActive("codeBlock"),
		isDisabled: (editor) => !(editor.can().insertCodeBlock?.() ?? false) || isGloballyDisabled(editor) || disabled,
		onClick: () => editor.chain().insertCodeBlock().focus().run()
	});
	const table = useControlButtonState({
		editor,
		onClick: () => editor.chain().insertTableWithCaption().focus().run(),
		active: false,
		isDisabled: (editor) => !(editor.can().insertTableWithCaption?.() ?? false) || isGloballyDisabled(editor) || disabled
	});
	const code = useControlButtonState({
		editor,
		isActive: (editor) => editor.isActive("code"),
		isDisabled: (editor) => !(editor.can().toggleCode?.() ?? false) || isGloballyDisabled(editor) || disabled,
		onClick: () => editor.chain().toggleCode().focus().run()
	});
	const blockMath = useControlButtonState({
		editor,
		isActive: (editor) => editor.isActive("blockMath"),
		isDisabled: (editor) => !(editor.can().insertBlockMath?.() ?? false) || isGloballyDisabled(editor) || disabled,
		onClick: () => editor.chain().insertBlockMath().focus().run()
	});
	const inlineMath = useControlButtonState({
		editor,
		isActive: (editor) => editor.isActive("inlineMath"),
		isDisabled: (editor) => !(editor.can().insertInlineMath?.() ?? false) || isGloballyDisabled(editor) || disabled,
		onClick: () => editor.chain().insertInlineMath().focus().run()
	});
	const footnote = useControlButtonState({
		editor,
		active: false,
		isDisabled: (editor) => !(editor.can().insertFootnote?.() ?? false) || isGloballyDisabled(editor) || disabled,
		onClick: () => editor.chain().insertFootnote().focus().run()
	});
	const revealHiddenChars = useControlButtonState({
		editor,
		isActive: (editor) => HiddenCharactersPluginKey.getState(editor.state)?.enabled ?? false,
		isDisabled: (editor) => !(editor.can().toggleHiddenCharacters?.() ?? false) || isGloballyDisabled(editor) || disabled,
		onClick: () => editor.chain().toggleHiddenCharacters().focus().run()
	});
	const thread = useControlButtonState({
		editor,
		active: false,
		isDisabled: (editor) => !(editor.can().canInsertThread?.() ?? false) || isGloballyDisabled(editor) || disabled || !onCreateThread,
		onClick: async () => {
			if (onCreateThread) try {
				const { threadId } = await onCreateThread();
				editor.chain().focus().insertThread(threadId).run();
			} catch (error) {
				console.error("Failed to create thread:", error);
			}
		}
	});
	const activeCollaborators = {
		collaborators,
		disabled: !!collaborators && collaborators?.length <= 1,
		onCollaboratorSelected: (collaborator) => {
			if (collaborator.anchor !== null) {
				editor.commands.focus();
				editor.commands.setTextSelection(collaborator.anchor);
				editor.commands.scrollIntoView();
			}
		}
	};
	return /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsx(Controlbar$1, {
		undo,
		redo,
		paragraph,
		bold,
		italic,
		underline,
		strikethrough,
		superscript,
		subscript,
		table,
		leftAlign,
		centerAlign,
		rightAlign,
		justifyAlign,
		orderedList,
		unorderedList,
		checkList,
		highlightColor,
		textColor,
		image,
		audio,
		video,
		link,
		indent,
		outdent,
		firstLineIndent,
		hangingIndent,
		normalIndent,
		codeBlock,
		code,
		blockMath,
		inlineMath,
		revealHiddenChars: displayRevealHiddenCharsButton ? revealHiddenChars : void 0,
		footnote: displayFootnoteButton ? footnote : void 0,
		thread: displayThreadButton ? thread : void 0,
		className,
		activeCollaborators
	}), /* @__PURE__ */ jsx("input", {
		"aria-label": "kind",
		type: "file",
		accept: ALLOWED_MIME_TYPES[activeMediaType].join(","),
		style: { display: "none" },
		ref: fileInputRef,
		onChange: (event) => onFileInputChange(event, activeMediaType),
		multiple: true
	})] });
}
function useParagraphProps(editor, disabled) {
	const enabledParagraphStyles = useMemo(() => {
		return ["blockquote", "heading"].reduce((styles, node) => {
			if (node === "heading" && editor.schema.nodes.heading) return [
				...styles,
				"heading-one",
				"heading-two",
				"heading-three",
				"heading-four"
			];
			else if (node === "blockquote" && editor.schema.nodes.blockquote) return [...styles, "blockquote"];
			return styles;
		}, ["paragraph"]);
	}, [editor]);
	const onChange = useCallback((style) => {
		if (!enabledParagraphStyles.includes(style)) editor.chain().focus().setParagraph().run();
		else switch (style) {
			case "paragraph":
				editor.chain().focus().setParagraph().run();
				break;
			case "blockquote":
				editor.chain().focus().toggleBlockquote().run();
				break;
			case "heading-one":
				editor.chain().focus().toggleHeading({ level: 1 }).run();
				break;
			case "heading-two":
				editor.chain().focus().toggleHeading({ level: 2 }).run();
				break;
			case "heading-three":
				editor.chain().focus().toggleHeading({ level: 3 }).run();
				break;
			case "heading-four":
				editor.chain().focus().toggleHeading({ level: 4 }).run();
				break;
		}
	}, [enabledParagraphStyles, editor]);
	const { paragraphStyle } = useEditorState$1({
		editor,
		selector: (ctx) => ({ paragraphStyle: getParagraphStyle(ctx.editor) })
	});
	return {
		paragraphStyle,
		onChange,
		enabledParagraphStyles,
		disabled: enabledParagraphStyles.length === 1 && enabledParagraphStyles[0] === "paragraph" || disabled
	};
}
function getParagraphStyle(editor) {
	if (editor.isActive("paragraph")) return "paragraph";
	if (editor.isActive("blockquote")) return "blockquote";
	if (editor.isActive("heading", { level: 1 })) return "heading-one";
	if (editor.isActive("heading", { level: 2 })) return "heading-two";
	if (editor.isActive("heading", { level: 3 })) return "heading-three";
	if (editor.isActive("heading", { level: 4 })) return "heading-four";
	return "paragraph";
}
//#endregion
//#region src/react/useCadmusEditor.ts
/**
* Cadmus specific wrapper for `useEditor` to initialise a TipTap `Editor`
* instance in a React hook.
*
* @see https://www.tiptap.dev/api/editor
*
* @param opts all options needed to configure the Cadmus extensions and the editor.
*/
function useCadmusEditor(opts, deps = []) {
	const { content, editable = true, autofocus = false, onUpdate = () => null, onFocus = () => null, onSelectionUpdate, onCreate, onDestroy, cursorBottomPadding = 52, extraExtensions = [], ...other } = opts;
	return useEditor$1({
		extensions: [CadmusKit.configure({
			...other,
			editable
		}), ...extraExtensions],
		content,
		editable,
		autofocus,
		onFocus,
		onSelectionUpdate,
		onDestroy,
		onUpdate,
		onCreate,
		editorProps: {
			scrollThreshold: {
				top: 0,
				left: 0,
				right: 0,
				bottom: cursorBottomPadding
			},
			scrollMargin: {
				top: 0,
				left: 0,
				right: 0,
				bottom: cursorBottomPadding
			}
		}
	}, deps);
}
/**
* Initialise a Cadmus Editor with pre-configured extensions and settings. This
* is the non-hooks version of `useCadmusEditor`.
*/
function createCadmusEditor(opts) {
	const { content, autofocus, cursorBottomPadding = 52, editable = true, extraExtensions = [], ...other } = opts;
	return new Editor$2({
		extensions: [CadmusKit.configure({
			...other,
			editable
		}), ...extraExtensions],
		content,
		editable,
		autofocus: autofocus ?? false,
		editorProps: {
			scrollThreshold: {
				top: 0,
				left: 0,
				right: 0,
				bottom: cursorBottomPadding
			},
			scrollMargin: {
				top: 0,
				left: 0,
				right: 0,
				bottom: cursorBottomPadding
			}
		}
	});
}
//#endregion
//#region src/suggestion-client/EventEmitter.ts
var EventEmitter = class {
	callbacks = {};
	on(event, fn) {
		if (!this.callbacks[event]) this.callbacks[event] = [];
		this.callbacks[event].push(fn);
		return this;
	}
	emit(event, ...args) {
		const callbacks = this.callbacks[event];
		if (callbacks) callbacks.forEach((callback) => callback.apply(this, args));
		return this;
	}
	off(event, fn) {
		const callbacks = this.callbacks[event];
		if (callbacks) if (fn) this.callbacks[event] = callbacks.filter((callback) => callback !== fn);
		else delete this.callbacks[event];
		return this;
	}
	removeAllListeners() {
		this.callbacks = {};
	}
};
//#endregion
//#region src/suggestion-client/SuggestionClient.ts
/**
* Client wrapper for managing suggestion requests to the server and providing a
* cache-based spelling suggestion lookup interface.
*
* The client also implements the `EventEmitter` interface to emit string events
* on certain lifecycle events. Callbacks can be attached and detached on these
* events. These events are:
*
* - `ignoreListUpdated` with the payload of the word that was freshly added to
*     the ignore list.
* - `newSuggestions` when the dictionary is updated with new spelling
*   suggestions, with the payload of the array of `SpellingSuggestion`.
*
*/
var SuggestionClient = class SuggestionClient extends EventEmitter {
	/** Array of words that are to be ignored for suggestions. */
	ignoredWords;
	/** Map of words to their spelling suggestions fetched from the server. */
	dictionary;
	/** Set of all words that have been processed by the server. */
	processedWords;
	/** API endpoint providing the spelling Suggestions service. */
	endpoint;
	/**
	* Create a new instance of the SuggestionClient.
	*
	* It is recommended to share this instance as much as possible to reap the
	* maximum benefits of a spelling dictionary and minimising server requests.
	*
	* @param endpoint full HTTP endpoint to the suggest API
	*/
	static create(endpoint) {
		return new SuggestionClient(endpoint);
	}
	constructor(endpoint) {
		super();
		this.ignoredWords = getIgnoreList();
		this.dictionary = /* @__PURE__ */ new Map();
		this.processedWords = /* @__PURE__ */ new Set();
		this.endpoint = endpoint;
	}
	/**
	* Spelling suggestions lookup for a given phrase
	*
	* The lookup is local and doesn't involve the server. To ensure the local
	* dictionary is populated use the `this.requestSuggestions` method.
	*/
	lookup(phrase) {
		return this.dictionary.get(phrase) ?? null;
	}
	/**
	* Ignore a word from current and future spelling suggestions.
	*
	* This will fire an event `ignoreListUpdated` which should be used to remove
	* any existing suggestion markup on the word.
	*/
	ignoreWord(word) {
		this.ignoredWords.push(word);
		this.dictionary.delete(word);
		setIgnoreList(this.ignoredWords);
		this.emit("ignoreListUpdated", word);
	}
	/**
	* Make a suggestions request to the server for the given words.
	*
	* Any previously processed word is filtered out from the given `words`. If
	* this is should be skipped, provide the `force` optional argument.
	*
	* @param words Set of words to send to the server
	* @param force optionally skip filtering of previously sent words
	* @return array of spelling suggestions for the words
	* @throws Error for network errors in calling the suggest API
	*/
	async requestSuggestions(words, force = false) {
		const unprocessedWords = force ? Array.from(words) : Array.from(words).filter((w) => !this.processedWords.has(w));
		const text = unprocessedWords.join(" ").trim();
		if (text === "") return [];
		const response = await fetch(this.endpoint, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			credentials: "same-origin",
			body: JSON.stringify({
				key: "ignore",
				text
			})
		});
		const data = await response.json();
		if (response.ok) this.addProcessedWords(unprocessedWords);
		if (response.ok && data.suggestions && data.suggestions.length > 0) {
			this.addSuggestions(data.suggestions);
			return data.suggestions;
		}
		if (!response.ok) return Promise.reject("Error fetching spelling suggestions");
		return [];
	}
	/**
	* Update the dictionary with the list of new suggestions.
	*
	* The ignored word list is consulted before performing the update to keep the
	* ignored words out of the dictionary.
	*/
	addSuggestions(suggestions) {
		const filteredSuggestions = suggestions.filter(({ phrase }) => !this.ignoredWords.includes(phrase));
		filteredSuggestions.forEach(({ phrase, candidates }) => {
			this.dictionary.set(phrase, candidates);
		});
		if (filteredSuggestions.length > 0) this.emit("newSuggestions", filteredSuggestions);
	}
	/**
	* Update the list of known processed words.
	*/
	addProcessedWords(words) {
		words.forEach((w) => this.processedWords.add(w));
	}
};
const ignoreListLocalStorage = "ignore_spellings";
/** Read the word igore list from localstorage (or fail doing nothing) */
function getIgnoreList() {
	try {
		const ignoreList = window.localStorage.getItem(ignoreListLocalStorage);
		if (ignoreList) return JSON.parse(ignoreList);
	} catch (e) {
		console.error("Failed parsing suggestions ignore list", e);
	}
	return [];
}
/** Update or set the Ignore list in localstorage */
function setIgnoreList(list) {
	try {
		window.localStorage.setItem(ignoreListLocalStorage, JSON.stringify(list));
	} catch (e) {
		console.error("Failed setting ignore list in localStorage", e);
	}
}
//#endregion
//#region src/extensions/contribution-decorations/viewport.ts
/**
* Nearest scrollable ancestor of the editor, or null when none exists. The
* plugin paints the whole document on null (today's behaviour) — safe
* degradation rather than a broken overlay.
*/
function findScrollParent(el) {
	let node = el?.parentElement ?? null;
	while (node) {
		const { overflowY } = getComputedStyle(node);
		if (overflowY === "auto" || overflowY === "scroll" || overflowY === "overlay") return node;
		node = node.parentElement;
	}
	return null;
}
/** Clamp a raw visible span, padded by `buffer` each side, into [0, docSize]. */
function bufferWindow(visFrom, visTo, buffer, docSize) {
	const lo = Math.min(visFrom, visTo);
	const hi = Math.max(visFrom, visTo);
	return {
		from: Math.max(0, Math.floor(lo - buffer)),
		to: Math.min(docSize, Math.ceil(hi + buffer))
	};
}
/**
* Whether the painted window must be rebuilt: true once the raw visible edge
* has drifted within `margin` of the painted edge on a side that isn't already
* pinned to a document boundary. The boundary guard stops a clamped edge (top
* at 0, bottom at docSize) from triggering a rebuild on every scroll tick.
*/
function windowNeedsRebuild(visible, current, margin, docSize) {
	if (current === null) return true;
	if (current.from <= 0 && current.to >= docSize && visible.to - visible.from + 4 * margin < docSize) return true;
	const nearTop = visible.from < current.from + margin && current.from > 0;
	const nearBottom = visible.to > current.to - margin && current.to < docSize;
	return nearTop || nearBottom;
}
/**
* Reduce sampled `posAtCoords` results to the real visible span. Inside a large
* node (a big table spanning tens of thousands of PM positions) the viewport's
* edge probes snap to that node's far-off start, so the sampled hits split into
* two groups: a tight cluster on the cells actually on screen, and a cluster
* collapsed onto the distant node start. Group the sorted hits by gap and return
* the cluster whose centre is nearest the geometric estimate — that is the one
* sitting in the viewport. `estLo`/`estHi` are the linear pixel→position
* estimate of the visible edges, used only as the anchor that picks the right
* cluster. Returns null when there are no hits to work with.
*/
function spanFromHits(hits, estLo, estHi) {
	if (hits.length === 0) return null;
	const sorted = [...hits].sort((a, b) => a - b);
	const estMid = (estLo + estHi) / 2;
	const gap = Math.max(1e3, (estHi - estLo) * 4);
	let best = [sorted[0]];
	let bestDist = Infinity;
	let cur = [sorted[0]];
	const consider = (cluster) => {
		const centre = (cluster[0] + cluster[cluster.length - 1]) / 2;
		const dist = Math.abs(centre - estMid);
		if (dist < bestDist) {
			bestDist = dist;
			best = cluster;
		}
	};
	for (let i = 1; i < sorted.length; i++) if (sorted[i] - sorted[i - 1] > gap) {
		consider(cur);
		cur = [sorted[i]];
	} else cur.push(sorted[i]);
	consider(cur);
	return {
		from: best[0],
		to: best[best.length - 1]
	};
}
/**
* Doc positions at the top and bottom edges of the visible viewport, padded by
* `buffer`. Uses `view.posAtCoords` rather than scrollTop-ratio math so it stays
* correct across variable-height nodes (images, code blocks). Null scroll
* element → whole doc.
*/
function getVisibleRange(view, scrollEl, buffer) {
	const docSize = view.state.doc.content.size;
	if (!scrollEl) return {
		from: 0,
		to: docSize
	};
	const scrollRect = scrollEl.getBoundingClientRect();
	const domRect = view.dom.getBoundingClientRect();
	const top = Math.max(scrollRect.top, domRect.top);
	const bottom = Math.min(scrollRect.bottom, domRect.bottom);
	const x = domRect.left + domRect.width / 2;
	const estimate = (clientY) => Math.round(Math.min(1, Math.max(0, (clientY - domRect.top) / Math.max(1, domRect.height))) * docSize);
	const estLo = estimate(top);
	const estHi = estimate(bottom);
	const topHit = view.posAtCoords({
		left: x,
		top
	});
	const bottomHit = view.posAtCoords({
		left: x,
		top: bottom
	});
	const rawFrom = topHit ? topHit.pos : null;
	const rawTo = bottomHit ? bottomHit.pos : null;
	const slop = Math.max(2e3, (estHi - estLo) * 3);
	if (rawFrom !== null && rawTo !== null && rawTo - rawFrom > 0 && rawTo - rawFrom <= slop) return bufferWindow(rawFrom, rawTo, buffer, docSize);
	const hits = [];
	if (rawFrom !== null) hits.push(rawFrom);
	if (rawTo !== null) hits.push(rawTo);
	const SAMPLES = 8;
	for (let i = 1; i < SAMPLES; i++) {
		const hit = view.posAtCoords({
			left: x,
			top: top + (bottom - top) * i / SAMPLES
		});
		if (hit) hits.push(hit.pos);
	}
	const span = spanFromHits(hits, estLo, estHi);
	if (!span) return bufferWindow(estLo, estHi, buffer, docSize);
	return bufferWindow(span.from, span.to, buffer, docSize);
}
//#endregion
//#region src/extensions/contribution-decorations/window-ranges.ts
/**
* Select the ranges and deletions that fall within `window`, so the decoration
* plugin only paints what's near the viewport instead of the whole document.
*
* Precondition: `ranges` is sorted by `from` and disjoint (the live
* contribution projection partitions the doc — each position has one author),
* which makes `to` strictly increasing too; `deletions` is sorted by `anchor`.
* Both hold for the per-block lists the fold emits. Selection is therefore
* O(log N + k) via binary search, not a full O(N) scan on every scroll tick.
*
* Straddling ranges are returned whole (not clamped to the window) — the
* decoration builder clamps to `docSize`, and the buffer guarantees the visible
* span is always fully painted.
*/
function selectWindow(ranges, deletions, window) {
	return {
		ranges: selectRanges(ranges, window),
		deletions: selectDeletions(deletions, window)
	};
}
function selectRanges(ranges, { from, to }) {
	const n = ranges.length;
	let lo = 0;
	let hi = n;
	while (lo < hi) {
		const mid = lo + hi >> 1;
		if (ranges[mid].to > from) hi = mid;
		else lo = mid + 1;
	}
	const out = [];
	for (let i = lo; i < n && ranges[i].from < to; i++) out.push(ranges[i]);
	return out;
}
function selectDeletions(deletions, { from, to }) {
	const n = deletions.length;
	let lo = 0;
	let hi = n;
	while (lo < hi) {
		const mid = lo + hi >> 1;
		if (deletions[mid].anchor >= from) hi = mid;
		else lo = mid + 1;
	}
	const out = [];
	for (let i = lo; i < n && deletions[i].anchor <= to; i++) out.push(deletions[i]);
	return out;
}
//#endregion
//#region src/extensions/contribution-decorations/contribution-decorations.ts
/**
* TipTap extension that paints group-contribution authorship as a read-only
* decoration overlay: per-author colour tints on surviving text, and struck-
* through widgets for deletions. Virtualised to the visible viewport.
*/
/** djb2 hash — fingerprints deletion content for unique widget keys. */
function djb2Hash(s) {
	let h = 5381;
	for (let i = 0; i < s.length; i++) h = (h << 5) + h + s.charCodeAt(i) >>> 0;
	return h.toString(36);
}
const ContributionDecorationsPluginKey = new PluginKey("contribution-decorations");
/**
* Cursor-following tooltip for deletion widgets (reads `data-cdm-tooltip`).
* One shared element to avoid per-widget leaks. Cursor-following rather than
* `::after` avoids two issues: a narrow deletion collapses an anchored box to
* one glyph per line, and an anchored tooltip clips at the scroll container.
* Returns `hide` (call when decorations rebuild) and `detach` (teardown for the
* plugin view's `destroy`).
*/
function createDeletionTooltip(view) {
	const tip = document.createElement("div");
	tip.className = "cdm-contribution-deletion-tooltip";
	tip.setAttribute("role", "tooltip");
	tip.style.position = "fixed";
	tip.style.zIndex = "1000";
	tip.style.width = "max-content";
	tip.style.maxWidth = "260px";
	tip.style.padding = "6px 10px";
	tip.style.borderRadius = "6px";
	tip.style.background = colors.neutralBlack500;
	tip.style.color = colors.white;
	tip.style.fontSize = "12px";
	tip.style.fontWeight = "500";
	tip.style.lineHeight = "1.4";
	tip.style.pointerEvents = "none";
	tip.style.boxShadow = "0 4px 12px rgba(20, 20, 43, 0.2)";
	tip.style.display = "none";
	document.body.appendChild(tip);
	const place = (clientX, clientY) => {
		const pad = 14;
		const r = tip.getBoundingClientRect();
		let x = clientX + pad;
		let y = clientY + pad;
		if (x + r.width > window.innerWidth - 8) x = clientX - r.width - pad;
		if (y + r.height > window.innerHeight - 8) y = clientY - r.height - pad;
		tip.style.left = `${Math.max(8, x)}px`;
		tip.style.top = `${Math.max(8, y)}px`;
	};
	const hide = () => {
		tip.style.display = "none";
	};
	const onMove = (e) => {
		const text = (e.target instanceof Element ? e.target.closest(".cdm-contribution-deletion[data-cdm-tooltip]") : null)?.getAttribute("data-cdm-tooltip");
		if (text == null || text === "") {
			hide();
			return;
		}
		if (tip.textContent !== text) tip.textContent = text;
		tip.style.display = "block";
		place(e.clientX, e.clientY);
	};
	view.dom.addEventListener("mousemove", onMove);
	view.dom.addEventListener("mouseleave", hide);
	document.addEventListener("scroll", hide, {
		capture: true,
		passive: true
	});
	return {
		hide,
		detach: () => {
			view.dom.removeEventListener("mousemove", onMove);
			view.dom.removeEventListener("mouseleave", hide);
			document.removeEventListener("scroll", hide, { capture: true });
			tip.remove();
		}
	};
}
/**
* Read-only overlay painting authorship: surviving text tinted per author, and
* (when enabled) deletions shown struck-through at their original position.
*
* Server-computed ranges/deletions are pushed in via `setContributionRanges`.
* The plugin keeps them, builds a windowed `DecorationSet`, re-windows on
* scroll, and reports the visible range via `onViewportWindowChange` so the
* host can fetch only that slice for long documents.
*/
const ContributionDecorations = Extension.create({
	name: "contributionDecorations",
	addOptions() {
		return {
			fallbackBg: colors.lilac200,
			fallbackStroke: colors.lilac700,
			highlightedBlockTypes: [
				"image",
				"video",
				"audio",
				"codeBlock",
				"mathFigure",
				"blockMath",
				"math"
			],
			selfStyledBlockTypes: ["codeBlock"],
			viewportBuffer: 1e3,
			viewportFetchBuffer: 4e3,
			onViewportWindowChange: () => void 0
		};
	},
	addCommands() {
		return {
			setContributionRanges: (ranges, deletions, bgByUserId, strokeByUserId, nameByUserId, options) => ({ tr, dispatch }) => {
				if (dispatch) {
					tr.setMeta(ContributionDecorationsPluginKey, {
						kind: "set",
						payload: {
							ranges,
							deletions,
							bgByUserId,
							strokeByUserId,
							nameByUserId,
							showDeletions: options?.showDeletions ?? true
						}
					});
					dispatch(tr);
				}
				return true;
			},
			clearContributionRanges: () => ({ tr, dispatch }) => {
				if (dispatch) {
					tr.setMeta(ContributionDecorationsPluginKey, {
						kind: "set",
						payload: {
							ranges: [],
							deletions: [],
							bgByUserId: {},
							strokeByUserId: {},
							nameByUserId: {},
							showDeletions: false
						}
					});
					dispatch(tr);
				}
				return true;
			}
		};
	},
	addProseMirrorPlugins() {
		const buildOptions = {
			fallbackBg: this.options.fallbackBg,
			fallbackStroke: this.options.fallbackStroke,
			highlightedBlockTypes: new Set(this.options.highlightedBlockTypes),
			selfStyledBlockTypes: new Set(this.options.selfStyledBlockTypes)
		};
		const minBuffer = this.options.viewportBuffer;
		const fetchBuffer = this.options.viewportFetchBuffer;
		const onViewportWindowChange = this.options.onViewportWindowChange;
		const key = ContributionDecorationsPluginKey;
		let editorView = null;
		let scrollEl = null;
		let lastFetchWindow = null;
		const resolveScroll = () => {
			if (scrollEl) return scrollEl;
			if (editorView) scrollEl = findScrollParent(editorView.dom);
			return scrollEl;
		};
		const currentWindow = (docSize) => {
			if (!editorView) return {
				from: 0,
				to: docSize
			};
			const sc = resolveScroll();
			const visible = getVisibleRange(editorView, sc, 0);
			const buffer = Math.max(minBuffer, visible.to - visible.from);
			return getVisibleRange(editorView, sc, buffer);
		};
		const reportFetchWindow = () => {
			if (!editorView) return;
			const sc = resolveScroll();
			const docSize = editorView.state.doc.content.size;
			const visible = getVisibleRange(editorView, sc, 0);
			const margin = Math.max(1, Math.floor(fetchBuffer / 2));
			if (lastFetchWindow && !windowNeedsRebuild(visible, lastFetchWindow, margin, docSize)) return;
			lastFetchWindow = getVisibleRange(editorView, sc, fetchBuffer);
			onViewportWindowChange(lastFetchWindow);
		};
		return [new Plugin({
			key,
			state: {
				init() {
					return {
						source: null,
						window: null,
						decorations: DecorationSet.empty
					};
				},
				apply(tr, old) {
					const meta = tr.getMeta(key);
					if (meta?.kind === "set") {
						const p = meta.payload;
						if (p.ranges.length === 0 && p.deletions.length === 0) return {
							source: null,
							window: null,
							decorations: DecorationSet.empty
						};
						const allDeletions = coalesceTextRuns([...p.deletions].sort((a, b) => a.anchor - b.anchor));
						const deletions = [];
						const blockDeletions = [];
						for (const d of allDeletions) (isBlockDeletion(d) ? blockDeletions : deletions).push(d);
						const source = {
							ranges: [...p.ranges].sort((a, b) => a.from - b.from),
							deletions,
							blockDeletions,
							bgByUserId: p.bgByUserId,
							strokeByUserId: p.strokeByUserId,
							nameByUserId: p.nameByUserId,
							showDeletions: p.showDeletions
						};
						const window = currentWindow(tr.doc.content.size);
						return {
							source,
							window,
							decorations: buildContributionDecorations(tr.doc, source, window, buildOptions)
						};
					}
					if (meta?.kind === "viewport") {
						if (!old.source) return old;
						return {
							...old,
							window: meta.window,
							decorations: buildContributionDecorations(tr.doc, old.source, meta.window, buildOptions)
						};
					}
					if (tr.docChanged) return {
						...old,
						decorations: old.decorations.map(tr.mapping, tr.doc)
					};
					return old;
				}
			},
			view(view) {
				editorView = view;
				const initFrame = requestAnimationFrame(() => reportFetchWindow());
				let frame = 0;
				const onScroll = () => {
					if (frame) return;
					frame = requestAnimationFrame(() => {
						frame = 0;
						reportFetchWindow();
						const state = key.getState(view.state);
						if (!state?.source) return;
						const sc = resolveScroll();
						const docSize = view.state.doc.content.size;
						const visible = getVisibleRange(view, sc, 0);
						const buffer = Math.max(minBuffer, visible.to - visible.from);
						const margin = Math.max(1, Math.floor(buffer / 2));
						if (!windowNeedsRebuild(visible, state.window, margin, docSize)) return;
						const next = getVisibleRange(view, sc, buffer);
						view.dispatch(view.state.tr.setMeta(key, {
							kind: "viewport",
							window: next
						}));
					});
				};
				document.addEventListener("scroll", onScroll, {
					capture: true,
					passive: true
				});
				const tooltip = createDeletionTooltip(view);
				return {
					update(_view, prevState) {
						if (editorView && !prevState.doc.eq(editorView.state.doc)) {
							reportFetchWindow();
							tooltip.hide();
						}
					},
					destroy() {
						if (frame) cancelAnimationFrame(frame);
						cancelAnimationFrame(initFrame);
						tooltip.detach();
						document.removeEventListener("scroll", onScroll, { capture: true });
						editorView = null;
						scrollEl = null;
						lastFetchWindow = null;
					}
				};
			},
			props: { decorations(state) {
				return key.getState(state)?.decorations;
			} }
		})];
	}
});
function sameMarks(a, b) {
	const x = a ?? [];
	const y = b ?? [];
	if (x.length !== y.length) return false;
	for (let i = 0; i < x.length; i++) if (x[i].type !== y[i].type || (x[i].attrs ?? null) !== (y[i].attrs ?? null)) return false;
	return true;
}
/**
* Merge adjacent text deletions sharing an anchor, author, deleter, and marks
* into one run. The fold splits deleted text per edit, so deleting an inline-code
* span character by character yields one run per character; without merging each
* renders as its own struck box, so a deleted `code` span shows as a box per
* letter rather than one continuous strike. Media/node deletions never merge and
* break a run. Expects deletions pre-sorted by anchor (stably) so same-anchor
* runs are adjacent in document order.
*
* Exported for unit testing.
*/
function coalesceTextRuns(deletions) {
	const mergeable = (d) => d.media == null && d.node == null && typeof d.text === "string";
	const out = [];
	for (const d of deletions) {
		const prev = out[out.length - 1];
		if (prev != null && mergeable(prev) && mergeable(d) && prev.anchor === d.anchor && prev.originalAuthorId === d.originalAuthorId && prev.deletedById === d.deletedById && sameMarks(prev.marks, d.marks)) prev.text += d.text;
		else out.push(mergeable(d) ? { ...d } : d);
	}
	return out;
}
/**
* Collapse a resized-then-deleted image's tombstones into one struck preview.
* Each resize re-commits the media node, creating one tombstone per intermediate
* size; this keeps only the widest (≈ final size) per source. Non-media and
* sourceless deletions pass through unchanged.
*
* Exported for unit testing.
*/
function dedupeResizedMedia(deletions) {
	const winnerBySrc = /* @__PURE__ */ new Map();
	for (const d of deletions) {
		const src = d.media?.src;
		if (src == null || src === "") continue;
		const prev = winnerBySrc.get(src);
		if (prev == null || (d.media?.customWidth ?? 0) > (prev.media?.customWidth ?? 0)) winnerBySrc.set(src, d);
	}
	if (winnerBySrc.size === 0) return deletions;
	return deletions.filter((d) => {
		const src = d.media?.src;
		if (src == null || src === "") return true;
		return winnerBySrc.get(src) === d;
	});
}
function buildContributionDecorations(doc, source, window, { fallbackBg, fallbackStroke, highlightedBlockTypes, selfStyledBlockTypes }) {
	const docSize = doc.content.size;
	const { ranges, deletions } = selectWindow(source.ranges, source.deletions, window);
	const windowedDeletions = source.blockDeletions.length > 0 ? [...source.blockDeletions, ...deletions] : deletions;
	const visibleRanges = ranges.filter((r) => r.from >= 0 && r.from < docSize && r.from < r.to);
	const inlineDecos = visibleRanges.map((r) => {
		const bg = source.bgByUserId[r.userId] ?? fallbackBg;
		const from = Math.max(0, Math.min(r.from, docSize));
		const to = Math.max(from, Math.min(r.to, docSize));
		return Decoration.inline(from, to, {
			class: "cdm-contribution",
			"data-author": r.userId,
			style: `background-color: ${bg};`
		}, { userId: r.userId });
	});
	const gapCache = /* @__PURE__ */ new Map();
	const atTopLevelGap = (anchor) => {
		const a = Math.min(anchor, docSize);
		let v = gapCache.get(a);
		if (v === void 0) {
			try {
				v = doc.resolve(a).depth === 0;
			} catch {
				v = false;
			}
			gapCache.set(a, v);
		}
		return v;
	};
	const isGrouped = (d) => isBlockDeletion(d) || atTopLevelGap(d.anchor);
	const groupByAnchor = /* @__PURE__ */ new Map();
	const visibleDeletions = source.showDeletions ? dedupeResizedMedia(windowedDeletions.filter((d) => d.anchor >= 0 && d.anchor <= docSize && (typeof d.text === "string" && d.text.length > 0 || d.media != null || d.node != null))) : [];
	for (const d of visibleDeletions) {
		if (!isGrouped(d)) continue;
		const { keyCore } = memoFor(d);
		const group = groupByAnchor.get(d.anchor);
		if (group != null) {
			group.deletions.push(d);
			group.key += `|${keyCore}`;
		} else groupByAnchor.set(d.anchor, {
			pos: resolveHoistedDeletionPos(doc, Math.min(d.anchor, docSize), docSize),
			deletions: [d],
			key: keyCore
		});
	}
	const emittedGroupAnchors = /* @__PURE__ */ new Set();
	const widgetDecos = [];
	for (const d of visibleDeletions) {
		const { keyCore } = memoFor(d);
		if (isGrouped(d)) {
			if (emittedGroupAnchors.has(d.anchor)) continue;
			emittedGroupAnchors.add(d.anchor);
			const group = groupByAnchor.get(d.anchor);
			if (group == null) continue;
			widgetDecos.push(Decoration.widget(group.pos, () => buildDeletionGroup(group.deletions, source.bgByUserId, source.strokeByUserId, fallbackBg, fallbackStroke, source.nameByUserId, doc.type.schema), {
				side: 1,
				marks: [],
				key: `del-group-${d.anchor}-${group.key}`
			}));
			continue;
		}
		const bg = source.bgByUserId[d.originalAuthorId] ?? fallbackBg;
		const stroke = source.strokeByUserId[d.originalAuthorId] ?? fallbackStroke;
		widgetDecos.push(Decoration.widget(Math.min(d.anchor, docSize), () => buildDeletionWidget(d, bg, stroke, source.nameByUserId, doc.type.schema), {
			side: 1,
			marks: [],
			key: `del-${d.anchor}-${d.originalAuthorId}-${keyCore}`
		}));
	}
	const blockDecos = [];
	if (highlightedBlockTypes.size > 0) doc.nodesBetween(window.from, window.to, (node, pos) => {
		if (!highlightedBlockTypes.has(node.type.name)) return;
		const owner = ownerRangeAt(visibleRanges, pos);
		if (!owner) return;
		const stroke = source.strokeByUserId[owner.userId] ?? fallbackStroke;
		const bg = source.bgByUserId[owner.userId] ?? fallbackBg;
		const style = selfStyledBlockTypes.has(node.type.name) ? `clip-path: none; box-shadow: 0 0 0 6px ${bg}, 0 0 0 8px ${stroke}; border-radius: 6px;` : `background-color: ${bg}; padding: 4px; outline: 2px solid ${stroke}; outline-offset: 2px; border-radius: 4px;`;
		blockDecos.push(Decoration.node(pos, pos + node.nodeSize, {
			class: "cdm-contribution-block",
			"data-author": owner.userId,
			style
		}));
	});
	return DecorationSet.create(doc, [
		...inlineDecos,
		...blockDecos,
		...widgetDecos
	]);
}
function ownerRangeAt(ranges, pos) {
	let lo = 0;
	let hi = ranges.length;
	while (lo < hi) {
		const mid = lo + hi >> 1;
		if (ranges[mid].from <= pos) lo = mid + 1;
		else hi = mid;
	}
	const candidate = ranges[lo - 1];
	return candidate != null && pos < candidate.to ? candidate : void 0;
}
/**
* Hoist `pos` out of any live block to the nearer of its top-level outer gaps,
* so the deletion widget never nests inside a live table cell / figcaption / etc.
* The nearer gap (not always the leading one) keeps a deletion anchored at a
* block's end from jumping above the whole block.
*/
function resolveHoistedDeletionPos(doc, pos, docSize) {
	const clamped = Math.min(pos, docSize);
	let $pos;
	try {
		$pos = doc.resolve(clamped);
	} catch {
		return clamped;
	}
	if ($pos.depth === 0) return clamped;
	const before = $pos.before(1);
	const after = $pos.after(1);
	return clamped - before <= after - clamped ? before : after;
}
function parseDeletedNodeType(nodeJson) {
	try {
		return JSON.parse(nodeJson).type ?? "";
	} catch {
		return "";
	}
}
const NODE_TOOLTIP_LABELS = {
	inlineMath: "equation",
	blockMath: "equation",
	codeBlock: "code block",
	tableGroup: "table",
	table: "table",
	tableRow: "table",
	tableCell: "table",
	tableHeader: "table",
	tableCaption: "table",
	tableFootnote: "table"
};
const deletionMemo = /* @__PURE__ */ new WeakMap();
function memoFor(d) {
	let m = deletionMemo.get(d);
	if (!m) {
		m = {
			nodeType: d.node != null ? parseDeletedNodeType(d.node) : null,
			keyCore: `${djb2Hash(d.text)}-${d.media ? `${d.media.type}:${djb2Hash(d.media.src ?? "")}` : ""}-${d.node != null ? djb2Hash(d.node) : ""}-${d.marks?.length ?? 0}`
		};
		deletionMemo.set(d, m);
	}
	return m;
}
/**
* Whether a deletion renders as a TALL block widget — a deleted media node or a
* reconstructed block node (table/code/blockMath). `inlineMath` is an INLINE node,
* so it's excluded (windowed like text). Block widgets occupy large height but
* ~zero document positions, so they must be painted regardless of the viewport
* (windowing one out on scroll drops its height and snaps the scroll); they're
* few, so always painting them is cheap. Drives both the source partition and the
* grouped-rendering check (`isGrouped`).
*/
function isBlockDeletion(d) {
	const { nodeType } = memoFor(d);
	return d.media != null || nodeType != null && nodeType !== "inlineMath";
}
function buildDeletionWidget(deletion, bg, stroke, nameByUserId, schema) {
	const el = document.createElement("del");
	el.className = "cdm-contribution-deletion";
	el.setAttribute("data-original-author", deletion.originalAuthorId);
	if (deletion.deletedById != null) el.setAttribute("data-deleted-by", deletion.deletedById);
	const deleterName = deletion.deletedById == null ? "the system" : deletion.deletedById === deletion.originalAuthorId ? "the original author" : nameByUserId[deletion.deletedById] ?? "another member";
	const nodeType = deletion.node != null ? parseDeletedNodeType(deletion.node) : null;
	const nodeLabel = nodeType != null ? NODE_TOOLTIP_LABELS[nodeType] : void 0;
	const tooltip = `Deleted ${deletion.media ? `${deletion.media.type} ` : nodeLabel != null ? `${nodeLabel} ` : ""}by ${deleterName}`;
	el.setAttribute("data-cdm-tooltip", tooltip);
	el.setAttribute("aria-label", tooltip);
	el.style.color = stroke;
	el.style.textDecoration = "line-through";
	el.style.textDecorationColor = "currentColor";
	if (deletion.node != null && deletion.node !== "" && schema) {
		const isInline = nodeType === "inlineMath";
		el.style.display = isInline ? "inline" : "block";
		if (!isInline) el.dataset.blockNode = "true";
		el.appendChild(buildDeletedNodePreview(deletion.node, schema, stroke));
	} else if (deletion.media) {
		el.style.display = "block";
		el.dataset.blockNode = "true";
		el.appendChild(buildDeletedMediaPreview(deletion.media, stroke));
	} else if (schema && deletion.marks && deletion.marks.length > 0) {
		el.style.backgroundColor = bg;
		el.appendChild(renderDeletedText(deletion.text, deletion.marks, schema));
	} else {
		el.style.backgroundColor = bg;
		el.textContent = deletion.text;
	}
	return el;
}
/**
* Render the same-anchor deletions for one gap into a single inert container (no
* border/bg of its own), inset to the live document column. Block-node children
* (media/code/math/table) each draw their own box; whole-paragraph text children
* flow inline within the column and wrap like a live paragraph rather than
* running edge-to-edge. Exported for direct instantiation in tests.
*/
function buildDeletionGroup(groupDeletions, bgByUserId, strokeByUserId, fallbackBg, fallbackStroke, nameByUserId, schema) {
	const container = document.createElement("div");
	container.dataset.deletionGroup = "true";
	container.dataset.indent = "0";
	container.style.paddingRight = "45px";
	for (const d of groupDeletions) {
		const bg = bgByUserId[d.originalAuthorId] ?? fallbackBg;
		const stroke = strokeByUserId[d.originalAuthorId] ?? fallbackStroke;
		container.appendChild(buildDeletionWidget(d, bg, stroke, nameByUserId, schema));
	}
	return container;
}
function renderDeletedText(text, marks, schema) {
	const pmMarks = marks.flatMap((m) => {
		if (!(m.type in schema.marks)) return [];
		const markType = schema.marks[m.type];
		try {
			return [markType.create(m.attrs != null ? JSON.parse(m.attrs) : void 0)];
		} catch {
			return [];
		}
	});
	return DOMSerializer.fromSchema(schema).serializeNode(schema.text(text, pmMarks));
}
function buildDeletedMediaPreview(media, stroke) {
	if ((media.type === "image" || media.type === "video") && media.src != null) {
		const wrapper = document.createElement("div");
		wrapper.className = "img-wrapper cdm-contribution-deletion-media";
		if (media.width != null) wrapper.setAttribute("data-image-width", media.width);
		if (media.imageAlign != null) wrapper.setAttribute("data-image-align", media.imageAlign);
		if (media.width === "custom" && media.customWidth != null) wrapper.style.width = `${media.customWidth}px`;
		wrapper.style.opacity = "0.5";
		wrapper.style.outline = `2px solid ${stroke}`;
		wrapper.style.borderRadius = "4px";
		wrapper.style.position = "relative";
		const thumb = media.type === "image" ? document.createElement("img") : document.createElement("video");
		if (thumb instanceof HTMLImageElement) thumb.alt = "Deleted image";
		thumb.src = media.src;
		thumb.style.display = "block";
		thumb.style.width = "100%";
		if (thumb instanceof HTMLVideoElement) {
			thumb.muted = true;
			thumb.preload = "metadata";
		}
		wrapper.appendChild(thumb);
		wrapper.appendChild(strikeLine(stroke));
		return wrapper;
	}
	const chip = document.createElement("span");
	chip.className = "cdm-contribution-deletion-media";
	chip.textContent = media.type;
	return chip;
}
function strikeLine(stroke) {
	const line = document.createElement("span");
	line.setAttribute("aria-hidden", "true");
	line.style.position = "absolute";
	line.style.left = "0";
	line.style.right = "0";
	line.style.top = "50%";
	line.style.borderTop = `1.5px solid ${stroke}`;
	line.style.pointerEvents = "none";
	return line;
}
function buildDeletedNodePreview(nodeJson, schema, stroke) {
	const wrapper = document.createElement("span");
	wrapper.className = "cdm-contribution-deletion-node";
	let node;
	try {
		node = schema.nodeFromJSON(JSON.parse(nodeJson));
	} catch {
		return wrapper;
	}
	if (node.type.name === "inlineMath" || node.type.name === "blockMath") {
		const equation = node.attrs?.equation ?? "";
		if (node.type.name === "blockMath") {
			const fig = document.createElement("figure");
			fig.className = "cdm-contribution-deletion-node";
			fig.style.outline = `2px solid ${stroke}`;
			fig.style.outlineOffset = "2px";
			fig.style.borderRadius = "4px";
			fig.style.textAlign = "center";
			fig.style.padding = "24px 0";
			fig.style.position = "relative";
			try {
				fig.innerHTML = convertLatexToMarkup(equation, { mathstyle: "displaystyle" });
			} catch {
				fig.textContent = equation;
			}
			fig.appendChild(strikeLine(stroke));
			return fig;
		}
		wrapper.style.display = "inline-block";
		wrapper.style.position = "relative";
		try {
			wrapper.innerHTML = convertLatexToMarkup(equation, { mathstyle: "textstyle" });
		} catch {
			wrapper.textContent = equation;
		}
		wrapper.appendChild(strikeLine(stroke));
		return wrapper;
	}
	if (node.type.name === "codeBlock") {
		wrapper.style.display = "block";
		try {
			const spec = makeCodeBlockDomSpec(node.textContent, node.attrs.language, node.attrs.theme, node.attrs.lineNumbersVisible, node.attrs.languageVisible);
			wrapper.appendChild(DOMSerializer.renderSpec(document, spec).dom);
		} catch {
			wrapper.textContent = node.textContent;
		}
		return wrapper;
	}
	wrapper.style.display = "block";
	try {
		wrapper.appendChild(DOMSerializer.fromSchema(schema).serializeNode(node));
		wrapper.querySelectorAll("table").forEach((t) => {
			t.style.width = "100%";
			t.style.tableLayout = "fixed";
		});
	} catch {}
	return wrapper;
}
//#endregion
//#region src/extensions/contribution-timeline/contribution-timeline.ts
const INCREMENTAL_STEP_CAP = 5e3;
/**
* Drives a read-only editor as a contribution-timeline surface: a host scrubber
* pushes frames with `applyTimelineFrame` and this renders each efficiently,
* never touching the live (collab/saving) editor. Pair it with
* `ContributionDecorations` to paint the authorship overlay on each frame — the
* host applies the overlay after the frame so a `setContent` can't wipe it.
*
* Enable it per page by adding it to that editor's extension list; an editor
* without it behaves exactly as before.
*/
const ContributionTimeline = Extension.create({
	name: "contributionTimeline",
	addStorage() {
		return {
			appliedVersion: null,
			cancel: null
		};
	},
	addCommands() {
		return {
			applyTimelineFrame: (frame) => ({ editor }) => {
				const storage = editor.storage.contributionTimeline;
				if (storage.appliedVersion === frame.version) return true;
				storage.cancel?.();
				let cancelled = false;
				storage.cancel = () => {
					cancelled = true;
				};
				queueMicrotask(() => {
					if (cancelled) return;
					if (editor.isDestroyed) return;
					storage.cancel = null;
					if (applyFrame(editor, frame)) storage.appliedVersion = frame.version;
				});
				return true;
			},
			resetTimeline: () => ({ editor }) => {
				const storage = editor.storage.contributionTimeline;
				storage.cancel?.();
				storage.cancel = null;
				storage.appliedVersion = null;
				return true;
			}
		};
	}
});
function applyFrame(editor, frame) {
	const { steps, doc } = frame;
	if (steps != null && steps.length > 0 && steps.length <= INCREMENTAL_STEP_CAP) try {
		const { schema } = editor.state;
		const tr = editor.state.tr;
		for (const raw of steps) tr.step(Step$1.fromJSON(schema, raw));
		tr.setMeta("addToHistory", false);
		editor.view.dispatch(tr);
		return true;
	} catch {}
	if (doc == null) return false;
	editor.commands.setContent(doc, false);
	return true;
}
//#endregion
export { CadmusEditorContent, CadmusEditorMenus, CadmusEditorWrapper, CadmusKit, ContributionDecorations, ContributionDecorationsPluginKey, ContributionTimeline, Controlbar, CoreEditor, Editor, EditorState, FootnoteActiveStatusPluginKey, FootnoteListPluginKey, HistoryPluginKey, Node, PastePluginKey, SlimEditorContent, SlimEditorWrapper, SlimKit, Step, SuggestionClient, ThreadActiveStatusPluginKey, ThreadListPluginKey, canSpellCheckWithCadmus, collab, textWordCount as countWords, textWordCount, createCadmusEditor, currentActiveFootnoteId, currentActiveThreadId, disableSpellCheck, editorTypography, editorWordCount, enableCadmusSpellCheck, generateHTML, getText, getVersion, isSlimEditor, listExistingBlanks, listFootnotes, listThreads, receiveTransaction, sendableSteps, sendableWordCountChange, uploadMediaToServer, useCadmusEditor, useEditor, useEditorState, useFootnoteList, useThreadList };

//# sourceMappingURL=index.mjs.map